// Debug Mode Control — JRSBASE-V8.3.0-09102026-BYOB — debug always ON in this theme
// Console: mrkDebug.* always runs. _debug_* / _bundle_debug_log still respect JRS_DEBUG_PROPERTIES_IN_CART.
// Performance audit (Bundle PDP): Loaded with defer. Uses jQuery/Select2 and DOM ready;
// upDateTotals() and event handlers run after DOM. No split into critical vs deferred in this file.
(function() {
  var DEBUG_MODE = true;

  var _themeId = String(window._bcThemeId || window._mrkThemeId || 'base');
  var _themeVersion = String(window._bcThemeVersion || window._mrkThemeVersion || 'JRSBASE-V8.3.0-09102026-BYOB');
  var _prefix = '[' + _themeVersion + '][' + _themeId + ']';
  var _makeWriter = function(method) {
    if (!DEBUG_MODE) return function(){};
    return function() {
      var args = Array.prototype.slice.call(arguments);
      args.unshift(_prefix);
      if (console && typeof console[method] === 'function') {
        console[method].apply(console, args);
      }
    };
  };

  var debugObj = window.bcDebug || window.betterConversionsDebug || window.mrkDebug || {};
  debugObj.enabled = DEBUG_MODE;
  debugObj.log = _makeWriter('log');
  debugObj.warn = _makeWriter('warn');
  debugObj.error = _makeWriter('error');
  debugObj.info = _makeWriter('info');
  window.bcDebug = debugObj;
  window.betterConversionsDebug = debugObj;
  window.mrkDebug = debugObj;
})();

var JRS_BUILD_VERSION = '7.0.0';
var JRS_BUILD_DATE = '2026-08-20';
var JRS_THEME_NAME = 'base';
// When true, _debug_* and _bundle_debug_log are added to bundle line item properties (visible in Shopify admin on every order).
var JRS_DEBUG_PROPERTIES_IN_CART = true;

// Initialize bundle debug tracker — JRSBASE-V8.3.0-09102026-BYOB
if (!window.bundleDebugTracker) {
  window.bundleDebugTracker = {
    sessionId: Date.now().toString(36) + Math.random().toString(36).substr(2, 9),
    addSequence: 0,
    userActions: [],
    errors: [],
    buildVersion: typeof JRS_BUILD_VERSION !== 'undefined' ? JRS_BUILD_VERSION : 'unknown',
    themeName: typeof JRS_THEME_NAME !== 'undefined' ? JRS_THEME_NAME : 'unknown'
  };
}

// BUG-BUNDLE-RAW-001: Validate _bundle_raw before cart add (must be available on bundle PDP where mrk-cart.js is not loaded)
function validateBundleRaw(bundleRaw) {
  var errors = [];
  if (!bundleRaw) return { valid: true, errors: [] };
  var raw = bundleRaw;
  if (typeof bundleRaw === 'string') {
    try { raw = JSON.parse(bundleRaw); } catch (e) {
      errors.push('_bundle_raw is not valid JSON');
      return { valid: false, errors: errors };
    }
  }
  var categories = Array.isArray(raw) ? raw : (raw && typeof raw === 'object' ? Object.keys(raw).map(function(k) { return raw[k]; }) : []);
  if (!categories || categories.length === 0) return { valid: true, errors: [] };
  categories.forEach(function(category, catIndex) {
    var cat = category && typeof category === 'object' ? category : {};
    var products = cat.products || {};
    Object.keys(products).forEach(function(prodKey) {
      var product = products[prodKey];
      if (product && !product.variantId) errors.push('Category ' + catIndex + ' ' + prodKey + ': Missing variantId');
    });
    var positions = cat.positions;
    var positionsList = Array.isArray(positions) ? positions : (positions && typeof positions === 'object' ? Object.keys(positions).map(function(k) { return positions[k]; }) : []);
    positionsList.forEach(function(position, posIndex) {
      var pos = position && typeof position === 'object' ? position : {};
      var logoType = pos.logoType || pos.logo_type || pos['Logo Type'];
      if (logoType === 'Upload Your Logo' || logoType === 'Existing Logo') {
        var logoUrl = (pos.logo && pos.logo.url) ? pos.logo.url : pos['Logo'];
        if (!logoUrl || logoUrl === '') {
          errors.push('Category ' + catIndex + ' Position ' + posIndex + ' (' + (pos.name || '') + '): Missing logo URL for ' + logoType + ' (logoId: ' + (pos.logo && pos.logo.logoId ? pos.logo.logoId : pos['Logo Id']) + '). Please upload or select a logo before adding to cart.');
        }
      }
    });
  });
  return { valid: errors.length === 0, errors: errors };
}
if (typeof window !== 'undefined') window.validateBundleRaw = window.validateBundleRaw || validateBundleRaw;

// Global cache to map logo URLs to their original filenames (shared with customizer)
// This ensures that when the same logo is reused, we preserve the original filename
if (!window.logoFilenameCache) {
  window.logoFilenameCache = {};
}

/**
 * Get the original filename for a logo URL
 * Checks cache first, then extracts from URL as fallback
 * Also checks if we've seen this base filename before (for timestamped uploads)
 * @param {string} logoUrl - The logo URL
 * @returns {string} - The original filename
 */
function getOriginalLogoFilename(logoUrl) {
  if (!logoUrl || typeof logoUrl !== 'string') return '';
  
  // Normalize URL (remove query params, decode if needed)
  var normalizedUrl = String(logoUrl).split('?')[0];
  normalizedUrl = decodeURIComponent(normalizedUrl);
  
  var result = '';
  
  // Check cache first (exact URL match)
  if (window.logoFilenameCache[normalizedUrl]) {
    var cached = window.logoFilenameCache[normalizedUrl];
    // If cache has timestamped name, strip to base so we always show clean filename
    var cachedMatch = cached && String(cached).match(/^logo_\d+_(.+)$/);
    result = cachedMatch ? cachedMatch[1] : (cached || '');
  } else {
    // Extract filename from URL
    try {
      var urlPath = normalizedUrl.split('?')[0];
      var fileName = urlPath.split('/').pop();
      
      // If filename matches pattern "logo_TIMESTAMP_BASENAME.ext", always return only BASENAME.ext
      if (fileName && fileName.indexOf('logo_') === 0) {
        var match = fileName.match(/^logo_\d+_(.+)$/);
        if (match && match[1]) {
          result = match[1];
          if (!window.logoFilenameCache[normalizedUrl]) {
            window.logoFilenameCache[normalizedUrl] = result;
          }
        } else {
          result = fileName || '';
        }
      } else {
        result = fileName || '';
      }
    } catch(e) {
      result = '';
    }
  }
  
  // Normalize so same file always has same name (e.g. "_TYR3894 1.png" and "_TYR3894_1.png" -> "_TYR3894_1.png")
  return normalizeLogoFilename(result);
}

/**
 * Normalize logo filename to a canonical form (same as upload sanitization).
 * So the same file always has the same filename regardless of source (cache vs URL).
 * e.g. "_TYR3894 1.png" and "_TYR3894_1.png" both become "_TYR3894_1.png"
 * @param {string} filename - Raw filename
 * @returns {string} - Normalized filename
 */
function normalizeLogoFilename(filename) {
  if (!filename || typeof filename !== 'string') return '';
  var s = filename.trim();
  var lastDot = s.lastIndexOf('.');
  var base = lastDot !== -1 ? s.substring(0, lastDot) : s;
  var ext = lastDot !== -1 ? s.substring(lastDot) : '';
  base = base.replace(/[^a-zA-Z0-9_-]/g, '_');
  return base + ext;
}

/**
 * Scroll offset for bundle panel: main sticky header + selector header + gap.
 * Used so category expand/collapse scroll doesn't hide content behind sticky headers.
 */
function getBundleScrollOffset(includeSelectorHeader) {
  if (includeSelectorHeader === undefined) includeSelectorHeader = true;
  var gap = 12;
  var offset = gap;
  try {
    var cssVal = getComputedStyle(document.documentElement).getPropertyValue('--sticky-header-offset-with-gap').trim();
    if (cssVal) offset = parseFloat(cssVal) || gap;
  } catch (e) {}
  /* On mobile always reserve space for all sticky header(s) so content isn't hidden after scroll */
  if (window.innerWidth <= 768) {
    var mobileOffset = 0;
    var mainHeader = document.querySelector('.jrs-main-header');
    if (mainHeader) mobileOffset += mainHeader.offsetHeight;
    var megaNav = document.querySelector('.mega-nav--sticky');
    if (megaNav) mobileOffset += megaNav.offsetHeight;
    var headerBarBottom = document.querySelector('.header-bar-bottom');
    if (headerBarBottom && window.getComputedStyle(headerBarBottom).position === 'sticky') {
      mobileOffset += headerBarBottom.offsetHeight;
    }
    /* Use at least 120px for main header area if measured height is small, plus gap */
    offset = Math.max(offset, mobileOffset + gap);
    if (offset < 120) offset = 120;
  }
  if (includeSelectorHeader) {
    var sel = document.querySelector('.bundle__wrapper.bundle-build-options .selector-header');
    if (sel) offset += sel.offsetHeight;
  }
  /* Extra gap so content stays clearly below sticky header (larger on mobile) */
  var extraGap = window.innerWidth <= 768 ? 24 : 16;
  return offset + extraGap;
}

/**
 * Scroll element into view with offset for sticky headers (smooth, visible below header).
 * @param {Element} el - DOM element to scroll into view
 * @param {Object} opts - { behavior: 'smooth'|'auto', block: 'start'|'center' }
 */
function scrollBundleElementIntoView(el, opts) {
  if (!el || !el.getBoundingClientRect) return;
  opts = opts || {};
  var behavior = opts.behavior || 'smooth';
  var block = opts.block || 'start';
  // includeSelectorHeader defaults to true (existing callers target elements
  // BELOW the wrapper's sticky .selector-header and must clear it). Pass false
  // when the target IS the wrapper itself (its first child is that header).
  var offset = getBundleScrollOffset(opts.includeSelectorHeader);
  var rect = el.getBoundingClientRect();
  var viewportHeight = window.innerHeight || document.documentElement.clientHeight;
  var targetScrollTop;
  if (block === 'center') {
    var centerScroll = window.pageYOffset + rect.top - (viewportHeight / 2) + (rect.height / 2);
    var maxScrollToKeepVisible = window.pageYOffset + rect.top - offset;
    targetScrollTop = Math.max(0, Math.min(centerScroll, maxScrollToKeepVisible));
  } else if (block === 'fit') {
    // Minimal scroll so the element is FULLY visible between the top sticky
    // offset and the viewport bottom. No-op when already fully in view; never
    // overshoots. Fixes the 'start' behaviour that dragged the whole selector
    // off-screen just to pin .cta-area at the very top ("scrolls to the wrong
    // spot"). Falls back to top-align only when the element is taller than the
    // available space (can't fit, so show its top).
    var bottomGap = (typeof opts.bottomGap === 'number')
      ? opts.bottomGap
      : (window.innerWidth <= 768 ? 24 : 16);
    var availTop = offset;
    var availBottom = viewportHeight - bottomGap;
    var curScroll = window.pageYOffset;
    if (rect.height > (availBottom - availTop)) {
      targetScrollTop = curScroll + rect.top - availTop;        // too tall → align its top
    } else if (rect.top < availTop) {
      targetScrollTop = curScroll + rect.top - availTop;        // top clipped → reveal from the top
    } else if (rect.bottom > availBottom) {
      targetScrollTop = curScroll + rect.bottom - availBottom;  // bottom clipped → reveal from the bottom
    } else {
      targetScrollTop = curScroll;                              // already fully visible → don't move
    }
  } else {
    targetScrollTop = window.pageYOffset + rect.top - offset;
  }
  targetScrollTop = Math.max(0, targetScrollTop);
  window.scrollTo({ top: Math.round(targetScrollTop), behavior: behavior });
}

/**
 * Store the original filename for a logo URL
 * @param {string} logoUrl - The logo URL
 * @param {string} originalFilename - The original filename from the file upload
 */
function storeOriginalLogoFilename(logoUrl, originalFilename) {
  if (!logoUrl || !originalFilename) return;
  
  // Normalize URL (remove query params, decode if needed)
  var normalizedUrl = String(logoUrl).split('?')[0];
  normalizedUrl = decodeURIComponent(normalizedUrl);
  
  // Store in cache (only if not already stored to preserve first upload)
  if (!window.logoFilenameCache[normalizedUrl] && originalFilename) {
    window.logoFilenameCache[normalizedUrl] = originalFilename;
  }
}

/**
 * Track user actions on bundle page
 */
function trackBundleUserAction(action, details) {
  window.bundleDebugTracker.userActions.push({
    action: action,
    timestamp: new Date().toISOString(),
    details: details || {}
  });
  mrkDebug.log('[Bundle User Action]', action, details);
}

/**
 * Generate comprehensive debug properties for bundle items
 */
function generateBundleDebugProperties(itemType, context) {
  context = context || {};
  if (!JRS_DEBUG_PROPERTIES_IN_CART) return {};
  if (window.bundleDebugTracker) window.bundleDebugTracker.addSequence = (window.bundleDebugTracker.addSequence || 0) + 1;
  var sessionId = (window.bundleDebugTracker && window.bundleDebugTracker.sessionId) || '';
  return {
    _debug_version: typeof JRS_BUILD_VERSION !== 'undefined' ? JRS_BUILD_VERSION : '7.0.0',
    _debug_build_date: '2026-08-20',
    _debug_session_id: sessionId,
    _debug_add_source: 'bundle_form',
    _debug_add_timestamp: new Date().toISOString(),
    _debug_theme: typeof JRS_THEME_NAME !== 'undefined' ? JRS_THEME_NAME : 'base'
  };
}

const moneyFormat = window.theme.moneyFormat;

let universalTimeValue = Date.now();
var customization = true;
if($('.mrk-direct-bundle-add').length)
var customization = false;

// ========== DEBUG: Page Initialization ==========

// Initialize bundle user journey tracker
if (!window.bundleUserJourney) {
  window.bundleUserJourney = {
    startTime: new Date().toISOString(),
    pageLoad: {
      timestamp: new Date().toISOString(),
      url: window.location.href,
      userAgent: navigator.userAgent,
      customizationEnabled: customization
    },
    interactions: [],
    stateChanges: [],
    errors: []
  };
}

// Max userActions to keep so _debug_user_actions (last 5) stays correct
var BUNDLE_USER_ACTIONS_CAP = 20;

// Function to track user interactions for bundle customization
function trackUserInteraction(type, details) {
  var ts = new Date().toISOString();
  var payload = { type: type, timestamp: ts, details: details || {} };
  if (window.bundleUserJourney && window.bundleUserJourney.interactions) {
    window.bundleUserJourney.interactions.push(payload);
  }
  // Populate _debug_user_actions on order (last 5 from bundleDebugTracker.userActions)
  if (window.bundleDebugTracker && window.bundleDebugTracker.userActions) {
    window.bundleDebugTracker.userActions.push({
      action: type,
      timestamp: ts,
      details: details || {}
    });
    if (window.bundleDebugTracker.userActions.length > BUNDLE_USER_ACTIONS_CAP) {
      window.bundleDebugTracker.userActions = window.bundleDebugTracker.userActions.slice(-BUNDLE_USER_ACTIONS_CAP);
    }
  }
}

// Global Logo ID cache helper functions (accessible throughout the bundle customization flow)
// Helper function to normalize bundle item names for cache keys
// This ensures consistency between different attribute sources (bundleitemName, productname, data-pro-name)
function normalizeBundleItemNameForCache(name) {
  if (!name) return '';
  return (name + '').trim().toLowerCase();
}

// Helper function to create consistent cache key
function createLogoIdCacheKey(bundleItemName, positionName, applicationMethod, logoType) {
  var normalizedBundleName = normalizeBundleItemNameForCache(bundleItemName);
  var normalizedPosition = (positionName || '').trim().toLowerCase();
  var normalizedAppMethod = (applicationMethod || 'Embroidery').trim().toLowerCase();
  var normalizedLogoType = (logoType || '').trim().toLowerCase();
  return normalizedBundleName + '|' + normalizedPosition + '|' + normalizedAppMethod + '|' + normalizedLogoType;
}

// CRITICAL FIX (Orders #52130, #52267): Shopify line item property values have a size limit.
// Large _bundle_debug_log (20KB–48KB) was not persisting to orders. Use a safe limit so the log is stored.
// 5000 chars is a safe limit; if full log fits, use it; otherwise persist a truncated summary.
var BUNDLE_DEBUG_LOG_MAX_CHARS = 5000;

function getPersistableDebugLog(debugLog) {
  if (!debugLog) return '';
  var full = JSON.stringify(debugLog);
  if (full.length <= BUNDLE_DEBUG_LOG_MAX_CHARS) return full;
  var steps = debugLog.steps || [];
  var errors = debugLog.errors || [];
  var warnings = debugLog.warnings || [];
  // Order #52352: Preserve logo/URL-related warnings when truncating
  function isLogoRelated(w) {
    var msg = (w && w.message) ? String(w.message) : '';
    var details = (w && w.details) ? JSON.stringify(w.details) : '';
    var combined = (msg + ' ' + details).toLowerCase();
    return combined.indexOf('logo') !== -1 || combined.indexOf('url') !== -1;
  }
  var criticalWarnings = warnings.filter(isLogoRelated);
  var otherWarnings = warnings.filter(function(w) { return !isLogoRelated(w); });
  var mergedWarnings = criticalWarnings.concat(otherWarnings);
  var lastSteps = steps.slice(-20);
  var summary = {
    version: debugLog.version || '7.0.0',
    buildVersion: debugLog.buildVersion || (typeof JRS_BUILD_VERSION !== 'undefined' ? JRS_BUILD_VERSION : 'unknown'),
    theme: debugLog.theme || 'base',
    themeVersion: debugLog.themeVersion || (typeof JRS_BUILD_DATE !== 'undefined' ? JRS_BUILD_DATE : '2026-07-08'),
    timestamp: debugLog.timestamp || new Date().toISOString(),
    truncated: true,
    fullStepsCount: steps.length,
    fullWarningsCount: warnings.length,
    fullErrorsCount: errors.length,
    lastSteps: lastSteps,
    errors: errors,
    warnings: mergedWarnings.slice(0, 15),
    note: 'Log truncated to fit order property limit (' + full.length + ' chars). Last ' + lastSteps.length + ' steps + all errors + logo-related warnings.'
  };
  var str = JSON.stringify(summary);
  // Orders #55910, #55911, #55912 (Bug E): Preserve ALL warnings at every truncation level
  if (str.length > BUNDLE_DEBUG_LOG_MAX_CHARS) {
    summary.lastSteps = steps.slice(-10);
    summary.warnings = warnings;
    summary.note = 'Log heavily truncated. Full had ' + steps.length + ' steps. Last 10 steps + all errors + all warnings.';
    str = JSON.stringify(summary);
  }
  if (str.length > BUNDLE_DEBUG_LOG_MAX_CHARS) {
    summary.lastSteps = steps.slice(-5);
    summary.warnings = warnings;
    summary.note = 'Minimal log. Full had ' + steps.length + ' steps. Last 5 steps + all errors + all warnings.';
    str = JSON.stringify(summary);
  }
  return str;
}

// Global debug helper functions (accessible throughout the bundle customization flow)
function addDebugStep(step, status, details) {
  if (window.bundleDebugLog && window.bundleDebugLog.steps) {
    window.bundleDebugLog.steps.push({
      step: step,
      status: status,
      details: details || {},
      time: new Date().toISOString()
    });
  }
}

function addDebugWarning(message, details) {
  if (window.bundleDebugLog && window.bundleDebugLog.warnings) {
    window.bundleDebugLog.warnings.push({
      message: message,
      details: details || {},
      time: new Date().toISOString()
    });
  }
}

function addDebugError(message, details) {
  if (window.bundleDebugLog && window.bundleDebugLog.errors) {
    window.bundleDebugLog.errors.push({
      message: message,
      details: details || {},
      time: new Date().toISOString()
    });
  }
}

$(document).ready(function() {
    $('.go-to-item').on('click', function() {
        var id = $(this).attr('id');
        var bundleItemName = $(this).find('.bundle__build-item-title').text().trim() || 'Unknown';
        var previousActiveId = $('.bundle__build-item--active').attr('id') || 'none';
        
        // Track navigation between bundle items
        trackUserInteraction('bundle_item_navigated', {
          bundleItemId: id,
          bundleItemName: bundleItemName,
          previousActive: previousActiveId
        });
        
        // 5d. Category transition state snapshot
        if (window.bundleDebugLog && previousActiveId !== 'none' && previousActiveId !== id) {
          try {
            var prevBundleSteps = $('[mrk-bundle-products="' + previousActiveId + '"]');
            var prevPositions = prevBundleSteps.find('.mrk-logo-inputs:checked');
            var prevState = [];
            prevPositions.each(function() {
              var posName = $(this).attr('data-position-name') || $(this).val();
              prevState.push({
                name: posName,
                logoId: $(this).attr('data-logo-id') || 'not_set',
                hasHiddenFields: $('.mrk-hidden-field-item').length
              });
            });
            window.bundleDebugLog.steps.push({
              step: 'category_transition',
              status: 'success',
              details: {
                fromCategory: previousActiveId,
                toCategory: id,
                toCategoryName: bundleItemName,
                previousCategoryState: {
                  positionCount: prevPositions.length,
                  positions: prevState
                },
                hiddenFieldsCount: $('.mrk-hidden-field-item').length,
                cacheSize: window.bundleLogoIdCache ? Object.keys(window.bundleLogoIdCache).length : 0,
                note: 'Verify Logo IDs and URLs persist after transition'
              },
              time: new Date().toISOString()
            });
          } catch(e) { /* debug should not break navigation */ }
        }
        
        $('.go-to-item').removeClass('bundle__build-item--active');
        $(this).addClass('bundle__build-item--active');
        $('.bundle_inside_wrap').removeClass('mx_active');
        $('.mrk-bundle-products-items').removeClass('mrk-bundle-active');
        $(`[mrk-bundle-products=${id}]`).addClass('mrk-bundle-active');
        $(`[mrk-bundle-products=${id}]`).closest('.bundle_inside_wrap').addClass('mx_active');
        updateNextPrevButton();
        scrollBundleElementIntoView($(`[mrk-bundle-products=${id}]`)[0], { behavior: "smooth", block: "start" });
        // $('html, body').animate({
        //     scrollTop: $(`[mrk-bundle-products=${id}]`).offset().top
        // }, 200); 
    });

    // New bundle selector: accordion categories
    $(document).on('click', '.bundle-selector .category__header', function() {
        var $cat = $(this).closest('.category');
        var isExpanded = $cat.hasClass('category--expanded');
        var stepNum = parseInt($cat.attr('data-category-index') || '1', 10);
        if (!isExpanded && typeof jrsPDPTrack === 'function' && window.jrsProductId) {
            try {
                if (!window.jrsConfiguratorStarted) {
                    window.jrsConfiguratorStarted = true;
                    jrsPDPTrack('pdp_configurator_start', {
                        product_id: window.jrsProductId,
                        bundle_type_count: window.jrsBundleTypeCount || 0,
                        team_size: window.jrsTeamSize != null ? String(window.jrsTeamSize) : '',
                        device_type: typeof jrsDeviceType === 'function' ? jrsDeviceType() : (window.innerWidth <= 768 ? 'mobile' : 'desktop')
                    });
                }
                jrsPDPTrack('pdp_configurator_step_interact', {
                    product_id: window.jrsProductId,
                    step_number: stepNum,
                    step_label: 'type_' + stepNum,
                    selected_value: $cat.find('.category__name').text() || ('type_' + stepNum),
                    device_type: typeof jrsDeviceType === 'function' ? jrsDeviceType() : (window.innerWidth <= 768 ? 'mobile' : 'desktop')
                });
            } catch (e) { console.warn('GA4 configurator track error', e); }
        }
        $('.bundle-selector .category').removeClass('category--active').removeClass('category--expanded');
        $('.bundle-selector .category__body').hide();
        if (!isExpanded) {
            $cat.addClass('category--expanded category--active');
            $cat.find('.category__body').show();
            $cat.find('.category__header').attr('aria-expanded', 'true');
            scrollBundleElementIntoView($cat[0], { behavior: 'smooth', block: 'start' });
            trackUserInteraction('category_expanded', { categoryIndex: stepNum, categoryName: ($cat.find('.category__name').text() || '').trim() });
        } else {
            $cat.find('.category__header').attr('aria-expanded', 'false');
            trackUserInteraction('category_collapsed', { categoryIndex: stepNum, categoryName: ($cat.find('.category__name').text() || '').trim() });
        }
        $('.bundle-selector .category').not($cat).find('.category__header').attr('aria-expanded', 'false');
        updateNextPrevButton();
    });

    $('.mixmatch-open').on('click', function() {
        var $clicked = $(this);
        var isMobile = window.innerWidth <= 768;
        var wasActive = $clicked.hasClass('active');
        if (!wasActive && typeof jrsPDPTrack === 'function' && window.jrsProductId) {
            try {
                if (!window.jrsConfiguratorStarted) {
                    window.jrsConfiguratorStarted = true;
                    jrsPDPTrack('pdp_configurator_start', {
                        product_id: window.jrsProductId,
                        bundle_type_count: window.jrsBundleTypeCount || 0,
                        team_size: window.jrsTeamSize != null ? String(window.jrsTeamSize) : '',
                        device_type: isMobile ? 'mobile' : 'desktop'
                    });
                }
            } catch (e) { console.warn('GA4 configurator start error', e); }
        }

        // On mobile: only one open at a time — close others before opening this one
        if (isMobile && !wasActive) {
            $('.bundle-selector .mixmatch-open.active').not($clicked).each(function() {
                var $other = $(this);
                $other.removeClass('active');
                $other.closest('.bundle__details').removeClass('bundle__details--open');
                $other.closest('.bundle__details').find('.bundle__details-inner').slideUp('fast');
            });
        }

        // Toggling the 'active' class on the clicked element
        $clicked.toggleClass('active');

        // Toggling the 'bundle__details--open' class on its parent '.bundle__details'
        $clicked.closest('.bundle__details').toggleClass('bundle__details--open');

        // Slide toggle on the nearest '.bundle__details-inner'
        $clicked.parents('.bundle__details').find('.bundle__details-inner').slideToggle('fast');

        // On mobile: when opening, scroll row into view with offset so it's not behind sticky header
        if (isMobile && !wasActive && typeof scrollBundleElementIntoView === 'function') {
            setTimeout(function() {
                scrollBundleElementIntoView($clicked[0], { behavior: 'smooth', block: 'start' });
            }, 150);
        }

        // Update bottom remaining banner: only visible when a row is open and category not complete
        var $items = $clicked.closest('.mrk-bundle-products-items');
        if ($items.length) {
            var hasOpen = $items.find('.bundle__details--open').length > 0;
            var topVisible = $items.find('.remaining-banner--top').is(':visible');
            $items.find('.remaining-banner--bottom').toggle(hasOpen && topVisible);
        }
        // Update category body hint (hide when any row is open)
        if (typeof upDateTotals === 'function') upDateTotals();
        trackUserInteraction('category_section_toggled', { open: !wasActive, categoryId: ($clicked.closest('.bundle__details').attr('id') || $clicked.closest('.bundle__details-inner').length ? 'row' : '') || 'section' });
    });

    // Colour block image: click to view larger (lightbox) — show loader until image loads
    function openBundleColourImageModal(src, alt) {
        if (!src) return;
        trackUserInteraction('colour_zoom_opened', { srcLength: (src + '').length, alt: (alt || '').substring(0, 80) });
        var $modal = $('#bundle-colour-image-modal');
        var $img = $modal.find('.bundle-colour-image-modal__img');
        var $loader = $modal.find('.bundle-colour-image-modal__loader');
        $img.removeClass('is-loaded').attr('src', '').attr('alt', alt || '');
        $loader.removeClass('is-hidden');
        $modal.addClass('is-loading').removeAttr('hidden').css('display', '');
        $('body').addClass('bundle-colour-modal-open');
        $img.attr('src', src).attr('alt', alt || '');
        function onImageLoad() {
            $modal.removeClass('is-loading');
            $loader.addClass('is-hidden');
            $img.addClass('is-loaded');
            // Detailed zoom (shared JRS.ImageZoom): pinch / double-tap / wheel /
            // pan on the enlarged colour image, same behaviour as the PDP
            // gallery lightbox. Re-attached per open (src changes between
            // colours); destroyed on close so transforms never leak.
            if (window.JRS && window.JRS.ImageZoom) {
                var modalEl = $modal[0];
                var contentEl = modalEl ? modalEl.querySelector('.bundle-colour-image-modal__content') : null;
                if (modalEl && modalEl._jrsZoom) { modalEl._jrsZoom.destroy(); modalEl._jrsZoom = null; }
                if (contentEl && $img[0]) {
                    modalEl._jrsZoom = window.JRS.ImageZoom.attach(contentEl, $img[0], {
                        // clip:false — the modal's close button overhangs the
                        // content box (top:-40px); overflow:hidden would clip
                        // it away. The button carries z-index in
                        // bundle-selector.css so the zoomed image stays under it.
                        clip: false,
                        hint: window.JRS.ImageZoom.defaultHint(),
                        onZoom: function (type) {
                            trackUserInteraction('colour_zoom_used', { zoom_type: type });
                        }
                    });
                }
            }
        }
        if ($img[0].complete && $img[0].naturalWidth) {
            onImageLoad();
        } else {
            $img.one('load', onImageLoad);
            $img.one('error', function() {
                $modal.removeClass('is-loading');
                $loader.addClass('is-hidden');
            });
        }
    }
    $(document).on('click', '.bundle-selector .colour-block-header__img--zoom', function(e) {
        var $btn = $(this);
        var src = $btn.data('full-img');
        if (!src) return;
        e.preventDefault();
        openBundleColourImageModal(src, $btn.find('img').attr('alt') || '');
    });
    $(document).on('click', '.bundle-selector .colour-block-header__zoom-link', function(e) {
        e.preventDefault();
        var fullImg = $(this).data('full-img');
        if (fullImg) {
            e.stopPropagation();
            var alt = $(this).closest('.image').find('img').attr('alt') || '';
            openBundleColourImageModal(fullImg, alt);
        } else {
            $(this).closest('.colour-block-header').find('.colour-block-header__img--zoom').trigger('click');
        }
    });
    // Shared close path so the zoom controller is always torn down with the modal.
    function closeBundleColourImageModal(method) {
        trackUserInteraction('colour_zoom_closed', { method: method });
        var $modal = $('#bundle-colour-image-modal');
        var modalEl = $modal[0];
        if (modalEl && modalEl._jrsZoom) { modalEl._jrsZoom.destroy(); modalEl._jrsZoom = null; }
        $modal.removeClass('is-loading').attr('hidden', true).css('display', 'none');
        $('body').removeClass('bundle-colour-modal-open');
    }
    $(document).on('click', '.bundle-selector .bundle-colour-image-modal__backdrop, .bundle-selector .bundle-colour-image-modal__close', function() {
        closeBundleColourImageModal('click');
    });
    $(document).on('keydown', function(e) {
        if (e.key === 'Escape' && $('#bundle-colour-image-modal').attr('hidden') !== 'hidden') {
            closeBundleColourImageModal('escape');
        }
    });

    function formatState (state) {
        if (!state.id) {
          return state.text;
        }
      
        var color = $(state.element).data('color');
        var $state = $(
          '<span class="detail__swatch">' +
            '<span class="detail__colour-swatch">' +
              '<span style="background: ' + color + ';"></span>' +
            '</span>' +
            '<span class="detail__text">' + state.text + '</span>' +
          '</span>'
        );
        
        return $state;
      };
      
    $('.mrk-color-picker').select2({
        templateResult: formatState,
        templateSelection: formatState,
        placeholder: "Select Colors"
    });
    $('.mrk-color-picker').on('select2:select select2:unselect', function(e) {
        var bundleItemName = $(this).closest('.mrk-bundle-products-items').attr('bundleitemName');
        var bundleIndex = $(this).closest('.mrk-bundle-products-items').attr('bundleitem');
        var selectedOptions = $(this).val();
        if (e.params && e.params.data && typeof jrsPDPTrack === 'function' && window.jrsProductId) {
            try {
                var stepNum = (parseInt(bundleIndex, 10) || 0) + 1;
                var opt = e.params.data;
                var colourName = (opt.text || '').trim();
                var colourHex = $(opt.element).attr('data-color') || '';
                jrsPDPTrack('pdp_configurator_colour_select', {
                    product_id: window.jrsProductId,
                    step_number: stepNum,
                    colour_name: colourName,
                    colour_hex: colourHex,
                    device_type: typeof jrsDeviceType === 'function' ? jrsDeviceType() : (window.innerWidth <= 768 ? 'mobile' : 'desktop')
                });
            } catch (err) { console.warn('GA4 colour select track error', err); }
        }

        
        trackUserInteraction('color_selected', {
          bundleItem: bundleItemName,
          bundleIndex: bundleIndex,
          selectedColors: selectedOptions,
          colorCount: selectedOptions ? selectedOptions.length : 0,
          eventType: e.type
        });
        
        if (selectedOptions.length > 0) {
            $(this).parents('.bundle__details-inner').find('.bundle__colour-hint').addClass('hide-no-colours');
            $(this).parents('.mrk-bundle-products-items').find('.mrk-selected-qty-text').show();

            let refEl = $(this)
            setTimeout(function(){
              updateBundleImage(refEl)
            }, 1000)
        } else {
            $(this).parents('.bundle__details-inner').find('.bundle__colour-hint').removeClass('hide-no-colours');
            $(this).parents('.mrk-bundle-products-items').find('.mrk-selected-qty-text').hide();

            let refEl = $(this)
            setTimeout(function(){
              updateBundleImage(refEl)
            }, 1000)
        }
      
        renderData($(this));
        updateSizeGuideTables2()
    });
    if ($('.bundle-selector').length) {
        upDateTotals();
        initBundleColourChips();
    }
});


function updateBundleImage(element) {
  var parentEl = element.parents('.bundle__details');
  var bundelItemImageEl = parentEl.find('img.bundle__item-featured-image');
  var bundelItemImageSrc = bundelItemImageEl.attr('data-native-img-url');
  var newColorImageSrc = parentEl.find('.bundle__colour-option').first().attr('data-featured-img-url');
  if (bundelItemImageEl && bundelItemImageEl.length && newColorImageSrc) {
    bundelItemImageEl.attr('src', newColorImageSrc);
  } else if (bundelItemImageEl && bundelItemImageEl.length && bundelItemImageSrc) {
    bundelItemImageEl.attr('src', bundelItemImageSrc);
  }
}

var COLOUR_GRID_INITIAL_COUNT = 10;
var COLOUR_GRID_STORAGE_KEY = 'bundleColourGridExpanded';

function buildColourChipsForDetail($detailInner) {
  var $select = $detailInner.find('.mrk-color-picker');
  var $grid = $detailInner.find('.colour-grid[data-colour-grid]');
  if (!$select.length || !$grid.length) return;
  $grid.removeClass('colour-grid--expanded');
  $detailInner.find('.colour-section__show-more-wrap').remove();
  $grid.empty();
  var $options = $select.find('option');
  // Popularity ordering (shared utility from jrs-colour-order.liquid). The DOM
  // <option>s are re-appended in sorted order so chips, the select2 dropdown
  // and the >250-variant JS-appended overflow colours all share one order
  // (this runs again after the overflow injection at hydrateBundleColourList).
  if (typeof window.jrsSortColours === 'function' && $options.length > 1) {
    var sortedOpts = window.jrsSortColours($options.get(), function (o) { return $(o).text(); });
    $.each(sortedOpts, function (_, el) { $select.append(el); });
    $options = $select.find('option');
  }
  var total = $options.length;
  $detailInner.find('.colour-section__total-num').text(total);
  var sectionId = $detailInner.closest('[data-section-id]').attr('data-section-id') || 'default';
  var storageKey = COLOUR_GRID_STORAGE_KEY + '-' + sectionId;
  var wasExpanded = false;
  try {
    wasExpanded = window.sessionStorage.getItem(storageKey) === 'true';
  } catch (e) {}
  $options.each(function(index) {
    var val = $(this).attr('value') || $(this).val();
    var label = $(this).text();
    var hex = $(this).attr('data-color') || '#ccc';
    var $chip = $('<div class="colour-chip">' +
      '<span class="colour-chip__dot" style="background:' + hex + '"></span>' +
      '<span class="colour-chip__name"></span>' +
      '<span class="colour-chip__check"><svg width="12" height="12" viewBox="0 0 12 12" fill="none"><path d="M2.5 6l2.5 2.5 4.5-5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></span>' +
      '</div>');
    $chip.attr('data-value', val);
    $chip.find('.colour-chip__name').text(label);
    if (index >= COLOUR_GRID_INITIAL_COUNT && !wasExpanded) {
      $chip.addClass('colour-chip--hidden');
    }
    $chip.on('click', function() {
      var chipVal = $(this).attr('data-value');
      var selected = ($select.val() || []).slice();
      var idx = selected.indexOf(chipVal);
      if (idx >= 0) {
        selected.splice(idx, 1);
      } else {
        selected.push(chipVal);
      }
      $select.val(selected);
      $select.trigger('select2:select');
    });
    $grid.append($chip);
  });
  if (total > COLOUR_GRID_INITIAL_COUNT) {
    var hiddenCount = total - COLOUR_GRID_INITIAL_COUNT;
    var $wrap = $('<div class="colour-section__show-more-wrap"></div>');
    var $btn = $('<button type="button" class="show-more-btn" data-colour-show-more></button>');
    function updateButtonText(expanded) {
      $btn.text(expanded ? 'Show fewer colours ↑' : '+' + hiddenCount + ' more colours ↓');
    }
    if (wasExpanded) {
      $grid.addClass('colour-grid--expanded');
      $detailInner.find('.colour-chip--hidden').removeClass('colour-chip--hidden');
      updateButtonText(true);
    } else {
      updateButtonText(false);
    }
    $btn.on('click', function() {
      var expanded = $grid.hasClass('colour-grid--expanded');
      if (expanded) {
        $grid.removeClass('colour-grid--expanded');
        $detailInner.find('.colour-chip').each(function(i) {
          if (i >= COLOUR_GRID_INITIAL_COUNT) $(this).addClass('colour-chip--hidden');
        });
        updateButtonText(false);
        try { window.sessionStorage.setItem(storageKey, 'false'); } catch (e) {}
      } else {
        $grid.addClass('colour-grid--expanded');
        $detailInner.find('.colour-chip--hidden').removeClass('colour-chip--hidden');
        updateButtonText(true);
        try { window.sessionStorage.setItem(storageKey, 'true'); } catch (e) {}
      }
    });
    $wrap.append($btn);
    $grid.after($wrap);
  }
  syncColourChipsAndCount($detailInner);
}

function syncColourChipsAndCount($detailInner) {
  var $select = $detailInner.find('.mrk-color-picker');
  var $num = $detailInner.find('.colour-section__selected-num');
  if (!$select.length || !$num.length) return;
  var selected = $select.val() || [];
  $num.text(selected.length);
  $detailInner.find('.colour-chip').each(function() {
    var val = $(this).attr('data-value');
    $(this).toggleClass('colour-chip--selected', selected.indexOf(val) >= 0);
  });
  var $hint = $detailInner.find('.bundle__colour-hint');
  if ($hint.length) {
    $hint.toggleClass('hide-no-colours', selected.length > 0);
  }
}

// Patches in colour <option> entries that the server-rendered Liquid loop missed
// because of Shopify's 250-variant cap on bundleItem.variants. Uses the same
// JRS.BundleSizeGrid.fetchProduct GraphQL helper that powers the per-colour size grid.
function hydrateBundleColourListFromGraphQL($detailInner) {
  var helper = window.JRS && window.JRS.BundleSizeGrid && window.JRS.BundleSizeGrid.fetchProduct;
  if (typeof helper !== 'function') return;
  var $select = $detailInner.find('.mrk-color-picker');
  if (!$select.length) return;
  var handle = $detailInner.find('[data-jrs-colour-select]').attr('data-product-handle')
    || $detailInner.closest('.bundle__details').attr('data-product-handle');
  if (!handle) return;

  helper(handle).then(function(product) {
    if (!product || !Array.isArray(product.variants)) return;
    var optionNames = product.options || [];
    var ci = -1;
    for (var i = 0; i < optionNames.length; i++) {
      if (/^col[ou]r$/i.test(String(optionNames[i] || ''))) { ci = i; break; }
    }
    if (ci < 0) return;

    var existing = {};
    $select.find('option').each(function() {
      var v = $(this).attr('value');
      if (v != null) existing[v] = true;
    });

    // First-variant-per-colour map — used to build varianturl below. The bundle
    // size-grid AJAX flow at line ~8764 reads $(option).attr('varianturl') and
    // GETs `${varianturl}&view=bundleSizes`. Without this attribute the request
    // becomes /products/undefined&view=bundleSizes -> 404.
    var firstVariantByColor = {};
    var ordered = [];
    for (var k = 0; k < product.variants.length; k++) {
      var v = product.variants[k];
      var name = (v.options && v.options[ci]) || v.option1 || '';
      if (!name) continue;
      if (firstVariantByColor[name]) continue;
      firstVariantByColor[name] = v;
      ordered.push(name);
    }

    var hexMap = window.JRS_COLOUR_HEX_MAP || {};
    var added = 0;
    for (var j = 0; j < ordered.length; j++) {
      var name2 = ordered[j];
      if (existing[name2]) continue;
      var hex = hexMap[name2] || hexMap[name2.toLowerCase()] || '#999';
      var firstV = firstVariantByColor[name2];
      var varianturl = '/products/' + encodeURIComponent(handle) + '?variant=' + firstV.id;
      var varianttitle = name2 + ' / ' + (firstV.options && firstV.options[ci === 0 ? 1 : 0] || '');
      $select.append(
        $('<option></option>')
          .attr('value', name2)
          .attr('data-color', hex)
          .attr('varianturl', varianturl)
          .attr('varianttitle', varianttitle)
          .text(name2)
      );
      added++;
    }
    if (!added) return;

    buildColourChipsForDetail($detailInner);
    var total = $select.find('option').length;
    $detailInner.closest('.bundle__details').find('.a-row__colour-count').text(total + ' colours');
    // Force select2 to reread the options so newly-added colours are searchable.
    try { $select.trigger('change.select2'); } catch (e) {}
  }).catch(function() { /* keep server-rendered fallback on error */ });
}

function initBundleColourChips() {
  if (!$('.bundle-selector').length) return;
  $('.bundle-selector .bundle__details-inner').each(function() {
    var $inner = $(this);
    buildColourChipsForDetail($inner);
    hydrateBundleColourListFromGraphQL($inner);
  });
  $('.bundle-selector .mrk-color-picker').on('select2:select select2:unselect', function() {
    var $inner = $(this).closest('.bundle__details-inner');
    syncColourChipsAndCount($inner);
  });
}


function formatMoney(cents, format) {
  if (typeof cents === 'string') {
    cents = cents.replace('.', '');
  }
  let value = '';
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  const formatString = format || moneyFormat;

  function formatWithDelimiters(
    number,
    precision = 2,
    thousands = ',',
    decimal = '.'
  ) {
    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    const parts = number.split('.');
    const dollarsAmount = parts[0].replace(
      /(\d)(?=(\d\d\d)+(?!\d))/g,
      `$1${thousands}`
    );
    const centsAmount = parts[1] ? decimal + parts[1] : '';

    return dollarsAmount + centsAmount;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_single':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
}

function preparePreview(file,container) {
  // Reset potential changes from previous uploads
  $(container).find('.mrk-progress').show();
  $(container).find('.mrk-upload').css('width', '0%');
  $(container).find('.mrk-error-message span').text('');

  // Display the file name and show the preview
  $(container).find('.mrk-filename span[data-mrk-name]').text(file.name);
  $(container).find('.preview-template').show();
}

function uploadFile(file,container) {
  var formData = new FormData();
  // Sanitize filename: prefix with 'logo_' + timestamp to avoid server rejection
  // for filenames starting with digits or containing patterns like _480x
  var ext = file.name.lastIndexOf('.') !== -1 ? file.name.substring(file.name.lastIndexOf('.')) : '';
  var baseName = file.name.lastIndexOf('.') !== -1 ? file.name.substring(0, file.name.lastIndexOf('.')) : file.name;
  var sanitizedName = 'logo_' + Date.now() + '_' + baseName.replace(/[^a-zA-Z0-9_-]/g, '_') + ext;
  formData.append('file', file, sanitizedName);

  $.ajax({
      url: 'https://jrsindustrial-files.com',
      type: 'POST',
      data: formData,
      cache: false,
      contentType: false,
      processData: false,
      beforeSend: function(){
        $('.mrk-steps-footer').addClass('loading');
      },
      xhr: function() {
          var xhr = new XMLHttpRequest();
          xhr.upload.addEventListener("progress", function(e) {
              if (e.lengthComputable) {
                  var percentComplete = (e.loaded / e.total) * 100;
                  $(container).find('.mrk-upload').css('width', percentComplete + '%');
              }
          });
          return xhr;
      },
      success: function(response) {
          // response = JSON.parse(response);
          var url = 'https://jrsindustrial-files.com/' + response.filePath;
          $(container).find('.mrk-image img').attr('src', url);  // Set the image source
          $(container).find('.input-file-logo').val(url);
          $(container).find('.mrk-progress').hide(); // Hide the progress bar on success
          
          // Track logo upload success
          var positionName = $(container).closest('.bundle_product_steps').find('.mrk-logo-inputs:checked').attr('data-position-name') || 'Unknown';
          var bundleItem = $(container).closest('.bundle_product_steps').attr('data-pro') || 'Unknown';
          
          // CRITICAL FIX: Generate and store logo ID on the checkbox when logo is uploaded
          // This ensures logo IDs are available even if hidden fields are cleared later
          var $positionCheckbox = $(container).closest('.bundle_product_steps').find('.mrk-logo-inputs:checked');
          if ($positionCheckbox.length > 0 && !$positionCheckbox.attr('data-logo-id')) {
            // Generate logo ID and store it on the checkbox for later retrieval
            var logoId = String(Math.floor(Math.random() * (999998 + 1)));
            $positionCheckbox.attr('data-logo-id', logoId);
            
            // Also store in sessionStorage for persistence across page interactions
            try {
              var sessionKey = 'logoId_' + bundleItem + '_' + positionName + '_' + 
                ($positionCheckbox.closest('.bundle_product_steps').find('.application-method-container input[type="radio"]:checked').val() || 'Embroidery') + '_' +
                ($positionCheckbox.closest('.bundle_product_steps').find('.bundle_pro_logo_style input[type="radio"]:checked').val() || 'Upload Your Logo');
              sessionStorage.setItem(sessionKey, logoId.toString());
            } catch(e) {
              // sessionStorage might not be available
            }
            
            // Store in shared cache if available
            if (window.bundleLogoIdCache) {
              var cacheKey = createLogoIdCacheKey(
                bundleItem,
                positionName,
                $positionCheckbox.closest('.bundle_product_steps').find('.application-method-container input[type="radio"]:checked').val() || 'Embroidery',
                $positionCheckbox.closest('.bundle_product_steps').find('.bundle_pro_logo_style input[type="radio"]:checked').val() || 'Upload Your Logo'
              );
              window.bundleLogoIdCache[cacheKey] = logoId;
            }
          }
          
          trackUserInteraction('logo_uploaded', {
            success: true,
            url: url,
            fileName: file.name,
            fileSize: file.size,
            fileType: file.type,
            position: positionName,
            bundleItem: bundleItem,
            uploadTime: new Date().toISOString()
          });
          
          // Store original filename in global cache for reuse
          if (file && file.name) {
            storeOriginalLogoFilename(url, file.name);
          }
          
          //Ak custom code
          $(container).find('.mrk-success-message').css('display','block');
          $('.mrk-steps-footer .mrk-steps-footer-next-buttons-container .next-bundle-inner').removeClass('disabled');
          $(container).find('button.next-inner').removeClass('disabled');
          //End Ak custom code
          $('.mrk-steps-footer').removeClass('loading');
          $('.mrk-steps-footer').removeClass('mrk-disable-btn');
      },
      error: function(jqXHR, textStatus, errorThrown) {
        var statusCode = jqXHR ? jqXHR.status : 'unknown';
        var responseBody = '';
        try { responseBody = jqXHR ? jqXHR.responseText || jqXHR.responseJSON : ''; } catch(re) {}
        mrkDebug.error('[Bundle] Logo upload failed (details):', {
            fileName: file ? file.name : 'Unknown',
            textStatus: textStatus,
            errorThrown: errorThrown,
            httpStatus: statusCode,
            responseBody: responseBody ? (responseBody.substring ? responseBody.substring(0, 200) : JSON.stringify(responseBody).substring(0, 200)) : ''
        });
        var errorMsg = 'Upload error: ' + textStatus;
        if (statusCode && statusCode !== 'unknown') errorMsg += ' (HTTP ' + statusCode + ')';
        if (errorThrown) errorMsg += ' - ' + errorThrown;
        $(container).find('.mrk-error-message span').text(errorMsg);
        $(container).find('.mrk-progress').hide(); // Hide the progress bar on error
        
        // Track logo upload error
        var positionName = $(container).closest('.bundle_product_steps').find('.mrk-logo-inputs:checked').attr('data-position-name') || 'Unknown';
        var bundleItem = $(container).closest('.bundle_product_steps').attr('data-pro') || 'Unknown';
        trackUserInteraction('logo_upload_failed', {
          success: false,
          fileName: file.name,
          fileSize: file.size,
          fileType: file.type,
          position: positionName,
          bundleItem: bundleItem,
          error: textStatus,
          errorThrown: errorThrown,
          uploadTime: new Date().toISOString()
        });
        
        mrkDebug.error('[Bundle] Logo upload failed:', {
          fileName: file.name,
          error: textStatus,
          errorThrown: errorThrown
        });
      }
  });
}
// customizer steps
function calculatePrice(){
  var sizes = $('.mrk-qty-item'),totalPrice = 0;
  const positions = $('.mrk-logo-inputs:checked');
  const isEmbroidery = $('[name="application-type"]:checked').val() == 'Embroidery' ? true:false;
  const positionsPrice = getAllPositionsPrice(isEmbroidery,positions);
  const logoTypePrice = Number($('[name="logo-type"]:checked').attr('price')) || 0;
    var qty = 1;
    var price = 0;
    if(qty>0){
    var variantPrice = window.bundlePrice;
    var price = positionsPrice;
    var finalPrice = (price*qty) + (variantPrice * qty) + logoTypePrice;
    totalPrice = totalPrice + finalPrice;
    }
  $('.mrk-final-price').html(formatMoney(totalPrice));
}
function getAllPositionsPrice(isEmbroidery,positions){
  var priceTotal = 0,price;
  positions.each(function(){
    if(isEmbroidery){
      price = Number($(this).data('embroideryprice'));
    }else{
      price = Number($(this).data('printprice'));
    }
    priceTotal = priceTotal + price;
  })
  return priceTotal;
}
function positionsData(){
  positionData = [];
  
  // Try to read from hidden fields
  $('.mrk-hidden-field-item').each(function() {
    try {
      var htmlContent = $(this).html();
      if (htmlContent && htmlContent.trim() !== '') {
        var parsed = JSON.parse(htmlContent);
        positionData.push(parsed);
      }
    } catch(e) {
    }
  });
  
  // If no hidden fields found, try to recover from sessionStorage
  if (positionData.length === 0) {
    try {
      var stored = JSON.parse(sessionStorage.getItem('bundle_positions') || '[]');
      if (stored.length > 0) {
        stored.forEach(function(item) {
          if (item.properties) {
            positionData.push(item.properties);
          }
        });
      }
    } catch(e) {
    }
  }
  
  return positionData;
}
function getAllPositionsVariants(mainVariant){
  var allPositionsItem = [], positionsDataArray = positionsData();
  var ParentVariantId = window.bundleId;
  
  // CRITICAL FIX: Track processed positions to prevent duplicates
  // This prevents the same position from being added multiple times
  var processedPositionVariants = new Map();
  
  // CRITICAL FIX: Extract Logo IDs from _bundle_raw if available
  // This ensures Logo IDs match what's stored in _bundle_raw
  var bundleRawLogoIds = {};
  if (mainVariant && mainVariant.properties && mainVariant.properties._bundle_raw) {
    try {
      var bundleRaw = mainVariant.properties._bundle_raw;
      if (typeof bundleRaw === 'string') {
        bundleRaw = JSON.parse(bundleRaw);
      }
      
      if (bundleRaw && typeof bundleRaw === 'object') {
        var bundleItemsToProcess = Array.isArray(bundleRaw) ? bundleRaw : Object.keys(bundleRaw).map(function(key) {
          return bundleRaw[key];
        });
        
        bundleItemsToProcess.forEach(function(bItem) {
          if (bItem && bItem.positions) {
            var positionsArray = Array.isArray(bItem.positions) 
              ? bItem.positions 
              : Object.keys(bItem.positions).map(function(key) {
                  return bItem.positions[key];
                });
            
            positionsArray.forEach(function(pos) {
              if (pos && pos.name && pos['Logo Id']) {
                var cacheKey = createLogoIdCacheKey(bItem.name, pos.name, pos['Application Method'] || 'Embroidery', pos.logo_type || '');
                bundleRawLogoIds[cacheKey] = pos['Logo Id'];
                
                // Also store in shared cache if not already there
                if (window.bundleLogoIdCache && !window.bundleLogoIdCache[cacheKey]) {
                  window.bundleLogoIdCache[cacheKey] = pos['Logo Id'];
                }
              }
            });
          }
        });
        
        if (Object.keys(bundleRawLogoIds).length > 0 && window.bundleDebugLog) {
          addDebugStep('logoIds_extracted_from_bundle_raw_for_getAllPositionsVariants', 'success', {
            count: Object.keys(bundleRawLogoIds).length,
            logoIds: bundleRawLogoIds
          });
        }
      }
    } catch(e) {
      if (window.bundleDebugLog) {
        addDebugWarning('Failed to extract Logo IDs from _bundle_raw in getAllPositionsVariants', {
          error: e.message
        });
      }
    }
  }
  
  // Try to get positions from hidden fields first
  if (positionsDataArray && positionsDataArray.length > 0) {
  
  // ====================================================================
  // CRITICAL FIX: Missing Position Variants Bug (Order #51260)
  // ====================================================================
  // PROBLEM: When a bundle category has multiple positions (e.g., Polo Shirts
  // with 2 positions: Logo 732302 and Logo 494428), the code was only looking
  // for `Positions ${index + 1}` where index is the array index, not the
  // position group index. This caused only the first position group to be
  // processed, missing subsequent positions in the same hidden field.
  //
  // EXAMPLE BUG:
  // - Hidden field has: Positions 1, Positions 2, Positions 3
  // - Code only processes: Positions 1 (index 0 + 1)
  // - Missing: Positions 2 and Positions 3
  //
  // SOLUTION: Iterate through ALL position groups in EACH hidden field,
  // checking for Positions 1, Positions 2, Positions 3, etc. until we
  // find no more position groups.
  // ====================================================================
  
  positionsDataArray.forEach(function(positionData, dataIndex){
      // CRITICAL FIX: Check for ALL position groups in this hidden field
      // Don't just check Positions ${index + 1} - check Positions 1, 2, 3, etc.
      var positionGroupIndex = 1;
      var hasMorePositions = true;
      
      while (hasMorePositions) {
        var bundleItemPositions = positionData[`Positions ${positionGroupIndex}`];
        
        if (!bundleItemPositions || !Array.isArray(bundleItemPositions)) {
          // No more position groups found - stop checking
          hasMorePositions = false;
          break;
        }
        
        // Process all positions in this group
        bundleItemPositions.forEach(function(bundleProperty, posIndex){
        // Always use variantID (position variant: Print/Embroidery) for the line item
        // logoVariant is stored in properties but NOT used as the line item ID
        var variantID = bundleProperty.variantID;
        var id = Number(variantID);
        
        // Validate variant ID
        if (!id || id === 0 || isNaN(id)) {
            // variantID, 
            // bundleProperty
          // });
          return; // Skip invalid variant
        }
        
        var ParentVariantId = bundleProperty.ParentVariantId;
        
        // Validate parent variant ID
        if (!ParentVariantId || ParentVariantId === 0 || isNaN(Number(ParentVariantId))) {
          return; // Skip invalid parent
        }
        
        var property = bundleProperty.property; // Individual product name
        var qty = bundleProperty.qty || 1;
        var logo_id = bundleProperty.logoId;
        var logoIdSource = 'hidden_fields';
        
        // CRITICAL FIX: Get bundle category name (not individual product name) for cache lookup
        // Try to find bundle category name from _bundle_raw by matching product name
        var bundleCategoryName = property; // Default to property if not found
        if (mainVariant && mainVariant.properties && mainVariant.properties._bundle_raw) {
          try {
            var bundleRaw = mainVariant.properties._bundle_raw;
            if (typeof bundleRaw === 'string') {
              bundleRaw = JSON.parse(bundleRaw);
            }
            if (bundleRaw && typeof bundleRaw === 'object') {
              var bundleItemsToProcess = Array.isArray(bundleRaw) ? bundleRaw : Object.keys(bundleRaw).map(function(key) {
                return bundleRaw[key];
              });
              
              // Find bundle category that contains this product
              for (var bi = 0; bi < bundleItemsToProcess.length; bi++) {
                var bItem = bundleItemsToProcess[bi];
                if (bItem && bItem.products) {
                  var products = bItem.products;
                  var productKeys = Object.keys(products);
                  for (var pk = 0; pk < productKeys.length; pk++) {
                    var product = products[productKeys[pk]];
                    if (product && product.name && product.name.trim().toLowerCase() === property.trim().toLowerCase()) {
                      bundleCategoryName = bItem.name || bundleCategoryName;
                      break;
                    }
                  }
                  if (bundleCategoryName !== property) break;
                }
              }
            }
          } catch(e) {
            // If lookup fails, use property as fallback
          }
        }
        
        // CRITICAL FIX (Order #52267): Logo ID source priority - _bundle_raw BEFORE hidden fields
        // Hidden fields can be empty for some categories (e.g. Softshell), causing wrong logoId (262311)
        // from another category's DOM to be used. _bundle_raw is authoritative (set in buildMainVariant).
        var cacheKey = createLogoIdCacheKey(bundleCategoryName, bundleProperty.name || '', bundleProperty.application_method || 'Embroidery', bundleProperty.logo_type || '');
        
        // 1. HIGHEST PRIORITY: _bundle_raw (extracted at start - matches order/main variant)
        if (bundleRawLogoIds[cacheKey] !== undefined && bundleRawLogoIds[cacheKey] !== null && bundleRawLogoIds[cacheKey] !== '') {
          logo_id = Number(bundleRawLogoIds[cacheKey]) || bundleRawLogoIds[cacheKey];
          logoIdSource = '_bundle_raw';
          if (window.bundleDebugLog) {
            addDebugStep('getAllPositionsVariants_logoId_from_bundle_raw', 'success', {
              bundleItem: bundleCategoryName,
              position: bundleProperty.name,
              logoId: logo_id,
              cacheKey: cacheKey,
              note: 'Authoritative - matches _bundle_raw (Order #52267 fix)'
            });
          }
        }
        // 2. Shared cache (from buildMainVariant)
        else if (window.bundleLogoIdCache && window.bundleLogoIdCache[cacheKey]) {
          logo_id = window.bundleLogoIdCache[cacheKey];
          logoIdSource = 'shared_cache';
          if (window.bundleDebugLog) {
            addDebugStep('getAllPositionsVariants_logoId_from_cache', 'success', {
              bundleItem: bundleCategoryName,
              position: bundleProperty.name,
              logoId: logo_id,
              cacheKey: cacheKey,
              note: 'Using shared cache from buildMainVariant'
            });
          }
        }
        // 3. User selection from hidden fields (can be wrong if hidden fields empty for this category)
        else if (bundleProperty.logoId) {
          logo_id = bundleProperty.logoId;
          logoIdSource = 'hidden_fields_user_selection';
          if (window.bundleDebugLog) {
            addDebugStep('getAllPositionsVariants_logoId_from_user_selection', 'success', {
              bundleItem: bundleCategoryName,
              position: bundleProperty.name,
              logoId: logo_id,
              source: 'hidden_fields_user_selection',
              note: 'No _bundle_raw/cache - using hidden fields (verify if Softshell/3rd category)'
            });
          }
        }
        // 4. Fallback already handled below (existing logic for !logo_id)
        
        // Only log if Logo ID was changed from a different source (not user selection)
        if (logo_id && logo_id !== bundleProperty.logoId && !bundleProperty.logoId && window.bundleDebugLog) {
          addDebugStep('logoId_retrieved_from_' + logoIdSource, 'success', {
            bundleItem: bundleCategoryName,
            position: bundleProperty.name,
            logoId: logo_id,
            source: logoIdSource
          });
        }
        
        // CRITICAL: Validate quantity
        if (!qty || qty <= 0 || isNaN(Number(qty))) {
            // qty: qty,
            // property: property,
            // variantID: id,
            // bundleProperty: bundleProperty
          // });
          addDebugError('Invalid quantity in position variant', {
            qty: qty,
            property: property,
            variantID: id
          });
          return; // Skip invalid quantity
        }
        
        // CRITICAL FIX: Determine application method from variant ID if not in bundleProperty
        // This ensures we use the correct method even if hidden fields have wrong data
        var applicationMethod = bundleProperty.application_method || '';
        if (!applicationMethod && id) {
          // Try to determine method from variant ID using position-method mapping
          if (typeof window.getVariantForPositionAndMethod === 'function') {
            // Check both methods to see which one matches this variant ID
            var embroideryVariant = window.getVariantForPositionAndMethod(bundleProperty.name || '', 'Embroidery');
            var printVariant = window.getVariantForPositionAndMethod(bundleProperty.name || '', 'Print');
            
            if (id === embroideryVariant) {
              applicationMethod = 'Embroidery';
            } else if (id === printVariant) {
              applicationMethod = 'Print';
            }
          }
        }
        
        // Fallback: If still no method, try to infer from variant ID patterns
        if (!applicationMethod) {
          // Common variant IDs: 44333841875187 = Embroidery, 44737873707251/44737893826803 = Print
          if (id === 44333841875187) {
            applicationMethod = 'Embroidery';
          } else if (id === 44737873707251 || id === 44737893826803 || id === 44737893859571) {
            applicationMethod = 'Print';
          } else {
            // Default fallback
            applicationMethod = bundleProperty.application_method || 'Embroidery';
          }
        }
        
        // Build additional properties object with all fulfillment details
        var additionalProperties = {
          position: bundleProperty.name || '',
          applicationMethod: applicationMethod, // Use determined method
          logoType: bundleProperty.logo_type || '',
          logoVariant: bundleProperty.logoVariant || '',
          bundleName: property || ''
        };
        
        // Add logo details from bundleProperty (Logo Text, Logo Color, Logo Font, Note, Logo)
        if (bundleProperty['Logo Text']) additionalProperties.logoText = bundleProperty['Logo Text'];
        if (bundleProperty['Logo Text 2']) additionalProperties.logoText2 = bundleProperty['Logo Text 2'];
        if (bundleProperty['Logo Text 3']) additionalProperties.logoText3 = bundleProperty['Logo Text 3'];
        if (bundleProperty['Logo Text 4']) additionalProperties.logoText4 = bundleProperty['Logo Text 4'];
        if (bundleProperty['Logo Color']) additionalProperties.logoColor = bundleProperty['Logo Color'];
        if (bundleProperty['Logo Font']) additionalProperties.logoFont = bundleProperty['Logo Font'];
        if (bundleProperty.Logo) additionalProperties.logo = bundleProperty.Logo;
        if (bundleProperty.Note) additionalProperties.note = bundleProperty.Note;
        
        // Try to get product variant details if available
        try {
          var $sizeInput = $(this);
          var productVariantId = Number($sizeInput.data('variant-id'));
          var productSku = $sizeInput.attr('data-sku') || '';
          var productSize = $sizeInput.attr('data-size') || '';
          var productColor = $sizeInput.attr('data-color') || '';
          
          if (productVariantId && !isNaN(productVariantId) && productVariantId !== 0) {
            additionalProperties.productVariantId = productVariantId;
          }
          if (productSku) additionalProperties.productSku = productSku;
          if (productSize) additionalProperties.productSize = productSize;
          if (productColor) additionalProperties.productColor = productColor;
        } catch(e) {
          // If we can't get product details, continue anyway
        }
        
        // CRITICAL FIX: Deduplication - prevent adding the same position variant multiple times
        // Create a unique key: variantId + parentVariantId + logoId + position + applicationMethod
        var variantKey = [
          id,
          ParentVariantId,
          logo_id || '',
          bundleProperty.name || '',
          bundleProperty.application_method || '',
          qty
        ].join('|');
        
        // Skip if this variant was already processed
        if (processedPositionVariants.has(variantKey)) {
          if (window.bundleDebugLog) {
            addDebugWarning('Position variant skipped - duplicate detected in getAllPositionsVariants', {
              variantId: id,
              position: bundleProperty.name || 'unknown',
              logoId: logo_id || 'unknown',
              reason: 'Position variant already processed - preventing duplicates'
            });
          }
          return; // Skip duplicate
        }
        
        // Mark this variant as processed
        processedPositionVariants.set(variantKey, true);
        
        var builtItem = buildItem(id,qty,ParentVariantId,property,logo_id,additionalProperties);
        if (builtItem) {
          // CRITICAL VALIDATION: Ensure built item has correct quantity
          if (builtItem.quantity !== qty) {
              // property: property,
              // expectedQty: qty,
              // actualQty: builtItem.quantity,
              // id: id
            // });
            addDebugError('Quantity mismatch in built item', {
              property: property,
              expectedQty: qty,
              actualQty: builtItem.quantity,
              id: id
            });
            // Fix the quantity
            builtItem.quantity = qty;
            if (builtItem.properties && builtItem.properties._qty) {
              builtItem.properties._qty = qty;
            }
          }
          
          allPositionsItem.push(builtItem);
        } else {
          addDebugError('buildItem returned null', {
            id: id,
            qty: qty,
            property: property
          });
        }
        }); // End bundleItemPositions.forEach
        
        // Move to next position group
        positionGroupIndex++;
      } // End while loop for position groups
  }); // End positionsDataArray.forEach
  
    if (allPositionsItem.length > 0) {
      return allPositionsItem;
    }
  }
  
  // CRITICAL FALLBACK: Try to read from _bundle_raw if it exists in main variant properties
  // This handles cases where hidden fields are missing but _bundle_raw was already created
  
  // Try to find _bundle_raw from the main variant that was already built
  // We need to check if buildMainVariant was called and has _bundle_raw
  var bundleRawData = null;
  try {
    // Check if we can access the main variant from the current context
    // This is a fallback - ideally we should pass the main variant or _bundle_raw as parameter
    // For now, try to reconstruct from DOM or check if it's in a global variable
    
    // Try to read from hidden fields that might contain _bundle_raw
    $('.mrk-hidden-field-item').each(function() {
      try {
        var htmlContent = $(this).html();
        if (htmlContent && htmlContent.indexOf('_bundle_raw') !== -1) {
          var parsed = JSON.parse(htmlContent);
          if (parsed._bundle_raw) {
            bundleRawData = typeof parsed._bundle_raw === 'string' ? JSON.parse(parsed._bundle_raw) : parsed._bundle_raw;
          }
        }
      } catch(e) {
        // Continue searching
      }
    });
  } catch(e) {
  }
  
  // If we found _bundle_raw, extract position variants from it
  if (bundleRawData && typeof bundleRawData === 'object') {
    var positionsFromBundleRaw = [];
    
    // Iterate through bundle items in _bundle_raw
    for (var bundleIndex in bundleRawData) {
      if (bundleRawData.hasOwnProperty(bundleIndex)) {
        var bundleItem = bundleRawData[bundleIndex];
        
        if (bundleItem.positions && typeof bundleItem.positions === 'object') {
          // Iterate through positions in this bundle item
          for (var posIndex in bundleItem.positions) {
            if (bundleItem.positions.hasOwnProperty(posIndex)) {
              var position = bundleItem.positions[posIndex];
              
              // Extract position data
              var positionName = position.name || '';
              var qty = Number(position.qty) || 1;
              var applicationMethod = position['Application Method'] || 'Print';
              var logoType = position.logo_type || position['Logo Type'] || '';
              var logoId = position['Logo Id'] || '';
              var logo = position.Logo || '';
              var logoVariant = position._logoVariant || '';
              var bundleName = position.bundleName || bundleItem.name || '';
              
              // Determine variant ID based on application method
              // We need to find the position checkbox to get the variant ID
              var variantID = null;
              
              // Try to find position checkbox in DOM
              var $positionCheckbox = $(`.mrk-logo-inputs[data-position-name="${positionName}"][forbundle*="bundleItem-${bundleIndex}"]`);
              if ($positionCheckbox.length > 0) {
                if (applicationMethod === 'Embroidery') {
                  variantID = Number($positionCheckbox.data('embroideryvariant'));
                } else {
                  variantID = Number($positionCheckbox.data('printvariant'));
                }
              }
              
              // If we couldn't find variant ID from DOM, we can't create the position variant
              // But we should still log this for debugging
              if (!variantID || variantID === 0 || isNaN(variantID)) {
                  // positionName: positionName,
                  // applicationMethod: applicationMethod,
                  // bundleIndex: bundleIndex,
                  // position: position
                // });
                addDebugError('Cannot determine variant ID from _bundle_raw', {
                  positionName: positionName,
                  applicationMethod: applicationMethod,
                  bundleIndex: bundleIndex
                });
                continue; // Skip this position
              }
              
              // Find parent variant ID - this should be the size variant for this bundle item
              var parentVariantId = null;
              
              // Try to find size variant from DOM
              var $bundleItem = $(`.mrk-bundle-products-items[bundleitem="${bundleIndex}"]`);
              if ($bundleItem.length > 0) {
                // Get the first size with quantity > 0 for this bundle item
                var $sizeInput = $bundleItem.find('.mrk-qty-item').filter(function() {
                  return Number($(this).val()) > 0;
                }).first();
                
                if ($sizeInput.length > 0) {
                  parentVariantId = Number($sizeInput.data('variant-id'));
                }
              }
              
              if (!parentVariantId || parentVariantId === 0 || isNaN(parentVariantId)) {
                  // bundleIndex: bundleIndex,
                  // positionName: positionName
                // });
                addDebugError('Cannot determine parent variant ID from _bundle_raw', {
                  bundleIndex: bundleIndex,
                  positionName: positionName
                });
                continue; // Skip this position
              }
              
              // CRITICAL FIX: For bundles, we need to create one child item PER PRODUCT per position
              // Extract product information from _bundle_raw
              var products = bundleItem.products || {};
              var productKeys = Object.keys(products);
              
              // If no products found, create at least one item for the position (fallback)
              if (productKeys.length === 0) {
                productKeys = ['Product_1']; // Fallback
              }
              
              // Iterate through each product to create one child item per product per position
              productKeys.forEach(function(productKey) {
                var product = products[productKey] || {};
                var productVariantId = null;
                var productSku = product.sku || '';
                var productSize = product.size || '';
                var productColor = product.color || '';
                var productName = product.name || '';
                var productQty = Number(product.quantity) || qty;
                
                // Try to find product variant ID from DOM if available
                try {
                  var $bundleItemEl = $(`.mrk-bundle-products-items[bundleitem="${bundleIndex}"]`);
                  if ($bundleItemEl.length > 0) {
                    // Find the product variant based on SKU or size/color
                    var $sizeInput = $bundleItemEl.find('.mrk-qty-item').filter(function() {
                      var inputSku = $(this).attr('data-sku') || '';
                      var inputSize = $(this).attr('data-size') || '';
                      var inputColor = $(this).attr('data-color') || '';
                      
                      if (productSku && inputSku === productSku) return true;
                      if (productSize && productColor && inputSize === productSize && inputColor === productColor) return true;
                      if (productSize && inputSize === productSize && !productColor) return true;
                      return false;
                    }).first();
                    
                    if ($sizeInput.length > 0) {
                      productVariantId = Number($sizeInput.data('variant-id'));
                      if (!productSku) productSku = $sizeInput.attr('data-sku') || '';
                      if (!productSize) productSize = $sizeInput.attr('data-size') || '';
                      if (!productColor) productColor = $sizeInput.attr('data-color') || '';
                    }
                  }
                } catch(e) {
                  // If we can't get product details, continue anyway
                }
                
                // Build additional properties object with all fulfillment details
                var additionalProperties = {
                  position: positionName,
                  applicationMethod: applicationMethod,
                  logoType: logoType,
                  logoVariant: logoVariant,
                  bundleName: bundleName,
                  productVariantId: productVariantId || null,
                  productSku: productSku || '',
                  productSize: productSize || '',
                  productColor: productColor || '',
                  productName: productName || ''
                };
                
                // Add logo details from position
                var logo = position.Logo || '';
                if (logo) additionalProperties.logo = logo;
                if (position['Logo Text']) additionalProperties.logoText = position['Logo Text'];
                if (position['Logo Text 2']) additionalProperties.logoText2 = position['Logo Text 2'];
                if (position['Logo Text 3']) additionalProperties.logoText3 = position['Logo Text 3'];
                if (position['Logo Text 4']) additionalProperties.logoText4 = position['Logo Text 4'];
                if (position['Logo Color']) additionalProperties.logoColor = position['Logo Color'];
                if (position['Logo Font']) additionalProperties.logoFont = position['Logo Font'];
                if (position.Note) additionalProperties.note = position.Note;
                
                // Build the position variant item with all fulfillment details
                var builtItem = buildItem(variantID, productQty, parentVariantId, bundleName, logoId, additionalProperties);
                
                if (builtItem) {
                  positionsFromBundleRaw.push(builtItem);
                    // position: positionName,
                    // qty: productQty,
                    // variantID: variantID,
                    // parentVariantId: parentVariantId,
                    // productKey: productKey
                  // });
                } else {
                    // variantID: variantID,
                    // qty: productQty,
                    // parentVariantId: parentVariantId,
                    // productKey: productKey
                  // });
                }
              }); // Close forEach callback
            } // Close if (bundleItem.positions.hasOwnProperty(posIndex))
          } // Close for (var posIndex in bundleItem.positions)
        } // Close if (bundleItem.positions && typeof bundleItem.positions === 'object')
      } // Close if (bundleRawData.hasOwnProperty(bundleIndex))
    } // Close for (var bundleIndex in bundleRawData)
    
    if (positionsFromBundleRaw.length > 0) {
      addDebugStep('positionVariants_from_bundle_raw', 'success', {
        count: positionsFromBundleRaw.length
      });
      return positionsFromBundleRaw;
    } else {
      addDebugWarning('_bundle_raw found but no valid position variants extracted', {
        bundleRawData: bundleRawData
      });
    }
  }
  
  // Final fallback: Collect directly from DOM if hidden fields and _bundle_raw are missing or empty
  return getAllPositionsVariantsFromDOM();
}

// Robust fallback: Collect position variants directly from DOM
function getAllPositionsVariantsFromDOM(){
  var allPositionsItem = [];
  var ParentVariantId = window.bundleId;
  
  if (!ParentVariantId) {
    return allPositionsItem;
  }
  
  
  // Collect position variants from checked positions (same logic as getAllPositionsProperties)
  var bundleItems = $('.mrk-bundle-products-items');
  
  if (bundleItems.length === 0) {
    return allPositionsItem;
  }
  
  bundleItems.each(function(){
    var bundleIndex = $(this).attr('bundleitem');
    // CRITICAL: Get bundle category name (not individual product name) for cache lookups
    var bundleCategoryName = $(this).attr('bundleitemName') || '';
    if (!bundleCategoryName) {
      // Fallback: try to get from data-pro-name or other attributes
      bundleCategoryName = $(this).attr('data-pro-name') || '';
    }
    
    const positions = $(`.mrk-position-item .mrk-logo-inputs[forbundle="bundleItem-${bundleIndex}"]:checked`);
    var sizes = $(this).find('.mrk-qty-item');
    
    if (positions.length === 0) {
    }
    
    $(sizes).each(function(){
      if(Number($(this).val()) > 0){
        var property = $(this).attr('productname'); // Individual product name (for properties)
        var qty = Number($(this).val());
        
        if(qty > 0 && positions.length > 0){
          // Use getAllPositionsProperties to get position data for all checked positions
          // Determine embroidery/print from first position (they should all be the same per bundle item)
          var isEmbroidery = false;
          if (positions.length > 0) {
            const targetDiv = positions[0].parentElement.querySelector('.application-method-container');
            if (targetDiv) {
              const application_method_val = targetDiv.querySelector('input[type="radio"]:checked');
              if (application_method_val) {
                isEmbroidery = application_method_val.value == 'Embroidery' ? true : false;
              }
            }
          }
          
          var positionData = getAllPositionsProperties(isEmbroidery, positions, qty, ParentVariantId, property);
          
          positionData.forEach(function(bundleProperty){
            var variantID = bundleProperty.variantID;
            var id = Number(variantID);
            
            if (!id || id === 0 || isNaN(id)) {
              return;
            }
            
            // CRITICAL FIX: Use bundle category name (not individual product name) for cache lookup
            // This matches how buildMainVariant cached Logo IDs
            var cacheKey = createLogoIdCacheKey(bundleCategoryName, bundleProperty.name, bundleProperty.applicationMethod || 'Embroidery', bundleProperty.logoType || '');
            var logo_id = window.bundleLogoIdCache && window.bundleLogoIdCache[cacheKey];
            var logoIdSource = logo_id ? 'shared_cache' : null;
            
            // FIX: Try to get logo ID from bundleProperty (which comes from getAllPositionsProperties)
            if (!logo_id && bundleProperty.logoId) {
              logo_id = bundleProperty.logoId;
              logoIdSource = 'bundleProperty';
            }
            
            if (!logo_id) {
              logoIdSource = 'fallback_lookup';
              // Try to find logo ID from _bundle_raw if it exists
              try {
                var mainVariantProperties = $('.mrk-hidden-field-item').first().html();
                if (mainVariantProperties) {
                  var parsed = JSON.parse(mainVariantProperties);
                  if (parsed._bundle_raw) {
                    var bundleRawStr = parsed._bundle_raw;
                    var bundleRawData = typeof bundleRawStr === 'string' ? JSON.parse(bundleRawStr) : bundleRawStr;
                    
                    // Search for matching position in _bundle_raw
                    for (var bIndex in bundleRawData) {
                      if (bundleRawData.hasOwnProperty(bIndex)) {
                        var bItem = bundleRawData[bIndex];
                        if (bItem.positions) {
                          var positionsArray = Array.isArray(bItem.positions) 
                            ? bItem.positions 
                            : Object.keys(bItem.positions).map(function(key) {
                                return bItem.positions[key];
                              });
                          
                          positionsArray.forEach(function(pos) {
                            // Match by position name and bundle category name (not individual product name)
                            if (pos.name === bundleProperty.name && 
                                (pos.bundleName === bundleCategoryName || bItem.name === bundleCategoryName)) {
                              logo_id = pos['Logo Id'];
                              logoIdSource = '_bundle_raw';
                              // Store in cache for future use (use bundle category name for consistency)
                              if (logo_id && window.bundleLogoIdCache) {
                                var normalizedCacheKey = createLogoIdCacheKey(bundleCategoryName, bundleProperty.name, bundleProperty.applicationMethod || 'Embroidery', bundleProperty.logoType || '');
                                window.bundleLogoIdCache[normalizedCacheKey] = logo_id;
                              }
                            }
                          });
                        }
                      }
                      if (logo_id) break;
                    }
                  }
                }
              } catch(e) {
                // Silently fail, will generate random logo ID below
              }
              
              // Final fallback: generate random logo ID only if absolutely not found
              if (!logo_id) {
                logo_id = String(Math.floor(Math.random() * (999998 + 1)));
                logoIdSource = 'random_generated';
                mrkDebug.warn('[Bundle] getAllPositionsVariantsFromDOM: Generated random logo ID for position:', bundleProperty.name);
                
                // Store in cache so it's consistent if called again
                if (window.bundleLogoIdCache) {
                  window.bundleLogoIdCache[cacheKey] = logo_id;
                }
                
                // Log warning in debug log
                if (window.bundleDebugLog) {
                  addDebugWarning('Generated random logo ID - should not happen in normal flow', {
                    bundleItem: bundleCategoryName,
                    position: bundleProperty.name,
                    randomLogoId: logo_id,
                    reason: 'Logo ID not found in cache, bundleProperty, or _bundle_raw'
                  });
                }
              } else {
                // Log successful logo ID retrieval
                if (window.bundleDebugLog) {
                  addDebugStep('logo_id_retrieved', 'success', {
                    bundleItem: bundleCategoryName,
                    position: bundleProperty.name,
                    logoId: logo_id,
                    source: logoIdSource
                  });
                }
              }
            } else {
              // Store in cache for consistency
              if (logo_id && window.bundleLogoIdCache) {
                window.bundleLogoIdCache[cacheKey] = logo_id;
              }
              
              // Log successful logo ID retrieval
              if (window.bundleDebugLog) {
                addDebugStep('getAllPositionsVariants_logoId_from_cache', 'success', {
                  bundleItem: bundleCategoryName,
                  position: bundleProperty.name,
                  logoId: logo_id,
                  cacheKey: cacheKey,
                  previousLogoId: bundleProperty.logoId || 'none'
                });
              }
            }
            
            // Get product variant ID (size/color) - CRITICAL for fulfillment
            var productVariantId = null;
            var productSku = null;
            var productSize = null;
            var productColor = null;
            try {
              var $sizeInput = $(this);
              productVariantId = Number($sizeInput.data('variant-id'));
              productSku = $sizeInput.attr('data-sku') || '';
              productSize = $sizeInput.attr('data-size') || '';
              productColor = $sizeInput.attr('data-color') || '';
              
              // If not found in data attributes, try to extract from other attributes
              if (!productSize) {
                var sizeText = $sizeInput.closest('.mrk-bundle-products-items').find('.mrk-size-item.selected').text() || '';
                if (sizeText) productSize = sizeText.trim();
              }
              if (!productColor) {
                var colorText = $sizeInput.closest('.mrk-bundle-products-items').find('.mrk-color-item.selected').text() || '';
                if (colorText) productColor = colorText.trim();
              }
            } catch(e) {
              // If we can't get product details, continue anyway
            }
            
            // Build additional properties object with all fulfillment details
            var additionalProperties = {
              position: bundleProperty.name || '',
              applicationMethod: bundleProperty.application_method || '',
              logoType: bundleProperty.logo_type || '',
              logoVariant: bundleProperty.logoVariant || '',
              bundleName: property || '',
              productVariantId: productVariantId || null,
              productSku: productSku || '',
              productSize: productSize || '',
              productColor: productColor || ''
            };
            
            // Add logo details from bundleProperty (Logo Text, Logo Color, Logo Font, Note, Logo)
            if (bundleProperty['Logo Text']) additionalProperties.logoText = bundleProperty['Logo Text'];
            if (bundleProperty['Logo Text 2']) additionalProperties.logoText2 = bundleProperty['Logo Text 2'];
            if (bundleProperty['Logo Text 3']) additionalProperties.logoText3 = bundleProperty['Logo Text 3'];
            if (bundleProperty['Logo Text 4']) additionalProperties.logoText4 = bundleProperty['Logo Text 4'];
            if (bundleProperty['Logo Color']) additionalProperties.logoColor = bundleProperty['Logo Color'];
            if (bundleProperty['Logo Font']) additionalProperties.logoFont = bundleProperty['Logo Font'];
            if (bundleProperty.Logo) additionalProperties.logo = bundleProperty.Logo;
            if (bundleProperty.Note) additionalProperties.note = bundleProperty.Note;
            
            var builtItem = buildItem(id, qty, ParentVariantId, property, logo_id, additionalProperties);
            
            if (builtItem) {
              allPositionsItem.push(builtItem);
                // id, 
                // qty, 
                // property, 
                // application_method: bundleProperty.application_method,
                // logo_type: bundleProperty.logo_type
              // });
            } else {
            }
          });
        }
      }
    });
  });
  
  
  if (allPositionsItem.length === 0) {
  }
  
  return allPositionsItem;
}
// function getAllPositionsProperties(isEmbroidery,positions,qty,ParentVariantId,property){
//   var allPositionsItem = [],id;
//   positions.each(function(){
//     // if(Number($(this).data('printprice')) == 0 && Number($(this).data('embroideryprice')) == 0){
//     //   return
//     // }
//     if(isEmbroidery){
//       id = Number($(this).data('embroideryvariant'));
//     }else{
//       id = Number($(this).data('printvariant'));
//     }
//     var name = $(this).val();
//     allPositionsItem.push({variantID:id,name:name,qty:qty,ParentVariantId:ParentVariantId,property:property});
//   })
//   return allPositionsItem;
// }

//Ak custom code
function getLogoDetailsbundle(logo_style, logo_type, main_div,position_name,target_position) {
  var logo = {};

  if(logo_style == 'yes'){
      if (logo_type == 'Upload Your Logo') {
          var uploadVal = $(main_div).find('.mrk-step-upload-logo-original [name="properties[Uploaded Logo]"]').val();
          var noteVal = $(main_div).find('.mrk-step-upload-logo-original #customerNotesFilesUploadedLogo').val();
          // Order #52352: Fallback - try any Uploaded Logo input in category if specific selector empty
          if (!uploadVal || uploadVal === '') {
            uploadVal = $(main_div).find('[name="properties[Uploaded Logo]"]').filter(function() { return $(this).val(); }).first().val();
            noteVal = noteVal || $(main_div).find('#customerNotesFilesUploadedLogo').val();
          }
          logo = { "Logo": uploadVal || undefined, "Note": noteVal || undefined };
      } else if (logo_type == 'Existing Logo') {
        var existingVal = $(main_div).find('.mrk-step-existing-logo-original [name="properties[Existing Logo]"]').val();
        var existingNote = $(main_div).find('.mrk-step-existing-logo-original #customerNotesFilesExisting').val();
        if (!existingVal || existingVal === '') {
          existingVal = $(main_div).find('[name="properties[Existing Logo]"]').filter(function() { return $(this).val(); }).first().val();
          existingNote = existingNote || $(main_div).find('#customerNotesFilesExisting').val();
        }
        logo = { "Logo": existingVal || undefined, "Note": existingNote || undefined };
      } else if (logo_type == 'Text Logo') {

        logo = {
              "Logo Text": $(main_div).find('.mrk-step-text-logo-original [name="properties[Text Line]"]').val(),
              "Logo Text 2": $(main_div).find('.mrk-step-text-logo-original [name="properties[Text Line 2]"]').val(),
              "Logo Text 3": $(main_div).find('.mrk-step-text-logo-original [name="properties[Text Line 3]"]').val(),
              "Logo Text 4": $(main_div).find('.mrk-step-text-logo-original [name="properties[Text Line 4]"]').val(),
              "Logo Color": $(main_div).find('.mrk-step-text-logo-original #logoColor').val(),
              "Logo Font": $(main_div).find('.mrk-step-text-logo-original #font-family').val(),
              "Note": $(main_div).find('.mrk-step-text-logo-original #notesLogoText').val()
          };
      }
  }else{
      if (logo_type == 'Upload Your Logo') {
          var uploadUrl = $(main_div).find(target_position ? ('.' + target_position + ' [name="properties[Uploaded Logo]"]') : '[name="properties[Uploaded Logo]"]').val();
          var uploadNote = $(main_div).find(target_position ? ('.' + target_position + ' #customerNotesFilesUploadedLogo') : '#customerNotesFilesUploadedLogo').val();
          // BUG-BUNDLE-RAW-001: Fallback to global upload field if position-specific returns empty
          if (!uploadUrl || uploadUrl === '') {
            uploadUrl = $(main_div).find('.mrk-step-upload-logo-original [name="properties[Uploaded Logo]"]').val();
            uploadNote = uploadNote || $(main_div).find('.mrk-step-upload-logo-original #customerNotesFilesUploadedLogo').val();
          }
          // Order #52352: Last resort - any non-empty Uploaded Logo input in category
          if (!uploadUrl || uploadUrl === '') {
            uploadUrl = $(main_div).find('[name="properties[Uploaded Logo]"]').filter(function() { return $(this).val(); }).first().val();
            uploadNote = uploadNote || $(main_div).find('#customerNotesFilesUploadedLogo').val();
          }
          logo = { "Logo": uploadUrl || undefined, "Note": uploadNote || undefined };
      } else if (logo_type == 'Existing Logo') {
        var $existInput = target_position ? $(main_div).find('.' + target_position + ' [name="properties[Existing Logo]"]') : $(main_div).find('[name="properties[Existing Logo]"]');
        var existUrl = $existInput.val();
        var $existNoteEl = target_position ? $(main_div).find('.' + target_position + ' #customerNotesFilesExisting') : $(main_div).find('#customerNotesFilesExisting');
        var existNote = $existNoteEl.val();
        if (!existUrl || existUrl === '') {
          existUrl = $(main_div).find('[name="properties[Existing Logo]"]').filter(function() { return $(this).val(); }).first().val();
          existNote = existNote || $(main_div).find('#customerNotesFilesExisting').val();
        }
        logo = { "Logo": existUrl || undefined, "Note": existNote || undefined };
      } else if (logo_type == 'Text Logo') {

        logo = {
              "Logo Text": $(main_div).find(`.${target_position} [name="properties[Text Line]"]`).val(),
              "Logo Text 2": $(main_div).find(`.${target_position} [name="properties[Text Line 2]"]`).val(),
              "Logo Text 3": $(main_div).find(`.${target_position} [name="properties[Text Line 3]"]`).val(),
              "Logo Text 4": $(main_div).find(`.${target_position} [name="properties[Text Line 4]"]`).val(),
              "Logo Color": $(main_div).find(`.${target_position} .logoColor-position`).val(),
              "Logo Font": $(main_div).find(`.${target_position} .font-family-position`).val(),
              "Note": $(main_div).find(`.${target_position} .notesLogoText-position`).val()
          };
      }
  }

  return logo;
}

function getAllPositionsProperties(isEmbroidery,positions,qty,ParentVariantId,property){
  var allPositionsItem = [],id;
  positions.each(function(){
    // CRITICAL FIX: Determine application method PER POSITION (not globally)
    // Each position can have its own application method (Embroidery or Print)
    // This prevents application method mismatch bugs
    var positionIsEmbroidery = false; // Use local variable, not function parameter
    const targetDiv = this.parentElement.querySelector('.application-method-container');
    if (targetDiv) {
      const application_method_val = targetDiv.querySelector('input[type="radio"]:checked');
      if (application_method_val) {
        positionIsEmbroidery = application_method_val.value == 'Embroidery' ? true : false;
      } else {
        // Fallback to function parameter if position doesn't have its own method
        positionIsEmbroidery = isEmbroidery;
      }
    } else {
      // Fallback to function parameter if no method container found
      positionIsEmbroidery = isEmbroidery;
    }

    let application_method;
    let id;
    if(positionIsEmbroidery){
      id = Number($(this).data('embroideryvariant'));
      application_method = 'Embroidery';
    }else{
      id = Number($(this).data('printvariant'));
      application_method = 'Print';
    }
    
    // CRITICAL FIX: If variant ID is invalid, try position-method mapping as fallback
    // This ensures we get the correct variant even if DOM data attributes are missing
    if (!id || id === 0 || isNaN(id)) {
      if (typeof window.getVariantForPositionAndMethod === 'function') {
        var mappedVariantId = window.getVariantForPositionAndMethod(name, application_method);
        if (mappedVariantId && mappedVariantId !== 0 && !isNaN(mappedVariantId)) {
          id = mappedVariantId;
          mrkDebug.log('[Bundle] getAllPositionsProperties: Using position-method mapping for variant ID:', {
            position: name,
            applicationMethod: application_method,
            variantId: id,
            source: 'position_method_mapping_fallback'
          });
        } else {
          mrkDebug.warn('[Bundle] getAllPositionsProperties: Invalid variant ID for position:', {
            position: name,
            applicationMethod: application_method,
            embroideryVariant: $(this).data('embroideryvariant'),
            printVariant: $(this).data('printvariant'),
            hasMethodContainer: !!targetDiv,
            mappingFailed: true
          });
          return; // Skip this position if variant ID is invalid
        }
      } else {
        mrkDebug.warn('[Bundle] getAllPositionsProperties: Invalid variant ID for position:', {
          position: name,
          applicationMethod: application_method,
          embroideryVariant: $(this).data('embroideryvariant'),
          printVariant: $(this).data('printvariant'),
          hasMethodContainer: !!targetDiv,
          mappingFunctionUnavailable: true
        });
        return; // Skip this position if variant ID is invalid
      }
    }
    
    // CRITICAL VALIDATION: Verify variant ID matches application method
    // If we have the mapping function, double-check the variant is correct
    if (typeof window.getVariantForPositionAndMethod === 'function') {
      var expectedVariantId = window.getVariantForPositionAndMethod(name, application_method);
      if (expectedVariantId && expectedVariantId !== id) {
        mrkDebug.warn('[Bundle] getAllPositionsProperties: Variant ID mismatch detected:', {
          position: name,
          applicationMethod: application_method,
          domVariantId: id,
          expectedVariantId: expectedVariantId,
          action: 'Using expected variant ID from mapping'
        });
        // Use the expected variant ID from mapping (more reliable)
        id = expectedVariantId;
      }
    }
    var name = $(this).val();


    //Ak custom code
    var main_div = $(this).parents('.bundle_product_steps');
    var position_name = $(this).attr('data-position-name');
    var logo_style = $(main_div).find('.bundle_pro_logo_style .logo-assignment-labels-container .logo-assignment-label.selected input[type="radio"]').val();
    let logo_type;
    let logoVariant;
    let target_position;

    if(logo_style == 'yes'){
      logo_type = $(main_div).find('.bundle_pro_logo_style .assignment-style-1 input[type="radio"]:checked').val();
      logoVariant = $(main_div).find('.bundle_pro_logo_style .assignment-style-1 input[type="radio"]:checked').attr('variant');
      target_position = '';
    }else{
      logo_type = $(main_div).find('.bundle_pro_logo_style .assignment-style-2 .selected-position.active[data-position-name="'+position_name+'"] input[type="radio"]:checked').val();
      logoVariant = $(main_div).find('.bundle_pro_logo_style .assignment-style-2 .selected-position.active[data-position-name="'+position_name+'"] input[type="radio"]:checked').attr('variant');
      target_position = $(main_div).find('.bundle_pro_logo_style .assignment-style-2 .selected-position.active[data-position-name="'+position_name+'"] input[type="radio"]:checked').attr('data-target');      
    }

    let logoDetails = getLogoDetailsbundle(logo_style, logo_type, main_div,position_name,target_position);

    //Ak custom code
    
    // CRITICAL: Get bundle category name (not individual product name) for cache lookup
    // The cache uses bundle category names, not individual product names
    var bundleItemName = '';
    try {
      // Try to get bundle category name from the bundle item container
      var bundleItemContainer = $(this).closest('.mrk-bundle-products-items');
      if (bundleItemContainer.length > 0) {
        bundleItemName = bundleItemContainer.attr('bundleitemName') || '';
      }
      // Fallback: try to get from main_div attribute
      if (!bundleItemName) {
        bundleItemName = main_div.attr('data-pro-name') || '';
      }
      // Last fallback: use property (individual product name) - not ideal but better than nothing
      if (!bundleItemName) {
        bundleItemName = property || '';
      }
    } catch(e) {
      // If DOM lookup fails, use property as fallback
      bundleItemName = property || '';
    }
    
    // CRITICAL FIX: Try to get Logo ID from multiple sources (prioritize existing IDs to prevent regeneration)
    // The goal is to NEVER regenerate a logo ID if one already exists for this position
    var logoId = null;
    var logoIdSource = 'none';
    
    // 0. FIRST: Check if this position already has a logo ID stored in hidden fields or _bundle_raw
    // This prevents regeneration when updateMetabundlenew is called multiple times
    // Check if there's existing position data with a logo ID for this exact position
    try {
      // Check hidden fields for existing logo ID
      $('.mrk-hidden-field-item').each(function() {
        try {
          var fieldData = $(this).val();
          if (!fieldData) return;
          var data = typeof fieldData === 'string' ? JSON.parse(fieldData) : fieldData;
          if (data.Positions && Array.isArray(data.Positions)) {
            data.Positions.forEach(function(pos) {
              // Match by position name, bundle category, application method, and logo type
              if ((pos.name === name || pos.position === name) &&
                  (pos.bundleName === bundleItemName || pos.property === bundleItemName) &&
                  (pos.application_method === application_method || pos['Application Method'] === application_method) &&
                  (pos.logo_type === logo_type || pos['logo_type'] === logo_type)) {
                var existingLogoId = pos['Logo Id'] || pos.logoId;
                if (existingLogoId && existingLogoId !== '' && existingLogoId !== 'undefined') {
                  logoId = existingLogoId;
                  logoIdSource = 'hidden_fields';
                  return false; // Break inner loop
                }
              }
            });
            if (logoId) return false; // Break outer loop
          }
        } catch(e) {
          // Skip invalid field data
        }
      });
    } catch(e) {
      // Continue to other sources
    }
    
    // 1. Check checkbox data-logo-id attribute (if not found in hidden fields)
    if (!logoId) {
      var checkboxLogoId = $(this).attr('data-logo-id');
      if (checkboxLogoId && checkboxLogoId !== '' && checkboxLogoId !== 'undefined') {
        logoId = checkboxLogoId;
        logoIdSource = 'checkbox_data_attribute';
      }
    }
    
    // 2. Check shared cache (highest priority for consistency)
    // Use bundle category name for cache lookup (matches how buildMainVariant cached Logo IDs)
    if (!logoId && window.bundleLogoIdCache) {
      var cacheKey = createLogoIdCacheKey(bundleItemName, name, application_method, logo_type || '');
      if (window.bundleLogoIdCache[cacheKey]) {
        logoId = window.bundleLogoIdCache[cacheKey];
        logoIdSource = 'shared_cache';
      }
    }
    
    // 3. Check sessionStorage (if cache didn't have it)
    // Use bundle category name for sessionStorage key (for consistency)
    if (!logoId) {
      try {
        var sessionKey = 'logoId_' + bundleItemName + '_' + name + '_' + application_method + '_' + (logo_type || '');
        var sessionLogoId = sessionStorage.getItem(sessionKey);
        if (sessionLogoId && sessionLogoId !== '' && sessionLogoId !== 'undefined') {
          logoId = sessionLogoId;
          logoIdSource = 'sessionStorage';
          // Also cache it for future use (use bundle category name)
          if (window.bundleLogoIdCache) {
            var cacheKey = createLogoIdCacheKey(bundleItemName, name, application_method, logo_type || '');
            window.bundleLogoIdCache[cacheKey] = logoId;
          }
        }
      } catch(e) {
        // sessionStorage might not be available
      }
    }
    
    // 3.5. CRITICAL FIX: Check cart _bundle_raw if available (for rebuild scenarios)
    // This ensures Logo IDs match what's stored in cart properties
    if (!logoId && window.Shopify && window.Shopify.cart && window.Shopify.cart.items) {
      try {
        window.Shopify.cart.items.forEach(function(cartItem) {
          if (cartItem.properties && cartItem.properties._bundle_raw) {
            var raw = cartItem.properties._bundle_raw;
            if (typeof raw === 'string') {
              try {
                raw = JSON.parse(raw);
              } catch(e) {
                raw = null;
              }
            }
            
            if (raw && typeof raw === 'object') {
              var bundleItemsToCheck = Array.isArray(raw) ? raw : Object.keys(raw).map(function(key) {
                return raw[key];
              });
              
              bundleItemsToCheck.forEach(function(bItem) {
                if (!logoId && bItem && bItem.name === bundleItemName && bItem.positions) {
                  var positionsArray = Array.isArray(bItem.positions) 
                    ? bItem.positions 
                    : Object.keys(bItem.positions).map(function(key) {
                        return bItem.positions[key];
                      });
                  
                  positionsArray.forEach(function(pos) {
                    if (!logoId && pos && pos.name === name && 
                        (pos['Application Method'] === application_method || pos.application_method === application_method) &&
                        (pos.logo_type === logo_type || pos['logo_type'] === logo_type) &&
                        pos['Logo Id']) {
                      logoId = pos['Logo Id'];
                      logoIdSource = 'cart_bundle_raw';
                      
                      // Cache it for future use
                      if (window.bundleLogoIdCache) {
                        var cacheKey = createLogoIdCacheKey(bundleItemName, name, application_method, logo_type || '');
                        window.bundleLogoIdCache[cacheKey] = logoId;
                      }
                    }
                  });
                }
              });
            }
          }
        });
      } catch(e) {
        // Ignore errors when checking cart
      }
    }
    
    // 4. LAST RESORT: Generate random Logo ID only if absolutely not found anywhere
    // This should rarely happen if the system is working correctly
    if (!logoId || logoId === '' || logoId === 'undefined') {
      logoId = String(Math.floor(Math.random() * (999998 + 1)));
      logoIdSource = 'random_generated';
      mrkDebug.error('[Bundle] CRITICAL: getAllPositionsProperties generated random Logo ID for position:', name, 'bundleItem:', bundleItemName, '- all lookup paths failed');
      
      // Cache the generated Logo ID for consistency (use bundle category name)
      if (window.bundleLogoIdCache) {
        var cacheKey = createLogoIdCacheKey(bundleItemName, name, application_method, logo_type || '');
        window.bundleLogoIdCache[cacheKey] = logoId;
      }
    } else {
      // Cache the found Logo ID for consistency (use bundle category name)
      // This ensures future calls will find it in the cache
      if (window.bundleLogoIdCache && logoIdSource !== 'shared_cache') {
        var cacheKey = createLogoIdCacheKey(bundleItemName, name, application_method, logo_type || '');
        window.bundleLogoIdCache[cacheKey] = logoId;
      }
      
      // Also ensure checkbox has the logo ID attribute for persistence
      if (logoIdSource !== 'checkbox_data_attribute') {
        $(this).attr('data-logo-id', logoId);
      }
    }

    // 5c. Logo ID lookup path tracking
    if (window.bundleDebugLog) {
      try {
        var lookupCacheKey = createLogoIdCacheKey(bundleItemName, name, application_method, logo_type || '');
        window.bundleDebugLog.steps.push({
          step: 'logo_id_lookup',
          status: logoIdSource === 'random_generated' ? 'error' : 'success',
          details: {
            categoryName: bundleItemName,
            positionName: name,
            logoType: logo_type || 'unknown',
            resolvedLogoId: logoId,
            source: logoIdSource,
            isGenerated: logoIdSource === 'random_generated',
            cacheKey: lookupCacheKey,
            warning: logoIdSource === 'random_generated'
              ? 'Logo ID was randomly generated — all lookup paths failed. This may cause incorrect logo assignments.'
              : null
          },
          time: new Date().toISOString()
        });
      } catch(e) { /* debug should not break functionality */ }
    }

    // $(this).attr('data-logo-id',logoId);

    // CRITICAL FIX: Add bundleName to position data for proper category filtering
    // This ensures positions can be correctly associated with their bundle category
    allPositionsItem.push({
      variantID: id,
      name: name,
      qty: qty,
      ParentVariantId: ParentVariantId,
      property: property,
      bundleName: bundleItemName, // Add bundle category name for filtering
      application_method: application_method,
      logo_type: logo_type,
      logoVariant: logoVariant,
      logoId: logoId,
      ...logoDetails // Spread the returned object here
    });


    // allPositionsItem.push({variantID:id,name:name,qty:qty,ParentVariantId:ParentVariantId,property:property,application_method:application_method,logo_type:logo_type,logoVariant:logoVariant});
    
  })
  return allPositionsItem;
}
//Ak custom code

function updateContentInfo(image, color){
  $('.mrk-popup-product-image').attr('src', image);
  $('.selected-color').text(color);
}
function UpdatePositionPrices(){
  const isEmbroidery = $('[name="application-type"]:checked').val() == 'Embroidery' ? true:false;
  var price;
  const positions = $('.mrk-logo-inputs');
  positions.each(function(){
    if(isEmbroidery){
      price = Number($(this).data('embroideryprice'));
    }else{
      price = Number($(this).data('printprice'));
    }
    var formatted_price = formatMoney(price);
    $(this).next('.mrk-abs-price-position').html(`+${formatted_price}`)
  })
}

/**
 * Extract position variants from _bundle_raw data structure
 * This function extracts logo IDs and builds position variant items from the bundle raw data
 * @param {Object} bundleRawData - The parsed _bundle_raw object
 * @param {Number} parentBundleVariantId - The parent bundle variant ID
 * @returns {Array} Array of position variant items with correct logo IDs
 */
function extractPositionVariantsFromBundleRaw(bundleRawData, parentBundleVariantId) {
  var positionVariants = [];
  
  if (!bundleRawData || typeof bundleRawData !== 'object') {
    mrkDebug.warn('[Bundle] extractPositionVariantsFromBundleRaw: Invalid bundleRawData');
    return positionVariants;
  }
  
  if (!parentBundleVariantId) {
    mrkDebug.error('[Bundle] extractPositionVariantsFromBundleRaw: parentBundleVariantId is required');
    return positionVariants;
  }
  
  
  // Iterate through bundle items (0, 1, 2, etc.)
  for (var bundleIndex in bundleRawData) {
    if (!bundleRawData.hasOwnProperty(bundleIndex)) continue;
    
    var bundleItem = bundleRawData[bundleIndex];
    var bundleItemName = bundleItem.name || '';
    
    // Check if this bundle item has positions
    if (!bundleItem.positions || typeof bundleItem.positions !== 'object') {
      continue;
    }
    
    // Iterate through positions in this bundle item
    for (var posIndex in bundleItem.positions) {
      if (!bundleItem.positions.hasOwnProperty(posIndex)) continue;
      
      var position = bundleItem.positions[posIndex];
      
      // Extract position data with all required fields
      var positionName = position.name || '';
      var qty = Number(position.qty) || 1;
      var applicationMethod = position.applicationMethod || position['Application Method'] || 'Print';
      var logoType = position.logoType || position.logo_type || position['Logo Type'] || '';
      var logoId = position['Logo Id'] || (position.logo && position.logo.logoId) || '';
      var logoVariant = position.logoVariantId || position._logoVariant || '';
      var bundleName = position.bundleName || bundleItemName;
      
      // Validate required fields
      if (!positionName || !logoId) {
        mrkDebug.warn('[Bundle] extractPositionVariantsFromBundleRaw: Missing required fields:', {
          positionName: positionName,
          logoId: logoId,
          bundleItem: bundleItemName
        });
        continue;
      }
      
      // Determine variant ID based on application method
      // CRITICAL: First check if variant ID is stored in _bundle_raw position object
      var variantID = null;
      var variantIdSource = 'unknown';
      
      // Method 1: Check if variant ID is stored in _bundle_raw (prefer BUG-BUNDLE-RAW-001 camelCase keys)
      if (position.positionVariantId && !isNaN(Number(position.positionVariantId))) {
        variantID = Number(position.positionVariantId);
        variantIdSource = '_bundle_raw.positionVariantId';
      } else if (position._positionVariant && !isNaN(Number(position._positionVariant))) {
        variantID = Number(position._positionVariant);
        variantIdSource = '_bundle_raw._positionVariant';
      } else if (applicationMethod === 'Embroidery' && (position.embroideryVariantId && !isNaN(Number(position.embroideryVariantId)))) {
        variantID = Number(position.embroideryVariantId);
        variantIdSource = '_bundle_raw.embroideryVariantId';
      } else if (applicationMethod === 'Embroidery' && position._embroideryVariant && !isNaN(Number(position._embroideryVariant))) {
        variantID = Number(position._embroideryVariant);
        variantIdSource = '_bundle_raw._embroideryVariant';
      } else if (applicationMethod !== 'Embroidery' && (position.printVariantId && !isNaN(Number(position.printVariantId)))) {
        variantID = Number(position.printVariantId);
        variantIdSource = '_bundle_raw.printVariantId';
      } else if (applicationMethod !== 'Embroidery' && position._printVariant && !isNaN(Number(position._printVariant))) {
        variantID = Number(position._printVariant);
        variantIdSource = '_bundle_raw._printVariant';
      }
      
      // Method 2: Try to find the position checkbox in DOM to get the correct variant ID (fallback)
      if (!variantID || variantID === 0 || isNaN(variantID)) {
        var $positionCheckbox = $(`.mrk-logo-inputs[data-position-name="${positionName}"]`).filter(function() {
          // Find checkbox that belongs to this bundle item
          var forBundle = $(this).attr('forbundle');
          return forBundle && forBundle.indexOf('bundleItem-' + bundleIndex) !== -1;
        });
        
        if ($positionCheckbox.length > 0) {
          if (applicationMethod === 'Embroidery') {
            variantID = Number($positionCheckbox.data('embroideryvariant'));
          } else {
            variantID = Number($positionCheckbox.data('printvariant'));
          }
          if (variantID) {
            variantIdSource = 'DOM_lookup';
          }
        }
      }
      
      // If we couldn't find variant ID from DOM, skip this position
      if (!variantID || variantID === 0 || isNaN(variantID)) {
        mrkDebug.warn('[Bundle] extractPositionVariantsFromBundleRaw: Could not determine variant ID for position:', {
          positionName: positionName,
          applicationMethod: applicationMethod,
          bundleIndex: bundleIndex,
          logoId: logoId,
          storedVariantIds: {
            positionVariantId: position.positionVariantId || position._positionVariant || 'missing',
            embroideryVariantId: position.embroideryVariantId || position._embroideryVariant || 'missing',
            printVariantId: position.printVariantId || position._printVariant || 'missing'
          }
        });
        continue;
      }
      
      // Log variant ID detection for debugging
      if (window.bundleDebugLog) {
        addDebugStep('extractPositionVariants_variantId_detected', 'success', {
          bundleItem: bundleItemName,
          position: positionName,
          variantId: variantID,
          applicationMethod: applicationMethod,
          logoId: logoId,
          source: variantIdSource,
          storedInBundleRaw: variantIdSource.indexOf('_bundle_raw') !== -1
        });
      }
      
      // CRITICAL FIX: For bundles, we need to create one child item PER PRODUCT per position
      // Extract product information from _bundle_raw
      var products = bundleItem.products || {};
      var productKeys = Object.keys(products);
      
      // If no products found, create at least one item for the position (fallback)
      if (productKeys.length === 0) {
        productKeys = ['Product_1']; // Fallback
      }
      
      // Iterate through each product to create one child item per product per position
      productKeys.forEach(function(productKey) {
        var product = products[productKey] || {};
        var productVariantId = null;
        var productSku = product.sku || '';
        var productSize = product.size || '';
        var productColor = product.color || '';
        var productName = product.name || '';
        var productQty = Number(product.quantity) || qty;
        
        // Try to find product variant ID from DOM if available
        try {
          var $bundleItemEl = $(`.mrk-bundle-products-items[bundleitem="${bundleIndex}"]`);
          if ($bundleItemEl.length > 0) {
            // Find the product variant based on SKU or size/color
            var $sizeInput = $bundleItemEl.find('.mrk-qty-item').filter(function() {
              var inputSku = $(this).attr('data-sku') || '';
              var inputSize = $(this).attr('data-size') || '';
              var inputColor = $(this).attr('data-color') || '';
              
              if (productSku && inputSku === productSku) return true;
              if (productSize && productColor && inputSize === productSize && inputColor === productColor) return true;
              if (productSize && inputSize === productSize && !productColor) return true;
              return false;
            }).first();
            
            if ($sizeInput.length > 0) {
              productVariantId = Number($sizeInput.data('variant-id'));
              if (!productSku) productSku = $sizeInput.attr('data-sku') || '';
              if (!productSize) productSize = $sizeInput.attr('data-size') || '';
              if (!productColor) productColor = $sizeInput.attr('data-color') || '';
            }
          }
        } catch(e) {
          // If we can't get product details, continue anyway
        }
        
        // Build additional properties object with all fulfillment details
        var categoryProductSkus = productKeys.map(function (pk) {
          var p = products[pk];
          return (p && (p.sku || p.name)) ? (p.sku || p.name) : pk;
        });
        var additionalProperties = {
          position: positionName,
          applicationMethod: applicationMethod,
          logoType: logoType,
          logoVariant: logoVariant,
          bundleName: bundleName,
          categoryName: bundleItemName,
          categoryIndex: bundleItem.categoryIndex != null ? Number(bundleItem.categoryIndex) : (parseInt(bundleIndex, 10) || 0),
          categoryProductCount: productKeys.length,
          categoryProducts: categoryProductSkus.join(', ').substring(0, 200),
          productVariantId: productVariantId || null,
          productSku: productSku || '',
          productSize: productSize || '',
          productColor: productColor || '',
          productName: productName || ''
        };
        
        // Add logo details from position
        var logo = position.Logo || '';
        if (logo) additionalProperties.logo = logo;
        if (position['Logo Text']) additionalProperties.logoText = position['Logo Text'];
        if (position['Logo Text 2']) additionalProperties.logoText2 = position['Logo Text 2'];
        if (position['Logo Text 3']) additionalProperties.logoText3 = position['Logo Text 3'];
        if (position['Logo Text 4']) additionalProperties.logoText4 = position['Logo Text 4'];
        if (position['Logo Color']) additionalProperties.logoColor = position['Logo Color'];
        if (position['Logo Font']) additionalProperties.logoFont = position['Logo Font'];
        if (position.Note) additionalProperties.note = position.Note;
        
        // Build the position variant item with all fulfillment details
        var builtItem = buildItem(variantID, productQty, parentBundleVariantId, bundleName, logoId, additionalProperties);
        
        if (builtItem) {
          // Log successful position variant building
          if (window.bundleDebugLog) {
            addDebugStep('extractPositionVariants_position_built', 'success', {
              bundleItem: bundleItemName,
              position: positionName,
              productKey: productKey,
              productSku: productSku,
              variantId: variantID,
              quantity: productQty,
              logoId: logoId,
              variantIdSource: variantIdSource,
              parentVariantId: parentBundleVariantId,
              productVariantId: productVariantId,
              builtItemId: builtItem.id || 'unknown',
              hasProperties: !!(builtItem.properties && Object.keys(builtItem.properties).length > 0),
              propertiesCount: builtItem.properties ? Object.keys(builtItem.properties).length : 0
            });
          }
          
          positionVariants.push(builtItem);
          
          //   position: positionName,
          //   productKey: productKey,
          //   logoId: logoId,
          //   qty: productQty,
          //   variantID: variantID
          // });
        } else {
          mrkDebug.error('[Bundle] extractPositionVariantsFromBundleRaw: buildItem returned null for:', {
            variantID: variantID,
            qty: productQty,
            bundleName: bundleName,
            logoId: logoId,
            productKey: productKey
          });
        }
      });
    }
  }
  
  return positionVariants;
}

async function addBulkItems(){
  // ====================================================================
  // CRITICAL FIX: State Clearing Between Add-to-Cart Attempts (Order #51234)
  // ====================================================================
  // PROBLEM: When customer adds to cart multiple times, hidden fields and
  // position data accumulate, causing:
  // 1. Duplicate position variants (10 instead of 5)
  // 2. Corrupted Logo IDs (same ID for multiple categories)
  // 3. Recovery system confusion
  //
  // SOLUTION: Clear previous state before building new data
  // BUT: Don't clear if Finish button was just clicked (those fields are fresh)
  // ====================================================================
  
  // CRITICAL FIX (Order #53753): Clear any stale cached position data from a previous
  // bundle add BEFORE reading fresh data. This prevents Bundle 1's position data from
  // leaking into Bundle 2's buildMainVariant when both bundles share the same product.
  window.bundlePositionsDataBeforeClear = null;
  
  // CRITICAL FIX: Read positionsData() BEFORE clearing hidden fields
  // This ensures we capture the data even if Finish button was just clicked
  var positionsDataBeforeClear = positionsData();
  var hadPositionsData = positionsDataBeforeClear.length > 0;
  
  // Store for use in buildMainVariant (which calls positionsData() later)
  if (hadPositionsData) {
    window.bundlePositionsDataBeforeClear = positionsDataBeforeClear;
  }
  
  // Clear previous hidden fields (but keep the container)
  // EXCEPTION: Don't clear if Finish button was just clicked (within last 2 seconds)
  // This prevents clearing fields that were just created by Finish button
  var shouldClearHiddenFields = true;
  if (window.bundleFinishButtonClicked && window.bundleFinishButtonTimestamp) {
    var timeSinceFinish = Date.now() - new Date(window.bundleFinishButtonTimestamp).getTime();
    if (timeSinceFinish < 2000) { // Within 2 seconds of Finish click
      shouldClearHiddenFields = false;
      if (window.bundleDebugLog) {
        addDebugStep('hidden_fields_preserved_after_finish', 'success', {
          reason: 'Finish button clicked recently, preserving fresh hidden fields',
          timeSinceFinish: timeSinceFinish + 'ms',
          hiddenFieldsCount: $('.mrk-hidden-field-item').length
        });
      }
    }
  }
  
  var $hiddenFieldsContainer = $('.mrk-hidden-fields');
  if ($hiddenFieldsContainer.length > 0 && shouldClearHiddenFields) {
    var existingHiddenFields = $hiddenFieldsContainer.find('.mrk-hidden-field-item');
    if (existingHiddenFields.length > 0) {
      existingHiddenFields.remove();
      if (window.bundleDebugLog) {
        addDebugStep('state_cleared_hidden_fields', 'success', {
          removedCount: existingHiddenFields.length,
          reason: 'Preventing state accumulation between add-to-cart attempts',
          hadPositionsDataBeforeClear: hadPositionsData
        });
      }
    }
  }
  
  // Reset Finish button flag after processing
  window.bundleFinishButtonClicked = false;
  
  // Clear sessionStorage bundle positions data (if exists)
  // Note: We don't clear ALL sessionStorage, just bundle-specific data
  try {
    if (sessionStorage.getItem('bundle_positions')) {
      sessionStorage.removeItem('bundle_positions');
      if (window.bundleDebugLog) {
        addDebugStep('state_cleared_sessionStorage', 'success', {
          reason: 'Preventing stale position data from previous attempts'
        });
      }
    }
  } catch(e) {
    // SessionStorage may not be available (e.g., private browsing)
    if (window.bundleDebugLog) {
      addDebugWarning('Could not clear sessionStorage', {
        error: e.message
      });
    }
  }
  
  // Reset any global position tracking arrays if they exist
  if (window.bundlePositionVariants) {
    window.bundlePositionVariants = [];
  }
  
  // Continue with normal add-to-cart flow
  
  // CRITICAL FIX (Order #53753): Always create a FRESH debug log for each add-to-cart
  // operation. Previously used `if (!window.bundleDebugLog)` which caused debug data
  // from Bundle 1 to accumulate into Bundle 2's logs when adding multiple instances
  // of the same bundle product.
  window.bundleDebugLog = {
    timestamp: new Date().toISOString(),
    theme: 'base',
    themeVersion: _themeVersion,
    version: '7.0.0',
    steps: [],
    warnings: [],
    errors: [],
    data: {}
  };
  var debugLog = window.bundleDebugLog;
  
  addDebugStep('addBulkItems_started', 'success', {
    customization: customization,
    bundleId: window.bundleId
  });
  
  var bundleItems = $('.mrk-bundle-products-items');
  var ids = [];
  var qty = 1;
  var ParentVariantId = window.bundleId;
  
  // CRITICAL FIX: Declare positionsVariants outside if(customization) block
  // so it's accessible in validation code later (line 1971)
  var positionsVariants = [];
  
  // CRITICAL FIX: Create shared Logo ID cache to ensure consistency between
  // buildMainVariant and getAllPositionsVariants
  // Key format: "bundleItemName|positionName|applicationMethod|logoType"
  // Clear cache at start of each add-to-cart to avoid stale data
  window.bundleLogoIdCache = {};
  
  if (debugLog) {
    addDebugStep('logoId_cache_initialized', 'success', {
      note: 'Shared Logo ID cache created for consistency between buildMainVariant and getAllPositionsVariants'
    });
  }
  
  
  debugLog.data.bundleItemsCount = bundleItems.length;
  debugLog.data.parentVariantId = ParentVariantId;
  
  if (!ParentVariantId) {
    addDebugError('window.bundleId is not set', {});
    return;
  }
  
  addDebugStep('bundleId_validation', 'success', { parentVariantId: ParentVariantId });
  
  const mainVariant = buildMainVariant(ParentVariantId,qty,bundleItems, debugLog);
  
  if (!mainVariant) {
    addDebugError('buildMainVariant returned null', {});
    return; // Stop execution if bundle is invalid
  }
  
  addDebugStep('buildMainVariant_completed', 'success', {
    variantId: mainVariant.id,
    propertiesCount: mainVariant.properties ? Object.keys(mainVariant.properties).length : 0
  });
  
    // id: mainVariant.id,
    // quantity: mainVariant.quantity,
    // propertiesCount: mainVariant.properties ? Object.keys(mainVariant.properties).length : 0
  // });
  
  // CRITICAL VALIDATION: Check if main variant has logo properties
  var hasLogoProperties = false;
  var logoPropertiesFound = [];
  if (mainVariant.properties) {
    // Check for logo-related properties in bundle format
    var logoPropertyKeys = ['Application Method', 'Position', 'Logo Type', 'Logo', 'Logo Text', '_logoVariant'];
    logoPropertyKeys.forEach(function(key) {
      for (var prop in mainVariant.properties) {
        if (prop.indexOf(key) === 0) {
          hasLogoProperties = true;
          logoPropertiesFound.push(prop);
        }
      }
    });
  }
  
  if(customization){
    addDebugStep('customization_enabled', 'success', {});
    
    var currentIds = [];
    
    // Log state before collecting positions
    var hiddenFieldsCount = $('.mrk-hidden-field-item').length;
    var checkedPositionsCount = $(`.mrk-logo-inputs:checked`).length;
    var sessionStorageExists = sessionStorage.getItem('bundle_positions') ? 'EXISTS' : 'EMPTY';
    
    
    debugLog.data.beforePositionCollection = {
      hiddenFields: hiddenFieldsCount,
      checkedPositions: checkedPositionsCount,
      bundleItems: bundleItems.length,
      sessionStorage: sessionStorageExists
    };
    
    // CRITICAL FIX: If no hidden fields exist, create them now!
    // This handles cases where customer skips the "Finish" button
    if (hiddenFieldsCount === 0 && checkedPositionsCount > 0) {
      addDebugWarning('No hidden fields found but positions checked - creating now', {
        checkedPositions: checkedPositionsCount,
        reason: 'Customer may have skipped Finish button'
      });
      updateMetabundlenew(debugLog);
      hiddenFieldsCount = $('.mrk-hidden-field-item').length;
      addDebugStep('hiddenFields_autoCreated', hiddenFieldsCount > 0 ? 'success' : 'error', { 
        count: hiddenFieldsCount,
        before: 0,
        after: hiddenFieldsCount
      });
      
      if (hiddenFieldsCount === 0) {
        addDebugError('Failed to create hidden fields after auto-creation attempt', {
          checkedPositions: checkedPositionsCount
        });
      }
    }
    
    // CRITICAL FIX: Pass mainVariant to getAllPositionsVariants so it can use Logo IDs from _bundle_raw
    // This ensures consistency between _bundle_raw and cart items
    positionsVariants = getAllPositionsVariants(mainVariant);
    
    // CRITICAL FALLBACK: If no position variants collected but _bundle_raw exists, extract from it
    if (positionsVariants.length === 0 && mainVariant && mainVariant.properties && mainVariant.properties._bundle_raw) {
      
      try {
        var bundleRawStr = mainVariant.properties._bundle_raw;
        var bundleRawData = typeof bundleRawStr === 'string' ? JSON.parse(bundleRawStr) : bundleRawStr;
        
        if (bundleRawData && typeof bundleRawData === 'object') {
          
          // Extract position variants from _bundle_raw
          var extractedVariants = extractPositionVariantsFromBundleRaw(bundleRawData, ParentVariantId);
          
          if (extractedVariants && extractedVariants.length > 0) {
            
            // Add extracted variants to positionsVariants array
            extractedVariants.forEach(function(variant) {
              positionsVariants.push(variant);
            });
            
            addDebugStep('positionVariants_extracted_from_bundle_raw', 'success', {
              count: extractedVariants.length,
              totalNow: positionsVariants.length
            });
          } else {
            addDebugWarning('Could not extract position variants from _bundle_raw', {
              bundleRawData: bundleRawData,
              bundleRawKeys: Object.keys(bundleRawData || {})
            });
          }
        } else {
          addDebugWarning('_bundle_raw exists but is not a valid object', {
            bundleRawStr: bundleRawStr,
            bundleRawDataType: typeof bundleRawStr
          });
        }
      } catch(e) {
        addDebugError('Error extracting from _bundle_raw', {
          error: e.message,
          stack: e.stack
        });
      }
    }
    
    // CRITICAL VALIDATION: If main variant has logo properties but no position variants, this is an error!
    if (hasLogoProperties && positionsVariants.length === 0) {
        // logoProperties: logoPropertiesFound,
        // positionVariantsCollected: positionsVariants.length,
        // mainVariantProperties: Object.keys(mainVariant.properties || {}),
        // hiddenFieldsCount: $('.mrk-hidden-field-item').length,
        // checkedPositions: $(`.mrk-logo-inputs:checked`).length
      // });
      
      addDebugError('Logo properties exist but position variants missing', {
        logoProperties: logoPropertiesFound,
        positionVariantsCollected: positionsVariants.length,
        mainVariantProperties: Object.keys(mainVariant.properties || {}),
        hiddenFieldsCount: $('.mrk-hidden-field-item').length,
        checkedPositions: $(`.mrk-logo-inputs:checked`).length
      });
      
      $('.mrk-loader-main').css('display', 'none');
      return; // Prevent adding to cart
    }
    
    // Also check if positions are checked but no variants collected
    var checkedPositionsCount = $(`.mrk-logo-inputs:checked`).length;
    if (checkedPositionsCount > 0 && positionsVariants.length === 0) {
        // checkedPositions: checkedPositionsCount,
        // positionVariantsCollected: positionsVariants.length,
        // hiddenFieldsCount: $('.mrk-hidden-field-item').length
      // });
      
      addDebugError('Positions checked but no variants collected', {
        checkedPositions: checkedPositionsCount,
        positionVariantsCollected: positionsVariants.length,
        hiddenFieldsCount: $('.mrk-hidden-field-item').length
      });
      
      $('.mrk-loader-main').css('display', 'none');
      return; // Prevent adding to cart
    }
    
    debugLog.data.positionVariants = {
      count: positionsVariants.length,
      variants: positionsVariants.map(function(v) {
        return {
          id: v.id,
          quantity: v.quantity,
          hasParentVariant: v.properties && v.properties._ParentVariant ? true : false
        };
      })
    };
    
    // Track position variants with detailed info
    var positionVariantsDetails = [];
    positionsVariants.forEach(function(variant) {
      if (variant && variant.id && variant.properties) {
        positionVariantsDetails.push({
          variantId: variant.id,
          quantity: variant.quantity || 1,
          logoId: variant.properties['Logo Id'] || 'missing',
          position: variant.properties.Position || 'unknown',
          applicationMethod: variant.properties['Application Method'] || 'unknown',
          parentVariantId: variant.properties._ParentVariant || 'missing',
          hasLogoId: !!(variant.properties['Logo Id']),
          hasPosition: !!(variant.properties.Position),
          hasApplicationMethod: !!(variant.properties['Application Method'])
        });
      }
    });
    
    // CRITICAL FIX: Validate position variant quantities match expected category quantities (Order #51763 fix)
    if (positionsVariants.length > 0 && debugLog && mainVariant && mainVariant.properties && mainVariant.properties._bundle_raw) {
      try {
        // Parse _bundle_raw to get bundle structure for quantity validation
        var bundleRawStr = mainVariant.properties._bundle_raw;
        var bundleRawData = typeof bundleRawStr === 'string' ? JSON.parse(bundleRawStr) : bundleRawStr;
        
        if (bundleRawData && typeof bundleRawData === 'object') {
          var bundleItemsToCheck = Array.isArray(bundleRawData) ? bundleRawData : Object.keys(bundleRawData).map(function(key) {
            return bundleRawData[key];
          });
          
          positionsVariants.forEach(function(variant) {
            if (variant.properties && variant.properties._BundleItemName) {
              var bundleItemName = variant.properties._BundleItemName;
              // Find matching bundle item to get expected quantity
              var matchingBundleItem = bundleItemsToCheck.find(function(bItem) {
                return bItem && bItem.name === bundleItemName;
              });
              
              if (matchingBundleItem && matchingBundleItem.products) {
                var expectedQty = 0;
                var productKeys = Object.keys(matchingBundleItem.products);
                productKeys.forEach(function(productKey) {
                  var product = matchingBundleItem.products[productKey];
                  if (product && product.quantity) {
                    expectedQty += Number(product.quantity) || 0;
                  }
                });
                
                if (expectedQty > 0 && variant.quantity !== expectedQty) {
                  addDebugWarning('Position variant quantity mismatch detected', {
                    bundleItem: bundleItemName,
                    position: variant.properties.Position || 'unknown',
                    expectedQty: expectedQty,
                    actualQty: variant.quantity,
                    logoId: variant.properties['Logo Id'] || 'unknown',
                    impact: 'Order will have incorrect embroidery quantities'
                  });
                }
              }
            }
          });
        }
      } catch(e) {
        // If parsing fails, skip validation (non-critical)
        if (debugLog && debugLog.warnings) {
          debugLog.warnings.push({
            message: 'Failed to parse _bundle_raw for quantity validation',
            details: { error: e.message },
            time: new Date().toISOString()
          });
        }
      }
    }
    
    addDebugStep('positionVariants_collected', positionsVariants.length > 0 ? 'success' : 'warning', {
      count: positionsVariants.length,
      variants: positionVariantsDetails,
      allHaveLogoIds: positionVariantsDetails.every(function(v) { return v.hasLogoId; }),
      allHavePositions: positionVariantsDetails.every(function(v) { return v.hasPosition; }),
      allHaveApplicationMethods: positionVariantsDetails.every(function(v) { return v.hasApplicationMethod; })
    });
    
    // Store in debug log data for analysis
    if (debugLog && debugLog.data) {
      debugLog.data.positionVariants = {
        count: positionsVariants.length,
        variants: positionVariantsDetails
      };
    }
    
    if (positionsVariants.length === 0) {
      addDebugError('No position variants collected', {
        hiddenFields: hiddenFieldsCount,
        checkedPositions: checkedPositionsCount
      });
    }
    
    
    if (positionsVariants.length === 0) {
        // hiddenFieldsCount: $('.mrk-hidden-field-item').length,
        // hiddenFieldsHTML: $('.mrk-hidden-field-item').map(function() { return $(this).html().substring(0, 100); }).get(),
        // checkedPositions: $(`.mrk-logo-inputs:checked`).length,
        // checkedPositionsDetails: $(`.mrk-logo-inputs:checked`).map(function() { 
          // return {
            // position: $(this).val(),
            // bundleItem: $(this).attr('forbundle'),
            // printVariant: $(this).data('printvariant'),
            // embroideryVariant: $(this).data('embroideryvariant')
          // };
        // }).get(),
        // bundleItems: bundleItems.length,
        // customization: customization,
        // bundleId: window.bundleId
      // });
      
      // Log warning but proceed without user confirmation
      if (debugLog) {
        addDebugStep('no_positions_detected', 'warning', {
          reason: 'No position variants collected'
        });
        // Still save debug log
        if (mainVariant && mainVariant.properties) {
          // Add version identifier for tracking (if not already present)
          if (!debugLog.version) {
            debugLog.version = '7.0.0';
          }
          // Ensure theme identifiers are always present
          if (!debugLog.theme) {
            debugLog.theme = 'base';
            debugLog.themeVersion = _themeVersion;
          }
          if (JRS_DEBUG_PROPERTIES_IN_CART) {
            mainVariant.properties['_bundle_debug_log'] = getPersistableDebugLog(debugLog);
            mainVariant.properties['_debug_errors_count'] = String(debugLog.errors ? debugLog.errors.length : 0);
            if (debugLog.errors && debugLog.errors.length > 0) {
              var lastErrEarly = debugLog.errors[debugLog.errors.length - 1];
              var lastErrMsgEarly = (typeof lastErrEarly === 'string' ? lastErrEarly : (lastErrEarly && lastErrEarly.message) || JSON.stringify(lastErrEarly)).slice(0, 200);
              mainVariant.properties['_debug_last_error'] = lastErrMsgEarly;
            }
          }
        }
      }
      $('.mrk-loader-main').css('display', 'none');
      return;
    } else {
      positionsVariants.forEach(function(item, index) {
          // id: item.id,
          // quantity: item.quantity,
          // hasParentVariant: !!item.properties._ParentVariant,
          // parentVariant: item.properties._ParentVariant
        // });
      });
    }
    
    currentIds = currentIds.concat(positionsVariants);
    ids = ids.concat(currentIds)
  } else {
  }
  
  // Add user journey data to debug log
  if (debugLog && window.bundleUserJourney) {
    if (!debugLog.data) debugLog.data = {};
    debugLog.data.userJourney = {
      startTime: window.bundleUserJourney.startTime,
      pageLoad: window.bundleUserJourney.pageLoad,
      totalInteractions: window.bundleUserJourney.interactions.length,
      totalStateChanges: window.bundleUserJourney.stateChanges.length,
      totalErrors: window.bundleUserJourney.errors.length,
      interactions: window.bundleUserJourney.interactions.slice(-50), // Last 50 interactions
      stateChanges: window.bundleUserJourney.stateChanges.slice(-20), // Last 20 state changes
      errors: window.bundleUserJourney.errors,
      timeOnPage: Date.now() - new Date(window.bundleUserJourney.startTime).getTime()
    };
  }
  
  // Add cart debug tracker data if available
  if (debugLog && window.cartDebugTracker) {
    if (!debugLog.data) debugLog.data = {};
    debugLog.data.cartUpdates = {
      startTime: window.cartDebugTracker.startTime,
      totalUpdates: window.cartDebugTracker.updates.length,
      totalRemovals: window.cartDebugTracker.removals.length,
      totalErrors: window.cartDebugTracker.errors.length,
      updates: window.cartDebugTracker.updates.slice(-20), // Last 20 updates
      removals: window.cartDebugTracker.removals.slice(-10), // Last 10 removals
      errors: window.cartDebugTracker.errors
    };
  }
  
  // Add debug log to main variant properties before adding to cart
  if (debugLog && mainVariant && mainVariant.properties) {
    // Add version identifier for tracking (if not already present)
    if (!debugLog.version) {
      debugLog.version = '7.0.0';
    }
    if (!debugLog.theme) {
      debugLog.theme = 'base';
      debugLog.themeVersion = _themeVersion;
    }
    if (JRS_DEBUG_PROPERTIES_IN_CART) {
      mainVariant.properties['_bundle_debug_log'] = getPersistableDebugLog(debugLog);
      mainVariant.properties['_debug_errors_count'] = String(debugLog.errors ? debugLog.errors.length : 0);
      if (debugLog.errors && debugLog.errors.length > 0) {
        var lastErrMain = debugLog.errors[debugLog.errors.length - 1];
        var lastErrMsgMain = (typeof lastErrMain === 'string' ? lastErrMain : (lastErrMain && lastErrMain.message) || JSON.stringify(lastErrMain)).slice(0, 200);
        mainVariant.properties['_debug_last_error'] = lastErrMsgMain;
      }
    }
    addDebugStep('debug_log_added_to_properties', 'success', {
      logSize: getPersistableDebugLog(debugLog).length,
      stepsCount: debugLog.steps.length,
      warningsCount: debugLog.warnings.length,
      errorsCount: debugLog.errors.length,
      hasUserJourney: !!(debugLog.data && debugLog.data.userJourney),
      hasCartUpdates: !!(debugLog.data && debugLog.data.cartUpdates)
    });
  }
  
  ids.push(mainVariant);
  
  // CRITICAL FIX: Log position variants before adding to cart (Order #51786 fix)
  if (customization && positionsVariants && positionsVariants.length > 0 && debugLog) {
    addDebugStep('position_variants_ready_for_cart', 'success', {
      count: positionsVariants.length,
      variants: positionsVariants.map(function(v) {
        return {
          variantId: v.id,
          quantity: v.quantity,
          logoId: v.properties && v.properties['Logo Id'] || 'missing',
          position: v.properties && v.properties.Position || 'missing',
          hasAllProperties: !!(v.properties && v.properties._ParentVariant && v.properties['Logo Id'])
        };
      }),
      note: 'Position variants prepared and ready to be added to cart data'
    });
  }
  
  var data = {
    items: ids
  };
  
  // Order #55441: Unique instance ID so parent and its children can be grouped; enables orphan detection
  var bundleInstanceId = Date.now().toString(36) + Math.random().toString(36).substring(2, 8);
  data.items.forEach(function(item) {
    if (!item.properties) item.properties = {};
    if (item.properties._bundle_raw || item.properties._bundle) item.properties._bundle_instance_id = bundleInstanceId;
    if (item.properties._ParentVariant == ParentVariantId) item.properties._bundle_instance_id = bundleInstanceId;
  });
  if (debugLog) {
    addDebugStep('bundle_instance_id_assigned', 'success', { bundleInstanceId: bundleInstanceId, itemCount: data.items.length });
  }
  
  // CRITICAL FIX: Verify position variants are in cart data before API call (Order #51786 fix)
  if (customization && positionsVariants && positionsVariants.length > 0) {
    var positionVariantsInData = data.items.filter(function(item) {
      return item.properties && item.properties._ParentVariant;
    });
    
    if (debugLog) {
      addDebugStep('position_variants_in_cart_data_verification', 
        positionVariantsInData.length === positionsVariants.length ? 'success' : 'error', {
        expected: positionsVariants.length,
        actual: positionVariantsInData.length,
        missing: positionsVariants.length - positionVariantsInData.length,
        totalItemsInData: data.items.length,
        mainBundleInData: data.items.filter(function(item) {
          return !item.properties || !item.properties._ParentVariant;
        }).length,
        expectedVariants: positionsVariants.map(function(v) {
          return {
            variantId: v.id,
            quantity: v.quantity,
            logoId: v.properties && v.properties['Logo Id'] || 'missing',
            position: v.properties && v.properties.Position || 'missing',
            parentVariant: v.properties && v.properties._ParentVariant || 'missing'
          };
        }),
        actualVariants: positionVariantsInData.map(function(v) {
          return {
            variantId: v.id,
            quantity: v.quantity,
            logoId: v.properties && v.properties['Logo Id'] || 'missing',
            position: v.properties && v.properties.Position || 'missing',
            parentVariant: v.properties && v.properties._ParentVariant || 'missing'
          };
        }),
        note: positionVariantsInData.length < positionsVariants.length ? 
          'CRITICAL: Position variants are missing from cart data before API call!' : 
          'All position variants are present in cart data'
      });
    }
    
    if (positionVariantsInData.length !== positionsVariants.length && debugLog) {
      addDebugError('Position variants missing from cart data before API call', {
        expected: positionsVariants.length,
        actual: positionVariantsInData.length,
        missing: positionsVariants.length - positionVariantsInData.length,
        expectedVariants: positionsVariants.map(function(v) {
          return {
            variantId: v.id,
            quantity: v.quantity,
            logoId: v.properties && v.properties['Logo Id'] || 'missing',
            position: v.properties && v.properties.Position || 'missing',
            parentVariant: v.properties && v.properties._ParentVariant || 'missing',
            hasId: !!v.id,
            hasProperties: !!v.properties,
            hasParentVariant: !!(v.properties && v.properties._ParentVariant)
          };
        }),
        actualVariants: positionVariantsInData.map(function(v) {
          return {
            variantId: v.id,
            quantity: v.quantity,
            logoId: v.properties && v.properties['Logo Id'] || 'missing',
            position: v.properties && v.properties.Position || 'missing',
            parentVariant: v.properties && v.properties._ParentVariant || 'missing'
          };
        }),
        impact: 'CRITICAL: Missing position variants will not be sent to cart API - customer will not be charged'
      });
    }
  }
  
  var totalItems = ids.length;
  var positionVariantsCount = customization ? ids.length - 1 : 0;
  
  // CRITICAL VALIDATION: Check if main products have logo properties but no position variants
  var mainProductsWithLogoButNoVariants = [];
  ids.forEach(function(item) {
    if (!item.properties || !item.properties._ParentVariant) {
      // This is a main product
      var hasLogoProps = false;
      var logoProps = [];
      if (item.properties) {
        var logoPropertyKeys = ['Application Method', 'Position', 'Logo Type', 'Logo', 'Logo Text', '_logoVariant'];
        logoPropertyKeys.forEach(function(key) {
          for (var prop in item.properties) {
            if (prop.indexOf(key) === 0) {
              hasLogoProps = true;
              logoProps.push(prop);
            }
          }
        });
      }
      
      if (hasLogoProps) {
        // Check if there are corresponding position variants
        var hasPositionVariants = ids.some(function(otherItem) {
          return otherItem.properties && 
                 otherItem.properties._ParentVariant && 
                 otherItem.properties._ParentVariant == item.id;
        });
        
        if (!hasPositionVariants) {
          mainProductsWithLogoButNoVariants.push({
            variantId: item.id,
            logoProperties: logoProps,
            quantity: item.quantity
          });
        }
      }
    }
  });
  
  if (mainProductsWithLogoButNoVariants.length > 0) {
      // issues: mainProductsWithLogoButNoVariants,
      // totalItems: ids.length
    // });
    
    addDebugError('Main products have logo properties but no position variants', {
      issues: mainProductsWithLogoButNoVariants,
      totalItems: ids.length
    });
    
    $('.mrk-loader-main').css('display', 'none');
    return; // Prevent adding to cart
  }
  
  // CRITICAL VALIDATION: Check for quantity mismatches before adding to cart
  var mainProduct = ids.find(function(item) { return !item.properties || !item.properties._ParentVariant; });
  var mainProductQty = mainProduct ? (mainProduct.quantity || 0) : 0;
  var bundleQuantityIssues = [];
  
  if (mainProduct && customization) {
    // For bundles, position variants should have quantities matching their size quantities
    // But we should validate they're all valid and consistent
    ids.forEach(function(item) {
      if (item.properties && item.properties._ParentVariant) {
        var positionQty = item.quantity || 0;
        if (positionQty <= 0 || isNaN(positionQty)) {
          bundleQuantityIssues.push({
            variantId: item.id,
            qty: positionQty,
            property: item.properties.property || 'Unknown',
            issue: 'Invalid quantity'
          });
        }
      }
    });
    
    if (bundleQuantityIssues.length > 0) {
        // issues: bundleQuantityIssues,
        // totalItems: ids.length
      // });
      addDebugError('Quantity issues detected before cart', {
        issues: bundleQuantityIssues,
        mainProductQty: mainProductQty
      });
    }
  }
  
  // ====================================================================
  // CRITICAL VALIDATION: Ensure All Position Variants Are Included
  // ====================================================================
  // This validation ensures that all position variants collected are
  // actually included in the cart data before sending to Shopify.
  // This prevents items from being lost due to filtering or deduplication.
  // ====================================================================
  if (customization && positionsVariants && positionsVariants.length > 0) {
    var positionVariantsInCart = ids.filter(function(item) {
      return item.properties && item.properties._ParentVariant;
    });
    
    if (positionVariantsInCart.length !== positionsVariants.length) {
      var missingVariants = positionsVariants.length - positionVariantsInCart.length;
      mrkDebug.error('[BUNDLE DEBUG] ❌ CRITICAL: Position variants missing from cart data!', {
        expected: positionsVariants.length,
        actual: positionVariantsInCart.length,
        missing: missingVariants
      });
      
      if (debugLog) {
        addDebugError('Position variants missing from cart data', {
          expected: positionsVariants.length,
          actual: positionVariantsInCart.length,
          missing: missingVariants,
          expectedVariants: positionsVariants.map(function(v) {
            return {
              variantId: v.id,
              logoId: v.properties && v.properties['Logo Id'] || 'missing',
              position: v.properties && v.properties.Position || 'missing',
              quantity: v.quantity || 0
            };
          }),
          actualVariants: positionVariantsInCart.map(function(v) {
            return {
              variantId: v.id,
              logoId: v.properties && v.properties['Logo Id'] || 'missing',
              position: v.properties && v.properties.Position || 'missing',
              quantity: v.quantity || 0
            };
          })
        });
      }
      
      // ====================================================================
      // CRITICAL FIX: Recovery System Enhancement (Order #51234)
      // ====================================================================
      // PROBLEM: Recovery system only checked positionsVariants (collected from
      // hidden fields). If items weren't collected due to state corruption
      // (e.g., multiple add-to-cart attempts), they won't be in positionsVariants,
      // so recovery won't add them.
      //
      // SOLUTION: Also check _bundle_raw directly as source of truth, similar
      // to cart validation system. This ensures ALL items from _bundle_raw are
      // included, regardless of whether they were collected in positionsVariants.
      // ====================================================================
      
      // Method 1: Recover from positionsVariants (existing logic)
      var missingLogoIds = [];
      positionsVariants.forEach(function(expectedVariant) {
        var expectedLogoId = expectedVariant.properties && expectedVariant.properties['Logo Id'];
        var found = positionVariantsInCart.some(function(actualVariant) {
          var actualLogoId = actualVariant.properties && actualVariant.properties['Logo Id'];
          return actualLogoId === expectedLogoId && 
                 actualVariant.quantity === expectedVariant.quantity;
        });
        
        if (!found && expectedLogoId) {
          missingLogoIds.push({
            logoId: expectedLogoId,
            variantId: expectedVariant.id,
            quantity: expectedVariant.quantity,
            position: expectedVariant.properties && expectedVariant.properties.Position || 'unknown',
            source: 'positionsVariants'
          });
          // Add the missing variant back to ids array
          ids.push(expectedVariant);
        }
      });
      
      // Method 2: Also check _bundle_raw directly as source of truth
      // This catches items that weren't collected in positionsVariants
      if (mainVariant && mainVariant.properties && mainVariant.properties._bundle_raw) {
        try {
          var bundleRaw = typeof mainVariant.properties._bundle_raw === 'string' 
            ? JSON.parse(mainVariant.properties._bundle_raw) 
            : mainVariant.properties._bundle_raw;
          
          if (bundleRaw && typeof bundleRaw === 'object') {
            // Extract all positions from _bundle_raw
            Object.keys(bundleRaw).forEach(function(categoryKey) {
              var category = bundleRaw[categoryKey];
              if (category && category.positions && typeof category.positions === 'object') {
                Object.keys(category.positions).forEach(function(positionKey) {
                  var position = category.positions[positionKey];
                  if (position && position['Logo Id']) {
                    var logoId = position['Logo Id'];
                    var positionName = position.name || '';
                    var positionQty = parseInt(position.qty) || 1;
                    var positionVariantId = position.positionVariantId || position._positionVariant || position.embroideryVariantId || position._embroideryVariant || position.printVariantId || position._printVariant;
                    
                    // Check if this position is already in cart
                    var foundInCart = positionVariantsInCart.some(function(actualVariant) {
                      var actualLogoId = actualVariant.properties && actualVariant.properties['Logo Id'];
                      return actualLogoId == logoId && 
                             actualVariant.quantity === positionQty;
                    });
                    
                    // Also check if it's already in missingLogoIds (from Method 1)
                    var alreadyRecovered = missingLogoIds.some(function(missing) {
                      return missing.logoId == logoId && missing.quantity === positionQty;
                    });
                    
                    if (!foundInCart && !alreadyRecovered && positionVariantId) {
                      // Try to build the missing variant
                      if (typeof extractPositionVariantsFromBundleRaw === 'function') {
                        try {
                          var extractedVariants = extractPositionVariantsFromBundleRaw(bundleRaw, ParentVariantId);
                          if (extractedVariants && Array.isArray(extractedVariants)) {
                            var matchingVariant = extractedVariants.find(function(variant) {
                              return variant.properties && 
                                     variant.properties['Logo Id'] == logoId &&
                                     variant.properties.Position === positionName;
                            });
                            
                            if (matchingVariant && matchingVariant.id) {
                              missingLogoIds.push({
                                logoId: logoId,
                                variantId: matchingVariant.id,
                                quantity: positionQty,
                                position: positionName,
                                source: '_bundle_raw',
                                bundleCategory: category.name || categoryKey
                              });
                              // Add the missing variant to ids array
                              ids.push(matchingVariant);
                              
                              if (debugLog) {
                                addDebugStep('recovered_from_bundle_raw', 'success', {
                                  logoId: logoId,
                                  position: positionName,
                                  variantId: matchingVariant.id,
                                  quantity: positionQty,
                                  bundleCategory: category.name || categoryKey
                                });
                              }
                            }
                          }
                        } catch(e) {
                          if (debugLog) {
                            addDebugWarning('Failed to extract variant from _bundle_raw', {
                              logoId: logoId,
                              position: positionName,
                              error: e.message
                            });
                          }
                        }
                      }
                    }
                  }
                });
              }
            });
          }
        } catch(e) {
          if (debugLog) {
            addDebugWarning('Failed to parse _bundle_raw for recovery', {
              error: e.message
            });
          }
        }
      }
      
      if (missingLogoIds.length > 0 && debugLog) {
        addDebugWarning('Recovered missing position variants', {
          recovered: missingLogoIds.length,
          variants: missingLogoIds,
          sources: {
            fromPositionsVariants: missingLogoIds.filter(function(m) { return m.source === 'positionsVariants'; }).length,
            fromBundleRaw: missingLogoIds.filter(function(m) { return m.source === '_bundle_raw'; }).length
          }
        });
      }
    }
  }
  
  
  if (debugLog) {
    debugLog.data.cartData = {
      totalItems: totalItems,
    bundleItems: 1,
      positionVariants: positionVariantsCount,
      positionVariantsExpected: customization && positionsVariants ? positionsVariants.length : 0,
      positionVariantsInCart: customization ? ids.filter(function(item) {
        return item.properties && item.properties._ParentVariant;
      }).length : 0
    };
    addDebugStep('cart_data_prepared', 'success', {
      totalItems: totalItems,
      positionVariants: positionVariantsCount,
      positionVariantsExpected: customization && positionsVariants ? positionsVariants.length : 0,
      positionVariantsInCart: customization ? ids.filter(function(item) {
        return item.properties && item.properties._ParentVariant;
      }).length : 0
    });
  }

  // CRITICAL FIX (Order #51964): Use window.updates — local variable "updates" does not exist
  // in this scope. Referencing it caused ReferenceError on second finish click, so cart add
  // never ran and position variants were never sent.
  var cartUpdatesPayload = (typeof window.updates !== 'undefined' && window.updates !== null) ? window.updates : null;

  if (debugLog) {
    addDebugStep('cart_operation_decision', 'success', {
      operation: cartUpdatesPayload ? 'update_then_add' : 'add',
      reason: cartUpdatesPayload ? 'cart_update_pending_then_add' : 'direct_add',
      hasUpdatesPayload: !!cartUpdatesPayload,
      updatesKeyCount: cartUpdatesPayload && typeof cartUpdatesPayload === 'object' ? Object.keys(cartUpdatesPayload).length : 0,
      willAddPositionVariants: !!(customization && positionsVariants && positionsVariants.length > 0),
      positionVariantsPrepared: customization && positionsVariants ? positionsVariants.length : 0
    });
  }

  // ====================================================================
  // CRITICAL FIX (Order #52267): Missing Logo Line Items After Cart Update
  // ====================================================================
  // Version: 4.3.0
  // Date: 2026-02-15
  //
  // PROBLEM: When window.updates exists (user changed quantities), the code calls
  // /cart/update.js first, then /cart/add.js. If the bundle already exists in cart,
  // Shopify may merge/deduplicate items, causing position variants to disappear.
  //
  // ROOT CAUSE:
  // 1. User clicks Finish first time → 4 items added (1 bundle + 3 position variants) ✓
  // 2. User changes quantities → window.updates populated
  // 3. User clicks Finish second time → /cart/update.js called → bundle quantity updated
  // 4. /cart/add.js called → Shopify sees bundle already exists → merges/deduplicates
  // 5. Position variants lost during merge → only bundle remains in cart
  //
  // SOLUTION:
  // Before updating cart, check if bundle already exists. If it does, remove the
  // existing bundle AND all its position variants first, then add fresh items.
  // This prevents merge/deduplication issues.
  //
  // TESTING:
  // - Add bundle with logos → verify all items in cart
  // - Change quantities → click Finish again → verify all items still present
  // - Complete checkout → verify order contains all line items
  // ====================================================================
  
  // P0.1 (Bug Q) — Orphan cleanup against the NEW bundleInstanceId being added.
  // Previous logic accepted any cart-side parent instance ID as "valid", so session-1 children survived
  // until the /cart/add.js merge overwrote the parent's properties. Now the new instance ID is the only
  // valid cohort: any child with _ParentVariant matching this product but a different (or missing)
  // _bundle_instance_id is an orphan from a prior session.
  // The `phase` arg is purely diagnostic ('pre_add' | 'post_add').
  function runOrphanCleanup(parentVariantId, newBundleInstanceId, phase) {
    var phaseLabel = phase || 'pre_add';
    function detectOrphans(cart) {
      var items = (cart && cart.items) || [];
      // Multi-bundle support: a child is only a TRUE orphan if no parent line item
      // currently in the cart claims its _bundle_instance_id. Previously we removed
      // any child whose instance id ≠ newBundleInstanceId, which deleted valid
      // children of other intentionally-added bundles (the user's "Shopify deletes
      // our prev bundle" complaint).
      //
      // Parent identification: a line item is a bundle parent when its variant_id
      // matches this bundle product AND it has no _ParentVariant property (children
      // always carry _ParentVariant pointing at their parent's variant).
      var validInstanceIds = {};
      items.forEach(function(item) {
        if (!item.properties) return;
        if (Number(item.variant_id) !== Number(parentVariantId)) return;
        if (item.properties._ParentVariant) return; // children — skip
        var cid = item.properties._bundle_instance_id;
        if (cid) validInstanceIds[cid] = true;
      });
      // The bundle being added right now isn't in cart yet — pre-claim its id so
      // freshly-built children that arrived via merge-from-staging aren't culled.
      if (newBundleInstanceId) validInstanceIds[newBundleInstanceId] = true;

      return items.filter(function(item) {
        if (!item.properties) return false;
        if (Number(item.properties._ParentVariant) !== Number(parentVariantId)) return false;
        var cid = item.properties._bundle_instance_id;
        // Legacy children with no instance id can't be associated with any parent — true orphan.
        if (!cid) return true;
        // Children belonging to a parent still in cart are valid (multi-bundle case). Otherwise orphan.
        return !validInstanceIds[cid];
      });
    }
    function removeKeys(keys) {
      if (!keys.length) return Promise.resolve();
      var updates = {};
      keys.forEach(function(k) { updates[k] = 0; });
      return fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/update.js' : '/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ updates: updates })
      });
    }
    return fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js', { method: 'GET', headers: { 'Accept': 'application/json' } })
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var orphans = detectOrphans(cart);
        if (orphans.length === 0) {
          if (debugLog && typeof addDebugStep === 'function') {
            addDebugStep('orphan_cleanup', 'success', { phase: phaseLabel, removedCount: 0, newBundleInstanceId: newBundleInstanceId });
          }
          return Promise.resolve();
        }
        var keys = orphans.map(function(o) { return o.key; });
        if (debugLog && typeof addDebugStep === 'function') {
          addDebugStep('orphan_cleanup', 'started', { phase: phaseLabel, removedCount: keys.length, keys: keys, newBundleInstanceId: newBundleInstanceId });
        }
        return removeKeys(keys).then(function() {
          // Verify removal — retry once if survivors persist.
          return fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js', { method: 'GET', headers: { 'Accept': 'application/json' } })
            .then(function(r) { return r.json(); })
            .then(function(cartAfter) {
              var survivors = detectOrphans(cartAfter);
              if (survivors.length === 0) {
                if (debugLog && typeof addDebugStep === 'function') {
                  addDebugStep('orphan_cleanup', 'success', { phase: phaseLabel, removedCount: keys.length, keys: keys, verified: true });
                }
                return;
              }
              return removeKeys(survivors.map(function(s) { return s.key; })).then(function() {
                return fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js', { method: 'GET', headers: { 'Accept': 'application/json' } })
                  .then(function(r) { return r.json(); })
                  .then(function(cartFinal) {
                    var stillSurviving = detectOrphans(cartFinal);
                    if (debugLog && typeof addDebugStep === 'function') {
                      addDebugStep('orphan_cleanup', stillSurviving.length === 0 ? 'success' : 'error', {
                        phase: phaseLabel,
                        initialCount: keys.length,
                        retried: survivors.length,
                        finalSurvivors: stillSurviving.length,
                        survivingKeys: stillSurviving.map(function(s) { return s.key; })
                      });
                    }
                  });
              });
            });
        }).catch(function(err) {
          if (debugLog && typeof addDebugError === 'function') {
            addDebugError('orphan_cleanup_failed', { phase: phaseLabel, error: (err && err.message) || String(err), keys: keys });
          }
        });
      })
      .catch(function() { return Promise.resolve(); });
  }

  runOrphanCleanup(ParentVariantId, bundleInstanceId, 'pre_add').then(function() {
  try {
    if (cartUpdatesPayload != null) {
      if (debugLog) {
        addDebugStep('cart_update_triggered', 'started', {
          existingUpdatesKeys: Object.keys(cartUpdatesPayload).length,
          updateType: 'before_add',
          positionVariantsIncluded: !!(customization && positionsVariants && positionsVariants.length > 0),
          positionVariantCount: customization && positionsVariants ? positionsVariants.length : 0
        });
      }
      
      // CRITICAL FIX (Order #52267 + Order #53753): Check if bundle already exists in cart
      // If it does, remove ONLY that specific instance and its position variants before updating.
      // CRITICAL: Must scope removal by _time to avoid removing children from OTHER bundle instances
      // of the same product (e.g., same bundle ordered in size L and size M).
      jQuery.ajax({
        url: window.Shopify.routes.root + 'cart.js',
        dataType: 'json'
      }).then(function(cartData) {
        // Count how many bundle parents share the same ParentVariantId
        var allBundlesWithSameVariant = cartData.items ? cartData.items.filter(function(item) {
          return item.variant_id == ParentVariantId && item.properties && (item.properties._bundle || item.properties._bundle_raw);
        }) : [];
        
        var existingBundle = allBundlesWithSameVariant.length > 0 ? allBundlesWithSameVariant[0] : null;
        
        // Multi-bundle support: NEVER remove existing bundle line items when adding
        // a new one. Each /cart/add.js call lands as its own cart line — distinct
        // _bundle_instance_id values keep two parents from merging, and children
        // stay associated with their respective parent via _bundle_instance_id.
        // Previous behaviour ("replace first existing bundle on re-add") was the
        // user's "Shopify deletes our prev bundle" complaint.
        var itemsToRemove = [];
        if (existingBundle && debugLog) {
          addDebugStep('existing_bundle_preserved_multi_bundle', 'success', {
            existingBundleKey: existingBundle.key,
            existingTime: (existingBundle.properties && existingBundle.properties._time) || 'N/A',
            bundleVariantId: ParentVariantId,
            totalBundleInstancesInCart: allBundlesWithSameVariant.length,
            flow: 'customization',
            note: 'Existing bundle(s) preserved; new bundle will be added as a separate cart line.'
          });
        }
        
        // Remove existing items if found
        if (itemsToRemove.length > 0) {
          var removeUpdates = {};
          itemsToRemove.forEach(function(key) {
            removeUpdates[key] = 0; // Set quantity to 0 to remove
          });
          
          return jQuery.ajax({
            type: 'POST',
            url: window.Shopify.routes.root + 'cart/update.js',
            data: { updates: removeUpdates },
            dataType: 'json'
          }).then(function(removeResponse) {
            if (debugLog) {
              addDebugStep('existing_bundle_removed', 'success', {
                itemsRemoved: itemsToRemove.length,
                note: 'Existing bundle and position variants removed; proceeding with fresh add'
              });
            }
            
            // Now proceed with the original update (if any) and add
            if (Object.keys(cartUpdatesPayload).length > 0) {
              // Still need to update other items if window.updates has non-bundle updates
              return jQuery.ajax({
                type: 'POST',
                url: window.Shopify.routes.root + 'cart/update.js',
                data: { updates: cartUpdatesPayload },
                dataType: 'json'
              });
            } else {
              return Promise.resolve({});
            }
          });
        } else {
          // No existing bundle - proceed with normal update
          return jQuery.ajax({
            type: 'POST',
            url: window.Shopify.routes.root + 'cart/update.js',
            data: { updates: cartUpdatesPayload },
            dataType: 'json'
          });
        }
      }).then(function(response) {
        if (debugLog) {
          addDebugStep('cart_update_completed', 'success', {
            note: 'Cart update succeeded; proceeding to addItemToCart with full payload including position variants'
          });
        }
        var refreshCart = true;
        addItemToCart(data, refreshCart, debugLog);
      }).catch(function(jqXHR, textStatus, errorThrown) {
        $('.mrk-loader-main').css('display', 'none');
        if (debugLog) {
          addDebugError('Error updating cart before adding items', {
            status: jqXHR && jqXHR.status,
            statusText: textStatus,
            error: errorThrown,
            note: 'Cart update or removal failed - items may not be added correctly'
          });
        }
      });
    } else {
      // Fetch cart state before direct_add to detect and remove stale bundle children
      jQuery.ajax({
        url: (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart.js',
        dataType: 'json'
      }).then(function(cartData) {
        var allBundlesWithSameVariant = cartData.items ? cartData.items.filter(function(item) {
          return item.variant_id == ParentVariantId && item.properties && (item.properties._bundle || item.properties._bundle_raw);
        }) : [];

        var existingBundle = allBundlesWithSameVariant.length > 0 ? allBundlesWithSameVariant[0] : null;

        // Multi-bundle support (direct_add path): same rule as the customization flow above —
        // never remove an existing bundle when adding a new one. Two parents with distinct
        // _bundle_instance_id and distinct debug-log properties don't merge in /cart/add.js.
        var itemsToRemove = [];
        if (existingBundle && debugLog) {
          addDebugStep('existing_bundle_preserved_multi_bundle', 'success', {
            existingBundleKey: existingBundle.key,
            existingInstanceId: (existingBundle.properties && existingBundle.properties._bundle_instance_id) || 'N/A',
            existingTime: (existingBundle.properties && existingBundle.properties._time) || 'N/A',
            bundleVariantId: ParentVariantId,
            totalBundleInstancesInCart: allBundlesWithSameVariant.length,
            flow: 'direct_add',
            note: 'Existing bundle(s) preserved; new bundle will be added as a separate cart line.'
          });
        }

        if (itemsToRemove.length > 0) {
          var removeUpdates = {};
          itemsToRemove.forEach(function(key) { removeUpdates[key] = 0; });

          return jQuery.ajax({
            type: 'POST',
            url: (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/update.js',
            data: JSON.stringify({ updates: removeUpdates }),
            contentType: 'application/json',
            dataType: 'json'
          }).then(function() {
            if (debugLog) {
              addDebugStep('existing_bundle_removed_direct_add', 'success', {
                itemsRemoved: itemsToRemove.length
              });
            }
          });
        }
        return jQuery.Deferred().resolve().promise();
      }).then(function() {
        var refreshCart = false;
        addItemToCart(data, refreshCart, debugLog);
      }).catch(function(err) {
        if (debugLog) {
          addDebugWarning('direct_add_cleanup_failed', { error: (err && err.message) || String(err) });
        }
        var refreshCart = false;
        addItemToCart(data, refreshCart, debugLog);
      });
    }
  } catch (e) {
    if (debugLog) {
      addDebugStep('cart_add_skipped', 'error', {
        reason: 'exception_before_add',
        error: e.message,
        stack: (e.stack || '').substring(0, 500),
        positionVariantsPrepared: customization && positionsVariants ? positionsVariants.length : 0
      });
      addDebugError('Exception after cart_data_prepared', {
        message: e.message,
        name: e.name
      });
    }
    $('.mrk-loader-main').css('display', 'none');
    throw e;
  }
  });
}
function addItemToCart(data,refreshCart, debugLog){
  // CRITICAL: Ensure every line item has minimum debug properties (Rule 1) — no order must arrive blank
  function ensureMinimalDebug(item, source) {
    var p = item.properties || {};
    if (p._debug_add_source) return;
    p._debug_add_source = source || 'bundle';
    p._debug_add_timestamp = new Date().toISOString();
    p._debug_pdp_variant_selected = String(item.id);
    p._debug_pdp_qty_selected = String(item.quantity || 1);
    p._debug_pdp_url = (window.location && window.location.href ? String(window.location.href).substring(0, 200) : '');
    p._debug_device = (window.innerWidth < 768 ? 'mobile' : window.innerWidth < 1024 ? 'tablet' : 'desktop');
    p._debug_session_id = Date.now().toString(36) + Math.random().toString(36).substring(2, 9);
    item.properties = p;
  }
  if (data.items && Array.isArray(data.items)) {
    data.items.forEach(function(it) { ensureMinimalDebug(it, 'bundle'); });
  } else if (data.id) {
    ensureMinimalDebug(data, 'bundle');
  }

  // Log cart data before sending
  var expectedItemCount = data.items ? data.items.length : 0;

  if (debugLog) {
    var positionVariantsInPayload = data.items ? data.items.filter(function(item) {
      return item.properties && item.properties._ParentVariant;
    }).length : 0;
    addDebugStep('cart_state_before_add', 'success', {
      payloadItemCount: expectedItemCount,
      positionVariantsInPayload: positionVariantsInPayload,
      mainBundleItemsInPayload: expectedItemCount - positionVariantsInPayload,
      note: 'Payload ready; current cart state not fetched to avoid extra request'
    });
  }

  // ===== NUMBERED PROPERTIES VERIFICATION (Order #55441: compare vs _bundle_raw, gate cart add) =====
  try {
    var mainBundleForVerify = data.items && data.items.find(function(item) {
      return item.properties && item.properties._bundle_raw;
    });
    if (mainBundleForVerify) {
      var verifyProps = mainBundleForVerify.properties;
      var verifyBundle = verifyProps._bundle_raw;
      if (typeof verifyBundle === 'string') {
        try { verifyBundle = JSON.parse(verifyBundle); } catch(e) { verifyBundle = null; }
      }
      if (verifyBundle && typeof verifyBundle === 'object') {
        var verifyBundleArr = Array.isArray(verifyBundle)
          ? verifyBundle.slice()
          : Object.keys(verifyBundle).map(function(k) { return verifyBundle[k]; });
        verifyBundleArr.sort(function(a, b) {
          var ai = (a && a.categoryIndex != null) ? Number(a.categoryIndex) : 999;
          var bi = (b && b.categoryIndex != null) ? Number(b.categoryIndex) : 999;
          return ai - bi;
        });
        // Build flat list of (category, position) in same order as rebuild: categories by categoryIndex, positions by numeric key
        var verifyFlatPositions = [];
        for (var vci = 0; vci < verifyBundleArr.length; vci++) {
          var vc = verifyBundleArr[vci];
          var vPositions = vc.positions || [];
          if (!Array.isArray(vPositions)) {
            vPositions = Object.keys(vPositions).sort(function(a, b) { return Number(a) - Number(b); }).map(function(k) { return vPositions[k]; });
          }
          for (var vpi = 0; vpi < vPositions.length; vpi++) {
            verifyFlatPositions.push({ category: vc, pos: vPositions[vpi] });
          }
        }
        var expectedTotalPositions = verifyFlatPositions.length;
        var failures = [];
        for (var propIdx = 1; propIdx <= expectedTotalPositions; propIdx++) {
          var pair = verifyFlatPositions[propIdx - 1];
          var vc = pair.category;
          var vPos = pair.pos;
          if (!vPos) continue;
          // Target 6 (Bug 2): Cross-validate Logo Id N — fail when expected is set and actual is missing or different
          var expectedLogoId = String(vPos['Logo Id'] || '');
          var actualLogoId = String(verifyProps['Logo Id ' + propIdx] || '');
          if (expectedLogoId && expectedLogoId !== actualLogoId) {
            failures.push({ check: 'Logo Id ' + propIdx, expected: expectedLogoId, actual: actualLogoId || '(empty)', category: vc.name, severity: 'CRITICAL' });
          }
          var expectedMethod = (vPos.applicationMethod || vPos['Application Method'] || '').toString().trim();
          var actualMethod = (verifyProps['Application Method ' + propIdx] || '').trim();
          if (expectedMethod && expectedMethod !== actualMethod) {
            failures.push({ check: 'Application Method ' + propIdx, expected: expectedMethod, actual: actualMethod || '(empty)', category: vc.name, severity: 'CRITICAL' });
          }
          var expectedProduct = (vc.name || '').trim();
          var actualProduct = (verifyProps['_logoproduct' + propIdx] || '').trim();
          if (expectedProduct && actualProduct && expectedProduct !== actualProduct) {
            failures.push({ check: '_logoproduct' + propIdx, expected: expectedProduct, actual: actualProduct, severity: 'HIGH' });
          }
          var expectedPosName = (vPos.name || vPos.position || '').toString().trim();
          var actualPosName = (verifyProps['Position ' + propIdx] || '').trim();
          if (expectedPosName && expectedPosName !== actualPosName) {
            failures.push({ check: 'Position ' + propIdx, expected: expectedPosName, actual: actualPosName || '(empty)', severity: 'HIGH' });
          }
          var actualLogopos = (verifyProps['_logoposition' + propIdx] || '').trim();
          if (expectedPosName && actualLogopos && expectedPosName !== actualLogopos) {
            failures.push({ check: '_logoposition' + propIdx, expected: expectedPosName, actual: actualLogopos, severity: 'HIGH' });
          }
        }
        // Bug 5: Cross-index alignment — use _logopositionN (not Position N) for lookup vs _bundle_raw
        var crossCheckFailures = [];
        function normalizeCartValStr(v) {
          if (v === null || v === undefined) return '';
          return v.toString().trim().toLowerCase().replace(/\s+/g, ' ');
        }
        for (var xIdx = 1; xIdx <= expectedTotalPositions; xIdx++) {
          var xProduct = normalizeCartValStr(verifyProps['_logoproduct' + xIdx] || '');
          var xPosition = normalizeCartValStr(verifyProps['_logoposition' + xIdx] || '');
          var xLogoId = normalizeCartValStr(verifyProps['Logo Id ' + xIdx] || '');
          var xMethod = normalizeCartValStr(verifyProps['Application Method ' + xIdx] || '');
          if (!xProduct || !xPosition) continue;
          var matchedRawPosition = null;
          for (var rIdx = 0; rIdx < verifyBundleArr.length && !matchedRawPosition; rIdx++) {
            var rCat = verifyBundleArr[rIdx];
            var rPositions = rCat.positions || [];
            if (!Array.isArray(rPositions)) {
              rPositions = Object.keys(rPositions).map(function(k) { return rPositions[k]; });
            }
            for (var rPosIdx = 0; rPosIdx < rPositions.length; rPosIdx++) {
              var rPos = rPositions[rPosIdx];
              if (normalizeCartValStr(rCat.name) === xProduct && normalizeCartValStr(rPos.name) === xPosition) {
                matchedRawPosition = rPos;
                var expectedLogoIdNorm = normalizeCartValStr(rPos['Logo Id'] || '');
                var expectedMethodNorm = normalizeCartValStr(rPos.applicationMethod || rPos['Application Method'] || '');
                if (xLogoId !== expectedLogoIdNorm || xMethod !== expectedMethodNorm) {
                  crossCheckFailures.push({
                    index: xIdx,
                    product: verifyProps['_logoproduct' + xIdx],
                    position: verifyProps['Position ' + xIdx],
                    logoId_numbered: verifyProps['Logo Id ' + xIdx],
                    logoId_raw: rPos['Logo Id'],
                    method_numbered: verifyProps['Application Method ' + xIdx],
                    method_raw: rPos.applicationMethod || rPos['Application Method'],
                    issue: 'cross_contamination'
                  });
                }
                break;
              }
            }
          }
          if (!matchedRawPosition) {
            crossCheckFailures.push({
              index: xIdx,
              product: verifyProps['_logoproduct' + xIdx],
              position: verifyProps['Position ' + xIdx],
              error: 'no_matching_raw_position'
            });
          }
        }
        if (crossCheckFailures.length > 0) {
          failures = failures.concat(crossCheckFailures);
        }
        for (var di = 1; di <= expectedTotalPositions; di++) {
          for (var dj = di + 1; dj <= expectedTotalPositions; dj++) {
            var lid = String(verifyProps['Logo Id ' + di] || '');
            var ljd = String(verifyProps['Logo Id ' + dj] || '');
            if (lid && ljd && lid === ljd) {
              var catDi = verifyFlatPositions[di - 1] && verifyFlatPositions[di - 1].category;
              var catDj = verifyFlatPositions[dj - 1] && verifyFlatPositions[dj - 1].category;
              var sameCategory = catDi && catDj && (catDi === catDj || ((catDi.name || '') === (catDj.name || '')));
              if (!sameCategory) {
                failures.push({ check: 'duplicate_logo_id', positions: [di, dj], logoId: lid, severity: 'CRITICAL', note: 'Same Logo ID in two positions (cross-category)' });
              }
            }
          }
        }
        var extraIdx = expectedTotalPositions + 1;
        while (verifyProps['Logo Id ' + extraIdx]) {
          failures.push({ check: 'extra_property_group', index: extraIdx, logoId: verifyProps['Logo Id ' + extraIdx], severity: 'HIGH', note: 'Property group beyond expected total positions' });
          extraIdx++;
        }
        var allMatch = failures.length === 0;
        if (debugLog) {
          addDebugStep('numbered_properties_verification', allMatch ? 'success' : 'error', {
            expectedTotalPositions: expectedTotalPositions,
            allMatch: allMatch,
            status: allMatch ? 'ALL_PROPERTIES_CORRECT' : 'MISMATCHES_FOUND',
            failures: failures,
            crossContaminationDetected: crossCheckFailures.length > 0,
            crossCheckFailures: crossCheckFailures,
            source: '_bundle_raw_cross_check_per_position'
          });

          // P1.2 (Bug L) — Tripwire: cross-check cart for orphan children that survived pre-add cleanup.
          // ALL_PROPERTIES_CORRECT alone is no longer sufficient — orphans referencing this parent variant
          // but tied to a different bundleInstanceId are now also a failure (Order #59402).
          // Sources `parentVariantId` from the payload (mainBundleForVerify.id) and `instanceId` from its
          // properties — these are the only outer-scope-free way to access them inside addItemToCart.
          (function() {
            try {
              var parentVariantIdLocal = Number(mainBundleForVerify && mainBundleForVerify.id);
              var instanceIdLocal = verifyProps && verifyProps._bundle_instance_id;
              if (!parentVariantIdLocal || !instanceIdLocal) return;
              var cartUrl = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js';
              fetch(cartUrl, { method: 'GET', headers: { 'Accept': 'application/json' } })
                .then(function(r) { return r.json(); })
                .then(function(cart) {
                  // Multi-bundle aware: only flag children whose _bundle_instance_id
                  // is not represented by any parent currently in cart. Without this,
                  // intentional double-bundle adds would always fire ORPHANS_IN_CART
                  // for the prior bundle's children.
                  var validInstanceIds = {};
                  ((cart && cart.items) || []).forEach(function(item) {
                    if (!item.properties) return;
                    if (Number(item.variant_id) !== parentVariantIdLocal) return;
                    if (item.properties._ParentVariant) return;
                    var cid = item.properties._bundle_instance_id;
                    if (cid) validInstanceIds[cid] = true;
                  });
                  validInstanceIds[instanceIdLocal] = true;

                  var orphans = ((cart && cart.items) || []).filter(function(item) {
                    if (!item.properties) return false;
                    if (Number(item.properties._ParentVariant) !== parentVariantIdLocal) return false;
                    var cid = item.properties._bundle_instance_id;
                    if (!cid) return true;
                    return !validInstanceIds[cid];
                  });
                  addDebugStep('numbered_properties_verification_cart_cross_check', orphans.length === 0 ? 'success' : 'error', {
                    orphanChildrenInCart: orphans.length,
                    orphanLineKeys: orphans.map(function(o) { return o.key; }),
                    bundleInstanceId: instanceIdLocal,
                    validInstanceIdsInCart: Object.keys(validInstanceIds),
                    status: orphans.length === 0 ? 'NO_ORPHANS' : 'ORPHANS_IN_CART'
                  });
                })
                .catch(function() {});
            } catch (e) {}
          })();
        }
        if (!allMatch) {
          if (debugLog && typeof addDebugError === 'function') {
            addDebugError('numbered_properties_verification_failed', { failures: failures, note: 'Parent numbered properties do not match _bundle_raw - proceeding with add (no user blocking)' });
          }
          mrkDebug.error('[Bundle] Numbered properties verification failed (logged only, add proceeds).', failures);
          $('.mrk-loader-main').css('display', 'none');
          // Re-enable Finish button so it never stays stuck (no user-facing blocking)
          var $finishBtn = $('.mrk-final-add-to-cart');
          if ($finishBtn.length) {
            $finishBtn.data('isProcessing', false);
            $finishBtn.prop('disabled', false);
            var orig = $finishBtn.data('originalText');
            if (orig) $finishBtn.text(orig).html(orig); else $finishBtn.text('Add to cart').html('Add to cart');
          }
          // Do not return — proceed with cart add so user flow is never blocked
        }
      }
    }
  } catch (verifyErr) {
    if (debugLog && typeof addDebugError === 'function') {
      addDebugError('numbered_properties_verification_error', { error: (verifyErr && verifyErr.message) || String(verifyErr) });
    }
  }
  // ===== END NUMBERED PROPERTIES VERIFICATION =====
  
  // CRITICAL FIX (Orders #52130, #52267): Log request steps BEFORE adding debug log to payload
  // so the payload we send includes these steps (order was only persisting log up to cart_state_before_add)
  if (debugLog) {
    addDebugStep('cart_add_request_sending', 'started', {
      payloadItemCount: data.items ? data.items.length : 0,
      note: 'About to send request to /cart/add.js - if log ends here, check for JS error or navigation'
    });
  }
  
  // Log detailed request payload (try/catch so we never block the actual request)
  if (debugLog) {
    try {
      var positionVariantsInRequest = data.items.filter(function(item) {
        return item.properties && item.properties._ParentVariant;
      });
      var detailedRequestItems = data.items.map(function(item) {
        var itemDetails = {
          id: item.id,
          quantity: item.quantity,
          isPositionVariant: !!(item.properties && item.properties._ParentVariant),
          hasLogoId: !!(item.properties && item.properties['Logo Id']),
          hasPosition: !!(item.properties && item.properties.Position),
          hasParentVariant: !!(item.properties && item.properties._ParentVariant)
        };
        if (item.properties && item.properties._ParentVariant) {
          itemDetails.logoId = item.properties['Logo Id'] || 'missing';
          itemDetails.position = item.properties.Position || 'missing';
          itemDetails.parentVariant = item.properties._ParentVariant || 'missing';
          itemDetails.applicationMethod = item.properties['Application Method'] || 'missing';
          itemDetails.logoType = item.properties['Logo Type'] || 'missing';
          itemDetails._qty = item.properties._qty || 'missing';
          itemDetails._lineItemKey = item.properties._lineItemKey || 'missing';
          itemDetails._BundleItemName = item.properties._BundleItemName || 'missing';
        }
        return itemDetails;
      });
      addDebugStep('cart_add_request_sent', 'started', {
        totalItems: data.items.length,
        mainBundleItems: data.items.filter(function(item) {
          return !item.properties || !item.properties._ParentVariant;
        }).length,
        positionVariants: positionVariantsInRequest.length,
        positionVariantsDetails: positionVariantsInRequest.map(function(item) {
          return {
            variantId: item.id,
            quantity: item.quantity,
            logoId: item.properties && item.properties['Logo Id'] || 'missing',
            position: item.properties && item.properties.Position || 'missing',
            parentVariant: item.properties && item.properties._ParentVariant || 'missing',
            applicationMethod: item.properties && item.properties['Application Method'] || 'missing',
            _qty: item.properties && item.properties._qty || 'missing',
            _lineItemKey: item.properties && item.properties._lineItemKey || 'missing'
          };
        }),
        requestPayload: { itemsCount: data.items.length, items: detailedRequestItems },
        note: 'Full request payload being sent to /cart/add.js'
      });
    } catch (payloadLogErr) {
      if (debugLog && typeof addDebugError === 'function') {
        addDebugError('cart_add_request_log_failed', {
          error: (payloadLogErr && payloadLogErr.message) || String(payloadLogErr),
          note: 'Payload logging threw - request still sent'
        });
      }
    }
  }
  
  // CRITICAL FIX (Orders #52130, #52267): Add debug log to payload AFTER request steps so
  // the body we send includes cart_add_request_sent (order was only showing log up to cart_state_before_add)
  if (debugLog && data.items && data.items.length > 0) {
    try {
      var mainBundleItem = data.items.find(function(item) {
        return item.properties && (item.properties._bundle || item.properties._bundle_raw);
      }) || data.items[0];
      if (mainBundleItem && mainBundleItem.properties) {
        if (!debugLog.version) { debugLog.version = '7.0.0'; }
        if (!debugLog.theme) { debugLog.theme = 'base'; debugLog.themeVersion = _themeVersion; }
        if (JRS_DEBUG_PROPERTIES_IN_CART) {
          mainBundleItem.properties['_bundle_debug_log'] = getPersistableDebugLog(debugLog);
          mainBundleItem.properties['_debug_errors_count'] = String(debugLog.errors ? debugLog.errors.length : 0);
          if (debugLog.errors && debugLog.errors.length > 0) {
            var lastErr = debugLog.errors[debugLog.errors.length - 1];
            var lastErrMsg = (typeof lastErr === 'string' ? lastErr : (lastErr && lastErr.message) || JSON.stringify(lastErr)).slice(0, 200);
            mainBundleItem.properties['_debug_last_error'] = lastErrMsg;
          }
        }
      }
    } catch (serializeErr) {
      if (typeof addDebugError === 'function') {
        addDebugError('debug_log_serialize_failed', {
          error: (serializeErr && serializeErr.message) || String(serializeErr),
          note: 'Debug log not added to payload - request still sent'
        });
      }
    }
  }
  
  // BUG-BUNDLE-RAW-001: Pre-cart-add validation - do not proceed if _bundle_raw is invalid
  var mainBundleItemForValidation = data.items && data.items.find(function(item) {
    return item.properties && (item.properties._bundle || item.properties._bundle_raw);
  });
  if (mainBundleItemForValidation && mainBundleItemForValidation.properties && typeof window.validateBundleRaw === 'function') {
    var bundleRawToValidate = mainBundleItemForValidation.properties._bundle_raw;
    var validation = window.validateBundleRaw(bundleRawToValidate);
    if (!validation.valid && validation.errors && validation.errors.length > 0) {
      if (debugLog && typeof addDebugError === 'function') {
        addDebugError('bundle_raw_validation_failed', { errors: validation.errors });
      }
      mrkDebug.error('[Bundle] _bundle_raw validation failed. Not adding to cart.', validation.errors);
      $('.mrk-loader-main').css('display', 'none');
      var $finishBtnRaw = $('.mrk-final-add-to-cart');
      if ($finishBtnRaw.length) {
        $finishBtnRaw.data('isProcessing', false);
        $finishBtnRaw.prop('disabled', false);
        var origRaw = $finishBtnRaw.data('originalText');
        if (origRaw) $finishBtnRaw.text(origRaw).html(origRaw); else $finishBtnRaw.text('Add to cart').html('Add to cart');
      }
      return;
    }
  }
  
  // Split same-variant children to prevent Shopify batch merge (Bug F)
  var seenVariants = {};
  var batchItems = [];
  var deferredItems = [];
  if (data.items && Array.isArray(data.items)) {
    data.items.forEach(function(item) {
      var vid = String(item.id);
      if (!item.properties || !item.properties._ParentVariant) {
        batchItems.push(item);
      } else if (!seenVariants[vid]) {
        seenVariants[vid] = true;
        batchItems.push(item);
      } else {
        deferredItems.push(item);
      }
    });
  } else {
    batchItems = data.items || [];
  }
  var batchData = { items: batchItems };

  function sendDeferredItems(deferredList, callback) {
    if (!deferredList || deferredList.length === 0) { callback(); return; }
    var idx = 0;
    function next() {
      if (idx >= deferredList.length) { callback(); return; }
      var item = deferredList[idx++];
      jQuery.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: JSON.stringify({ items: [item] }),
        contentType: 'application/json',
        dataType: 'json'
      }).always(next);
    }
    next();
  }

  jQuery.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: batchData,
    dataType: 'json',
    beforeSend :function(){
      $('.mrk-loader-main').css('display', 'flex');
    },
    success: function(resp) {
      sendDeferredItems(deferredItems, function() {
      // CRITICAL FIX: Log cart API response immediately (Order #51786 fix, #52500 enhancement)
      if (debugLog) {
        var positionVariantsInResponse = resp && resp.items ? resp.items.filter(function(item) {
          return item.properties && item.properties._ParentVariant;
        }) : [];
        
        addDebugStep('cart_add_response_received', 'success', {
          responseItemCount: resp && resp.items ? resp.items.length : 0,
          responseHasItems: !!(resp && resp.items),
          responseStatus: 'success',
          positionVariantsInResponse: positionVariantsInResponse.length,
          responseItems: resp && resp.items ? resp.items.map(function(item) {
            return {
              variantId: item.variant_id,
              quantity: item.quantity,
              isPositionVariant: !!(item.properties && item.properties._ParentVariant),
              logoId: item.properties && item.properties['Logo Id'] || 'missing',
              position: item.properties && item.properties.Position || 'missing',
              parentVariant: item.properties && item.properties._ParentVariant || 'missing',
              lineItemKey: item.properties && item.properties._lineItemKey || 'missing'
            };
          }) : [],
          positionVariantsDetails: positionVariantsInResponse.map(function(item) {
            return {
              variantId: item.variant_id,
              quantity: item.quantity,
              logoId: item.properties && item.properties['Logo Id'] || 'missing',
              position: item.properties && item.properties.Position || 'missing',
              parentVariant: item.properties && item.properties._ParentVariant || 'missing',
              lineItemKey: item.properties && item.properties._lineItemKey || 'missing'
            };
          }),
          note: 'Response received from /cart/add.js - verifying items next'
        });
        
        // ====================================================================
        // CRITICAL FIX (Order #52472): Missing Cart Items - Same Variant ID Merge
        // ====================================================================
        // PROBLEM: When multiple logo positions use the same variant ID (e.g., 44333841875187),
        // Shopify's cart API merges them into a single line item, causing items to disappear.
        // Order #52472 had 3 logo positions sent but only 1 ended up in the order.
        //
        // ROOT CAUSE:
        // 1. All 3 logo positions used same variant ID (44333841875187)
        // 2. Shopify merged them into one line item (kept only one set of properties)
        // 3. Cart validation matched by variant ID + logo ID, not _lineItemKey
        // 4. Validation only recovered 1 of 3 missing items
        //
        // SOLUTION:
        // 1. Enhanced response parsing to detect same variant ID groups
        // 2. Match by _lineItemKey FIRST (most reliable identifier)
        // 3. Immediate recovery for missing items detected in response
        // 4. Updated validation to use _lineItemKey for matching
        // ====================================================================
        // CRITICAL FIX (Order #52500, #52472): Parse and log response data with detailed comparison
        var responseItemKeys = [];
        if (resp && resp.items) {
          resp.items.forEach(function(item) {
            if (item.properties && item.properties._lineItemKey) {
              responseItemKeys.push(item.properties._lineItemKey);
            } else if (item.properties && item.properties._ParentVariant) {
              // Build key from properties if _lineItemKey missing
              var logoId = String(item.properties['Logo Id'] || '').trim();
              var position = String(item.properties.Position || '').trim();
              var key = item.variant_id + '_' + logoId + '_' + position.replace(/\s/g, '_');
              responseItemKeys.push(key);
            }
          });
        }
        
        var requestItemKeys = [];
        if (batchData.items) {
          batchData.items.forEach(function(item) {
            if (item.properties && item.properties._lineItemKey) {
              requestItemKeys.push(item.properties._lineItemKey);
            } else if (item.properties && item.properties._ParentVariant) {
              var logoId = String(item.properties['Logo Id'] || '').trim();
              var position = String(item.properties.Position || '').trim();
              var key = item.id + '_' + logoId + '_' + position.replace(/\s/g, '_');
              requestItemKeys.push(key);
            }
          });
        }
        
        var missingKeys = requestItemKeys.filter(function(key) {
          return responseItemKeys.indexOf(key) === -1;
        });
        
        // CRITICAL FIX (Order #52472): Detect same variant ID groups
        var sameVariantIdGroups = {};
        if (batchData.items) {
          batchData.items.forEach(function(item) {
            if (item.properties && item.properties._ParentVariant) {
              var vid = item.id;
              if (!sameVariantIdGroups[vid]) {
                sameVariantIdGroups[vid] = [];
              }
              sameVariantIdGroups[vid].push({
                logoId: item.properties['Logo Id'],
                lineItemKey: item.properties._lineItemKey,
                quantity: item.quantity,
                position: item.properties.Position
              });
            }
          });
        }
        
        var hasSameVariantId = Object.keys(sameVariantIdGroups).some(function(vid) {
          return sameVariantIdGroups[vid].length > 1;
        });
        
        addDebugStep('cart_add_response_parsed', 'success', {
          itemsReturned: resp && resp.items ? resp.items.length : 0,
          hasItems: !!(resp && resp.items),
          itemIds: resp && resp.items ? resp.items.map(function(i) { return i.variant_id; }) : [],
          positionVariantIds: positionVariantsInResponse.map(function(i) { return i.variant_id; }),
          requestItemKeys: requestItemKeys,
          responseItemKeys: responseItemKeys,
          missingKeys: missingKeys,
          sameVariantIdDetected: hasSameVariantId ? {
            detected: true,
            groups: Object.keys(sameVariantIdGroups).filter(function(vid) {
              return sameVariantIdGroups[vid].length > 1;
            }).map(function(vid) {
              return {
                variantId: vid,
                itemCount: sameVariantIdGroups[vid].length,
                items: sameVariantIdGroups[vid],
                warning: 'Multiple items with same variant ID - Shopify may merge them into one line item'
              };
            })
          } : false,
          note: missingKeys.length > 0 ?
            'CRITICAL: Items missing from response - will trigger immediate recovery' :
            'Response parsed successfully - proceeding to verification'
        });

        // P1.4 — Spec-named cart_add_confirmed / cart_add_partial step (Bug #7 fix verification).
        var bundleItemsExpected = batchData.items ? batchData.items.length : 0;
        var bundleItemsInResponse = resp && resp.items ? resp.items.length : 0;
        var bundleItemsLost = Math.max(0, bundleItemsExpected - bundleItemsInResponse);
        addDebugStep(
          (bundleItemsLost === 0 && missingKeys.length === 0) ? 'cart_add_confirmed' : 'cart_add_partial',
          (bundleItemsLost === 0 && missingKeys.length === 0) ? 'success' : 'partial',
          {
            httpStatus: 200,
            itemsRequested: bundleItemsExpected,
            itemsAdded: bundleItemsInResponse,
            itemsLost: bundleItemsLost,
            addedKeys: resp && resp.items ? resp.items.map(function(i) { return i.key; }) : [],
            expectedChildKeys: requestItemKeys,
            missingChildKeys: missingKeys
          }
        );
      }
      $('.mrk-loader-main').css('display', 'none');
      
      // CRITICAL FIX: Verify position variants were added (Order #51786 fix)
      var positionVariantsInResponse = resp && resp.items ? resp.items.filter(function(item) {
        return item.properties && item.properties._ParentVariant;
      }) : [];
      
      var positionVariantsInRequest = batchData.items.filter(function(item) {
        return item.properties && item.properties._ParentVariant;
      });
      
      if (debugLog && positionVariantsInRequest.length > 0) {
        addDebugStep('position_variants_verification', positionVariantsInResponse.length === positionVariantsInRequest.length ? 'success' : 'error', {
          expected: positionVariantsInRequest.length,
          actual: positionVariantsInResponse.length,
          missing: positionVariantsInRequest.length - positionVariantsInResponse.length,
          expectedVariants: positionVariantsInRequest.map(function(item) {
            return {
              variantId: item.id,
              quantity: item.quantity,
              logoId: item.properties && item.properties['Logo Id'] || 'missing',
              position: item.properties && item.properties.Position || 'missing'
            };
          }),
          actualVariants: positionVariantsInResponse.map(function(item) {
            return {
              variantId: item.variant_id,
              quantity: item.quantity,
              logoId: item.properties && item.properties['Logo Id'] || 'missing',
              position: item.properties && item.properties.Position || 'missing'
            };
          }),
          note: positionVariantsInResponse.length < positionVariantsInRequest.length ? 
            'CRITICAL: Some position variants are missing from cart response!' : 
            'All position variants successfully added to cart'
        });
        
        // CRITICAL FIX (Order #52472): Match by _lineItemKey for accurate comparison when same variant ID
        var responseByKey = {};
        positionVariantsInResponse.forEach(function(item) {
          var key = item.properties && item.properties._lineItemKey;
          if (!key) {
            // Build key if missing
            var logoId = String(item.properties && item.properties['Logo Id'] || '').trim();
            var position = String(item.properties && item.properties.Position || '').trim();
            key = item.variant_id + '_' + logoId + '_' + position.replace(/\s/g, '_');
          }
          if (!responseByKey[key]) {
            responseByKey[key] = [];
          }
          responseByKey[key].push(item);
        });
        
        var requestByKey = {};
        positionVariantsInRequest.forEach(function(item) {
          var key = item.properties && item.properties._lineItemKey;
          if (!key) {
            var logoId = String(item.properties && item.properties['Logo Id'] || '').trim();
            var position = String(item.properties && item.properties.Position || '').trim();
            key = item.id + '_' + logoId + '_' + position.replace(/\s/g, '_');
          }
          requestByKey[key] = item;
        });
        
        var missingByKey = [];
        Object.keys(requestByKey).forEach(function(key) {
          if (!responseByKey[key] || responseByKey[key].length === 0) {
            missingByKey.push({
              key: key,
              item: requestByKey[key]
            });
          }
        });
        
        // Target 1a (Order #56619): Post-add verification — fetch /cart.js after short delay to catch async merge; log if children disappeared.
        if (positionVariantsInRequest.length > 0 && typeof fetch === 'function') {
          var verifyKeys = Object.keys(requestByKey);
          setTimeout(function() {
            fetch((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root + 'cart.js' : '/cart.js')
              .then(function(r) { return r.json(); })
              .then(function(cart) {
                if (!cart || !cart.items) return;
                var cartKeys = [];
                cart.items.forEach(function(item) {
                  if (item.properties && item.properties._ParentVariant) {
                    var k = item.properties._lineItemKey || (item.variant_id + '_' + (item.properties['Logo Id'] || '').trim() + '_' + (item.properties.Position || '').trim().replace(/\s/g, '_'));
                    cartKeys.push(k);
                  }
                });
                var stillMissing = verifyKeys.filter(function(key) {
                  return cartKeys.indexOf(key) === -1;
                });
                if (stillMissing.length > 0 && typeof mrkDebug !== 'undefined' && mrkDebug.warn) {
                  mrkDebug.warn('[BundleCustomizer] Post-add verification: ' + stillMissing.length + ' children missing from cart ~1s after add — possible async merge (Order #56619)', { keys: stillMissing });
                }
              })
              .catch(function() {});
          }, 1000);
        }
        
        // CRITICAL: If position variants are missing, log detailed error with same variant ID warning
        if (missingByKey.length > 0) {
          var sameVariantIdGroups = {};
          positionVariantsInRequest.forEach(function(item) {
            var vid = item.id;
            if (!sameVariantIdGroups[vid]) {
              sameVariantIdGroups[vid] = [];
            }
            sameVariantIdGroups[vid].push(item);
          });
          
          var hasSameVariantId = Object.keys(sameVariantIdGroups).some(function(vid) {
            return sameVariantIdGroups[vid].length > 1;
          });
          
          addDebugError('Position variants missing from cart response', {
            missingCount: missingByKey.length,
            missingVariants: missingByKey.map(function(m) {
              return {
                variantId: m.item.id,
                quantity: m.item.quantity,
                logoId: m.item.properties && m.item.properties['Logo Id'] || 'missing',
                position: m.item.properties && m.item.properties.Position || 'missing',
                parentVariant: m.item.properties && m.item.properties._ParentVariant || 'missing',
                lineItemKey: m.key,
                note: 'This variant was in the request but not in the response - possible API rejection or same variant ID merge'
              };
            }),
            impact: 'CRITICAL: Customer will not be charged for missing embroidery positions',
            sameVariantIdIssue: hasSameVariantId ? {
              detected: true,
              groups: Object.keys(sameVariantIdGroups).filter(function(vid) {
                return sameVariantIdGroups[vid].length > 1;
              }).map(function(vid) {
                return {
                  variantId: vid,
                  itemCount: sameVariantIdGroups[vid].length,
                  items: sameVariantIdGroups[vid].map(function(item) {
                    return {
                      logoId: item.properties && item.properties['Logo Id'],
                      lineItemKey: item.properties && item.properties._lineItemKey,
                      quantity: item.quantity,
                      position: item.properties && item.properties.Position
                    };
                  }),
                  warning: 'Multiple items with same variant ID - Shopify may have merged them into one line item'
                };
              })
            } : false
          });
        }
      }
      
      // Verify all items were added
      if (resp && resp.items) {
        var actualItemCount = resp.items.length;
        
        // CRITICAL VALIDATION: Check if main product has logo properties but no position variants in cart
        var mainProductInCart = resp.items.find(function(item) {
          return !item.properties || !item.properties._ParentVariant;
        });
        var mainProductHasLogoButNoVariants = false;
        var mainProductLogoProperties = [];
        
        if (mainProductInCart && mainProductInCart.properties) {
          var logoPropertyKeys = ['Application Method', 'Position', 'Logo Type', 'Logo', 'Logo Text', '_logoVariant'];
          logoPropertyKeys.forEach(function(key) {
            for (var prop in mainProductInCart.properties) {
              if (prop.indexOf(key) === 0) {
                mainProductHasLogoButNoVariants = true;
                mainProductLogoProperties.push(prop);
              }
            }
          });
          
          if (mainProductHasLogoButNoVariants) {
            // Check if position variants exist in cart
            var hasPositionVariantsInCart = resp.items.some(function(item) {
              return item.properties && 
                     item.properties._ParentVariant && 
                     item.properties._ParentVariant == mainProductInCart.variant_id;
            });
            
            if (!hasPositionVariantsInCart) {
                // mainProductVariantId: mainProductInCart.variant_id,
                // logoProperties: mainProductLogoProperties,
                // cartItems: resp.items.map(function(item) {
                  // return {
                    // variantId: item.variant_id,
                    // isPositionVariant: !!(item.properties && item.properties._ParentVariant),
                    // parentVariant: item.properties && item.properties._ParentVariant
                  // };
                // })
              // });
              
              if (debugLog) {
                addDebugError('Main product has logo properties but no position variants in cart response', {
                  mainProductVariantId: mainProductInCart.variant_id,
                  logoProperties: mainProductLogoProperties
                });
                
                // Add to debug log
                if (!debugLog.data.cartResponseValidation) {
                  debugLog.data.cartResponseValidation = {};
                }
                debugLog.data.cartResponseValidation.missingPositionVariants = {
                  mainProductVariantId: mainProductInCart.variant_id,
                  logoProperties: mainProductLogoProperties,
                  cartItems: resp.items.map(function(item) {
                    return {
                      variantId: item.variant_id,
                      isPositionVariant: !!(item.properties && item.properties._ParentVariant),
                      parentVariant: item.properties && item.properties._ParentVariant
                    };
                  })
                };
              }
            }
          }
        }
        
        // CRITICAL: Verify logo products quantities match expected
        var bundleQuantityMismatches = [];
        var logoProductsAdded = 0;
        
        // For bundles, Shopify may aggregate items with the same variant ID and Logo ID
        // So we need to calculate expected quantity from _bundle_raw or sum of _qty from original request
        // Build a map of expected quantities by variant ID + Logo ID
        var expectedQuantitiesByKey = {};
        if (data && data.items) {
          data.items.forEach(function(requestItem) {
            if (requestItem.properties && requestItem.properties._ParentVariant) {
              // Normalize Logo ID to string and trim whitespace
              var logoId = String(requestItem.properties['Logo Id'] || '').trim();
              var variantId = Number(requestItem.id) || 0;
              var key = variantId + '_' + logoId;
              var qty = Number(requestItem.quantity) || 0;
              
              if (!expectedQuantitiesByKey[key]) {
                expectedQuantitiesByKey[key] = 0;
              }
              expectedQuantitiesByKey[key] += qty;
            }
          });
        }
        
        // CRITICAL FIX: Sum actual quantities by key first, then compare
        // Shopify may or may not aggregate items depending on properties (_BundleItemName, etc.)
        // If items aren't aggregated, we'll have multiple line items with the same variant+LogoId
        // We need to sum their quantities before comparing to expected totals
        var actualQuantitiesByKey = {};
        resp.items.forEach(function(item) {
          if (item.properties && item.properties._ParentVariant) {
            logoProductsAdded++;
            
            var positionQty = Number(item.quantity) || 0;
            // Normalize Logo ID to string and trim whitespace (must match normalization above)
            var logoId = String(item.properties['Logo Id'] || '').trim();
            var variantId = Number(item.variant_id) || 0;
            var key = variantId + '_' + logoId;
            
            // Sum actual quantities by key (handles both aggregated and non-aggregated scenarios)
            if (!actualQuantitiesByKey[key]) {
              actualQuantitiesByKey[key] = 0;
            }
            actualQuantitiesByKey[key] += positionQty;
            
            // Also check if quantity is valid
            if (positionQty <= 0 || isNaN(positionQty)) {
              bundleQuantityMismatches.push({
                variantId: item.variant_id,
                position: item.properties.Position || item.properties.property || 'Unknown',
                issue: 'Invalid quantity',
                qty: positionQty
              });
            }
          }
        });
        
        // Now compare summed actual quantities against expected quantities
        Object.keys(actualQuantitiesByKey).forEach(function(key) {
          var actualTotalQty = actualQuantitiesByKey[key];
          var expectedQty = expectedQuantitiesByKey[key] || 0;
          
          // Only flag as mismatch if expectedQty > 0 AND there's a real difference
          if (expectedQty > 0 && actualTotalQty !== expectedQty) {
            // Find one of the items with this key for reporting
            var sampleItem = resp.items.find(function(item) {
              if (item.properties && item.properties._ParentVariant) {
                var logoId = String(item.properties['Logo Id'] || '').trim();
                var variantId = Number(item.variant_id) || 0;
                return (variantId + '_' + logoId) === key;
              }
              return false;
            });
            
            bundleQuantityMismatches.push({
              variantId: sampleItem ? sampleItem.variant_id : key.split('_')[0],
              position: sampleItem ? (sampleItem.properties.Position || sampleItem.properties.property || 'Unknown') : 'Unknown',
              logoId: key.split('_')[1] || '',
              expectedQty: expectedQty,
              actualQty: actualTotalQty,
              difference: expectedQty - actualTotalQty,
              lookupKey: key,
              foundInExpectedMap: !!expectedQuantitiesByKey[key],
              note: 'Comparing summed actual quantities against expected totals (handles both aggregated and non-aggregated items)'
            });
          }
        });
        
        if (bundleQuantityMismatches.length > 0) {
            // mismatches: bundleQuantityMismatches,
            // totalMismatches: bundleQuantityMismatches.length
          // });
          if (debugLog) {
            addDebugError('Logo product quantity mismatches in cart response', {
              mismatches: bundleQuantityMismatches
            });
            
            // Add to debug log
            if (!debugLog.data.cartResponseValidation) {
              debugLog.data.cartResponseValidation = {};
            }
            debugLog.data.cartResponseValidation.quantityMismatches = bundleQuantityMismatches;
            debugLog.data.cartResponseValidation.totalMismatches = bundleQuantityMismatches.length;
          }
        }
        
        // CRITICAL FIX: Account for Shopify aggregating items with same variant ID + Logo ID
        // When Shopify aggregates items, the item count decreases but quantities are preserved
        // So we need to check if total quantities match, not just item count
        var expectedTotalQty = 0;
        var actualTotalQty = 0;
        
        if (data && data.items) {
          data.items.forEach(function(item) {
            expectedTotalQty += Number(item.quantity) || 0;
          });
        }
        
        if (resp && resp.items) {
          resp.items.forEach(function(item) {
            actualTotalQty += Number(item.quantity) || 0;
          });
        }
        
        // Check if items are missing (variant IDs not in response)
        var addedVariantIds = resp.items.map(function(item) { return item.variant_id; });
        var requestedVariantIds = data.items.map(function(item) { return item.id; });
        var missingVariantIds = requestedVariantIds.filter(function(id) {
          return addedVariantIds.indexOf(id) === -1;
        });
        
        // CRITICAL FIX: Only check for missing variant IDs if quantities don't match
        // When Shopify aggregates items, variant IDs will be "missing" even though
        // items were successfully added (just aggregated). Only flag as error if
        // quantities also don't match, which indicates actual missing items.
        var itemCountDifference = expectedItemCount - actualItemCount;
        var quantityDifference = expectedTotalQty - actualTotalQty;
        
        // Only consider variant IDs as "missing" if quantities don't match
        // If quantities match, missing variant IDs are just due to aggregation
        var hasMissingVariants = missingVariantIds.length > 0 && quantityDifference > 0;
        
        // Only show error if:
        // 1. Variant IDs are missing AND quantities don't match (definite failure)
        // 2. OR item count is significantly lower AND quantities don't match (suggests actual missing items)
        if (hasMissingVariants || (itemCountDifference > 0 && quantityDifference > 0 && itemCountDifference > quantityDifference)) {
            // expected: expectedItemCount,
            // actual: actualItemCount,
            // expectedTotalQty: expectedTotalQty,
            // actualTotalQty: actualTotalQty,
            // missingVariantIds: missingVariantIds,
            // requestData: data,
            // response: resp
          // });
          
          if (debugLog) {
            addDebugError('Not all items added to cart', {
              expected: expectedItemCount,
              actual: actualItemCount,
              expectedTotalQty: expectedTotalQty,
              actualTotalQty: actualTotalQty,
              missingVariantIds: missingVariantIds,
              note: 'Shopify may have aggregated some items - checking quantities and variant IDs'
            });
          }
          
        } else if (itemCountDifference > 0 && quantityDifference === 0) {
          // Items were aggregated but quantities match - this is OK, just log it
          if (debugLog) {
            addDebugStep('items_aggregated_by_shopify', 'success', {
              expectedItemCount: expectedItemCount,
              actualItemCount: actualItemCount,
              expectedTotalQty: expectedTotalQty,
              actualTotalQty: actualTotalQty,
              note: 'Shopify aggregated items with same variant ID + Logo ID, but quantities match'
            });
          }
        } else {
          
          if (debugLog) {
            // CRITICAL FIX: Enhanced success logging with position variant verification (Order #51786 fix)
            var positionVariantsSuccessfullyAdded = resp.items.filter(function(item) {
              return item.properties && item.properties._ParentVariant;
            }).length;
            
            debugLog.steps.push({
              step: 'cart_add_success',
              status: bundleQuantityMismatches.length === 0 && positionVariantsSuccessfullyAdded === positionVariantsInRequest.length ? 'success' : 'warning',
              details: {
                expectedItems: data.items.length,
                actualItems: actualItemCount,
                quantityMismatches: bundleQuantityMismatches.length,
                logoProductsAdded: logoProductsAdded,
                positionVariantsExpected: positionVariantsInRequest.length,
                positionVariantsAdded: positionVariantsSuccessfullyAdded,
                allPositionVariantsAdded: positionVariantsSuccessfullyAdded === positionVariantsInRequest.length,
                note: positionVariantsSuccessfullyAdded < positionVariantsInRequest.length ? 
                  'WARNING: Not all position variants were added to cart!' : 
                  'All position variants successfully added'
              },
              time: new Date().toISOString()
            });
            // Order #52267: Track that bundle was just added (for re-configuration / bundleAlreadyInCart detection)
            var mainBundleVariantId = mainProductInCart ? mainProductInCart.variant_id : (window.bundleId || null);
            if (mainBundleVariantId) {
              window.bundleLastAddedVariantId = mainBundleVariantId;
              window.bundleLastAddedAt = Date.now();
            }
            window.bundleFinishPreviouslySucceeded = true;

            // CRITICAL: If position variants are missing, this is a critical error
            if (positionVariantsSuccessfullyAdded < positionVariantsInRequest.length) {
              addDebugError('Position variants missing after cart add success', {
                expected: positionVariantsInRequest.length,
                actual: positionVariantsSuccessfullyAdded,
                missing: positionVariantsInRequest.length - positionVariantsSuccessfullyAdded,
                impact: 'CRITICAL: Customer will not be charged for missing embroidery positions',
                recommendation: 'Check Shopify cart API response and item properties'
              });
            }
          }
          
          if (bundleQuantityMismatches.length === 0) {
              // logoProductsCount: logoProductsAdded,
              // allQuantitiesMatch: true
            // });
          }
        }
      }

      // CRITICAL FIX (Order #52039, #52500, #52472): Post-add verification - fetch cart and verify all position variants are present
      function doRedirect() {
        // P0.8 — Universal post-add verification + recovery via JRS.CartValidator. Fire-and-forget.
        if (window.JRS && JRS.CartValidator && typeof JRS.CartValidator.verifyAfterAdd === 'function') {
          try {
            JRS.CartValidator.verifyAfterAdd(batchData, resp).then(function(validatorResult) {
              if (debugLog && typeof addDebugStep === 'function') {
                addDebugStep('jrs_validator_verifyAfterAdd', validatorResult && validatorResult.valid ? 'success' : 'error', {
                  valid: !!(validatorResult && validatorResult.valid),
                  issuesFound: validatorResult && validatorResult.issues ? validatorResult.issues.length : 0,
                  issuesFixed: (validatorResult && validatorResult.issuesFixed) || 0,
                  issues: (validatorResult && validatorResult.issues) || []
                });
              }
            }).catch(function(err) {
              if (debugLog && typeof addDebugStep === 'function') {
                addDebugStep('jrs_validator_verifyAfterAdd', 'error', { error: (err && err.message) || String(err) });
              }
            });
          } catch (e) {
            mrkDebug.warn('[Bundle] JRS.CartValidator.verifyAfterAdd threw:', e && e.message);
          }
        }
        if (debugLog) {
          addDebugStep('post_add_behavior', 'success', {
            redirecting: true,
            redirectUrl: '/cart',
            note: 'Always redirect to /cart after successful bundle add to prevent duplicate children on repeat clicks'
          });
        }
        // P1.4 — Persist post-add debug log so cart_add_confirmed/partial/failed steps reach the order.
        // Pre-add seal at line ~4201 froze the log on the bundle parent's properties; this layer writes the latest version.
        if (typeof JRS_DEBUG_PROPERTIES_IN_CART !== 'undefined' && JRS_DEBUG_PROPERTIES_IN_CART && debugLog && resp && resp.items) {
          try {
            var bundleLogJson = getPersistableDebugLog(debugLog);
            // Cart-attribute fallback (mirrors customizer line 5709 pattern).
            jQuery.ajax({
              type: 'POST',
              url: window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/update.js' : '/cart/update.js',
              data: { attributes: { '_bundle_debug_log': bundleLogJson } },
              dataType: 'json'
            });
            // Line-item property write — survives to the order.
            var bundleParentInResponse = resp.items.find(function(item) {
              return item.properties && (item.properties._bundle_raw || item.properties._bundle);
            });
            if (bundleParentInResponse && bundleParentInResponse.key) {
              var mergedBundleProps = {};
              if (bundleParentInResponse.properties) {
                for (var bpk in bundleParentInResponse.properties) {
                  if (bundleParentInResponse.properties.hasOwnProperty(bpk)) {
                    mergedBundleProps[bpk] = bundleParentInResponse.properties[bpk];
                  }
                }
              }
              mergedBundleProps['_bundle_debug_log'] = bundleLogJson;
              jQuery.ajax({
                type: 'POST',
                url: window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/change.js' : '/cart/change.js',
                data: { id: bundleParentInResponse.key, properties: mergedBundleProps },
                dataType: 'json'
              });
            }
          } catch (e) {
            mrkDebug.warn('[Bundle] Failed to persist post-add debug log:', e && e.message);
          }
        }
        // Committed add-to-cart: consume the saved builder selection so the next
        // visit starts fresh (jrs.pdp.selection.v1 — product-scoped on read).
        // Only reachable on the success path; failed/abandoned adds return
        // earlier and stay resumable.
        if (window.JRS && window.JRS.PdpSelectionStore && typeof window.JRS.PdpSelectionStore.clear === 'function') {
          try { window.JRS.PdpSelectionStore.clear(); } catch (e) {}
        } else {
          try { localStorage.removeItem('jrs.pdp.selection.v1'); } catch (e) {}
        }
        // Run 3 — fire post_add_complete. variantaug's original behaviour on
        // the direct-bundle add IS the redirect, so BOTH arms navigate; the
        // button stays locked while the page unloads (prior behaviour).
        window.__jrsDirectAddRedirecting = true;
        if (window.JRS && window.JRS.PostAdd && typeof window.JRS.PostAdd.complete === 'function') {
          if (window.JRS.PostAdd.complete({ path: 'bundle_direct' }) !== 'redirect') {
            location.pathname = '/cart';
          }
        } else {
          location.pathname = '/cart';
        }
      }

      var batchPositionVariants = batchData.items ? batchData.items.filter(function(i) {
        return i.properties && i.properties._ParentVariant;
      }) : [];
      var expectedPositionVariants = data.items ? data.items.filter(function(i) {
        return i.properties && i.properties._ParentVariant;
      }) : [];
      var cartJsUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root + 'cart.js' : '/cart.js';

      // CRITICAL FIX (Order #52472): Immediate recovery for missing items detected in response
      // Only check batch items against response — deferred items were sent separately
      if (debugLog && resp && resp.items && batchPositionVariants.length > 0) {
        var responseByKey = {};
        resp.items.forEach(function(item) {
          if (item.properties && item.properties._ParentVariant) {
            var key = item.properties._lineItemKey;
            if (!key) {
              var logoId = String(item.properties['Logo Id'] || '').trim();
              var position = String(item.properties.Position || '').trim();
              key = item.variant_id + '_' + logoId + '_' + position.replace(/\s/g, '_');
            }
            responseByKey[key] = item;
          }
        });
        
        var immediateMissingItems = [];
        batchPositionVariants.forEach(function(expected) {
          var key = expected.properties && expected.properties._lineItemKey;
          if (!key) {
            var logoId = String(expected.properties['Logo Id'] || '').trim();
            var position = String(expected.properties.Position || '').trim();
            key = expected.id + '_' + logoId + '_' + position.replace(/\s/g, '_');
          }
          if (!responseByKey[key]) {
            immediateMissingItems.push(expected);
          }
        });
        
        if (immediateMissingItems.length > 0) {
          if (debugLog) {
            addDebugStep('cart_add_immediate_missing_detected', 'error', {
              missingCount: immediateMissingItems.length,
              missingItems: immediateMissingItems.map(function(item) {
                return {
                  variantId: item.id,
                  logoId: item.properties && item.properties['Logo Id'],
                  position: item.properties && item.properties.Position,
                  quantity: item.quantity,
                  lineItemKey: item.properties && item.properties._lineItemKey,
                  note: 'Item missing from response - will attempt immediate recovery'
                };
              }),
              note: 'Items detected missing from response - attempting immediate recovery before cart verification'
            });
          }
          
          // CRITICAL FIX (Order #52472): Immediately try to add missing items individually
          // This handles same variant ID merge scenarios
          var immediateRecoveryPromises = immediateMissingItems.map(function(missingItem, idx) {
            return new Promise(function(resolve) {
              setTimeout(function() {
                var props = missingItem.properties || {};
                if (!props._debug_add_source) {
                  props._debug_add_source = 'bundle_recovery';
                  props._debug_add_timestamp = new Date().toISOString();
                  props._debug_pdp_variant_selected = String(missingItem.id);
                  props._debug_pdp_qty_selected = String(missingItem.quantity || 1);
                  props._debug_session_id = Date.now().toString(36) + Math.random().toString(36).substring(2, 9);
                }
                jQuery.ajax({
                  type: 'POST',
                  url: (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js',
                  data: {
                    items: [{
                      id: missingItem.id,
                      quantity: missingItem.quantity,
                      properties: props
                    }]
                  },
                  dataType: 'json'
                }).done(function(recoveryResp) {
                  if (debugLog) {
                    addDebugStep('cart_add_immediate_recovery_success', 'success', {
                      variantId: missingItem.id,
                      logoId: missingItem.properties && missingItem.properties['Logo Id'],
                      quantity: missingItem.quantity,
                      itemsInResponse: recoveryResp && recoveryResp.items ? recoveryResp.items.length : 0
                    });
                  }
                  resolve({ success: true, item: missingItem });
                }).fail(function(jqXHR, textStatus) {
                  if (debugLog) {
                    addDebugStep('cart_add_immediate_recovery_failed', 'error', {
                      variantId: missingItem.id,
                      logoId: missingItem.properties && missingItem.properties['Logo Id'],
                      error: textStatus,
                      status: jqXHR.status,
                      note: 'Immediate recovery failed - will rely on cart validation'
                    });
                  }
                  resolve({ success: false, item: missingItem, error: textStatus });
                });
              }, idx * 200); // Stagger requests by 200ms
            });
          });
          
          // Wait for immediate recovery before proceeding to full verification
          Promise.all(immediateRecoveryPromises).then(function(results) {
            var recovered = results.filter(function(r) { return r.success; }).length;
            if (debugLog) {
              addDebugStep('cart_add_immediate_recovery_complete', recovered === immediateMissingItems.length ? 'success' : 'error', {
                attempted: immediateMissingItems.length,
                recovered: recovered,
                failed: immediateMissingItems.length - recovered,
                note: 'Immediate recovery complete - proceeding to full cart verification'
              });
            }
            // Continue to full verification
            proceedToVerification();
          }).catch(function(err) {
            mrkDebug.error('[Bundle] Error in immediate recovery:', err);
            // Continue to verification even if recovery had errors
            proceedToVerification();
          });
        } else {
          // No immediate missing items - proceed directly to verification
          proceedToVerification();
        }
      } else {
        // No response or no expected variants - proceed directly
        proceedToVerification();
      }
      
      function proceedToVerification() {
        if (expectedPositionVariants.length === 0) {
          if (debugLog) {
            addDebugStep('cart_add_verification', 'success', {
              expectedPositionVariants: 0,
              note: 'No position variants expected - skipping verification'
            });
          }
          doRedirect();
        } else {
          // CRITICAL FIX (Order #52500): Enhanced verification with detailed logging
          if (debugLog) {
            addDebugStep('cart_add_verification_started', 'started', {
              expectedPositionVariants: expectedPositionVariants.length,
              note: 'Fetching cart to verify all position variants were added'
            });
          }
        
        fetch(cartJsUrl).then(function(r) { return r.json(); }).then(function(cartData) {
          var cartItems = cartData.items || [];
          var actualByKey = {};
          cartItems.forEach(function(item) {
            if (item.properties && item.properties._ParentVariant) {
              // CRITICAL FIX (Order #52472): Use _lineItemKey for accurate matching when same variant ID
              var key = item.properties._lineItemKey;
              if (!key) {
                // Fallback: build key from properties if _lineItemKey missing
                var logoId = String(item.properties['Logo Id'] || '').trim();
                var position = String(item.properties.Position || '').trim();
                key = item.variant_id + '_' + logoId + '_' + position.replace(/\s/g, '_');
              }
              actualByKey[key] = (actualByKey[key] || 0) + (item.quantity || 0);
            }
          });
          var expectedByKey = {};
          var itemByKey = {};
          expectedPositionVariants.forEach(function(exp) {
            // CRITICAL FIX (Order #52472): Use _lineItemKey for accurate matching when same variant ID
            var key = exp.properties && exp.properties._lineItemKey;
            if (!key) {
              // Fallback: build key from properties if _lineItemKey missing
              var logoId = String(exp.properties && exp.properties['Logo Id'] || '').trim();
              var position = String(exp.properties && exp.properties.Position || '').trim();
              key = exp.id + '_' + logoId + '_' + position.replace(/\s/g, '_');
            }
            expectedByKey[key] = (expectedByKey[key] || 0) + (exp.quantity || 0);
            if (!itemByKey[key]) itemByKey[key] = exp;
          });
          var missingItems = [];
          Object.keys(expectedByKey).forEach(function(key) {
            var expectedQty = expectedByKey[key];
            var actualQty = actualByKey[key] || 0;
            if (actualQty < expectedQty) {
              var addQty = expectedQty - actualQty;
              var template = itemByKey[key];
              missingItems.push({ id: template.id, quantity: addQty, properties: template.properties || {} });
            }
          });
          
          // CRITICAL FIX (Order #52500): Enhanced verification logging
          if (debugLog) {
            addDebugStep('cart_add_verification', missingItems.length === 0 ? 'success' : 'error', {
              expectedCount: expectedPositionVariants.length,
              actualPositionVariantsInCart: Object.keys(actualByKey).length,
              missingCount: missingItems.length,
              expectedByKey: expectedByKey,
              actualByKey: actualByKey,
              missingItems: missingItems.map(function(m) {
                return { 
                  variantId: m.id, 
                  quantity: m.quantity, 
                  logoId: m.properties && m.properties['Logo Id'],
                  position: m.properties && m.properties.Position,
                  parentVariant: m.properties && m.properties._ParentVariant,
                  lineItemKey: m.properties && m.properties._lineItemKey
                };
              }),
              allItemsPresent: missingItems.length === 0,
              note: missingItems.length > 0 ? 'CRITICAL: Items missing after add - retry will run' : 'All position variants verified in cart'
            });
          }
          
          if (missingItems.length > 0) {
            // CRITICAL FIX (Order #52500): Enhanced recovery logging
            if (debugLog) {
              addDebugStep('cart_add_retry_individual', 'started', { 
                missingCount: missingItems.length,
                missingItems: missingItems.map(function(m) {
                  return {
                    variantId: m.id,
                    quantity: m.quantity,
                    logoId: m.properties && m.properties['Logo Id'],
                    position: m.properties && m.properties.Position
                  };
                }),
                note: 'Attempting to add missing items individually'
              });
            }
            
            var delay = 0;
            var retryResults = [];
            var runRetry = function(idx) {
              if (idx >= missingItems.length) {
                // CRITICAL FIX (Order #52500): Log retry completion
                if (debugLog) {
                  addDebugStep('cart_add_retry_completed', 'success', {
                    attempted: missingItems.length,
                    results: retryResults,
                    note: 'Retry attempts completed - final verification should happen on cart page'
                  });
                }
                doRedirect();
                return;
              }
              var item = missingItems[idx];
              var itemProps = item.properties || {};
              if (!itemProps._debug_add_source) {
                itemProps._debug_add_source = 'bundle_retry';
                itemProps._debug_add_timestamp = new Date().toISOString();
                itemProps._debug_pdp_variant_selected = String(item.id);
                itemProps._debug_pdp_qty_selected = String(item.quantity || 1);
                itemProps._debug_session_id = Date.now().toString(36) + Math.random().toString(36).substring(2, 9);
                item.properties = itemProps;
              }
              setTimeout(function() {
                jQuery.ajax({
                  type: 'POST',
                  url: (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js',
                  data: item,
                  dataType: 'json'
                }).done(function(retryResp) {
                  if (debugLog) {
                    retryResults.push({
                      variantId: item.id,
                      logoId: item.properties && item.properties['Logo Id'],
                      success: true,
                      itemsInResponse: retryResp && retryResp.items ? retryResp.items.length : 0
                    });
                    addDebugStep('cart_add_retry_item_success', 'success', {
                      variantId: item.id,
                      logoId: item.properties && item.properties['Logo Id'],
                      quantity: item.quantity,
                      position: item.properties && item.properties.Position
                    });
                  }
                  runRetry(idx + 1);
                }).fail(function(jqXHR, textStatus, errorThrown) {
                  if (debugLog) {
                    retryResults.push({
                      variantId: item.id,
                      logoId: item.properties && item.properties['Logo Id'],
                      success: false,
                      error: textStatus,
                      status: jqXHR.status
                    });
                    addDebugStep('cart_add_retry_item_failed', 'error', {
                      variantId: item.id,
                      logoId: item.properties && item.properties['Logo Id'],
                      quantity: item.quantity,
                      error: textStatus,
                      status: jqXHR.status,
                      note: 'Retry attempt failed - item may still be missing'
                    });
                  }
                  runRetry(idx + 1);
                });
              }, delay);
              delay += 250;
            };
            runRetry(0);
          } else {
            if (debugLog) {
              addDebugStep('cart_add_verification_passed', 'success', {
                expectedCount: expectedPositionVariants.length,
                actualCount: Object.keys(actualByKey).length,
                note: 'All position variants verified - no recovery needed'
              });
            }
            doRedirect();
          }
        }).catch(function(err) {
          // CRITICAL FIX (Order #52475): Re-enable Finish button on verification error
          var $finishBtn = $('.mrk-final-add-to-cart');
          if ($finishBtn.length > 0 && $finishBtn.data('isProcessing')) {
            $finishBtn.data('isProcessing', false);
            $finishBtn.prop('disabled', false);
            var originalText = $finishBtn.data('originalText') || 'Finish';
            $finishBtn.text(originalText).html(originalText);
          }
          
          if (debugLog) {
            addDebugStep('cart_add_verification_error', 'error', {
              error: (err && err.message) || String(err),
              stack: (err && err.stack) ? err.stack.substring(0, 500) : null,
              note: 'Failed to fetch cart for verification - items may be missing'
            });
          }
          doRedirect();
        });
      }
    }
    }); // close sendDeferredItems callback
    },
    error: function(jqXHR, textStatus, errorThrown) {
      $('.mrk-loader-main').css('display', 'none');
      
      // CRITICAL FIX (Order #52475): Re-enable Finish button on error
      var $finishBtn = $('.mrk-final-add-to-cart');
      if ($finishBtn.length > 0 && $finishBtn.data('isProcessing')) {
        $finishBtn.data('isProcessing', false);
        $finishBtn.prop('disabled', false);
        var originalText = $finishBtn.data('originalText') || 'Finish';
        $finishBtn.text(originalText).html(originalText);
      }
      
      // CRITICAL FIX (Order #52267): Always log a response step so debug log never "ends" without response
      if (debugLog && typeof addDebugStep === 'function') {
        addDebugStep('cart_add_response_received', 'error', {
          status: jqXHR.status,
          statusText: textStatus,
          error: errorThrown,
          responseJSON: jqXHR.responseJSON ? true : false,
          note: 'Cart add API failed - this step ensures debug log has a response entry'
        });

        // P1.4 — Spec-named cart_add_failed step.
        addDebugStep('cart_add_failed', 'error', {
          httpStatus: jqXHR.status,
          statusText: textStatus,
          error: errorThrown,
          itemsRequested: data && data.items ? data.items.length : (batchData && batchData.items ? batchData.items.length : 0),
          itemsAdded: 0,
          itemsLost: data && data.items ? data.items.length : (batchData && batchData.items ? batchData.items.length : 0)
        });
      }
      
      // CRITICAL FIX: Log cart add errors to debug log so we can diagnose failures (Order #51786 fix)
      if (debugLog) {
        var positionVariantsInRequest = data.items ? data.items.filter(function(item) {
          return item.properties && item.properties._ParentVariant;
        }) : [];
        
        debugLog.steps.push({
          step: 'cart_add_error',
          status: 'error',
          details: {
            status: jqXHR.status,
            statusText: textStatus,
            error: errorThrown,
            response: jqXHR.responseJSON,
            expectedItems: data.items ? data.items.length : 0,
            positionVariantsInRequest: positionVariantsInRequest.length,
            requestItems: data.items ? data.items.map(function(item) {
              return {
                id: item.id,
                quantity: item.quantity,
                isChild: !!(item.properties && item.properties._ParentVariant),
                logoId: item.properties && item.properties['Logo Id'] || null,
                position: item.properties && item.properties.Position || null,
                parentVariant: item.properties && item.properties._ParentVariant || null
              };
            }) : [],
            errorDetails: {
              statusCode: jqXHR.status,
              statusText: textStatus,
              errorMessage: errorThrown,
              responseText: jqXHR.responseText ? jqXHR.responseText.substring(0, 500) : null,
              responseJSON: jqXHR.responseJSON
            }
          },
          time: new Date().toISOString()
        });
        
        if (debugLog.errors) {
          debugLog.errors.push({
            message: 'Cart add API error',
            details: {
              status: jqXHR.status,
              statusText: textStatus,
              error: errorThrown,
              response: jqXHR.responseJSON
            },
            time: new Date().toISOString()
          });
        }
      }
      
        // status: jqXHR.status,
        // statusText: textStatus,
        // error: errorThrown,
        // response: jqXHR.responseJSON,
        // requestData: data
      // });
      
      var errorMessage = 'Unable to add items to cart. Please try again.';
      
      if (jqXHR.responseJSON) {
        if (jqXHR.responseJSON.description) {
          errorMessage = jqXHR.responseJSON.description;
        } else if (jqXHR.responseJSON.message) {
          errorMessage = jqXHR.responseJSON.message;
        } else if (jqXHR.responseJSON.errors) {
          errorMessage = 'Error: ' + JSON.stringify(jqXHR.responseJSON.errors);
        }
      }
      
      // Error logged but no alert shown
    },
    // CRITICAL FIX (Orders #52130, #52267, #52475): complete() runs after success OR error so we always know request finished
    complete: function(jqXHR, textStatus) {
      // CRITICAL FIX (Order #52475): Ensure Finish button is re-enabled even if error handler didn't run
      if (textStatus !== 'success') {
        var $finishBtn = $('.mrk-final-add-to-cart');
        if ($finishBtn.length > 0 && $finishBtn.data('isProcessing')) {
          $finishBtn.data('isProcessing', false);
          $finishBtn.prop('disabled', false);
          var originalText = $finishBtn.data('originalText') || 'Finish';
          $finishBtn.text(originalText).html(originalText);
        }
        // Direct add-to-cart: restore the .mrk-direct-bundle-add loading state
        // on genuine failure (the click handler's promise settles too early to
        // know — this complete handler is the real network settle point).
        if (typeof window.__jrsDirectAddRestore === 'function') {
          try { window.__jrsDirectAddRestore(); } catch (restoreErr) {}
        }
      }
      
      if (debugLog && typeof addDebugStep === 'function') {
        addDebugStep('cart_add_complete', textStatus === 'success' ? 'success' : 'error', {
          textStatus: textStatus,
          status: jqXHR && jqXHR.status,
          note: 'Ajax complete - ran after success or error; if log still ends at cart_state_before_add, request may not have been sent'
        });
      }
    }
  });
}
function buildMainVariant(ParentVariantId,qty,bundleItems, debugLog){
  
  var bundle = []; 
  var properties = {};
  var index_ = 1;
  let allPositionProperties = {};
  
  // Helper functions for debug logging (if debugLog provided)
  function addDebugStep(step, status, details) {
    if (debugLog && debugLog.steps) {
      debugLog.steps.push({
        step: step,
        status: status,
        details: details || {},
        time: new Date().toISOString()
      });
    }
  }
  
  function addDebugWarning(message, details) {
    if (debugLog && debugLog.warnings) {
      debugLog.warnings.push({
        message: message,
        details: details || {},
        time: new Date().toISOString()
      });
    }
  }
  
  addDebugStep('buildMainVariant_started', 'success', {
    parentVariantId: ParentVariantId,
    bundleItemsCount: bundleItems.length
  });
  
  // CRITICAL: Use positionsData captured before clearing (if available)
  // This ensures we have the data even if hidden fields were cleared
  var bundleProperties = window.bundlePositionsDataBeforeClear || positionsData();
  
  // Clear the cached data after use
  window.bundlePositionsDataBeforeClear = null;
  
  if (debugLog) {
    debugLog.data.positionsData = {
      count: bundleProperties.length,
      hasData: bundleProperties.length > 0,
      source: window.bundlePositionsDataBeforeClear ? 'cached_before_clear' : 'current_hidden_fields'
    };
  }
  
  if (bundleProperties.length === 0) {
    addDebugWarning('positionsData() returned empty', {});
  } else {
    addDebugStep('positionsData_loaded', 'success', { count: bundleProperties.length });
  }
  
  // Task 1 (BUG-BUNDLE-RAW-001): Track bundle_raw construction for debugging
  if (debugLog) {
    addDebugStep('bundle_raw_construction_start', 'success', {
      timestamp: new Date().toISOString(),
      categoriesCount: bundleItems.length,
      version: '7.0.0'
    });
  }
  
  bundleItems.each(function(categoryIdx) {
    var bundleItemName = ($(this).attr('bundleitemName') || '').trim();
    var bundleIndex = $(this).attr('bundleitem'),allPositionsItem=[];
    
    
    // Find or create the bundle object
    var bundleObject = bundle.find(b => b.name === bundleItemName);
    if (!bundleObject) {
        bundleObject = { name: bundleItemName, products: {}, categoryIndex: Number(categoryIdx) };
        bundle.push(bundleObject);
    } else {
        bundleObject.categoryIndex = Number(categoryIdx);
    }
    if (debugLog) {
      addDebugStep('bundle_raw_construction_category', 'success', {
        categoryIndex: categoryIdx,
        categoryName: bundleItemName,
        version: '7.0.0'
      });
    }
    
    // Process positions from bundleProperties
    if (bundleProperties && bundleProperties.length > 0) {
    // ====================================================================
    // CRITICAL FIX: Cross-Category Iteration Bug (Bundle Bug Report #2)
    // ====================================================================
    // PROBLEM: bundleProperties contains ALL positions from ALL categories.
    // The old code iterated through ALL positions for EACH category, causing:
    // 1. Positions from "Sweatshirts" being processed for "Polo Shirts & T-Shirts"
    // 2. Duplicate position variants being collected (14 instead of 10)
    // 3. Cross-category contamination of Logo IDs
    //
    // SOLUTION: Filter positions by category BEFORE processing.
    // Only process positions that belong to the current bundle category.
    // ====================================================================
    
    // Track unique positions to prevent duplicates
    var processedPositions = new Map();
    var categoryPositionsCount = 0;
    
    bundleProperties.forEach(function(positionData, index){
        var bundleItemPositions = positionData[`Positions ${index+1}`];
        
        // Fix: Add null check for bundleItemPositions
        if (!bundleItemPositions || !Array.isArray(bundleItemPositions)) {
          if (debugLog) {
            addDebugWarning('Missing or invalid bundleItemPositions', {
              index: index + 1,
              bundleItem: bundleItemName,
              positionDataKeys: Object.keys(positionData),
              bundleItemPositionsType: typeof bundleItemPositions
            });
          }
          return; // Skip this iteration
        }
        
        // CRITICAL FIX: Filter positions to only include those belonging to current category
        // This prevents cross-category contamination
        var categoryPositions = bundleItemPositions.filter(function(bundleProperty) {
          var positionBundleName = bundleProperty.bundleName || '';
          
          // If bundleName is missing, try to infer it from the property field
          if (!positionBundleName && bundleProperty.property) {
            var propertyMatchesCategory = false;
            $(`[bundleitem="${bundleIndex}"] .mrk-qty-item`).each(function(){
              if(Number($(this).val()) > 0){
                var productName = $(this).attr('productname');
                if(productName && bundleProperty.property && 
                   (productName === bundleProperty.property ||
                    productName.trim().toLowerCase() === bundleProperty.property.trim().toLowerCase())) {
                  propertyMatchesCategory = true;
                  positionBundleName = bundleItemName; // Infer bundleName from context
                  return false; // Break
                }
              }
            });
          }
          
          // Only include positions that belong to the current bundle category
          return positionBundleName === bundleItemName;
        });
        
        // Update count of positions for this category
        categoryPositionsCount += categoryPositions.length;
        
        if (debugLog && categoryPositions.length > 0) {
          addDebugStep('processing_positionData_' + (index+1), 'success', {
            bundleItem: bundleItemName,
            totalPositionsInData: bundleItemPositions.length,
            categoryPositionsCount: categoryPositions.length,
            filteredOut: bundleItemPositions.length - categoryPositions.length
          });
        }
        
        // Now process only the filtered positions for this category
        categoryPositions.forEach(function(bundleProperty, index){
          // CRITICAL FIX: Deduplication - prevent processing the same position multiple times
          // Create a unique key for this position: bundleName + position + logoId + applicationMethod
          var positionKey = [
            bundleItemName,
            bundleProperty.name || '',
            bundleProperty.logoId || '',
            bundleProperty.application_method || '',
            bundleProperty.qty || 1
          ].join('|');
          
          // Skip if this position was already processed
          if (processedPositions.has(positionKey)) {
            if (debugLog) {
              addDebugWarning('Position skipped - duplicate detected', {
                bundleItem: bundleItemName,
                position: bundleProperty.name || 'unknown',
                logoId: bundleProperty.logoId || 'unknown',
                reason: 'Position already processed for this category - preventing duplicates'
              });
            }
            return; // Skip duplicate
          }
          
          // Mark this position as processed
          processedPositions.set(positionKey, true);
          
          var name = bundleProperty.name ,qty=bundleProperty.qty;

          //Ak custom code
          var application_method = bundleProperty.application_method
          var logo_type = bundleProperty.logo_type;
          var logoVariant = bundleProperty.logoVariant;
          var logoId = bundleProperty.logoId;
          var logo = bundleProperty["Logo"];
          var note = bundleProperty["Note"];
          var logo_text = bundleProperty["Logo Text"];
          var logo_text_2 = bundleProperty["Logo Text 2"];
          var logo_text_3 = bundleProperty["Logo Text 3"];
          var logo_text_4 = bundleProperty["Logo Text 4"];
          var logo_color = bundleProperty["Logo Color"];
          var logo_font = bundleProperty["Logo Font"];
          
          // CRITICAL FIX: Trust stored position name - DO NOT "correct" based on current DOM state
          // The stored position name is the source of truth. DOM state may have changed (popup closed, etc.)
          // Normalize position name format for consistency, but never change the actual position
          // This prevents corruption like "Large back" being changed to "left-breast"
          
          // Normalize position name format (lowercase, replace spaces with hyphens) for consistency
          // But preserve the original stored value - only normalize the format, not the position itself
          var normalizedStoredName = (name || '').toLowerCase().trim().replace(/\s+/g, '-');
          
          // Only log if there's a format difference (for debugging), but don't change the position
          if (name && normalizedStoredName !== name.toLowerCase().trim().replace(/\s+/g, '-')) {
            // Format differs but that's OK - we'll use the stored name as-is
            // Just normalize for comparison purposes
          }
          
          // Use the stored position name as-is - it's the source of truth
          // DO NOT check DOM checkboxes - they may not reflect stored state
          
          // CRITICAL FIX: ALWAYS check DOM for current application method and Logo ID (Issue 1 & Cart Data 11 fix)
          // Even if bundleProperty has application_method/logoId, user may have changed it in UI
          // This ensures _bundle_raw always reflects the actual DOM state
          var $positionCheckbox = $(`.mrk-logo-inputs[data-position-name="${name}"][forbundle*="bundleItem-${bundleIndex}"]`);
          
          // CRITICAL FIX: Verify Logo ID from DOM if available (Cart Data 11 fix)
          // This ensures we use the user's actual selection, not stale values from bundleProperty
          if ($positionCheckbox && $positionCheckbox.length > 0) {
            var main_div_check = $positionCheckbox.closest('.bundle_product_steps');
            var position_name_check = $positionCheckbox.attr('data-position-name');
            var logo_style_check = main_div_check.find('.bundle_pro_logo_style .logo-assignment-labels-container .logo-assignment-label.selected input[type="radio"]').val();
            
            // Try to get Logo ID from DOM logo selection
            var domLogoId = null;
            if (logo_style_check == 'yes') {
              // Global logo assignment
              var globalLogoInput = main_div_check.find('.bundle_pro_logo_style .assignment-style-1 input[type="radio"]:checked');
              if (globalLogoInput && globalLogoInput.length > 0) {
                domLogoId = globalLogoInput.attr('data-logo-id') || globalLogoInput.data('logo-id') || globalLogoInput.attr('logo-id') || globalLogoInput.data('logoId');
              }
            } else {
              // Position-specific logo assignment
              var positionLogoInput = main_div_check.find('.bundle_pro_logo_style .assignment-style-2 .selected-position.active[data-position-name="'+position_name_check+'"] input[type="radio"]:checked');
              if (positionLogoInput && positionLogoInput.length > 0) {
                domLogoId = positionLogoInput.attr('data-logo-id') || positionLogoInput.data('logo-id') || positionLogoInput.attr('logo-id') || positionLogoInput.data('logoId');
              }
            }
            
            // If DOM has a Logo ID and it differs from bundleProperty, use DOM value (user's actual selection)
            if (domLogoId && domLogoId !== logoId) {
              if (debugLog) {
                addDebugWarning('buildMainVariant_logoId_mismatch_dom_vs_bundleProperty', {
                  bundleItem: bundleItemName,
                  position: name,
                  bundlePropertyLogoId: logoId,
                  domLogoId: domLogoId,
                  action: 'Using DOM value (user\'s actual selection)'
                });
              }
              logoId = domLogoId; // Use DOM value - user's actual selection
            }
          }
          
          // CRITICAL FIX (BUG-BUNDLE-RAW-002): Get application method from THIS position's container only.
          // Previously we used .bundle_product_steps .find() which returned the first container (Left Breast),
          // so all positions got "Embroidery" when Left Breast was Embroidery. Scope to .mrk-position-item.
          if ($positionCheckbox && $positionCheckbox.length > 0) {
            var $methodContainer = $positionCheckbox.closest('.mrk-position-item').find('.application-method-container');
            if ($methodContainer.length === 0) {
              $methodContainer = $positionCheckbox.closest('.bundle_product_steps').find('.application-method-container');
            }
            if ($methodContainer.length > 0) {
              var $selectedMethod = $methodContainer.find('input[type="radio"]:checked');
              if ($selectedMethod.length > 0) {
                var domApplicationMethod = $selectedMethod.val();
                // Update application_method to match DOM state (source of truth)
                if (domApplicationMethod === 'Embroidery') {
                  application_method = 'Embroidery';
                } else {
                  application_method = 'Print';
                }
                
                // Log if there's a mismatch between stored and DOM values
                // FIXED (WARN-1): Use case-insensitive comparison to avoid false positives
                var appMethodLower = (application_method || '').toLowerCase().trim();
                var bundlePropAppMethodLower = (bundleProperty.application_method || '').toLowerCase().trim();
                if (debugLog && bundleProperty.application_method && bundlePropAppMethodLower !== appMethodLower) {
                  addDebugWarning('buildMainVariant_application_method_mismatch', {
                    position: name,
                    productName: bundleItemName,
                    domApplicationMethod: application_method,
                    bundleRawApplicationMethod: bundleProperty.application_method,
                    logoId: logoId,
                    note: 'Using DOM value (source of truth) - hidden fields may be stale'
                  });
                }
              }
            }
          }
          
          // CRITICAL FIX: Get variant ID from bundleProperty or lookup from DOM
          // This is needed for cart validation to determine correct variant IDs
          var positionVariantID = bundleProperty.variantID || null;
          
          // If variant ID not in bundleProperty, try to get it from DOM
          if (!positionVariantID || positionVariantID === 0 || isNaN(positionVariantID)) {
            if ($positionCheckbox && $positionCheckbox.length > 0) {
              // Get variant ID based on ACTUAL application method from DOM
              if (application_method === 'Embroidery') {
                positionVariantID = Number($positionCheckbox.data('embroideryvariant'));
              } else {
                positionVariantID = Number($positionCheckbox.data('printvariant'));
              }
              
              // CRITICAL FIX: If variant ID is still invalid, try position-method mapping as fallback
              if ((!positionVariantID || positionVariantID === 0 || isNaN(positionVariantID)) && typeof getVariantForPositionAndMethod === 'function') {
                positionVariantID = getVariantForPositionAndMethod(name, application_method);
                if (positionVariantID && debugLog) {
                  addDebugStep('position_variant_id_from_mapping', 'success', {
                    bundleItem: bundleItemName,
                    position: name,
                    applicationMethod: application_method,
                    variantId: positionVariantID,
                    source: 'position_method_mapping_fallback'
                  });
                }
              }
            }
          } else {
            // CRITICAL FIX: Even if variant ID exists, verify it matches the current application method
            // If variant ID doesn't match the application method, get the correct one from DOM
            if ($positionCheckbox && $positionCheckbox.length > 0) {
              var expectedVariantId = null;
              if (application_method === 'Embroidery') {
                expectedVariantId = Number($positionCheckbox.data('embroideryvariant'));
              } else {
                expectedVariantId = Number($positionCheckbox.data('printvariant'));
              }
              
              // If stored variant ID doesn't match expected for current method, use expected
              if (expectedVariantId && expectedVariantId !== positionVariantID) {
                if (debugLog) {
                  addDebugWarning('buildMainVariant_variant_id_mismatch', {
                    position: name,
                    productName: bundleItemName,
                    applicationMethod: application_method,
                    storedVariantId: positionVariantID,
                    expectedVariantId: expectedVariantId,
                    note: 'Updating variant ID to match current application method from DOM'
                  });
                }
                positionVariantID = expectedVariantId;
              }
            }
          }

          //Ak custom code
          
          // ====================================================================
          // CRITICAL FIX: Multiple Products Per Category Bug (Order #51287)
          // ====================================================================
          // PROBLEM: When a bundle category has multiple products (e.g., RX350 and RX402
          // in Sweatshirts), positions are associated with specific products via the
          // 'property' field. The old logic only added a position if its property
          // matched a product's productname, causing positions to be dropped when:
          // 1. Property names don't match exactly (case sensitivity, whitespace)
          // 2. Products are reordered or filtered
          // 3. Multiple products share the same position name
          //
          // SOLUTION: Add position if property matches OR if no property match is
          // required (position belongs to the bundle item regardless of product).
          // Also add fallback logic to match by position name and logoId if property
          // matching fails.
          // ====================================================================
          
          var positionAdded = false;
          var matchingProduct = null;
          
          // First, try to find matching product by property name
          $(`[bundleitem="${bundleIndex}"] .mrk-qty-item`).each(function(){
            if(Number($(this).val()) > 0){
              var productName = $(this).attr('productname');
              if(productName == bundleProperty.property){
                matchingProduct = $(this);
                return false; // Break the loop
              }
            }
          });
          
          // If no exact match, try fuzzy matching (case-insensitive, trim whitespace)
          if (!matchingProduct && bundleProperty.property) {
            $(`[bundleitem="${bundleIndex}"] .mrk-qty-item`).each(function(){
              if(Number($(this).val()) > 0){
                var productName = $(this).attr('productname');
                if(productName && bundleProperty.property && 
                   productName.trim().toLowerCase() == bundleProperty.property.trim().toLowerCase()){
                  matchingProduct = $(this);
                  return false; // Break the loop
                }
              }
            });
          }
          
          // CRITICAL FIX: Only add position if product matches within THIS bundle category
          // DO NOT add positions from other categories even if logoId exists
          // This prevents cross-category contamination (e.g., T-Shirt products in Sweatshirts category)
          var shouldAddPosition = false;
          if (matchingProduct) {
            shouldAddPosition = true;
          } else if (logoId && bundleProperty.property) {
            // CRITICAL: Verify the property belongs to THIS bundle category before adding
            // Check if the property name matches any product in the current bundle category
            var propertyBelongsToCategory = false;
            $(`[bundleitem="${bundleIndex}"] .mrk-qty-item`).each(function(){
              if(Number($(this).val()) > 0){
                var productName = $(this).attr('productname');
                // Check if property matches this product (fuzzy match)
                if (productName && bundleProperty.property && 
                    (productName === bundleProperty.property ||
                     productName.trim().toLowerCase() === bundleProperty.property.trim().toLowerCase())) {
                  propertyBelongsToCategory = true;
                  return false; // Break
                }
              }
            });
            
            // Only add if property belongs to this category
            if (propertyBelongsToCategory) {
              shouldAddPosition = true;
            } else {
              // Property doesn't belong to this category - skip to prevent cross-category contamination
              if (debugLog) {
                addDebugWarning('Position skipped - property does not belong to bundle category', {
                  bundleItem: bundleItemName,
                  position: name,
                  logoId: logoId,
                  property: bundleProperty.property,
                  reason: 'Property name does not match any product in this bundle category - preventing cross-category contamination'
                });
              }
            }
          }
          
          if(shouldAddPosition){
            // allPositionsItem.push({name: name, qty: qty, bundleName: bundleItemName });

            //Ak custom code - BUG-BUNDLE-RAW-001: qty as integer, standardized camelCase keys
            var qtyNum = Number(qty) || 0;
            let itemObj = {
              name: name,
              qty: qtyNum,
              bundleName: (bundleItemName || '').trim()
            };
                // BUG-BUNDLE-RAW-001: Standardized keys (camelCase only, no duplicates)
                if (application_method) itemObj.applicationMethod = application_method;
                if (logo_type) itemObj.logoType = logo_type || '';
                if (logoId) itemObj["Logo Id"] = logoId;
                if (logoVariant) itemObj.logoVariantId = String(logoVariant);
                
                // Debug logging to track values being stored in _bundle_raw
                if (debugLog) {
                  addDebugStep('position_stored_in_bundle_raw', 'success', {
                    bundleItem: bundleItemName,
                    position: name,
                    applicationMethod: application_method,
                    logoId: logoId,
                    logoType: logo_type,
                    qty: qty,
                    note: 'Values verified from DOM - should match user\'s actual selection'
                  });
                }
                
                // CRITICAL FIX: Store position variant ID for cart validation (Issue 1 fix)
                // This allows cart validation to determine correct variant IDs without DOM access
                // CRITICAL: Only store the variant ID that matches the CURRENT application method
                // Remove any variant IDs that don't match to prevent confusion
                var variantIdSource = 'unknown';
                if (positionVariantID && positionVariantID !== 0 && !isNaN(positionVariantID)) {
                  // BUG-BUNDLE-RAW-001: Standardized camelCase keys for variant IDs
                  itemObj.positionVariantId = String(positionVariantID);
                  if (application_method === 'Embroidery') {
                    itemObj.embroideryVariantId = String(positionVariantID);
                  } else {
                    itemObj.printVariantId = String(positionVariantID);
                  }
                  
                  // Track where variant ID came from for debugging
                  if (bundleProperty.variantID) {
                    variantIdSource = 'bundleProperty';
                  } else {
                    variantIdSource = 'DOM_lookup';
                  }
                  
                  // Add debug step for variant ID detection
                  if (debugLog) {
                    addDebugStep('position_variant_id_detected', 'success', {
                      bundleItem: bundleItemName,
                      position: name,
                      variantId: positionVariantID,
                      applicationMethod: application_method,
                      source: variantIdSource,
                      logoId: logoId || 'missing',
                      storedInBundleRaw: !!(positionVariantID && itemObj.positionVariantId)
                    });
                  }
                } else {
                  // Log error if variant ID could not be determined
                  if (debugLog) {
                    addDebugError('Could not determine position variant ID', {
                      bundleItem: bundleItemName,
                      position: name,
                      applicationMethod: application_method,
                      logoId: logoId || 'missing',
                      bundlePropertyVariantID: bundleProperty.variantID || 'missing',
                      domCheckboxFound: $positionCheckbox ? $positionCheckbox.length : 0
                    });
                  }
                }

                if(logo_type == 'Existing Logo' || logo_type == 'Upload Your Logo'){
                  if (logo) itemObj["Logo"] = logo;
                  // Fix: Only add Note if it exists
                  if (note) itemObj["Note"] = note;
                }
                if(logo_type == 'Text Logo'){
                  // Fix: Only add Text Logo fields if they exist
                  if (logo_text) itemObj["Logo Text"] = logo_text;
                  if (logo_text_2) itemObj["Logo Text 2"] = logo_text_2;
                  if (logo_text_3) itemObj["Logo Text 3"] = logo_text_3;
                  if (logo_text_4) itemObj["Logo Text 4"] = logo_text_4;
                  if (logo_color) itemObj["Logo Color"] = logo_color;
                  if (logo_font) itemObj["Logo Font"] = logo_font;
                  if (note) itemObj["Note"] = note;
                }

                // Plan: Reinforce Logo (uploaded file) and Note from DOM when missing - must not be missed
                if ($positionCheckbox && $positionCheckbox.length > 0 && (!itemObj["Logo"] || !itemObj["Note"])) {
                  var main_div_reinforce = $positionCheckbox.closest('.bundle_product_steps');
                  var logo_style_reinforce = main_div_reinforce.find('.bundle_pro_logo_style .logo-assignment-labels-container .logo-assignment-label.selected input[type="radio"]').val();
                  var position_name_reinforce = $positionCheckbox.attr('data-position-name') || name;
                  var target_position_reinforce = '';
                  if (logo_style_reinforce != 'yes') {
                    target_position_reinforce = main_div_reinforce.find('.bundle_pro_logo_style .assignment-style-2 .selected-position.active[data-position-name="'+position_name_reinforce+'"] input[type="radio"]:checked').attr('data-target') || '';
                  }
                  try {
                    var logoDetailsReinforce = getLogoDetailsbundle(logo_style_reinforce, logo_type, main_div_reinforce, position_name_reinforce, target_position_reinforce);
                    if (logoDetailsReinforce && typeof logoDetailsReinforce === 'object') {
                      if (!itemObj["Logo"] && logoDetailsReinforce.Logo) itemObj["Logo"] = logoDetailsReinforce.Logo;
                      if (!itemObj["Note"] && logoDetailsReinforce.Note) itemObj["Note"] = logoDetailsReinforce.Note;
                      if (logo_type == 'Text Logo') {
                        if (!itemObj["Logo Text"] && logoDetailsReinforce["Logo Text"]) itemObj["Logo Text"] = logoDetailsReinforce["Logo Text"];
                        if (!itemObj["Logo Text 2"] && logoDetailsReinforce["Logo Text 2"]) itemObj["Logo Text 2"] = logoDetailsReinforce["Logo Text 2"];
                        if (!itemObj["Logo Text 3"] && logoDetailsReinforce["Logo Text 3"]) itemObj["Logo Text 3"] = logoDetailsReinforce["Logo Text 3"];
                        if (!itemObj["Logo Text 4"] && logoDetailsReinforce["Logo Text 4"]) itemObj["Logo Text 4"] = logoDetailsReinforce["Logo Text 4"];
                        if (!itemObj["Logo Color"] && logoDetailsReinforce["Logo Color"]) itemObj["Logo Color"] = logoDetailsReinforce["Logo Color"];
                        if (!itemObj["Logo Font"] && logoDetailsReinforce["Logo Font"]) itemObj["Logo Font"] = logoDetailsReinforce["Logo Font"];
                      }
                    }
                  } catch (e) { /* ignore */ }
                }

                itemObj.categoryIndex = Number(categoryIdx);
                itemObj.positionIndex = Number(index);
                var logoObj = {};
                if (itemObj["Logo Id"]) logoObj.logoId = itemObj["Logo Id"];
                if (itemObj.logoType) logoObj.logoType = itemObj.logoType;
                if (itemObj.applicationMethod) logoObj.applicationMethod = itemObj.applicationMethod;
                if (itemObj["Logo Text"]) logoObj.text1 = itemObj["Logo Text"];
                if (itemObj["Logo Text 2"]) logoObj.text2 = itemObj["Logo Text 2"];
                if (itemObj["Logo Text 3"]) logoObj.text3 = itemObj["Logo Text 3"];
                if (itemObj["Logo Text 4"]) logoObj.text4 = itemObj["Logo Text 4"];
                if (itemObj["Logo Color"]) logoObj.color = itemObj["Logo Color"];
                if (itemObj["Logo Font"]) logoObj.font = itemObj["Logo Font"];
                // Order #52354: Text Logo - always include color/font (empty string if missing) for all categories
                if (itemObj.logoType === 'Text Logo') {
                  logoObj.color = itemObj["Logo Color"] || logoObj.color || '';
                  logoObj.font = itemObj["Logo Font"] || logoObj.font || '';
                }
                if (itemObj["Logo"]) {
                  logoObj.url = itemObj["Logo"];
                  // Derive filename from URL for image logos - use original filename from cache
                  var fileName1 = getOriginalLogoFilename(itemObj["Logo"]);
                  if (fileName1) {
                    itemObj['Logo Filename'] = fileName1;
                    logoObj.filename = fileName1;
                  }
                }
                if (itemObj["Note"]) logoObj.note = itemObj["Note"];
                if (Object.keys(logoObj).length > 0) itemObj.logo = logoObj;

                // Detailed bundle_raw debug (Path 1) - Order #52352/52354
                if (debugLog) {
                  var urlVal = itemObj['Logo'] || (itemObj.logo && itemObj.logo.url);
                  var details = {
                    categoryIndex: categoryIdx,
                    categoryName: bundleItemName,
                    positionName: name,
                    logoId: itemObj['Logo Id'] || logoId,
                    logoType: logo_type,
                    hasUrl: !!urlVal,
                    urlPreview: urlVal ? String(urlVal).substring(0, 50) + (String(urlVal).length > 50 ? '...' : '') : 'EMPTY',
                    urlSource: 'Path1_bundleProperty_or_getLogoDetailsbundle'
                  };
                  if (logo_type === 'Text Logo') {
                    details.hasColor = !!(itemObj['Logo Color'] || (itemObj.logo && itemObj.logo.color));
                    details.hasFont = !!(itemObj['Logo Font'] || (itemObj.logo && itemObj.logo.font));
                    details.colorPreview = (itemObj['Logo Color'] || (itemObj.logo && itemObj.logo.color) || '').toString().substring(0, 30);
                    details.fontPreview = (itemObj['Logo Font'] || (itemObj.logo && itemObj.logo.font) || '').toString().substring(0, 30);
                  }
                  addDebugStep('bundle_raw_construction_position', 'success', details);
                }

                // if (logo) itemObj["Logo"] = logo;
                // if (logo_text) itemObj["Logo Text"] = logo_text;
                // if (logo_text_2) itemObj["Logo Text 2"] = logo_text_2;
                // if (logo_text_3) itemObj["Logo Text 3"] = logo_text_3;
                // if (logo_text_4) itemObj["Logo Text 4"] = logo_text_4;
                // if (logo_color) itemObj["Logo Color"] = logo_color;
                // if (logo_font) itemObj["Logo Font"] = logo_font;
                // if (note) itemObj["Note"] = note;

                allPositionsItem.push(itemObj);
                positionAdded = true;
                //Ak custom code


                // allPositionsItem.push({name: name, qty: qty, bundleName: bundleItemName,"Application Method": application_method,"logo_type":logo_type,"_logoVariant":logoVariant});
              }
              
              // CRITICAL: If position wasn't added and we have a logoId, log an error
              // This should never happen with the new logic above, but serves as a safety check
              if (!positionAdded && logoId) {
                mrkDebug.error('[BUNDLE DEBUG] ❌ CRITICAL: Position with logoId was not added!', {
                  bundleItem: bundleItemName,
                  position: name,
                  logoId: logoId,
                  property: bundleProperty.property,
                  availableProducts: $(`[bundleitem="${bundleIndex}"] .mrk-qty-item`).map(function() {
                    return {
                      productname: $(this).attr('productname'),
                      qty: $(this).val()
                    };
                  }).get()
                });
                
                if (debugLog) {
                  addDebugError('Position with logoId not added to bundle', {
                    bundleItem: bundleItemName,
                    position: name,
                    logoId: logoId,
                    property: bundleProperty.property,
                    availableProducts: $(`[bundleitem="${bundleIndex}"] .mrk-qty-item`).map(function() {
                      return {
                        productname: $(this).attr('productname'),
                        qty: $(this).val()
                      };
                    }).get()
                  });
                }
              }
          }); // End categoryPositions.forEach
    }); // End bundleProperties.forEach
    
    // Log summary of positions processed for this category
    if (debugLog && categoryPositionsCount > 0) {
      addDebugStep('positions_processed_for_category', 'success', {
        bundleItem: bundleItemName,
        totalPositionsProcessed: categoryPositionsCount,
        uniquePositionsAdded: allPositionsItem.length,
        duplicatesPrevented: categoryPositionsCount - allPositionsItem.length
      });
    }
    } else {
    }
    
    // ====================================================================
    // CRITICAL FIX: Final Deduplication (Order #51287, #51286, Bundle Bug Report #2)
    // ====================================================================
    // PROBLEM: Even with category filtering, duplicates can still occur if:
    // 1. Same position appears in multiple positionData entries
    // 2. Shared Logo IDs are used for multiple positions
    // 3. Positions are processed multiple times due to data structure issues
    //
    // SOLUTION: Final deduplication pass using composite key including logoId.
    // Two positions are only duplicates if ALL fields match, INCLUDING logoId.
    // ====================================================================
    var beforeDedupCount = allPositionsItem.length;
    allPositionsItem = allPositionsItem.filter((position, index, self) =>
      index === self.findIndex((p) => (
          p.name === position.name && 
          p.qty === position.qty && 
          p.bundleName === position.bundleName &&
          p["Application Method"] === position["Application Method"] &&
          p["logo_type"] === position["logo_type"] &&
          p["_logoVariant"] === position["_logoVariant"] &&
          p["Logo Id"] === position["Logo Id"]  // CRITICAL: Include logoId in comparison
      ))
    );
    
    if (debugLog && beforeDedupCount !== allPositionsItem.length) {
      addDebugWarning('Final deduplication removed positions', {
        bundleItem: bundleItemName,
        beforeDedup: beforeDedupCount,
        afterDedup: allPositionsItem.length,
        removed: beforeDedupCount - allPositionsItem.length
      });
    }
    
    
    // CRITICAL: Always collect products from DOM, regardless of positions
    var sizes = $(this).find('.mrk-qty-item');
    var sizesWithQty = $(sizes).filter(function() { return Number($(this).val()) > 0; });
    
    
    if (debugLog) {
      addDebugStep('collecting_products_' + bundleItemName, 'started', {
        totalSizes: sizes.length,
        sizesWithQty: sizesWithQty.length
      });
    }
    
      var _index = 1;
    var productsCollected = 0;
    var productsDetails = [];
    
    $(sizes).each(function() {
        if (Number($(this).val()) > 0) {
            var $el = $(this);
            var size = $el.attr('size'),
            color = $el.attr('color'),
            sku = $el.attr('sku'),
            name = $el.attr('productName'),
            qty = Number($el.val()) || 0,
            productName = `Product_${_index}`;
            // BUG-BUNDLE-RAW-001: Include variantId and productId for backend fulfillment
            var variantId = $el.attr('data-variant-id') || $el.data('variant-id') || $el.data('variantId');
            var productId = $el.attr('data-product-id') || $el.data('product-id') || $el.data('productId');
            
            var productDetail = {
              productName: productName,
              name: name,
              color: color,
              size: size,
              qty: qty,
              sku: sku,
              variantId: variantId,
              productId: productId
            };
            
            
            var productObj = { name: name, color: color, size: size, quantity: qty, sku: sku };
            if (variantId) productObj.variantId = String(variantId);
            if (productId) productObj.productId = String(productId);
            bundleObject.products[productName] = productObj;
            productsCollected++;
            productsDetails.push(productDetail);
            _index = _index + 1;
        }
    });
 
    
    if (debugLog) {
      addDebugStep('products_collected_' + bundleItemName, productsCollected > 0 ? 'success' : 'error', {
        count: productsCollected,
        products: productsDetails
      });
      
      if (productsCollected === 0) {
        addDebugError('No products collected for bundle item', {
          bundleItem: bundleItemName,
          totalSizes: sizes.length,
          sizesWithQty: sizesWithQty.length,
          sizesDetails: $(sizes).map(function() {
            return {
              val: $(this).val(),
              productname: $(this).attr('productname'),
              size: $(this).attr('size'),
              color: $(this).attr('color')
            };
          }).get()
        });
      }
    }
    
    // CRITICAL FIX: If positions weren't collected from bundleProperties (hidden fields),
    // collect them directly from DOM (checked checkboxes) as fallback
    // This ensures positions are available in bundle array when buildMainVariant runs
    if(customization && allPositionsItem.length === 0){
      // Fallback: Collect positions directly from DOM
      const checkedPositions = $(`.mrk-logo-inputs[forbundle*="bundleItem-${bundleIndex}"]:checked`);
      
      if (checkedPositions.length > 0 && debugLog) {
        addDebugWarning('Collecting positions from DOM (hidden fields empty)', {
          bundleItem: bundleItemName,
          checkedPositionsCount: checkedPositions.length
        });
      }
      
      var positionIdx = 0;
      checkedPositions.each(function(){
        var $checkbox = $(this);
        var name = $checkbox.val();
        var position_name = $checkbox.attr('data-position-name');
        // BUG-BUNDLE-RAW-002: Scope to THIS position's container (.mrk-position-item), not first in category
        var $methodRadio = $checkbox.closest('.mrk-position-item').find('.application-method-container input[type="radio"]:checked');
        if ($methodRadio.length === 0) {
          $methodRadio = $checkbox.closest('.bundle_product_steps').find('.application-method-container input[type="radio"]:checked');
        }
        var application_method = ($methodRadio.length > 0 ? $methodRadio.val() : null) || 'Embroidery';
        var isEmbroidery = application_method === 'Embroidery';
        var variantId = isEmbroidery ? Number($checkbox.data('embroideryvariant')) : Number($checkbox.data('printvariant'));
        
        // Get logo details from DOM
        var main_div = $checkbox.closest('.bundle_product_steps');
        var logo_style = main_div.find('.bundle_pro_logo_style .logo-assignment-labels-container .logo-assignment-label.selected input[type="radio"]').val();
        var logo_type = '';
        var logoVariant = '';
        var logoId = null;
        
        if(logo_style == 'yes'){
          logo_type = main_div.find('.bundle_pro_logo_style .assignment-style-1 input[type="radio"]:checked').val();
          logoVariant = main_div.find('.bundle_pro_logo_style .assignment-style-1 input[type="radio"]:checked').attr('variant');
        } else {
          logo_type = main_div.find('.bundle_pro_logo_style .assignment-style-2 .selected-position.active[data-position-name="'+position_name+'"] input[type="radio"]:checked').val();
          logoVariant = main_div.find('.bundle_pro_logo_style .assignment-style-2 .selected-position.active[data-position-name="'+position_name+'"] input[type="radio"]:checked').attr('variant');
        }
        
        // CRITICAL FIX: Get logoId from multiple sources (Cart Data 11 fix - prioritize user selection)
        // Priority order: 1) Hidden fields (user's actual selection), 2) DOM logo selection, 3) Checkbox data, 4) Fallbacks
        
        // 1. PRIORITY: Try to find in hidden fields (positionsData) - user's actual selection
        if (bundleProperties && bundleProperties.length > 0) {
          bundleProperties.forEach(function(positionData) {
            Object.keys(positionData).forEach(function(key) {
              if (key.startsWith('Positions ')) {
                var positions = positionData[key];
                if (Array.isArray(positions)) {
                  positions.forEach(function(pos) {
                    // Match by position name AND bundle name to ensure correct category
                    var posMatches = pos.name === name;
                    var bundleMatches = !pos.bundleName || pos.bundleName === bundleItemName || 
                                       (pos.bundleName && bundleItemName && 
                                        pos.bundleName.trim().toLowerCase() === bundleItemName.trim().toLowerCase());
                    if (posMatches && bundleMatches && pos.logoId) {
                      logoId = pos.logoId;
                      if (debugLog) {
                        addDebugStep('dom_collection_logoId_from_hidden_fields', 'success', {
                          bundleItem: bundleItemName,
                          position: name,
                          logoId: logoId,
                          source: 'hidden_fields_user_selection'
                        });
                      }
                    }
                  });
                }
              }
            });
          });
        }
        
        // 2. Get Logo ID from DOM logo selection inputs (user's actual selection in UI)
        if (!logoId) {
          // Try to get from logo selection radio buttons
          var logoSelectionInput = null;
          if (logo_style == 'yes') {
            // Global logo assignment
            logoSelectionInput = main_div.find('.bundle_pro_logo_style .assignment-style-1 input[type="radio"]:checked');
          } else {
            // Position-specific logo assignment
            logoSelectionInput = main_div.find('.bundle_pro_logo_style .assignment-style-2 .selected-position.active[data-position-name="'+position_name+'"] input[type="radio"]:checked');
          }
          
          if (logoSelectionInput && logoSelectionInput.length > 0) {
            // Try to get Logo ID from the selected logo input
            var selectedLogoId = logoSelectionInput.attr('data-logo-id') || 
                                 logoSelectionInput.data('logo-id') ||
                                 logoSelectionInput.attr('logo-id') ||
                                 logoSelectionInput.data('logoId');
            
            if (selectedLogoId) {
              logoId = selectedLogoId;
              if (debugLog) {
                addDebugStep('dom_collection_logoId_from_dom_selection', 'success', {
                  bundleItem: bundleItemName,
                  position: name,
                  logoId: logoId,
                  source: 'dom_logo_selection_input'
                });
              }
            }
          }
        }
        
        // 3. Checkbox data attribute (fallback)
        if (!logoId) {
          logoId = $checkbox.attr('data-logo-id') || $checkbox.data('logo-id');
        }
        
        // 4. Try to get from sessionStorage if available
        if (!logoId) {
          try {
            var bundlePositions = sessionStorage.getItem('bundle_positions');
            if (bundlePositions) {
              var parsed = JSON.parse(bundlePositions);
              if (parsed && Array.isArray(parsed)) {
                parsed.forEach(function(pos) {
                  if (pos.name === name && pos.bundleName === bundleItemName && pos.logoId) {
                    logoId = pos.logoId;
                  }
                });
              }
            }
          } catch(e) {
            // Ignore sessionStorage errors
          }
        }
        
        // 5. CRITICAL FIX: Check bundle array being built (LAST RESORT - may have stale values)
        // This ensures we reuse Logo IDs from existing bundle data instead of generating new ones
        if (!logoId && bundle && Array.isArray(bundle)) {
          var existingBundleItem = bundle.find(function(bItem) {
            var bItemName = (bItem.name || '').trim();
            var currentItemName = (bundleItemName || '').trim();
            return bItemName === currentItemName || 
                   bItemName.toLowerCase() === currentItemName.toLowerCase();
          });
          
          if (existingBundleItem && existingBundleItem.positions && Array.isArray(existingBundleItem.positions)) {
            // Find matching position in existing bundle item
            var existingPosition = existingBundleItem.positions.find(function(pos) {
              return pos.name === name && 
                     pos['Application Method'] === application_method &&
                     pos.logo_type === logo_type;
            });
            
            if (existingPosition && existingPosition['Logo Id']) {
              logoId = existingPosition['Logo Id'];
              if (debugLog) {
                addDebugStep('logoId_resolved', 'success', {
                  bundleItem: bundleItemName,
                  position: name,
                  logoId: logoId,
                  source: 'existing_bundle_array'
                });
              }
            }
          }
        }
        
        // 5. CRITICAL FIX: Check _bundle_raw from cart if available (for rebuild scenarios)
        // This ensures Logo IDs match what's stored in cart properties
        if (!logoId) {
          try {
            // Try to get _bundle_raw from the main bundle product in cart
            var cartBundleRaw = null;
            if (window.Shopify && window.Shopify.cart && window.Shopify.cart.items) {
              window.Shopify.cart.items.forEach(function(cartItem) {
                if (cartItem.properties && cartItem.properties._bundle_raw) {
                  var raw = cartItem.properties._bundle_raw;
                  if (typeof raw === 'string') {
                    try {
                      raw = JSON.parse(raw);
                    } catch(e) {
                      raw = null;
                    }
                  }
                  if (raw && !cartBundleRaw) {
                    cartBundleRaw = raw;
                  }
                }
              });
            }
            
            if (cartBundleRaw) {
              // Handle both object and array formats
              var bundleItemsToCheck = Array.isArray(cartBundleRaw) ? cartBundleRaw : Object.keys(cartBundleRaw).map(function(key) {
                return cartBundleRaw[key];
              });
              
              bundleItemsToCheck.forEach(function(bItem) {
                if (!logoId && bItem && bItem.name) {
                  var bItemName = (bItem.name || '').trim();
                  var currentItemName = (bundleItemName || '').trim();
                  
                  if (bItemName === currentItemName || 
                      bItemName.toLowerCase() === currentItemName.toLowerCase()) {
                    // Found matching bundle item, check positions
                    if (bItem.positions) {
                      var positionsArray = Array.isArray(bItem.positions) 
                        ? bItem.positions 
                        : Object.keys(bItem.positions).map(function(key) {
                            return bItem.positions[key];
                          });
                      
                      positionsArray.forEach(function(pos) {
                        if (!logoId && pos && pos.name === name && 
                            pos['Application Method'] === application_method &&
                            pos['Logo Id']) {
                          logoId = pos['Logo Id'];
                          if (debugLog) {
                            addDebugStep('logoId_resolved', 'success', {
                              bundleItem: bundleItemName,
                              position: name,
                              logoId: logoId,
                              source: '_bundle_raw_from_cart'
                            });
                          }
                        }
                      });
                    }
                  }
                }
              });
            }
          } catch(e) {
            // Ignore errors when checking cart
            if (debugLog) {
              mrkDebug.warn('[Bundle] Error checking _bundle_raw from cart:', e);
            }
          }
        }
        
        // 6. LAST RESORT: Generate Logo ID only if absolutely not found anywhere
        // This should rarely happen in normal flow - if it does, it's a data consistency issue
        if (!logoId) {
          logoId = String(Math.floor(Math.random() * (999998 + 1)));
          if (debugLog) {
            addDebugWarning('Generated Logo ID during DOM collection (not found elsewhere)', {
              bundleItem: bundleItemName,
              position: name,
              generatedLogoId: logoId,
              reason: 'Logo ID not found in checkbox, hidden fields, sessionStorage, bundle array, or _bundle_raw - generating as last resort',
              warning: 'This may cause Logo ID mismatches - check data flow'
            });
          }
        }
        
        // CRITICAL FIX: Calculate total quantity for this bundle category (Order #51763 fix)
        // Use sum of all products with qty > 0, not just the first product
        var qty = 0;
        $(`[bundleitem="${bundleIndex}"] .mrk-qty-item`).each(function(){
          var productQty = Number($(this).val()) || 0;
          if(productQty > 0){
            qty += productQty;
          }
        });
        // Fallback to 1 if no products have quantity (shouldn't happen, but safety check)
        if (qty <= 0) {
          qty = 1;
        }
        
        if (name && variantId) {
          // CRITICAL FIX: Store Logo ID in shared cache for consistency
          // This ensures getAllPositionsVariants can reuse the same Logo ID
          var cacheKey = createLogoIdCacheKey(bundleItemName, name, application_method, logo_type);
          if (logoId) {
            window.bundleLogoIdCache[cacheKey] = logoId;
            if (debugLog) {
              addDebugStep('logoId_resolved', 'success', {
                cacheKey: cacheKey,
                logoId: logoId,
                bundleItem: bundleItemName,
                position: name,
                source: 'cache'
              });
            }
          } else {
            // Check cache first before generating random ID
            if (window.bundleLogoIdCache[cacheKey]) {
              logoId = window.bundleLogoIdCache[cacheKey];
              if (debugLog) {
                addDebugStep('logoId_resolved', 'success', {
                  cacheKey: cacheKey,
                  logoId: logoId,
                  bundleItem: bundleItemName,
                  position: name,
                  source: 'cache'
                });
              }
            }
          }
          
          var itemObj = {
            name: name,
            qty: Number(qty) || 0,
            bundleName: (bundleItemName || '').trim(),
            applicationMethod: application_method || '',
            logoType: logo_type || '',
            logoVariantId: logoVariant ? String(logoVariant) : undefined
          };
          
          if (logoId) itemObj["Logo Id"] = logoId;
          itemObj.positionVariantId = String(variantId);
          if (isEmbroidery) itemObj.embroideryVariantId = String(variantId);
          else itemObj.printVariantId = String(variantId);
          
          // Plan: Populate full logo details in DOM fallback path - Logo (uploaded file) and Note must not be missed
          var target_position = '';
          if (logo_style == 'yes') {
            target_position = '';
          } else {
            target_position = main_div.find('.bundle_pro_logo_style .assignment-style-2 .selected-position.active[data-position-name="'+position_name+'"] input[type="radio"]:checked').attr('data-target') || '';
          }
          try {
            var logoDetails = getLogoDetailsbundle(logo_style, logo_type, main_div, position_name, target_position);
            if (logoDetails && typeof logoDetails === 'object') {
              if (logo_type == 'Existing Logo' || logo_type == 'Upload Your Logo') {
                if (logoDetails.Logo) itemObj["Logo"] = logoDetails.Logo;
                if (logoDetails.Note) itemObj["Note"] = logoDetails.Note;
              }
              if (logo_type == 'Text Logo') {
                if (logoDetails["Logo Text"]) itemObj["Logo Text"] = logoDetails["Logo Text"];
                if (logoDetails["Logo Text 2"]) itemObj["Logo Text 2"] = logoDetails["Logo Text 2"];
                if (logoDetails["Logo Text 3"]) itemObj["Logo Text 3"] = logoDetails["Logo Text 3"];
                if (logoDetails["Logo Text 4"]) itemObj["Logo Text 4"] = logoDetails["Logo Text 4"];
                if (logoDetails["Logo Color"]) itemObj["Logo Color"] = logoDetails["Logo Color"];
                if (logoDetails["Logo Font"]) itemObj["Logo Font"] = logoDetails["Logo Font"];
                if (logoDetails.Note) itemObj["Note"] = logoDetails.Note;
              }
              // Note for any logo type (if not already set)
              if (logoDetails.Note && !itemObj["Note"]) itemObj["Note"] = logoDetails.Note;
            }
          } catch (e) {
            if (debugLog) {
              addDebugWarning('DOM fallback: getLogoDetailsbundle failed', {
                bundleItem: bundleItemName,
                position: name,
                error: (e && e.message) || String(e)
              });
            }
          }
          
          itemObj.categoryIndex = Number(categoryIdx);
          itemObj.positionIndex = Number(positionIdx++);
          var logoObjPath2 = {};
          if (itemObj["Logo Id"]) logoObjPath2.logoId = itemObj["Logo Id"];
          if (itemObj.logoType) logoObjPath2.logoType = itemObj.logoType;
          if (itemObj.applicationMethod) logoObjPath2.applicationMethod = itemObj.applicationMethod;
          if (itemObj["Logo Text"]) logoObjPath2.text1 = itemObj["Logo Text"];
          if (itemObj["Logo Text 2"]) logoObjPath2.text2 = itemObj["Logo Text 2"];
          if (itemObj["Logo Text 3"]) logoObjPath2.text3 = itemObj["Logo Text 3"];
          if (itemObj["Logo Text 4"]) logoObjPath2.text4 = itemObj["Logo Text 4"];
          if (itemObj["Logo Color"]) logoObjPath2.color = itemObj["Logo Color"];
          if (itemObj["Logo Font"]) logoObjPath2.font = itemObj["Logo Font"];
          // Order #52354: Text Logo - always include color/font (empty string if missing) for all categories
          if (itemObj.logoType === 'Text Logo') {
            logoObjPath2.color = itemObj["Logo Color"] || logoObjPath2.color || '';
            logoObjPath2.font = itemObj["Logo Font"] || logoObjPath2.font || '';
          }
          if (itemObj["Logo"]) {
            logoObjPath2.url = itemObj["Logo"];
            // Derive filename from URL for image logos - use original filename from cache
            var fileName2 = getOriginalLogoFilename(itemObj["Logo"]);
            if (fileName2) {
              itemObj['Logo Filename'] = fileName2;
              logoObjPath2.filename = fileName2;
            }
          }
          if (itemObj["Note"]) logoObjPath2.note = itemObj["Note"];
          if (Object.keys(logoObjPath2).length > 0) itemObj.logo = logoObjPath2;
          
          // Detailed bundle_raw debug (Path 2 / DOM fallback) - Order #52352/52354
          if (debugLog) {
            var urlValPath2 = itemObj['Logo'] || (itemObj.logo && itemObj.logo.url);
            var detailsPath2 = {
              categoryIndex: categoryIdx,
              categoryName: bundleItemName,
              positionName: name,
              logoId: itemObj['Logo Id'] || logoId,
              logoType: logo_type,
              hasUrl: !!urlValPath2,
              urlPreview: urlValPath2 ? String(urlValPath2).substring(0, 50) + (String(urlValPath2).length > 50 ? '...' : '') : 'EMPTY',
              urlSource: 'Path2_DOM_getLogoDetailsbundle'
            };
            if (logo_type === 'Text Logo') {
              detailsPath2.hasColor = !!(itemObj['Logo Color'] || (itemObj.logo && itemObj.logo.color));
              detailsPath2.hasFont = !!(itemObj['Logo Font'] || (itemObj.logo && itemObj.logo.font));
              detailsPath2.colorPreview = (itemObj['Logo Color'] || (itemObj.logo && itemObj.logo.color) || '').toString().substring(0, 30);
              detailsPath2.fontPreview = (itemObj['Logo Font'] || (itemObj.logo && itemObj.logo.font) || '').toString().substring(0, 30);
            }
            addDebugStep('bundle_raw_construction_position', 'success', detailsPath2);
          }
          
          allPositionsItem.push(itemObj);
        }
      });
      // Plan (DOM fallback): Sort by position name so slot order is stable and matches Phase 2 category-forward order
      if (allPositionsItem.length > 1) {
        allPositionsItem.sort(function(a, b) {
          var na = (a && a.name || '').toString().trim();
          var nb = (b && b.name || '').toString().trim();
          return na.localeCompare(nb, 'en', { sensitivity: 'base' });
        });
      }
    }
    
    // Fix: Set positions ONCE per bundle item, not per size
    if(customization && allPositionsItem.length > 0){
      bundleObject.positions = allPositionsItem;
      
      // Track variant ID storage in _bundle_raw for debugging
      var positionsWithVariantIds = 0;
      var positionsWithoutVariantIds = 0;
      allPositionsItem.forEach(function(pos) {
        if (pos.positionVariantId || pos._positionVariant || pos.embroideryVariantId || pos._embroideryVariant || pos.printVariantId || pos._printVariant) {
          positionsWithVariantIds++;
        } else {
          positionsWithoutVariantIds++;
        }
      });
      
      addDebugStep('positions_set_for_' + bundleItemName, 'success', {
        count: allPositionsItem.length,
        withVariantIds: positionsWithVariantIds,
        withoutVariantIds: positionsWithoutVariantIds,
        variantIdsStored: positionsWithVariantIds === allPositionsItem.length
      });
      
      // Warn if variant IDs are missing
      if (positionsWithoutVariantIds > 0 && debugLog) {
        addDebugWarning('Some positions missing variant IDs in _bundle_raw', {
          bundleItem: bundleItemName,
          totalPositions: allPositionsItem.length,
          withVariantIds: positionsWithVariantIds,
          withoutVariantIds: positionsWithoutVariantIds,
          impact: 'Cart validation may fail to add missing items without DOM access'
        });
      }
    } else if (customization) {
      addDebugWarning('Customization enabled but no positions found', {
        bundleItem: bundleItemName
      });
    }
    
    var bundleObjectState = {
      hasProducts: Object.keys(bundleObject.products).length > 0,
      productsCount: Object.keys(bundleObject.products).length,
      hasPositions: !!bundleObject.positions,
      positionsCount: bundleObject.positions ? bundleObject.positions.length : 0
    };
    
    
    if (debugLog && debugLog.data) {
      if (!debugLog.data.bundleItems) debugLog.data.bundleItems = [];
      debugLog.data.bundleItems.push({
        name: bundleItemName,
        productsCount: bundleObjectState.productsCount,
        positionsCount: bundleObjectState.positionsCount,
        hasProducts: bundleObjectState.hasProducts,
        hasPositions: bundleObjectState.hasPositions
      });
    }
 
  });


    // ====================================================================
    // CRITICAL FIX: Logo ID Overwriting Bug (Order #51234)
    // ====================================================================
    // PROBLEM: Logo IDs were being assigned using position index (0, 1, 2...)
    // instead of bundle category index. This caused:
    // 1. Multiple bundle categories to get the same Logo ID
    // 2. Logo IDs to not match what's in _bundle_raw
    // 3. Logo IDs to be overwritten when positions are checked in different order
    //
    // SOLUTION: First collect Logo IDs per bundle category, then assign
    // Logo Id 1, Logo Id 2, etc. based on bundle category order, not position order.
    // ====================================================================
    
    // Step 1: Collect Logo IDs per bundle category (not per position)
    var logoIdsByBundleCategory = {};
    var bundleCategoryOrder = [];
    
    // Iterate through bundle items in order to determine category order
    bundleItems.each(function() {
      var bundleItemName = $(this).attr('bundleitemName');
      if (bundleItemName && !logoIdsByBundleCategory[bundleItemName]) {
        bundleCategoryOrder.push(bundleItemName);
        logoIdsByBundleCategory[bundleItemName] = null; // Initialize
      }
    });
    
    // Step 2: Find Logo ID for each bundle category from bundle.positions
    bundleCategoryOrder.forEach(function(categoryName) {
      var matchingBundleItem = bundle.find(function(bundleItem) {
        return bundleItem.name === categoryName;
      });
      
      if (matchingBundleItem && matchingBundleItem.positions && Array.isArray(matchingBundleItem.positions) && matchingBundleItem.positions.length > 0) {
        // Get Logo ID from the first position in this category
        var firstPosition = matchingBundleItem.positions[0];
        if (firstPosition && firstPosition['Logo Id']) {
          logoIdsByBundleCategory[categoryName] = firstPosition['Logo Id'];
          
          if (debugLog) {
            addDebugStep('buildMainVariant_logoId_mapped_to_category', 'success', {
              bundleCategory: categoryName,
              logoId: firstPosition['Logo Id'],
              position: firstPosition.name,
              categoryIndex: bundleCategoryOrder.indexOf(categoryName) + 1
            });
          }
        }
      }
    });
    
    // Step 3: Now process positions and assign Logo IDs based on bundle category
    // FIXED (BUG-1): Iterate by category explicitly instead of using global selector
    // The global selector $(`.mrk-logo-inputs:checked`) returns positions in document order,
    // which may not match category order (0→1→2). This causes numbered properties
    // (Position N, Logo Id N) to be scrambled even though _logoproductN is correct.
    // FIX: Use bundleItems.each() to iterate categories in order, then find positions within each
    var positionIndex = 0;
    bundleItems.each(function(categoryIdx) {
        var categoryPositions = $(this).find('.mrk-logo-inputs:checked');
        
        if (debugLog) {
          addDebugStep('buildMainVariant_category_iteration', 'success', {
            categoryIdx: categoryIdx,
            categoryName: $(this).attr('bundleitemName'),
            positionsCount: categoryPositions.length,
            note: 'BUG-1 fix: Processing positions in category order'
          });
        }
        
        categoryPositions.each(function(){
        positionIndex = positionIndex + 1;
        const targetDiv = this.parentElement.querySelector('.application-method-container');
        if (targetDiv) {
          const application_method_val = targetDiv.querySelector('input[type="radio"]:checked').value;
          isEmbroidery = application_method_val == 'Embroidery' ? true:false;
        }

        let application_method;
        if(isEmbroidery){
          id = Number($(this).data('embroideryvariant'));
          application_method = 'Embroidery';
        }else{
          id = Number($(this).data('printvariant'));
          application_method = 'Print';
        }
        var name = $(this).val();

        var main_div = $(this).parents('.bundle_product_steps');
        var position_name = $(this).attr('data-position-name');
        var logo_style = $(main_div).find('.bundle_pro_logo_style .logo-assignment-labels-container .logo-assignment-label.selected input[type="radio"]').val();
        let logo_type;
        let logoVariant;
        let target_position;

        if(logo_style == 'yes'){
          logo_type = $(main_div).find('.bundle_pro_logo_style .assignment-style-1 input[type="radio"]:checked').val();
          logoVariant = $(main_div).find('.bundle_pro_logo_style .assignment-style-1 input[type="radio"]:checked').attr('variant');
          target_position = '';
        }else{
          logo_type = $(main_div).find('.bundle_pro_logo_style .assignment-style-2 .selected-position.active[data-position-name="'+position_name+'"] input[type="radio"]:checked').val();
          logoVariant = $(main_div).find('.bundle_pro_logo_style .assignment-style-2 .selected-position.active[data-position-name="'+position_name+'"] input[type="radio"]:checked').attr('variant');
          target_position = $(main_div).find('.bundle_pro_logo_style .assignment-style-2 .selected-position.active[data-position-name="'+position_name+'"] input[type="radio"]:checked').attr('data-target');      
        }

        const product_name = $(main_div).attr('data-pro-name');

        let logoDetails = getLogoDetailsbundleout(positionIndex, logo_style, logo_type, main_div, position_name, target_position);
        
        // ====================================================================
        // CRITICAL FIX: Logo ID Priority Fix (Cart Data 10 - Critical Bug)
        // ====================================================================
        // PROBLEM: buildMainVariant was using stale Logo IDs from bundle.positions
        // (built earlier) instead of the user's actual selection from hidden fields.
        // This caused _bundle_raw to have wrong Logo IDs (e.g., 217029) when user
        // selected a different logo (e.g., 28164).
        //
        // SOLUTION: Check hidden fields (positionsData) FIRST - this is the user's
        // actual selection. Only use bundle.positions or cache as fallback.
        // ====================================================================
        let logo_id = null;
        var logoIdSource = 'unknown';
        
        // Method 0: CRITICAL FIX - Check hidden fields FIRST (user's actual selection)
        // This must be checked before bundle.positions to ensure user's selection takes priority
        var bundleProps = positionsData();
        if (bundleProps && bundleProps.length > 0) {
          bundleProps.forEach(function(posData) {
            var positions = posData['Positions 1'] || posData['Positions 2'] || posData['Positions 3'] || posData['Positions 4'] || posData['Positions 5'] || posData['Positions 6'];
            if (positions && Array.isArray(positions)) {
              positions.forEach(function(pos) {
                // Match by position name AND product name to avoid cross-category contamination
                if (pos.name === name) {
                  var posProductName = pos.bundleName || '';
                  var posProductMatches = !posProductName || 
                    posProductName.trim().toLowerCase() === product_name.trim().toLowerCase();
                  
                  if (posProductMatches && pos.logoId) {
                    // Found user's actual selection - use it (highest priority)
                    logo_id = pos.logoId;
                    logoIdSource = 'hidden_fields_user_selection';
                    
                    // CRITICAL FIX: Store user's selection in cache to ensure consistency
                    // This ensures subsequent lookups use the correct Logo ID
                    if (window.bundleLogoIdCache) {
                      var cacheKey = createLogoIdCacheKey(product_name, name, application_method, logo_type);
                      window.bundleLogoIdCache[cacheKey] = logo_id;
                    }
                    
                    if (debugLog) {
                      addDebugStep('buildMainVariant_logoId_from_hidden_fields', 'success', {
                        position: name,
                        productName: product_name,
                        logoId: logo_id,
                        source: 'hidden_fields_user_selection',
                        note: 'User\'s actual selection - highest priority, stored in cache'
                      });
                    }
                  }
                }
              });
            }
          });
        }
        
        // Method 1: Look up logoId from the bundle array (fallback if hidden fields don't have it)
        // Find the bundle item that matches this product_name
        // CRITICAL FIX: Use trim() and case-insensitive matching to handle whitespace/case differences
        // This prevents random Logo ID generation when names don't match exactly
        // Also try matching against the main_div's bundleitemName attribute as fallback
        var matchingBundleItem = bundle.find(function(bundleItem) {
          var bundleItemName = (bundleItem.name || '').trim();
          var productName = (product_name || '').trim();
          // Try exact match first, then case-insensitive match
          if (bundleItemName === productName || 
              bundleItemName.toLowerCase() === productName.toLowerCase()) {
            return true;
          }
          // Fallback: Try matching against bundleitemName attribute from DOM
          // This handles cases where data-pro-name differs from bundleitemName
          var domBundleItemName = (main_div && $(main_div).attr('bundleitemName')) ? 
                                   $(main_div).attr('bundleitemName').trim() : '';
          if (domBundleItemName && 
              (bundleItemName === domBundleItemName || 
               bundleItemName.toLowerCase() === domBundleItemName.toLowerCase())) {
            return true;
          }
          return false;
        });
        
        // Debug logging if no match found
        if (!matchingBundleItem && debugLog) {
          var availableBundleNames = bundle.map(function(b) { return b.name; });
          mrkDebug.warn('[Bundle] buildMainVariant: No matching bundle item found for product_name:', product_name, {
            productName: product_name,
            availableBundleNames: availableBundleNames,
            bundleItemNameFromDOM: main_div ? $(main_div).attr('bundleitemName') : 'N/A'
          });
        }
        
        if (matchingBundleItem && matchingBundleItem.positions && Array.isArray(matchingBundleItem.positions)) {
          // Find the position in this bundle item's positions array
          // CRITICAL FIX: Try strict match first (with application method), then fallback to position name only
          // This handles cases where DOM state (application method) doesn't match _bundle_raw
          // Example: User changes application method in DOM but _bundle_raw still has old value
          var matchingPosition = null;
          
          // First attempt: Strict match (position name + application method + logo type)
          // FIXED (WARN-1): Use case-insensitive comparison for application method
          matchingPosition = matchingBundleItem.positions.find(function(pos) {
            var nameMatches = pos.name === name;
            var posAppMethod = (pos['Application Method'] || '').toLowerCase().trim();
            var currentAppMethod = (application_method || '').toLowerCase().trim();
            var applicationMethodMatches = posAppMethod === currentAppMethod;
            var logoTypeMatches = pos.logo_type === logo_type;
            
            return nameMatches && pos['Logo Id'] && 
                   (!application_method || applicationMethodMatches) &&
                   (!logo_type || logoTypeMatches);
          });
          
          // Second attempt: If strict match failed, try matching by position name only
          // This handles mismatches between DOM state and _bundle_raw
          if (!matchingPosition) {
            matchingPosition = matchingBundleItem.positions.find(function(pos) {
              return pos.name === name && pos['Logo Id'];
            });
            
            if (matchingPosition && debugLog) {
              addDebugWarning('buildMainVariant_application_method_mismatch', {
                position: name,
                productName: product_name,
                domApplicationMethod: application_method,
                bundleRawApplicationMethod: matchingPosition['Application Method'],
                logoId: matchingPosition['Logo Id'],
                note: 'Using Logo ID from _bundle_raw despite application method mismatch'
              });
            }
          }
          
          // CRITICAL FIX: Only use bundle.positions if we don't already have Logo ID from hidden fields
          // Hidden fields (user's selection) takes priority over bundle.positions (may be stale)
          if (!logo_id && matchingPosition && matchingPosition['Logo Id']) {
            logo_id = matchingPosition['Logo Id'];
            logoIdSource = 'bundle.positions';
            
            // CRITICAL FIX: Store in shared cache for consistency
            // Use the actual application method from _bundle_raw for cache key to ensure consistency
            var actualApplicationMethod = matchingPosition['Application Method'] || application_method;
            var cacheKey = createLogoIdCacheKey(product_name, name, actualApplicationMethod, logo_type);
            if (window.bundleLogoIdCache) {
              window.bundleLogoIdCache[cacheKey] = logo_id;
            }
          }
        }
        
        // Method 2: Check shared cache (from getAllPositionsVariants or previous buildMainVariant call)
        if (!logo_id && window.bundleLogoIdCache) {
          var cacheKey = createLogoIdCacheKey(product_name, name, application_method, logo_type);
          if (window.bundleLogoIdCache[cacheKey]) {
            logo_id = window.bundleLogoIdCache[cacheKey];
            logoIdSource = 'shared_cache';
            if (debugLog) {
              addDebugStep('buildMainVariant_logoId_from_cache', 'success', {
                position: name,
                productName: product_name,
                logoId: logo_id,
                cacheKey: cacheKey
              });
            }
          }
        }
        
        // Method 3: Fallback to positionsData() only if bundle lookup and cache failed
        if (!logo_id) {
          var bundleProps = positionsData();
          if (bundleProps && bundleProps.length > 0) {
            bundleProps.forEach(function(posData) {
              var positions = posData['Positions 1'] || posData['Positions 2'] || posData['Positions 3'];
              if (positions && Array.isArray(positions)) {
                positions.forEach(function(pos) {
                  // Match by position name AND product name to avoid cross-category contamination
                  if (pos.name === name && pos.logoId) {
                    // Additional check: verify this position belongs to the correct bundle item
                    var posProductName = pos.bundleName || '';
                    if (!logo_id || posProductName === product_name) {
                      logo_id = pos.logoId;
                      logoIdSource = 'positionsData';
                    }
                  }
                });
              }
            });
          }
        }
        
        // Method 3: CRITICAL FIX - Check _bundle_raw from cart if available (for rebuild scenarios)
        // This ensures Logo IDs match what's stored in cart properties
        if (!logo_id) {
          try {
            // Try to get _bundle_raw from the main bundle product in cart
            var cartBundleRaw = null;
            if (window.Shopify && window.Shopify.cart && window.Shopify.cart.items) {
              window.Shopify.cart.items.forEach(function(cartItem) {
                if (cartItem.properties && cartItem.properties._bundle_raw && 
                    parseInt(cartItem.variant_id) === parseInt(ParentVariantId)) {
                  var raw = cartItem.properties._bundle_raw;
                  if (typeof raw === 'string') {
                    try {
                      raw = JSON.parse(raw);
                    } catch(e) {
                      raw = null;
                    }
                  }
                  if (raw && !cartBundleRaw) {
                    cartBundleRaw = raw;
                  }
                }
              });
            }
            
            if (cartBundleRaw) {
              // Handle both object and array formats
              var bundleItemsToCheck = Array.isArray(cartBundleRaw) ? cartBundleRaw : Object.keys(cartBundleRaw).map(function(key) {
                return cartBundleRaw[key];
              });
              
              bundleItemsToCheck.forEach(function(bItem) {
                if (!logo_id && bItem && bItem.name) {
                  var bItemName = (bItem.name || '').trim();
                  var currentProductName = (product_name || '').trim();
                  
                  if (bItemName === currentProductName || 
                      bItemName.toLowerCase() === currentProductName.toLowerCase()) {
                    // Found matching bundle item, check positions
                    if (bItem.positions) {
                      var positionsArray = Array.isArray(bItem.positions) 
                        ? bItem.positions 
                        : Object.keys(bItem.positions).map(function(key) {
                            return bItem.positions[key];
                          });
                      
                      // CRITICAL FIX: Try strict match first (with application method), then fallback to position name only
                      // This handles cases where DOM state (application method) doesn't match _bundle_raw
                      var matchingPosFromCart = null;
                      
                      // First attempt: Strict match (position name + application method)
                      // FIXED (WARN-1): Use case-insensitive comparison for application method
                      positionsArray.forEach(function(pos) {
                        var posAppMethod = (pos['Application Method'] || '').toLowerCase().trim();
                        var currentAppMethod = (application_method || '').toLowerCase().trim();
                        if (!matchingPosFromCart && pos && pos.name === name && 
                            posAppMethod === currentAppMethod &&
                            pos['Logo Id']) {
                          matchingPosFromCart = pos;
                        }
                      });
                      
                      // Second attempt: If strict match failed, try matching by position name only
                      if (!matchingPosFromCart) {
                        positionsArray.forEach(function(pos) {
                          if (!matchingPosFromCart && pos && pos.name === name && pos['Logo Id']) {
                            matchingPosFromCart = pos;
                            
                            if (debugLog) {
                              addDebugWarning('buildMainVariant_application_method_mismatch_in_cart', {
                                position: name,
                                productName: product_name,
                                domApplicationMethod: application_method,
                                bundleRawApplicationMethod: pos['Application Method'],
                                logoId: pos['Logo Id'],
                                note: 'Using Logo ID from cart _bundle_raw despite application method mismatch'
                              });
                            }
                          }
                        });
                      }
                      
                      if (matchingPosFromCart && matchingPosFromCart['Logo Id']) {
                        logo_id = matchingPosFromCart['Logo Id'];
                        logoIdSource = '_bundle_raw_from_cart';
                        
                        // CRITICAL FIX: Store in shared cache for consistency
                        // Use the actual application method from _bundle_raw for cache key
                        var actualApplicationMethod = matchingPosFromCart['Application Method'] || application_method;
                        if (logo_id && window.bundleLogoIdCache) {
                          var cacheKey = createLogoIdCacheKey(product_name, name, actualApplicationMethod, logo_type);
                          window.bundleLogoIdCache[cacheKey] = logo_id;
                        }
                        
                        if (debugLog) {
                          addDebugStep('buildMainVariant_logoId_from_bundle_raw', 'success', {
                            position: name,
                            productName: product_name,
                            logoId: logo_id,
                            source: '_bundle_raw_from_cart',
                            applicationMethodMatch: matchingPosFromCart['Application Method'] === application_method
                          });
                        }
                      }
                    }
                  }
                }
              });
            }
          } catch(e) {
            // Ignore errors when checking cart
            if (debugLog) {
              mrkDebug.warn('[Bundle] buildMainVariant: Error checking _bundle_raw from cart:', e);
            }
          }
        }
        
        // Method 4: If we still don't have logo ID, generate one (last resort fallback)
        // This should rarely happen - if it does, there's a data consistency issue
        if (!logo_id) {
          logo_id = String(Math.floor(Math.random() * (999998 + 1)));
          logoIdSource = 'random_generated';
          mrkDebug.warn('[Bundle] buildMainVariant: Generated random logo ID for position:', name, 'product:', product_name);
          
          // Log warning in debug log
          if (debugLog) {
            addDebugWarning('Generated random logo ID in buildMainVariant - should not happen', {
              position: name,
              productName: product_name,
              randomLogoId: logo_id,
              reason: 'Logo ID not found in bundle.positions, positionsData, or _bundle_raw',
              bundleItemFound: !!matchingBundleItem,
              bundleItemPositionsCount: matchingBundleItem ? (matchingBundleItem.positions ? matchingBundleItem.positions.length : 0) : 0,
              warning: 'This may cause Logo ID mismatches - check data flow'
            });
          }
        } else if (debugLog) {
          // Log successful logo ID retrieval
          addDebugStep('buildMainVariant_logoId_retrieved', 'success', {
            position: name,
            productName: product_name,
            logoId: logo_id,
            source: logoIdSource,
            positionIndex: positionIndex,
            bundleItemFound: !!matchingBundleItem,
            bundleItemName: matchingBundleItem ? matchingBundleItem.name : 'not found'
          });
        }
        
        // CRITICAL FIX: Store Logo ID in shared cache for consistency
        // This ensures getAllPositionsVariants can reuse the same Logo ID
        if (logo_id && window.bundleLogoIdCache) {
          var cacheKey = createLogoIdCacheKey(product_name, name, application_method, logo_type);
          window.bundleLogoIdCache[cacheKey] = logo_id;
        }
        
        // CRITICAL FIX: Use position index for Logo Id assignment (Issue 3 fix)
        // Each position should have its own Logo Id property (Logo Id 1, Logo Id 2, etc.)
        // Previously used bundleCategoryIndex which caused overwrites when a category had multiple positions
        // Now using positionIndex ensures all positions get their Logo IDs stored
        var logoIdPropertyIndex = positionIndex; // Use position index directly (already 1-based)
        
        // NEUTRALIZED (v3 fix): Numbered properties now come exclusively from the
        // bundle array rebuild (lines ~6770+). The DOM loop still runs for variant
        // detection, Logo ID generation, and category order tracking — only the
        // numbered property output is disabled to eliminate reversed writes.
        // Previously wrote: Application Method N, Logo Type N, Logo Id N,
        // _logoVariantN, _logoproductN, _logopositionN using DOM-order positionIndex.
        let genericProperties = {};
        
        // Log variant ID detection for this position in buildMainVariant
        if (debugLog) {
          // Calculate bundleCategoryIndex for debug purposes only
          var bundleCategoryIndex = bundleCategoryOrder.indexOf(product_name);
          if (bundleCategoryIndex === -1) {
            bundleCategoryIndex = positionIndex - 1; // Fallback
          }
          
          addDebugStep('buildMainVariant_position_properties', 'success', {
            positionIndex: positionIndex,
            bundleCategoryIndex: bundleCategoryIndex,
            logoIdPropertyIndex: logoIdPropertyIndex,
            position: name,
            applicationMethod: application_method,
            logoType: logo_type,
            logoId: logo_id,
            logoIdSource: logoIdSource,
            variantId: id,
            productName: product_name,
            logoVariant: logoVariant || 'missing'
          });
        }

        // NEUTRALIZED (v3 fix): logoDetails (from getLogoDetailsbundleout) contained
        // DOM-order numbered properties (Logo N, Note N, Logo Text N, etc.). These
        // now come from the bundle array rebuild. genericProperties is also empty
        // (see Change 1 above). getLogoDetailsbundleout() call is kept for its
        // debug logging side effects only.
        allPositionProperties = Object.assign(allPositionProperties, genericProperties);

        //Ak custom code
        
        }); // End categoryPositions.each()
    }); // End bundleItems.each() - FIXED (BUG-1): Category-explicit iteration
  //End Ak custom code
  

  // NEUTRALIZED (v3 fix): positionsData() hidden fields contain DOM-order numbered
  // properties (Application Method N, Logo Type N, Logo N, _logoproductN, etc.)
  // written by updateMetabundlenew at lines 9255-9259. These are reversed relative
  // to the bundle array order and are now handled exclusively by the rebuild block
  // (lines ~6770+). The only non-numbered key was _time, which is not needed.
  // var bundleProperties = positionsData();
  // bundleProperties.forEach(bundle => {
  //     for (let key in bundle) {
  //         if (!key.includes("Positions")) {
  //             properties[key] = bundle[key];
  //         }
  //     }
  // });
  
  // ===== SYNC LOOP — WRITE-BACK DISABLED (Fix: prevents _bundle_raw corruption) =====
  // Previously this loop wrote DOM-read allPositionProperties (reversed across categories) back into
  // bundle.positions, corrupting the otherwise-correct _bundle_raw.
  // Now: QTY sync is KEPT (reads from product quantities, not reversed DOM data).
  //       Application Method and Logo ID writes are DISABLED — replaced with comparison logging.
  //       The rebuild block below will rebuild allPositionProperties from the authoritative bundle array.

  var syncMismatches = [];
  var syncPropertyIdx = 0;

  bundle.forEach(function(bundleItem) {
    if (bundleItem.positions && Array.isArray(bundleItem.positions)) {
      bundleItem.positions.forEach(function(position) {
        var positionName = position.name || '';
        var productName = bundleItem.name || '';
        syncPropertyIdx++;

        // --- QTY SYNC: KEPT (reads from product quantities, not DOM) ---
        // CRITICAL FIX: Sync position qty from product quantities (Order #51763 fix)
        var calculatedCategoryQty = 0;
        if (bundleItem.products && typeof bundleItem.products === 'object') {
          var productKeys = Object.keys(bundleItem.products);
          productKeys.forEach(function(productKey) {
            var product = bundleItem.products[productKey];
            if (product && product.quantity) {
              calculatedCategoryQty += Number(product.quantity) || 0;
            }
          });
        }

        if (calculatedCategoryQty > 0 && Number(position.qty) !== calculatedCategoryQty) {
          if (debugLog) {
            addDebugStep('syncing_position_qty_from_products', 'success', {
              bundleItem: productName,
              position: positionName,
              propertyIndex: syncPropertyIdx,
              oldQty: position.qty,
              newQty: calculatedCategoryQty,
              source: 'product_quantities_sum'
            });
          }
          position.qty = calculatedCategoryQty.toString();
        }

        // --- APPLICATION METHOD + LOGO ID: COMPARISON ONLY (no writes) ---
        // Search allPositionProperties for matching position (to log mismatches)
        for (var i = 1; i <= 20; i++) {
          var logopositionKey = '_logoposition' + i;
          var logoproductKey = '_logoproduct' + i;
          var appMethodKey = 'Application Method ' + i;
          var logoIdKey = 'Logo Id ' + i;

          if (allPositionProperties[logopositionKey] === positionName &&
              allPositionProperties[logoproductKey] === productName) {
            // Found matching position — compare but DO NOT write
            var domAppMethod = allPositionProperties[appMethodKey] || '';
            var bundleAppMethod = position.applicationMethod || position['Application Method'] || '';
            var domLogoId = allPositionProperties[logoIdKey] || '';
            var bundleLogoId = position['Logo Id'] || '';

            if (domAppMethod !== bundleAppMethod || domLogoId !== bundleLogoId) {
              syncMismatches.push({
                index: i,
                category: productName,
                position: positionName,
                appMethod_dom: domAppMethod,
                appMethod_bundle: bundleAppMethod,
                logoId_dom: domLogoId,
                logoId_bundle: bundleLogoId
              });
            }
            break;
          }
        }
      });
    }
  });

  if (debugLog) {
    addDebugStep('sync_loop_comparison', syncMismatches.length > 0 ? 'warning' : 'success', {
      status: 'write_back_disabled',
      reason: 'DOM-read values were reversed; bundle array is authoritative. QTY sync still active.',
      mismatchCount: syncMismatches.length,
      mismatches: syncMismatches.slice(0, 10),
      note: syncMismatches.length > 0
        ? 'Mismatches confirm DOM state diverges from bundle array — write-back correctly disabled'
        : 'No mismatches between DOM and bundle — data is consistent'
    });
  }
  // ===== END SYNC LOOP =====

  // Old rebuild block removed — moved to after Object.assign(properties, allPositionProperties)
  // to catch reversed data from ALL upstream sources (positionsData, DOM loop, etc.)
  
  // CRITICAL VALIDATION: Check if bundle has products before creating _bundle_raw
  
  var hasProducts = bundle.some(function(bundleItem) {
    return bundleItem.products && Object.keys(bundleItem.products).length > 0;
  });
  
  if (!hasProducts) {
    
    if (debugLog) {
      addDebugError('Bundle has no products - matches wrong order pattern', {
        bundleStructure: JSON.stringify(bundle),
        bundleItemsCount: bundle.length,
        bundleItems: bundle.map(function(item) {
          return {
            name: item.name,
            hasProducts: !!item.products,
            productsCount: item.products ? Object.keys(item.products).length : 0,
            hasPositions: !!item.positions,
            positionsCount: item.positions ? item.positions.length : 0
          };
        }),
        positionsDataCount: bundleProperties.length,
        sizesFound: bundleItems.map(function() {
          return $(this).find('.mrk-qty-item').length;
        }).get()
      });
      
      // Add final summary
      debugLog.data.finalState = {
        hasProducts: false,
        bundleItems: bundle.length,
        totalProducts: 0,
        totalPositions: bundle.reduce(function(sum, item) {
          return sum + (item.positions ? item.positions.length : 0);
        }, 0),
        error: 'NO_PRODUCTS_COLLECTED'
      };
    }
    
    return null; // Prevent adding incomplete bundle to cart
  }
  
  if (debugLog) {
    var totalProducts = bundle.reduce(function(sum, item) {
      return sum + (item.products ? Object.keys(item.products).length : 0);
    }, 0);
    var totalPositions = bundle.reduce(function(sum, item) {
      return sum + (item.positions ? item.positions.length : 0);
    }, 0);
    
    addDebugStep('bundle_validation_passed', 'success', {
      bundleItems: bundle.length,
      totalProducts: totalProducts,
      totalPositions: totalPositions
    });
    
    // Add final summary
    debugLog.data.finalState = {
      hasProducts: true,
      bundleItems: bundle.length,
      totalProducts: totalProducts,
      totalPositions: totalPositions,
      bundleStructure: bundle.map(function(item) {
        return {
          name: item.name,
          productsCount: item.products ? Object.keys(item.products).length : 0,
          positionsCount: item.positions ? item.positions.length : 0,
          products: item.products ? Object.keys(item.products) : [],
          hasPositions: !!item.positions
        };
      })
    };
  }
  
  // CRITICAL FIX: Create minimal bundle structure for URL to prevent truncation
  // Full bundle data is stored in _bundle_raw, so URL can be minimal
  // This reduces URL length significantly while preserving all data
  // BACKWARD COMPATIBILITY: Old theme links use full bundle structure, new links use minimal
  // The bundle page template handles both formats automatically
  var minimalBundle = bundle.map(function(bundleItem) {
    var minimal = {
      name: bundleItem.name,
      products: {}
    };
    
    // Include products (essential for bundle page)
    if (bundleItem.products) {
      Object.keys(bundleItem.products).forEach(function(key) {
        var product = bundleItem.products[key];
        minimal.products[key] = {
          name: product.name,
          color: product.color,
          size: product.size,
          quantity: product.quantity,
          sku: product.sku
        };
      });
    }
    
    // Include positions but remove empty/null fields to reduce size
    // CRITICAL FIX: For URL version, ONLY include essential fields needed for bundle page display
    // All detailed fields (Logo Text, Logo Color, Logo Font, Note, Logo URL) are in _bundle_raw
    // This dramatically reduces URL size while preserving all data in _bundle_raw
    var positionsArray = Array.isArray(bundleItem.positions) 
      ? bundleItem.positions 
      : (bundleItem.positions ? Object.keys(bundleItem.positions).map(function(key) {
          return bundleItem.positions[key];
        }) : []);
    
    if (positionsArray.length > 0) {
      minimal.positions = positionsArray.map(function(pos) {
        // CRITICAL FIX: Only include absolute minimum fields for URL
        // All other fields (Logo Text, Logo Color, Logo Font, Note, Logo URL) are in _bundle_raw
        // This reduces URL size by 60-80% for bundles with text logos or uploaded logos
        var minimalPos = {
          name: pos.name,
          qty: pos.qty || pos.quantity || 1,
          bundleName: pos.bundleName || bundleItem.name,
          'Application Method': pos['Application Method'] || pos.application_method || 'Embroidery',
          logo_type: pos.logoType || pos.logo_type || pos['Logo Type'] || ''
        };
        
        // Only include variant IDs and Logo ID (essential for bundle page) - support BUG-BUNDLE-RAW-001 camelCase
        if (pos['Logo Id']) minimalPos['Logo Id'] = pos['Logo Id'];
        if (pos.logoVariantId) minimalPos.logoVariantId = pos.logoVariantId;
        if (pos._logoVariant) minimalPos._logoVariant = pos._logoVariant;
        if (pos.embroideryVariantId) minimalPos.embroideryVariantId = pos.embroideryVariantId;
        if (pos._embroideryVariant) minimalPos._embroideryVariant = pos._embroideryVariant;
        if (pos.printVariantId) minimalPos.printVariantId = pos.printVariantId;
        if (pos._printVariant) minimalPos._printVariant = pos._printVariant;
        if (pos.positionVariantId) minimalPos.positionVariantId = pos.positionVariantId;
        if (pos._positionVariant) minimalPos._positionVariant = pos._positionVariant;
        
        // CRITICAL: DO NOT include text fields, colors, fonts, notes, or logo URLs in URL
        // These are all stored in _bundle_raw and will be loaded from there
        // This reduces URL size significantly (text fields can be 100+ chars each)
        
        return minimalPos;
      });
    }
    
    return minimal;
  });
  
  // Stringify the minimal bundle (smaller than full bundle)
  // Use compact JSON (no spaces) to reduce size further
  var jsonString = JSON.stringify(minimalBundle);
  
  // CRITICAL: Check JSON length BEFORE encoding to avoid unnecessary processing
  // If JSON is already too long, skip encoding and use placeholder URL immediately
  var baseUrlLength = 'https://jrsindustrial.co.uk/pages/bundle?bundle='.length;
  // Conservative estimate: Base64 adds ~33% overhead, URL encoding can add 20-50% more for special chars
  // Use 1.6x multiplier to be safe (accounts for both base64 and URL encoding)
  var estimatedEncodedLength = baseUrlLength + (jsonString.length * 1.6);
  
  // Declare mrkPage_url variable before if/else to ensure it's in scope
  var mrkPage_url = '';
  
  // CRITICAL FIX: Use much higher threshold (1800) to ensure URLs never get truncated
  // With text fields removed, URLs should be much shorter, but we want to be safe
  // Only use placeholder if absolutely necessary (URL would exceed 2000 chars)
  if (estimatedEncodedLength > 1800 || jsonString.length > 1100) {
    // JSON is still too long even after removing text fields - try one more optimization
    // Remove variant IDs from URL (they're in _bundle_raw and can be looked up)
    var ultraMinimalBundle = minimalBundle.map(function(bundleItem) {
      var ultraMinimal = {
        name: bundleItem.name,
        products: bundleItem.products
      };
      
      // Only include position name, qty, and Logo ID (remove variant IDs)
      if (bundleItem.positions && bundleItem.positions.length > 0) {
        ultraMinimal.positions = bundleItem.positions.map(function(pos) {
          return {
            name: pos.name,
            qty: pos.qty || 1,
            bundleName: pos.bundleName || bundleItem.name,
            'Application Method': pos['Application Method'] || 'Embroidery',
            logo_type: pos.logo_type || '',
            'Logo Id': pos['Logo Id'] || ''
          };
        });
      }
      
      return ultraMinimal;
    });
    
    var ultraMinimalJson = JSON.stringify(ultraMinimalBundle);
    var ultraMinimalEstimatedLength = baseUrlLength + (ultraMinimalJson.length * 1.6);
    
    if (ultraMinimalEstimatedLength > 1800 || ultraMinimalJson.length > 1100) {
      // Still too long - use placeholder URL
      mrkDebug.warn('[BUNDLE DEBUG] ⚠️ WARNING: Bundle JSON is too long even after optimization (' + ultraMinimalJson.length + ' chars, estimated URL: ' + ultraMinimalEstimatedLength + ' chars). Using placeholder URL. Full data available in _bundle_raw.');
      if (debugLog) {
        addDebugWarning('Bundle JSON too long - using placeholder URL', {
          jsonStringLength: ultraMinimalJson.length,
          estimatedUrlLength: ultraMinimalEstimatedLength,
          baseUrlLength: baseUrlLength,
          minimalBundleItems: ultraMinimalBundle.length,
          note: 'Full bundle data is stored in _bundle_raw property - URL is for reference only'
        });
      }
      
      // CRITICAL FIX: Instead of "truncated", use a hash of the bundle for reference
      // This allows the page to at least identify which bundle it is
      var bundleHash = '';
      try {
        // Create a short hash from bundle name and first product
        var hashSource = '';
        if (bundle.length > 0 && bundle[0].name) {
          hashSource = bundle[0].name.substring(0, 20);
        }
        if (bundle.length > 0 && bundle[0].products) {
          var firstProductKey = Object.keys(bundle[0].products)[0];
          if (firstProductKey && bundle[0].products[firstProductKey]) {
            hashSource += bundle[0].products[firstProductKey].sku || '';
          }
        }
        // Simple hash function
        var hash = 0;
        for (var i = 0; i < hashSource.length; i++) {
          hash = ((hash << 5) - hash) + hashSource.charCodeAt(i);
          hash = hash & hash; // Convert to 32bit integer
        }
        bundleHash = Math.abs(hash).toString(36).substring(0, 8);
      } catch(e) {
        bundleHash = 'bundle';
      }
      
      // CRITICAL FIX: Include _bundle_raw as JSON (not PHP array) for new orders
      // This allows the bundle page to load data even when using a hash placeholder
      // For backward compatibility, the bundle page will also handle PHP array format from old orders
      var bundleRawString = '';
      try {
        // Convert bundle array to JSON string (raw JSON format for new orders)
        var bundleRawJson = JSON.stringify(bundle);
        
        // Try base64 encoding first (more compact)
        var base64Raw = '';
        try {
          base64Raw = btoa(unescape(encodeURIComponent(bundleRawJson)));
          var base64Url = 'https://jrsindustrial.co.uk/pages/bundle?bundle=' + bundleHash + '&from=order&_bundle_raw=' + encodeURIComponent(base64Raw);
          
          // Check if base64 version fits in URL (use 8000 char limit - most browsers support this)
          if (base64Url.length <= 8000) {
            bundleRawString = encodeURIComponent(base64Raw);
            mrkDebug.log('[BUNDLE DEBUG] Using base64 encoded _bundle_raw in URL (length: ' + base64Url.length + ' chars)');
          } else {
            // Base64 too long, try raw JSON (but this will likely also be too long)
            var rawJsonUrl = 'https://jrsindustrial.co.uk/pages/bundle?bundle=' + bundleHash + '&from=order&_bundle_raw=' + encodeURIComponent(bundleRawJson);
            if (rawJsonUrl.length <= 8000) {
              bundleRawString = encodeURIComponent(bundleRawJson);
              mrkDebug.log('[BUNDLE DEBUG] Using raw JSON _bundle_raw in URL (base64 too long, length: ' + rawJsonUrl.length + ' chars)');
            } else {
              // Both too long - use base64 anyway (better than nothing)
              bundleRawString = encodeURIComponent(base64Raw);
              mrkDebug.warn('[BUNDLE DEBUG] Both base64 and raw JSON too long, using base64 anyway (length: ' + base64Url.length + ' chars)');
            }
          }
        } catch(e) {
          // Base64 encoding failed, use raw JSON
          bundleRawString = encodeURIComponent(bundleRawJson);
          mrkDebug.log('[BUNDLE DEBUG] Using raw JSON _bundle_raw in URL (base64 failed)');
        }
      } catch(e) {
        mrkDebug.warn('[BUNDLE DEBUG] Failed to convert bundle to JSON:', e);
        bundleRawString = '';
      }
      
      // Build URL with _bundle_raw parameter (as JSON, not PHP array)
      // CRITICAL: Always try to include _bundle_raw - most browsers support URLs up to 8000 chars
      // Only fall back to hash-only if URL exceeds 8000 characters (very rare)
      if (bundleRawString) {
        var finalUrl = 'https://jrsindustrial.co.uk/pages/bundle?bundle=' + bundleHash + '&from=order&_bundle_raw=' + bundleRawString;
        // Use higher threshold (8000 chars) - most browsers can handle this
        // Only fall back if URL is extremely long (which is very rare with base64 encoding)
        if (finalUrl.length <= 8000) {
          mrkPage_url = finalUrl;
          mrkDebug.log('[BUNDLE DEBUG] ✅ Bundle URL with _bundle_raw created (length: ' + finalUrl.length + ' chars)');
        } else {
          mrkDebug.warn('[BUNDLE DEBUG] ⚠️ URL with _bundle_raw extremely long (' + finalUrl.length + ' chars). Using hash only as fallback.');
          mrkPage_url = 'https://jrsindustrial.co.uk/pages/bundle?bundle=' + bundleHash + '&from=order';
        }
      } else {
        mrkDebug.warn('[BUNDLE DEBUG] ⚠️ Could not create _bundle_raw string, using hash only');
        mrkPage_url = 'https://jrsindustrial.co.uk/pages/bundle?bundle=' + bundleHash + '&from=order';
      }
    } else {
      // Ultra-minimal version works - use it
      jsonString = ultraMinimalJson;
      minimalBundle = ultraMinimalBundle;
      estimatedEncodedLength = ultraMinimalEstimatedLength;
    }
  }
  
  // Only create URL if we haven't set mrkPage_url yet (i.e., not using placeholder)
  if (!mrkPage_url || mrkPage_url === '') {
    // JSON is small enough - proceed with encoding
    // CRITICAL: Use base64 encoding to compress the JSON string (reduces size by ~33%)
    // This helps prevent URL truncation issues
    var base64String = '';
    try {
      // Convert string to base64
      base64String = btoa(unescape(encodeURIComponent(jsonString)));
    } catch(e) {
      base64String = encodeURIComponent(jsonString);
    }
    
    // URL-encode the base64 string (base64 is URL-safe but encodeURIComponent ensures compatibility)
    var encodedJsonString = encodeURIComponent(base64String);
    // Note: Removed &format=base64 parameter as it causes 404 errors
    // The bundle page template auto-detects base64 strings, so the parameter is not needed
    mrkPage_url = 'https://jrsindustrial.co.uk/pages/bundle?bundle=' + encodedJsonString;
    
    // Final check after encoding - use stricter threshold (1900 instead of 2000)
    if (mrkPage_url.length > 1900) {
      // CRITICAL: Base64 is too long, try raw JSON before falling back to hash
      mrkDebug.warn('[BUNDLE DEBUG] ⚠️ Base64 URL too long (' + mrkPage_url.length + ' chars). Trying raw JSON...');
      
      // Try raw JSON (URL encoded) instead of base64
      var rawJsonUrl = 'https://jrsindustrial.co.uk/pages/bundle?bundle=' + encodeURIComponent(jsonString);
      
      if (rawJsonUrl.length <= 1900) {
        // Raw JSON fits - use it
        mrkPage_url = rawJsonUrl;
        mrkDebug.log('[BUNDLE DEBUG] ✅ Using raw JSON in bundle parameter (length: ' + rawJsonUrl.length + ' chars)');
        if (debugLog) {
          addDebugStep('bundle_url_created', 'success', {
            urlLength: mrkPage_url.length,
            jsonStringLength: jsonString.length,
            format: 'raw_json',
            isPlaceholder: false
          });
        }
      } else {
        // Raw JSON also too long - use hash + _bundle_raw
        mrkDebug.warn('[BUNDLE DEBUG] ⚠️ Raw JSON also too long (' + rawJsonUrl.length + ' chars). Using hash + _bundle_raw.');
        if (debugLog) {
          addDebugWarning('Bundle URL is very long - using hash + _bundle_raw', {
            base64UrlLength: mrkPage_url.length,
            rawJsonUrlLength: rawJsonUrl.length,
            jsonStringLength: jsonString.length,
            note: 'Using hash placeholder with _bundle_raw parameter (JSON format)'
          });
        }
        
        // Generate hash
        var bundleHash = '';
        try {
          var hashSource = '';
          if (bundle.length > 0 && bundle[0].name) {
            hashSource = bundle[0].name.substring(0, 20);
          }
          if (bundle.length > 0 && bundle[0].products) {
            var firstProductKey = Object.keys(bundle[0].products)[0];
            if (firstProductKey && bundle[0].products[firstProductKey]) {
              hashSource += bundle[0].products[firstProductKey].sku || '';
            }
          }
          var hash = 0;
          for (var i = 0; i < hashSource.length; i++) {
            hash = ((hash << 5) - hash) + hashSource.charCodeAt(i);
            hash = hash & hash;
          }
          bundleHash = Math.abs(hash).toString(36).substring(0, 8);
        } catch(e) {
          bundleHash = 'bundle';
        }
        
        // Include _bundle_raw as JSON (not PHP array) for new orders
        var bundleRawString = '';
        try {
          // Convert bundle array to JSON string (raw JSON format for new orders)
          var bundleRawJson = JSON.stringify(bundle);
          
          // Try base64 encoding first (more compact)
          var base64Raw = '';
          try {
            base64Raw = btoa(unescape(encodeURIComponent(bundleRawJson)));
            var base64Url = 'https://jrsindustrial.co.uk/pages/bundle?bundle=' + bundleHash + '&from=order&_bundle_raw=' + encodeURIComponent(base64Raw);
            
            // Check if base64 version fits in URL (use 8000 char limit - most browsers support this)
            if (base64Url.length <= 8000) {
              bundleRawString = encodeURIComponent(base64Raw);
              mrkDebug.log('[BUNDLE DEBUG] Using base64 encoded _bundle_raw in URL (length: ' + base64Url.length + ' chars)');
            } else {
              // Base64 too long, try raw JSON (but this will likely also be too long)
              var rawJsonUrl = 'https://jrsindustrial.co.uk/pages/bundle?bundle=' + bundleHash + '&from=order&_bundle_raw=' + encodeURIComponent(bundleRawJson);
              if (rawJsonUrl.length <= 8000) {
                bundleRawString = encodeURIComponent(bundleRawJson);
                mrkDebug.log('[BUNDLE DEBUG] Using raw JSON _bundle_raw in URL (base64 too long, length: ' + rawJsonUrl.length + ' chars)');
              } else {
                // Both too long - use base64 anyway (better than nothing)
                bundleRawString = encodeURIComponent(base64Raw);
                mrkDebug.warn('[BUNDLE DEBUG] Both base64 and raw JSON too long, using base64 anyway (length: ' + base64Url.length + ' chars)');
              }
            }
          } catch(e) {
            // Base64 encoding failed, use raw JSON
            bundleRawString = encodeURIComponent(bundleRawJson);
            mrkDebug.log('[BUNDLE DEBUG] Using raw JSON _bundle_raw in URL (base64 failed)');
          }
        } catch(e) {
          mrkDebug.warn('[BUNDLE DEBUG] Failed to convert bundle to JSON:', e);
          bundleRawString = '';
        }
        
        // Build URL with _bundle_raw parameter (as JSON, not PHP array)
        if (bundleRawString) {
          var finalUrl = 'https://jrsindustrial.co.uk/pages/bundle?bundle=' + bundleHash + '&from=order&_bundle_raw=' + bundleRawString;
          // Final safety check - if still too long, just use hash (data is in cart properties)
          if (finalUrl.length <= 2000) {
            mrkPage_url = finalUrl;
          } else {
            mrkDebug.warn('[BUNDLE DEBUG] URL with _bundle_raw still too long, using hash only. Data available in cart _bundle_raw property.');
            mrkPage_url = 'https://jrsindustrial.co.uk/pages/bundle?bundle=' + bundleHash + '&from=order';
          }
        } else {
          mrkPage_url = 'https://jrsindustrial.co.uk/pages/bundle?bundle=' + bundleHash + '&from=order';
        }
      }
    } else {
      // Log successful URL creation for debugging
      if (debugLog) {
        addDebugStep('bundle_url_created', 'success', {
          urlLength: mrkPage_url.length,
          jsonStringLength: jsonString.length,
          base64Length: base64String.length,
          encodedLength: encodedJsonString.length,
          isPlaceholder: false
        });
      }
    }
  }
  // Detailed bundle_raw summary - so we know exactly what went into _bundle_raw (Order #52352/52354)
  if (debugLog) {
    var totalCategories = bundle.length;
    var totalPositions = 0;
    var totalProducts = 0;
    var positionsWithUrl = 0;
    var positionsWithLogoType = 0;
    var textLogoWithColor = 0;
    var textLogoWithFont = 0;
    var productsWithVariantId = 0;
    bundle.forEach(function(bundleItem) {
      var positions = bundleItem.positions;
      var positionsList = Array.isArray(positions) ? positions : (positions && typeof positions === 'object' ? Object.keys(positions).map(function(k) { return positions[k]; }) : []);
      totalPositions += positionsList.length;
      var products = bundleItem.products || {};
      var productKeys = Object.keys(products);
      totalProducts += productKeys.length;
      productKeys.forEach(function(k) {
        if (products[k] && products[k].variantId) productsWithVariantId++;
      });
      positionsList.forEach(function(pos) {
        if (!pos || typeof pos !== 'object') return;
        var lt = pos.logoType || pos.logo_type || pos['Logo Type'];
        if (lt) positionsWithLogoType++;
        var u = pos['Logo'] || (pos.logo && pos.logo && pos.logo.url);
        if (u && String(u).length > 0) positionsWithUrl++;
        if (lt === 'Text Logo' && pos.logo) {
          if ((pos.logo.color !== undefined && pos.logo.color !== null) || (pos['Logo Color'] && String(pos['Logo Color']).length > 0)) textLogoWithColor++;
          if ((pos.logo.font !== undefined && pos.logo.font !== null) || (pos['Logo Font'] && String(pos['Logo Font']).length > 0)) textLogoWithFont++;
        }
      });
    });
    addDebugStep('bundle_raw_construction_complete', 'success', {
      version: debugLog.version || '7.0.0',
      themeVersion: debugLog.themeVersion || _themeVersion,
      totalCategories: totalCategories,
      totalProducts: totalProducts,
      totalPositions: totalPositions,
      productsWithVariantId: productsWithVariantId,
      positionsWithUrl: positionsWithUrl,
      positionsWithLogoType: positionsWithLogoType,
      textLogoWithColor: textLogoWithColor,
      textLogoWithFont: textLogoWithFont,
      timestamp: new Date().toISOString()
    });
  }
  // Order #52352: Normalize positions - fix empty logoType for Category 2 (and any category)
  // Order #52354: Normalize Text Logo - ensure color/font always present in logo object for all categories
  bundle.forEach(function(bundleItem) {
    var positions = bundleItem.positions;
    if (!positions) return;
    var positionsList = Array.isArray(positions) ? positions : (typeof positions === 'object' ? Object.keys(positions).map(function(k) { return positions[k]; }) : []);
    positionsList.forEach(function(pos) {
      if (!pos || typeof pos !== 'object') return;
      var logoId = pos['Logo Id'] || (pos.logo && pos.logo.logoId);
      var logoType = pos.logoType || pos.logo_type || pos['Logo Type'];
      if ((!logoType || logoType === '') && logoId) {
        pos.logoType = (pos.logo && pos.logo.logoType) || 'Upload Your Logo';
        if (pos.logo && typeof pos.logo === 'object') {
          pos.logo.logoType = pos.logo.logoType || pos.logoType || 'Upload Your Logo';
        }
        if (debugLog) {
          addDebugWarning('bundle_raw_logoType_inferred', {
            positionName: pos.name,
            logoId: logoId,
            inferredLogoType: pos.logoType,
            note: 'logoType was empty but logoId present (Order #52352 fix)'
          });
        }
      }
      // Order #52354: Text Logo - ensure color and font always present in logo object
      if ((logoType || pos.logoType) === 'Text Logo' && pos.logo && typeof pos.logo === 'object') {
        pos.logo.color = pos['Logo Color'] || pos.logo.color || '';
        pos.logo.font = pos['Logo Font'] || pos.logo.font || '';
      }
    });
  });
  var genricProperties = {
    '_bundle': mrkPage_url,
    '_bundle_raw': bundle
  };
  
    // bundleItems: bundle.length,
    // totalProducts: bundle.reduce(function(sum, item) {
      // return sum + (item.products ? Object.keys(item.products).length : 0);
    // }, 0),
    // totalPositions: bundle.reduce(function(sum, item) {
      // return sum + (item.positions ? item.positions.length : 0);
    // }, 0)
  // });

  //Ak custom code
  properties = Object.assign(properties, allPositionProperties);
  //Ak custom code

  // ===== POST-MERGE DIAGNOSTIC (v3 fix) =====
  // With Sources A, A.1, and B neutralized, properties should have NO numbered
  // properties at this point. The rebuild below is the sole writer.
  if (debugLog) {
    try {
      var preMergeNumbered = [];
      for (var pmKey in properties) {
        if (/^(Application Method |Logo Type |Logo Id |_logoVariant|Logo |Logo Text |Logo Text [234] |Logo Color |Logo Font |Note |Position |_logoproduct|_logoposition)\d+$/.test(pmKey)) {
          preMergeNumbered.push(pmKey);
        }
      }
      addDebugStep('properties_object_post_merge_check', preMergeNumbered.length === 0 ? 'success' : 'warning', {
        numberedPropertiesFound: preMergeNumbered.length,
        keys: preMergeNumbered.slice(0, 20),
        status: preMergeNumbered.length === 0
          ? 'CLEAN — no reversed numbered properties before rebuild'
          : 'WARNING — stale numbered properties detected; rebuild will clear them',
        note: 'v3 source elimination: all upstream reversed write sources neutralized'
      });
    } catch(e) { /* diagnostic should not break cart add */ }
  }
  // ===== END POST-MERGE DIAGNOSTIC =====

  // ===== REBUILD ALL NUMBERED PROPERTIES FROM BUNDLE ARRAY =====
  // SINGLE CANONICAL WRITER for Position N, Logo Id N, Application Method N, etc.
  // All other paths (positionsData, DOM collection) must not write these; Phase 2 overwrites them.
  // Iteration order: bundle sorted by categoryIndex, then positions within each category (category 0 → 1 → 2).
  // Works directly on `properties` to catch reversed data from ALL upstream sources.

  // Phase 1: CLEAR all existing numbered properties (indices 1-20)
  var maxPossiblePositions = 20;
  for (var clearIdx = 1; clearIdx <= maxPossiblePositions; clearIdx++) {
      delete properties['Application Method ' + clearIdx];
      delete properties['Application Method ' + clearIdx]; // pre-rename form
      delete properties['Logo Type ' + clearIdx];
      delete properties['Logo Type ' + clearIdx]; // pre-rename form
      delete properties['_logoVariant' + clearIdx];
      delete properties['Logo Id ' + clearIdx];
      delete properties['Logo Id ' + clearIdx]; // pre-rename form
      delete properties['Logo ' + clearIdx];
      delete properties['Logo ' + clearIdx]; // pre-rename form
      delete properties['Logo Text ' + clearIdx];
      delete properties['Logo Text 2 ' + clearIdx];
      delete properties['Logo Text 3 ' + clearIdx];
      delete properties['Logo Text 4 ' + clearIdx];
      delete properties['Logo Color ' + clearIdx];
      delete properties['Logo Font ' + clearIdx];
      delete properties['Note ' + clearIdx];
      delete properties['Note ' + clearIdx]; // pre-rename form
      delete properties['Position ' + clearIdx];
      delete properties['Position ' + clearIdx]; // pre-rename form
      delete properties['_logoproduct' + clearIdx];
      delete properties['_logoposition' + clearIdx];
  }

  // Phase 2: REBUILD from bundle array in forward order (category 0 → 1 → 2)
  // CRITICAL (Order #55448): Sort bundle by categoryIndex so property group N always matches _bundle_raw category N.
  // DOM order can differ from logical category order; sorting guarantees Logo Id 1 = category 0, etc.
  bundle.sort(function (a, b) {
    var ai = (a && a.categoryIndex != null) ? Number(a.categoryIndex) : 999;
    var bi = (b && b.categoryIndex != null) ? Number(b.categoryIndex) : 999;
    return ai - bi;
  });
  if (debugLog) {
    addDebugStep('bundle_sorted_by_category_index', 'success', {
      order: bundle.map(function (c) { return { name: c.name, categoryIndex: c.categoryIndex }; }),
      note: 'Parent numbered properties will match _bundle_raw by category index'
    });
  }

  // Phase 2 (Bug 2 / Order #55519): REBUILD from single canonical flattened array — one loop, no reversal
  var flatPositions = [];
  for (var c = 0; c < bundle.length; c++) {
    var cat = bundle[c];
    var positions = cat.positions || [];
    if (!Array.isArray(positions)) {
      // Target 5 (Bug I): Sort by numeric key so rebuild order matches verification and avoids slot 1 contamination
      positions = Object.keys(positions).sort(function(a, b) { return Number(a) - Number(b); }).map(function(k) { return positions[k]; });
    }
    for (var p = 0; p < positions.length; p++) {
      flatPositions.push({ categoryName: (cat.name || '').trim(), position: positions[p] });
    }
  }
  var rebuildIndex = 0;
  for (var i = 0; i < flatPositions.length; i++) {
    var idx = i + 1;
    var item = flatPositions[i];
    var pos = item.position;
    var catName = item.categoryName;
    rebuildIndex = idx;

    properties['_logoproduct' + idx] = catName;
    properties['_logoposition' + idx] = pos.name || '';
    properties['Position ' + idx] = pos.name || '';
    properties['Application Method ' + idx] = pos.applicationMethod || pos['Application Method'] || '';
    properties['Logo Type ' + idx] = pos.logoType || pos.logo_type || pos['Logo Type'] || '';
    properties['_logoVariant' + idx] = pos.logoVariantId || pos._logoVariant || '';
    properties['Logo Id ' + idx] = pos['Logo Id'] || '';

    var rLogoType = pos.logoType || pos.logo_type || pos['Logo Type'] || '';
    if (rLogoType === 'Existing Logo' || rLogoType === 'Upload Your Logo') {
      var logoUrlVal = pos.Logo || pos['Logo'] || (pos.logo && pos.logo.url) || '';
      if (logoUrlVal === 'Customer uploaded image' || (logoUrlVal && typeof logoUrlVal === 'string' && logoUrlVal.indexOf('http') !== 0)) {
        logoUrlVal = (pos.logo && pos.logo.url && String(pos.logo.url).indexOf('http') === 0) ? pos.logo.url : '';
      }
      properties['Logo ' + idx] = logoUrlVal;
      properties['Note ' + idx] = pos.Note || pos['Note'] || '';
    } else if (rLogoType === 'Text Logo') {
      properties['Logo Text ' + idx] = pos['Logo Text'] || '';
      properties['Logo Text 2 ' + idx] = pos['Logo Text 2'] || '';
      properties['Logo Text 3 ' + idx] = pos['Logo Text 3'] || '';
      properties['Logo Text 4 ' + idx] = pos['Logo Text 4'] || '';
      properties['Logo Color ' + idx] = pos['Logo Color'] || pos.color || '';
      properties['Logo Font ' + idx] = pos['Logo Font'] || pos.font || '';
      properties['Note ' + idx] = pos.Note || pos['Note'] || '';
    }
  }

  // Order #55531: Keep Position N and _logoposition N in sync (same value from same source).
  for (var syncIdx = 1; syncIdx <= rebuildIndex; syncIdx++) {
    var logopos = properties['_logoposition' + syncIdx] || '';
    if (logopos) {
      properties['Position ' + syncIdx] = logopos;
    }
  }

  // Auto-correct numbered properties from _bundle_raw (source of truth when loading from cart)
  if (properties['_bundle_raw']) {
    try {
      var bundleRaw = typeof properties['_bundle_raw'] === 'string' ? JSON.parse(properties['_bundle_raw']) : properties['_bundle_raw'];
      var flatExpected = [];
      if (bundleRaw && Array.isArray(bundleRaw)) {
        var bundleSorted = bundleRaw.slice().sort(function(a, b) {
          var ai = (a && a.categoryIndex != null) ? Number(a.categoryIndex) : 999;
          var bi = (b && b.categoryIndex != null) ? Number(b.categoryIndex) : 999;
          return ai - bi;
        });
        bundleSorted.forEach(function(cat) {
          var catPositions = cat.positions || [];
          if (!Array.isArray(catPositions)) {
            catPositions = Object.keys(catPositions).map(function(k) { return catPositions[k]; });
          }
          catPositions.forEach(function(pos) {
            flatExpected.push({
              position: (pos && (pos.name || pos.position)) ? String(pos.name || pos.position).trim() : '',
              logoId: String(pos && (pos['Logo Id'] || pos.logoId) || ''),
              logoType: (pos && (pos.logo_type || pos.logoType || pos['Logo Type'])) || '',
              method: (pos && (pos['Application Method'] || pos.applicationMethod)) || ''
            });
          });
        });
        var mismatches = [];
        for (var v = 0; v < flatExpected.length; v++) {
          var slot = v + 1;
          var exp = flatExpected[v];
          if (properties['Position ' + slot] !== exp.position ||
              (properties['Logo Id ' + slot] || '').toString() !== exp.logoId ||
              (properties['Logo Type ' + slot] || '') !== exp.logoType ||
              (properties['Application Method ' + slot] || '') !== exp.method) {
            mismatches.push({
              slot: slot,
              expected: exp,
              actual: {
                position: properties['Position ' + slot],
                logoId: properties['Logo Id ' + slot],
                logoType: properties['Logo Type ' + slot],
                method: properties['Application Method ' + slot]
              }
            });
            // pre-rename keys for this slot would otherwise linger next to the
            // healed ones on carts created before the Tracker-conformance rename
            delete properties['Position ' + slot];
            delete properties['Logo Id ' + slot];
            delete properties['Logo Type ' + slot];
            delete properties['Application Method ' + slot];
            delete properties['Logo ' + slot];
            delete properties['Note ' + slot];
            properties['Position ' + slot] = exp.position;
            properties['_logoposition' + slot] = exp.position;
            properties['Logo Id ' + slot] = exp.logoId;
            properties['Logo Type ' + slot] = exp.logoType;
            properties['Application Method ' + slot] = exp.method;
          }
        }
        if (mismatches.length > 0 && debugLog) {
          addDebugStep('bundle_raw_autocorrect', 'warning', {
            corrected: mismatches.length,
            total: flatExpected.length,
            mismatches: mismatches
          });
        }
      }
    } catch (e) { /* do not break cart add */ }
  }

  // D7: Post-rebuild comparison log (expected vs actual per slot)
  if (debugLog && flatPositions.length > 0) {
    var rebuildComparison = flatPositions.map(function(fp, i) {
      var idx = i + 1;
      var expectedLogoId = (fp.position && (fp.position['Logo Id'] || fp.position.logoId)) ? String(fp.position['Logo Id'] || fp.position.logoId) : '';
      var actualLogoId = (properties['Logo Id ' + idx] || '').toString();
      var expectedPos = (fp.position && (fp.position.name || fp.position.position)) ? String(fp.position.name || fp.position.position) : '';
      var actualPos = (properties['Position ' + idx] || '').toString();
      return {
        n: idx,
        cat: (fp.categoryName || '').substring(0, 20),
        posMatch: expectedPos === actualPos,
        logoMatch: expectedLogoId === actualLogoId,
        expected: { pos: expectedPos, logoId: expectedLogoId },
        actual: { pos: actualPos, logoId: actualLogoId }
      };
    });
    var allMatchD7 = rebuildComparison.every(function(r) { return r.posMatch && r.logoMatch; });
    addDebugStep('numbered_properties_post_rebuild', allMatchD7 ? 'success' : 'error', {
      phase: 'after_rebuild',
      allMatch: allMatchD7,
      slots: rebuildComparison
    });
  }

  // Optional (Bug 2): consistency check — numbered props vs flattened list (only when debugLog set)
  if (debugLog && debugLog.warnings && flatPositions.length > 0) {
    for (var chk = 0; chk < flatPositions.length; chk++) {
      var n = chk + 1;
      var entry = flatPositions[chk];
      var pos = entry.position;
      var expectProduct = entry.categoryName;
      var expectPosition = pos.name || '';
      var expectLogoId = pos['Logo Id'] || '';
      var expectAppMethod = pos.applicationMethod || pos['Application Method'] || '';
      var gotProduct = properties['_logoproduct' + n] || '';
      var gotPosition = properties['_logoposition' + n] || '';
      var gotLogoId = properties['Logo Id ' + n] || '';
      var gotAppMethod = properties['Application Method ' + n] || '';
      if (gotProduct !== expectProduct || gotPosition !== expectPosition || gotLogoId !== expectLogoId || gotAppMethod !== expectAppMethod) {
        debugLog.warnings.push({
          code: 'numbered_property_mismatch',
          index: n,
          expected: { product: expectProduct, position: expectPosition, logoId: expectLogoId, appMethod: expectAppMethod },
          actual: { product: gotProduct, position: gotPosition, logoId: gotLogoId, appMethod: gotAppMethod },
          note: 'Numbered property N does not match flatPositions[N-1] — possible reversal'
        });
      }
    }
  }

  // Phase 2.5 (Order #53753): POST-REBUILD ASSERTION — Bug S: read-only, do not overwrite
  // Verify that _logoposition N always equals Position N (they are set from the same pos.name).
  // If they differ, log only; do not force-correct (assertion overwrite could scramble Position N / Logo Id N).
  var rebuildCorrections = 0;
  for (var assertIdx = 1; assertIdx <= rebuildIndex; assertIdx++) {
    var assertLogoPos = properties['_logoposition' + assertIdx] || '';
    var assertPosN = properties['Position ' + assertIdx] || '';
    if (assertLogoPos !== assertPosN) {
      rebuildCorrections++;
      var assertCorrectValue = '';
      var assertBundleIdx = 0;
      for (var aCatIdx = 0; aCatIdx < bundle.length && !assertCorrectValue; aCatIdx++) {
        var aCatPositions = bundle[aCatIdx].positions || [];
        if (!Array.isArray(aCatPositions)) {
          aCatPositions = Object.keys(aCatPositions).map(function(k) { return aCatPositions[k]; });
        }
        for (var aPosIdx = 0; aPosIdx < aCatPositions.length; aPosIdx++) {
          assertBundleIdx++;
          if (assertBundleIdx === assertIdx) {
            assertCorrectValue = aCatPositions[aPosIdx].name || '';
            break;
          }
        }
      }
      if (debugLog) {
        addDebugWarning('post_rebuild_assertion_failed', {
          index: assertIdx,
          _logoposition: assertLogoPos,
          positionN: assertPosN,
          expectedFromBundle: assertCorrectValue || 'could_not_determine',
          note: 'Position N and _logoposition N differed after rebuild — logged only (Bug S: no overwrite)'
        });
      }
    }
  }
  if (debugLog && rebuildCorrections > 0) {
    addDebugStep('post_rebuild_corrections', 'warning', {
      totalCorrections: rebuildCorrections,
      totalPositions: rebuildIndex,
      note: 'Numbered properties were corrected after rebuild — indicates upstream contamination source'
    });
  }

  // Phase 2.6 (verification-only): Cross-validate ALL positions vs bundle; same order as rebuild (no overwrite)
  var crossValidateIssues = [];
  var phase2PropIdx = 0;
  for (var vIdx = 0; vIdx < bundle.length; vIdx++) {
    var vCat = bundle[vIdx];
    var vPositions = vCat.positions || [];
    if (!Array.isArray(vPositions)) vPositions = Object.keys(vPositions).sort(function(a, b) { return Number(a) - Number(b); }).map(function (k) { return vPositions[k]; });
    for (var vPosIdx = 0; vPosIdx < vPositions.length; vPosIdx++) {
      phase2PropIdx++;
      var vPos = vPositions[vPosIdx];
      var expectedLogoId = (vPos && (vPos['Logo Id'] || vPos.logoId)) ? String(vPos['Logo Id'] || vPos.logoId) : '';
      var actualLogoId = (properties['Logo Id ' + phase2PropIdx] || '').toString();
      var expectedProduct = (vCat.name || '').trim();
      var actualProduct = (properties['_logoproduct' + phase2PropIdx] || '').trim();
      var expectedPosName = (vPos && (vPos.name || vPos.position)) ? String(vPos.name || vPos.position) : '';
      var actualPosName = (properties['Position ' + phase2PropIdx] || '').toString();
      var actualLogopos = (properties['_logoposition' + phase2PropIdx] || '').toString();
      if (expectedLogoId && actualLogoId && expectedLogoId !== actualLogoId) {
        crossValidateIssues.push({ type: 'LOGO_ID_MISMATCH', severity: 'CRITICAL', categoryIndex: vIdx, categoryName: vCat.name, propertyGroup: phase2PropIdx, expected: expectedLogoId, actual: actualLogoId });
      }
      if (expectedProduct && actualProduct !== expectedProduct) {
        crossValidateIssues.push({ type: 'PRODUCT_NAME_MISMATCH', severity: 'HIGH', categoryIndex: vIdx, propertyGroup: phase2PropIdx, expected: expectedProduct, actual: actualProduct });
      }
      if (expectedPosName && actualPosName !== expectedPosName) {
        crossValidateIssues.push({ type: 'POSITION_MISMATCH', severity: 'HIGH', propertyGroup: phase2PropIdx, expected: expectedPosName, actual: actualPosName });
      }
      if (expectedPosName && actualLogopos !== expectedPosName) {
        crossValidateIssues.push({ type: 'LOGOPOSITION_MISMATCH', severity: 'HIGH', propertyGroup: phase2PropIdx, expected: expectedPosName, actual: actualLogopos });
      }
    }
  }
  if (crossValidateIssues.length > 0 && debugLog) {
    addDebugError('parent_vs_bundle_raw_mismatch', { issues: crossValidateIssues, fixed: false, note: 'Verification only — mismatches logged; rebuild is sole writer (correct-by-construction)' });
  }

  // Order #55441: Strip extra numbered property groups beyond rebuildIndex (avoids leftover groups from merge/collision)
  for (var cleanIdx = rebuildIndex + 1; cleanIdx <= 20; cleanIdx++) {
    delete properties['Logo Id ' + cleanIdx];
    delete properties['Logo Id ' + cleanIdx]; // pre-rename form
    delete properties['_logoproduct' + cleanIdx];
    delete properties['Position ' + cleanIdx];
    delete properties['Position ' + cleanIdx]; // pre-rename form
    delete properties['Application Method ' + cleanIdx];
    delete properties['Application Method ' + cleanIdx]; // pre-rename form
    delete properties['Logo Type ' + cleanIdx];
    delete properties['Logo Type ' + cleanIdx]; // pre-rename form
    delete properties['_logoVariant' + cleanIdx];
    delete properties['Logo ' + cleanIdx];
    delete properties['Logo ' + cleanIdx]; // pre-rename form
    delete properties['Note ' + cleanIdx];
    delete properties['Note ' + cleanIdx]; // pre-rename form
    delete properties['_logoposition' + cleanIdx];
    delete properties['Logo Text ' + cleanIdx];
    delete properties['Logo Text 2 ' + cleanIdx];
    delete properties['Logo Text 3 ' + cleanIdx];
    delete properties['Logo Text 4 ' + cleanIdx];
    delete properties['Logo Color ' + cleanIdx];
    delete properties['Logo Font ' + cleanIdx];
  }

  // Phase 3: Debug snapshot — numbered_properties_final_state
  if (debugLog) {
    try {
      var logoSummaryPositions = [];
      var existingLogoUrls = [];

      for (var sIdx = 1; sIdx <= rebuildIndex; sIdx++) {
        var sLogoType = properties['Logo Type ' + sIdx] || '';
        var sLogoUrl = properties['Logo ' + sIdx] || '';

        logoSummaryPositions.push({
          index: sIdx,
          category: properties['_logoproduct' + sIdx] || '',
          position: properties['_logoposition' + sIdx] || '',
          logoType: sLogoType,
          logoId: properties['Logo Id ' + sIdx] || '',
          logoUrl: sLogoUrl || 'N/A',
          logoText: properties['Logo Text ' + sIdx] || 'N/A',
          appMethod: properties['Application Method ' + sIdx] || '',
          positionProp: properties['Position ' + sIdx] || ''
        });

        if (sLogoType === 'Existing Logo' && sLogoUrl) {
          existingLogoUrls.push(sLogoUrl);
        }
      }

      var uniqueUrls = [];
      existingLogoUrls.forEach(function(u) {
        if (uniqueUrls.indexOf(u) === -1) uniqueUrls.push(u);
      });

      addDebugStep('numbered_properties_final_state', 'success', {
        totalPositions: rebuildIndex,
        source: 'rebuilt_from_bundle_array',
        position1: {
          _logoproduct: properties['_logoproduct1'] || 'N/A',
          _logoposition: properties['_logoposition1'] || 'N/A',
          applicationMethod: properties['Application Method 1'] || 'N/A',
          logoType: properties['Logo Type 1'] || 'N/A',
          logoId: properties['Logo Id 1'] || 'N/A',
          position: properties['Position 1'] || 'N/A',
          logo: properties['Logo 1'] || properties['Logo Text 1'] || 'N/A'
        },
        positionLast: {
          _logoproduct: properties['_logoproduct' + rebuildIndex] || 'N/A',
          _logoposition: properties['_logoposition' + rebuildIndex] || 'N/A',
          applicationMethod: properties['Application Method ' + rebuildIndex] || 'N/A',
          logoType: properties['Logo Type ' + rebuildIndex] || 'N/A',
          logoId: properties['Logo Id ' + rebuildIndex] || 'N/A',
          position: properties['Position ' + rebuildIndex] || 'N/A',
          logo: properties['Logo ' + rebuildIndex] || properties['Logo Text ' + rebuildIndex] || 'N/A'
        },
        consistencyCheck: {
          pos1_logoproduct_matches_bundle0: (properties['_logoproduct1'] || '').trim() === (bundle[0] && bundle[0].name || '').trim(),
          posLast_logoproduct_matches_bundleLast: (properties['_logoproduct' + rebuildIndex] || '').trim() === (bundle[bundle.length - 1] && bundle[bundle.length - 1].name || '').trim()
        },
        positions: logoSummaryPositions,
        duplicateUrlCheck: {
          existingLogoUrls: existingLogoUrls,
          uniqueUrls: uniqueUrls.length,
          totalExistingLogoPositions: existingLogoUrls.length,
          allIdentical: uniqueUrls.length === 1 && existingLogoUrls.length > 1,
          warning: (uniqueUrls.length === 1 && existingLogoUrls.length > 1)
            ? 'LIKELY BUG: All existing logo positions share the same URL despite potentially different Logo IDs'
            : null
        }
      });
    } catch(e) { /* debug should not break cart add */ }
  }
  // ===== END REBUILD ALL NUMBERED PROPERTIES =====

  const newProperties = Object.assign({}, genricProperties, properties);
  
  // Add debug log to properties if provided
  if (typeof debugLog !== 'undefined' && debugLog) {
    // Add version identifier for tracking (if not already present)
    if (!debugLog.version) {
      debugLog.version = '7.0.0';
    }
    // Ensure theme identifiers are always present
    if (!debugLog.theme) {
      debugLog.theme = 'base';
      debugLog.themeVersion = _themeVersion;
    }
    if (!debugLog.version) {
      debugLog.version = '7.0.0';
    }
    // Store debug log as JSON string in order properties (size-limited so it persists to order)
    if (JRS_DEBUG_PROPERTIES_IN_CART) {
      newProperties['_bundle_debug_log'] = getPersistableDebugLog(debugLog);
      newProperties['_debug_errors_count'] = String(debugLog.errors ? debugLog.errors.length : 0);
      if (debugLog.errors && debugLog.errors.length > 0) {
        var lastErrBuild = debugLog.errors[debugLog.errors.length - 1];
        var lastErrMsgBuild = (typeof lastErrBuild === 'string' ? lastErrBuild : (lastErrBuild && lastErrBuild.message) || JSON.stringify(lastErrBuild)).slice(0, 200);
        newProperties['_debug_last_error'] = lastErrMsgBuild;
      }
    }
  }

  // ===== Todo 6: Cart Data Integrity Validation =====
  // Cross-reference numbered properties vs _bundle_raw before sending to cart.
  // Catches mismatches that would cause incorrect logo assignments in orders.
  if (debugLog) {
    try {
      var integrityErrors = [];
      var bundleRaw = null;
      try {
        bundleRaw = JSON.parse(newProperties['_bundle_raw'] || '[]');
      } catch(e) { bundleRaw = []; }

      var validationIndex = 0;
      for (var vCatIdx = 0; vCatIdx < bundleRaw.length; vCatIdx++) {
        var vCat = bundleRaw[vCatIdx];
        var vPositions = vCat.positions || [];
        if (!Array.isArray(vPositions)) {
          vPositions = Object.keys(vPositions).sort(function(a, b) { return Number(a) - Number(b); }).map(function(k) { return vPositions[k]; });
        }

        for (var vPosIdx = 0; vPosIdx < vPositions.length; vPosIdx++) {
          var vPos = vPositions[vPosIdx];
          validationIndex++;

          // Check 1: Application Method match
          var propAppMethod = newProperties['Application Method ' + validationIndex] || '';
          var rawAppMethod = vPos.applicationMethod || vPos['Application Method'] || '';
          if (propAppMethod && rawAppMethod && propAppMethod !== rawAppMethod) {
            integrityErrors.push({
              type: 'app_method_mismatch',
              index: validationIndex,
              numbered: propAppMethod,
              bundleRaw: rawAppMethod,
              category: vCat.name,
              position: vPos.name
            });
          }

          // Check 2: Logo URL match (for Existing/Upload logos)
          var propLogoUrl = newProperties['Logo ' + validationIndex] || '';
          var rawLogoUrl = vPos.Logo || vPos['Logo'] || '';
          if (propLogoUrl && rawLogoUrl && propLogoUrl !== rawLogoUrl) {
            integrityErrors.push({
              type: 'logo_url_mismatch',
              index: validationIndex,
              numbered: propLogoUrl,
              bundleRaw: rawLogoUrl,
              category: vCat.name,
              position: vPos.name
            });
          }

          // Check 3: Logo Id match
          var propLogoId = String(newProperties['Logo Id ' + validationIndex] || '');
          var rawLogoId = String(vPos['Logo Id'] || '');
          if (propLogoId && rawLogoId && propLogoId !== rawLogoId) {
            integrityErrors.push({
              type: 'logo_id_mismatch',
              index: validationIndex,
              numbered: propLogoId,
              bundleRaw: rawLogoId,
              category: vCat.name,
              position: vPos.name
            });
          }

          // Check 4: _logoproduct match
          var propProduct = (newProperties['_logoproduct' + validationIndex] || '').trim();
          var rawProduct = (vCat.name || '').trim();
          if (propProduct && rawProduct && propProduct !== rawProduct) {
            integrityErrors.push({
              type: 'product_mismatch',
              index: validationIndex,
              numbered: propProduct,
              bundleRaw: rawProduct,
              position: vPos.name
            });
          }

          // Check 5 (Order #53753): _logoposition must match Position N and _bundle_raw position name
          var propLogoPos = newProperties['_logoposition' + validationIndex] || '';
          var propPositionN = newProperties['Position ' + validationIndex] || '';
          var rawPositionName = vPos.name || '';
          if (propLogoPos && rawPositionName && propLogoPos !== rawPositionName) {
            integrityErrors.push({
              type: 'logoposition_vs_raw_mismatch',
              index: validationIndex,
              _logoposition: propLogoPos,
              bundleRaw: rawPositionName,
              category: vCat.name
            });
          }
          if (propLogoPos && propPositionN && propLogoPos !== propPositionN) {
            integrityErrors.push({
              type: 'logoposition_vs_positionN_mismatch',
              index: validationIndex,
              _logoposition: propLogoPos,
              positionN: propPositionN,
              category: vCat.name,
              note: 'These are set from the same source — mismatch means post-rebuild overwrite'
            });
          }
        }
      }

      addDebugStep('cart_data_integrity_check', integrityErrors.length === 0 ? 'success' : 'error', {
        totalChecks: validationIndex * 6,
        errorCount: integrityErrors.length,
        errors: integrityErrors.slice(0, 15),
        status: integrityErrors.length === 0 ? 'ALL_CHECKS_PASSED' : 'INTEGRITY_ERRORS_DETECTED',
        note: integrityErrors.length > 0
          ? 'Cart data has mismatches between numbered properties and _bundle_raw — order may have incorrect logo assignments'
          : 'v4.2: All numbered properties including _logoproduct/_logoposition vs _bundle_raw are consistent'
      });
    } catch(e) { /* integrity check should not block cart add */ }
  }
  // ===== END INTEGRITY VALIDATION =====
  
  // Add comprehensive debug properties - Updated 2026-02-14
  var bundleItemsCount = bundle.length;
  var totalPositionsCount = bundle.reduce(function(sum, item) {
    return sum + (item.positions ? item.positions.length : 0);
  }, 0);
  var bundleRawSize = JSON.stringify(bundle).length;
  
  var debugProps = generateBundleDebugProperties('parent', {
    bundleCategories: bundleItemsCount,
    bundleItems: bundleItemsCount,
    bundlePositions: totalPositionsCount,
    bundleRawSize: bundleRawSize,
    expectedChildren: totalPositionsCount,
    childCount: totalPositionsCount,
    bundleValidation: 'passed',
    bundleRawTruncated: bundleRawSize > 5000
  });
  
  // Merge all debug properties into newProperties
  for (var key in debugProps) {
    if (debugProps.hasOwnProperty(key)) {
      newProperties[key] = debugProps[key];
    }
  }
  
  return({
    quantity: qty,
    id:ParentVariantId,
    properties: newProperties
  })
}
function buildItem(id,qty,ParentVariantId,property,logo_id,additionalProperties){
  // Validate inputs
  if (!id || id === 0 || isNaN(Number(id))) {
    return null;
  }
  
  if (!qty || qty <= 0) {
    qty = 1;
  }
  
  if(ParentVariantId == '' || !ParentVariantId){
    return ({
      quantity: qty,
      id: Number(id)
    })
  }else{
    // Build base properties
    var properties = {
        '_ParentVariant': String(ParentVariantId),
        '_qty': String(qty),
        '_time': String(universalTimeValue),
        'Logo Id': logo_id || ''
    };
    
    // ====================================================================
    // CRITICAL FIX: Prevent Shopify Cart API from Merging Items
    // ====================================================================
    // PROBLEM: Shopify's /cart/add.js API may merge items with the same
    // variantId if properties are too similar. Order #51287 failed because
    // all 5 items used the same variantId (44333841875187) and Shopify
    // merged some of them, resulting in only 3 items in cart.
    //
    // SOLUTION: Add a unique line item identifier that combines variantId,
    // logoId, and position to ensure each logo item is treated as a separate
    // line item by Shopify's cart API.
    //
    // This ensures that even if multiple items have the same variantId,
    // they won't be merged because they have different _lineItemKey values.
    // ====================================================================
    if (logo_id && additionalProperties && additionalProperties.position) {
      // P0.5 (Bug F) — Universal _lineItemKey format: variantId_parentVariantId_logoId_position.
      // Including ParentVariantId differentiates same-decoration-variant children that belong to
      // different bundle parent sizes (e.g., size L + size M sharing the same Large Back Print variant).
      var lineItemKey = [id, ParentVariantId, logo_id, (additionalProperties.position || '').replace(/\s+/g, '_')].join('_');
      properties._lineItemKey = lineItemKey;
      // Inject _unique_key visible at /cart/add.js merge-hash time so Shopify never collapses two
      // children that share variant_id but differ by parent / logo / position.
      properties._unique_key = lineItemKey;
    }
    
    // CRITICAL FIX: Add all additional properties needed for fulfillment
    // This ensures the factory has all information needed:
    // - Position (which position on the product)
    // - Application Method (Embroidery or Print)
    // - Logo Type (Text Logo, Upload Your Logo, Existing Logo)
    // - Logo details (Logo Text, Logo Color, Logo Font, Note, Logo URL)
    // - Product details (bundle item name, product variant info)
    if (additionalProperties && typeof additionalProperties === 'object') {
      // Position and application method (required for fulfillment)
      if (additionalProperties.position || additionalProperties.name) {
        properties.Position = additionalProperties.position || additionalProperties.name || '';
      }
      if (additionalProperties.applicationMethod || additionalProperties.application_method) {
        properties['Application Method'] = additionalProperties.applicationMethod || additionalProperties.application_method || '';
      }
      
      // Logo type and variant
      if (additionalProperties.logoType || additionalProperties.logo_type) {
        properties['Logo Type'] = additionalProperties.logoType || additionalProperties.logo_type || '';
      }
      if (additionalProperties.logoVariant || additionalProperties._logoVariant) {
        properties._logoVariant = additionalProperties.logoVariant || additionalProperties._logoVariant || '';
      }
      
      // Logo details (text, color, font, note, logo URL, filename)
      if (additionalProperties.logoText || additionalProperties['Logo Text']) {
        properties['Logo Text'] = additionalProperties.logoText || additionalProperties['Logo Text'] || '';
      }
      if (additionalProperties.logoText2 || additionalProperties['Logo Text 2']) {
        properties['Logo Text 2'] = additionalProperties.logoText2 || additionalProperties['Logo Text 2'] || '';
      }
      if (additionalProperties.logoText3 || additionalProperties['Logo Text 3']) {
        properties['Logo Text 3'] = additionalProperties.logoText3 || additionalProperties['Logo Text 3'] || '';
      }
      if (additionalProperties.logoText4 || additionalProperties['Logo Text 4']) {
        properties['Logo Text 4'] = additionalProperties.logoText4 || additionalProperties['Logo Text 4'] || '';
      }
      if (additionalProperties.logoColor || additionalProperties['Logo Color']) {
        properties['Logo Color'] = additionalProperties.logoColor || additionalProperties['Logo Color'] || '';
      }
      if (additionalProperties.logoFont || additionalProperties['Logo Font']) {
        properties['Logo Font'] = additionalProperties.logoFont || additionalProperties['Logo Font'] || '';
      }
      if (additionalProperties.logo || additionalProperties.Logo) {
        properties.Logo = additionalProperties.logo || additionalProperties.Logo || '';
        // Derive filename from URL for image logos - use original filename from cache
        var logoFileName = getOriginalLogoFilename(properties.Logo);
        if (logoFileName) {
          properties['Logo Filename'] = logoFileName;
        }
      }
      if (additionalProperties.note || additionalProperties.Note) {
        properties.Note = additionalProperties.note || additionalProperties.Note || '';
      }
      
      // Product details (which specific product this logo applies to)
      // CRITICAL FIX: Use property parameter as fallback if not in additionalProperties (Cart Data 13 fix)
      if (additionalProperties.bundleName || additionalProperties.property || property) {
        properties._BundleItemName = additionalProperties.bundleName || additionalProperties.property || property || '';
      }
      // Order #55448: Child enrichment — category name and product count so fulfillment sees full category
      if (additionalProperties.categoryName != null) {
        properties._BundleCategoryName = String(additionalProperties.categoryName);
      }
      if (additionalProperties.categoryIndex != null) {
        properties._BundleCategoryIndex = String(additionalProperties.categoryIndex);
      }
      if (additionalProperties.categoryProductCount != null) {
        properties._BundleCategoryProductCount = String(additionalProperties.categoryProductCount);
      }
      if (additionalProperties.categoryProducts != null && String(additionalProperties.categoryProducts).length > 0) {
        properties._BundleCategoryProducts = String(additionalProperties.categoryProducts).substring(0, 200);
      }
      if (additionalProperties.productVariantId || additionalProperties.product_variant_id) {
        properties._ProductVariantId = additionalProperties.productVariantId || additionalProperties.product_variant_id || '';
      }
      if (additionalProperties.productSku || additionalProperties.sku) {
        properties._ProductSku = additionalProperties.productSku || additionalProperties.sku || '';
      }
      if (additionalProperties.productSize || additionalProperties.size) {
        properties._ProductSize = additionalProperties.productSize || additionalProperties.size || '';
      }
      if (additionalProperties.productColor || additionalProperties.color) {
        properties._ProductColor = additionalProperties.productColor || additionalProperties.color || '';
      }
    }
    
    // Add comprehensive debug properties - Updated 2026-02-14
    var productTitle = additionalProperties && additionalProperties.bundleName 
      ? additionalProperties.bundleName 
      : property || '';
    var logoSource = 'unknown';
    if (additionalProperties) {
      if (additionalProperties.logoType === 'Upload Your Logo' || additionalProperties['Logo Type'] === 'Upload Your Logo') {
        logoSource = 'upload';
      } else if (additionalProperties.logoType === 'Existing Logo' || additionalProperties['Logo Type'] === 'Existing Logo') {
        logoSource = 'existing';
      } else if (additionalProperties.logoType === 'Text Logo' || additionalProperties['Logo Type'] === 'Text Logo') {
        logoSource = 'text';
      }
    }
    
    var logoType = (additionalProperties && (additionalProperties.logoType || additionalProperties['Logo Type'])) || '';
    var logoValue = (additionalProperties && (additionalProperties.logo || additionalProperties.Logo)) || '';
    // CRITICAL FIX (Bug 3): Extract logoText for text logos so _debug_logo_value is populated
    // Previously logoText was never passed, so generateBundleDebugProperties always fell through
    // to logoValue (which is the image URL — empty for text logos)
    var logoText = (additionalProperties && (additionalProperties.logoText || additionalProperties['Logo Text'])) || '';
    
    var debugProps = generateBundleDebugProperties('child', {
      productTitle: productTitle,
      qtyRatio: qty,
      positionValidated: !!(additionalProperties && additionalProperties.position),
      methodValidated: !!(additionalProperties && additionalProperties.applicationMethod),
      logoSource: logoSource,
      parentBundleKey: ParentVariantId ? ParentVariantId.toString() : '',
      logoType: logoType,
      logoValue: logoValue,
      logoText: logoText
    });
    
    // Merge debug properties
    for (var key in debugProps) {
      if (debugProps.hasOwnProperty(key)) {
        properties[key] = debugProps[key];
      }
    }
    
    return ({
      quantity: qty,
      id: Number(id),
      properties: properties
    })
  }
  
}

function updateSizeGuideTables2() {
  var tableHtml = '';
  if (window.template.template.includes("bundle")) {
    let kiwiSizingModal = document.querySelector('.kiwi-sizing-modal')
    if (kiwiSizingModal) {
      $('.bundle__colour-header .customSizeGuideButton').css('display', 'flex');
      $('.custom-size-guide-text').css('display', 'block');
    } else {
      $('.bundle__colour-header .customSizeGuideButton').css('display', 'none');
      $('.custom-size-guide-text').css('display', 'none');
    }
  }
  else {
    $('.mrk-size-guide-table').each(function () {
        if ($(this).html() !== '') {
            tableHtml = $(this).html();
            $('.bundle__colour-header .customSizeGuideButton').css('display', 'flex');
            $('.custom-size-guide-text').css('display', 'block');
        }
    });
    $('.mrk-size-guide-table').each(function () {
        if ($(this).html() === '') {
            $(this).html(tableHtml);
            $('.bundle__colour-header .customSizeGuideButton').css('display', 'none');
            $('.custom-size-guide-text').css('display', 'none');
        }
    });
  }
}

function renderData(select){
    $('.mrk-bundle-loader-main').css('display', 'flex');
    var $container = $(select).parents('.bundle__details').find('.bundle__details-inner .bundle__colour-options');
    var savedQuantities = [];
    if ($container.length) {
        $container.find('input.mrk-qty-item').each(function() {
            var variantId = $(this).attr('data-variant-id');
            var val = parseInt($(this).val(), 10) || 0;
            if (variantId && val > 0) {
                savedQuantities.push({ variantId: variantId, value: val });
            }
        });
    }

    var selectedOptions = $(select).find('option:selected');
    var ajaxCalls = [];
    var urls = new Set(); // To keep track of already processed URLs

    selectedOptions.each(function() {
        var variantUrl = $(this).attr('varianturl') + '&view=bundleSizes&_=' + (Date.now ? Date.now() : new Date().getTime());
        if (variantUrl) {
            ajaxCalls.push($.ajax({
                url: variantUrl,
                method: 'GET',
                cache: false
            }));
        }
    });

    if (ajaxCalls.length === 0) {
        // No options selected, clear the HTML
        $container.html('');
        $('.mrk-bundle-loader-main').hide();
        return;
    }

    $.when.apply($, ajaxCalls).then(function() {
        var combinedHtml = '';
        if (ajaxCalls.length > 1) {
            // Multiple calls, arguments is an array of responses
            $.each(arguments, function(index, responseData) {
              
                combinedHtml += responseData[0];
            });
        } else {
            // Single call, arguments is the response data directly
            combinedHtml = arguments[0];
        }

        $container.html(combinedHtml);
        $('.mrk-bundle-loader-main').hide();

        // The injected HTML contains [data-jrs-flat-grid] mount points. Liquid's
        // product.variants is capped at 250, so for products with more variants
        // (JH001 has 693) the size grid is rendered client-side from
        // /products/{handle}.js. Wait for those grids before binding events and
        // restoring quantities — qty inputs don't exist until cards are rendered.
        var _finalize = function() {
            bindEvents();

            // Restore quantities for variants that are still in the new HTML
            $container = $(select).parents('.bundle__details').find('.bundle__details-inner .bundle__colour-options');
            for (var i = 0; i < savedQuantities.length; i++) {
                var item = savedQuantities[i];
                var $input = $container.find('input.mrk-qty-item[data-variant-id="' + item.variantId + '"]');
                if ($input.length) {
                    $input.val(item.value).change();
                }
            }
            if (savedQuantities.length) {
                upDateTotals();
            }
        };

        if (window.JRS && JRS.BundleSizeGrid && typeof JRS.BundleSizeGrid.render === 'function') {
            try {
                JRS.BundleSizeGrid.render($container[0]).then(_finalize, _finalize);
            } catch (e) {
                _finalize();
            }
        } else {
            _finalize();
        }
    });
}

function bindEvents(){
    $('.bundle__details-inner .mrk-qty-item').off('change');
    $('.bundle__details-inner [data-action="decrement"]').off('click');
    $('.bundle__details-inner [data-action="increment"]').off('click');
    $('.bundle__details-inner [data-action="decrement"]').click(function() {
        // Find the nearest input of type number and decrement its value
        var $input = $(this).parents('.stock').find('.mrk-qty-item');
        var currentValue = parseInt($input.val(), 10);
        var minValue = $input.attr('min') ? parseInt($input.attr('min'), 10) : 0;
        
        if (currentValue > minValue) {
            $input.val(currentValue - 1).change();
        }
        upDateTotals();
    });

    // Handle increment action
    $('.bundle__details-inner [data-action="increment"]').click(function() {
        var $input = $(this).parents('.stock').find('.mrk-qty-item');
        var currentValue = parseInt($input.val(), 10);
        var maxValue = $input.attr('max') ? parseInt($input.attr('max'), 10) : 100;
        var total = 0;
        var limit = $('.bundle-selector').length
            ? parseInt($(this).closest('.category').attr('data-category-limit') || 0, 10)
            : Number($('.bundle__build-item--active').attr('limit'));
        $(this).parents('.bundle__colour-options').find('.mrk-qty-item').each(function(){
            total = total + Number($(this).val());
        });
        if(total > limit){
            $($input).val(0);
            return;
        }
        if(total == limit){
            upDateTotals();
            return;
        }
        
        if (currentValue < maxValue) {
            $input.val(currentValue + 1).change();
            if (typeof jrsPDPTrack === 'function' && window.jrsProductId) {
              try {
                var $cat = $input.closest('.category');
                var stepNum = parseInt($cat.attr('data-category-index') || '1', 10);
                jrsPDPTrack('pdp_configurator_add_step', {
                  product_id: window.jrsProductId,
                  step_number: stepNum,
                  step_label: 'type_' + stepNum,
                  device_type: typeof jrsDeviceType === 'function' ? jrsDeviceType() : (window.innerWidth <= 768 ? 'mobile' : 'desktop')
                });
              } catch (e) { console.warn('GA4 add step track error', e); }
            }
        }
        upDateTotals();
    });
    $('.bundle__details-inner .mrk-qty-item').on('change',function(){
      var bundleItemName = $(this).closest('.mrk-bundle-products-items').attr('bundleitemName');
      var bundleIndex = $(this).closest('.mrk-bundle-products-items').attr('bundleitem');
      var productName = $(this).attr('productname');
      var size = $(this).attr('size');
      var color = $(this).attr('color');
      var qty = Number($(this).val());
      
      
      var previousQty = $(this).data('previous-qty') || 0;
      $(this).data('previous-qty', qty);
      
      var total = 0;
      var limit = $(this).closest('.bundle-selector').length
          ? parseInt($(this).closest('.category').attr('data-category-limit') || 0, 10)
          : Number($('.bundle__build-item--active').attr('limit'));
      $(this).parents('.bundle__colour-options').find('.mrk-qty-item').each(function(){
          total = total + Number($(this).val());
      });
      
      
      if(total > limit){
          $(this).val(0);
          
          trackUserInteraction('quantity_limit_exceeded', {
            bundleItem: bundleItemName,
            product: productName,
            size: size,
            color: color,
            requestedQty: qty,
            totalForColor: total,
            limit: limit
          });
          
          return;
      }else{
        
        trackUserInteraction('quantity_changed', {
          bundleItem: bundleItemName,
          product: productName,
          size: size,
          color: color,
          previousQty: previousQty,
          newQty: qty,
          totalForColor: total,
          limit: limit
        });
        if (typeof jrsPDPTrack === 'function' && window.jrsProductId) {
          try {
            var $cat = $(this).closest('.category');
            var stepNum = parseInt($cat.attr('data-category-index') || '1', 10);
            jrsPDPTrack('pdp_configurator_quantity_change', {
              product_id: window.jrsProductId,
              step_number: stepNum,
              from_quantity: previousQty,
              to_quantity: qty,
              device_type: typeof jrsDeviceType === 'function' ? jrsDeviceType() : (window.innerWidth <= 768 ? 'mobile' : 'desktop')
            });
            if (size && previousQty === 0 && qty > 0) {
              jrsPDPTrack('pdp_configurator_size_select', {
                product_id: window.jrsProductId,
                step_number: stepNum,
                size_value: size,
                device_type: typeof jrsDeviceType === 'function' ? jrsDeviceType() : (window.innerWidth <= 768 ? 'mobile' : 'desktop')
              });
            }
          } catch (err) { console.warn('GA4 quantity/size track error', err); }
        }
        upDateTotals();
      }
    });

    // Real-time clamp for manual typing in size-grid qty inputs.
    // Cap = min(maxAttr, categoryLimit − sumOfOtherInputs) so a 50-cap category with 21
    // already chosen elsewhere caps the active input at 29. Re-uses the same selectors
    // and limit-resolution rules as the +/− and change handlers above so behaviour stays
    // identical between button clicks and typing.
    //
    // Delegated through document with a window-level guard so it survives the multiple
    // bindEvents() calls triggered by the colour-change AJAX flow without double-binding.
    if (!window._jrsTypedQtyClampBound) {
      window._jrsTypedQtyClampBound = true;
      $(document).on('input', '.bundle__details-inner .mrk-qty-item', function () {
        var $input = $(this);
        // Strip non-digits the user might have pasted; preserve cursor at end.
        var raw = String($input.val() == null ? '' : $input.val()).replace(/[^0-9]/g, '');
        if (raw === '' && $input.val() !== '') $input.val('');
        var typed = raw === '' ? 0 : parseInt(raw, 10);
        if (!isFinite(typed) || typed < 0) typed = 0;

        var maxAttr = $input.attr('max') ? parseInt($input.attr('max'), 10) : 100;
        if (!isFinite(maxAttr) || maxAttr <= 0) maxAttr = 100;

        var $cat = $input.closest('.category');
        var categoryLimit = $('.bundle-selector').length
          ? parseInt($cat.attr('data-category-limit') || 0, 10)
          : Number($('.bundle__build-item--active').attr('limit'));
        if (!isFinite(categoryLimit) || categoryLimit <= 0) categoryLimit = maxAttr;

        // Sum of all OTHER size inputs across all colour-blocks of this bundleItem.
        var otherTotal = 0;
        $input.parents('.bundle__colour-options').find('.mrk-qty-item').each(function () {
          if (this !== $input[0]) otherTotal += Number($(this).val()) || 0;
        });

        var capacityRemaining = Math.max(0, categoryLimit - otherTotal);
        var cap = Math.min(maxAttr, capacityRemaining);

        if (typed > cap) {
          // Snap to cap and let the existing change handler take over for totals/tracking.
          $input.val(cap);
          if (cap !== typed) $input.trigger('change');
        } else if (raw !== $input.val()) {
          // Normalised numeric (e.g. user pasted "1a2"); reflect the cleaned value.
          $input.val(typed);
        }
      });
    }
}
function UpdateBundle(){
    var bundleItems = {};

    $('.mrk-bundle-products-items .mrk-qty-item').each(function() {
        var indexArray = Number($(this).parents('.mrk-bundle-products-items').attr('bundleItem'));

        if (!bundleItems['bundleItem_' + indexArray]) {
            bundleItems['bundleItem_' + indexArray] = [];
        }

        var itemObject = {
            quantity: $(this).val(),
            variantId: $(this).attr('data-variant-id')
        };
        if($(this).val()>0)
        bundleItems['bundleItem_' + indexArray].push(itemObject);
    });

}
function calculateTotal(){
    var total = 0;
    $('.bundle__options-contain').find('.mrk-qty-item').each(function(){
        total = total + Number($(this).val())
    });
    $('.bundle__build .selected_products').text(total);
}

function updateOptionARow($detail) {
    if (!$detail || $detail.length === 0) return;
    var $summary = $detail.find('.a-row__summary');
    if ($summary.length === 0) return;

    var total = 0;
    $detail.find('.mrk-qty-item').each(function() {
        total += parseInt($(this).val(), 10) || 0;
    });

    var $qtyEl = $detail.find('.a-row__qty, .amount-selected.a-row__qty');
    if ($qtyEl.length) {
        $qtyEl.removeClass('qty-neutral qty-active').addClass(total > 0 ? 'qty-active' : 'qty-neutral');
    }

    $summary.empty().removeClass('has-chips');
    $detail.find('.mrk-qty-item').each(function() {
        var val = parseInt($(this).val(), 10) || 0;
        if (val <= 0) return;
        var color = $(this).attr('color') || '';
        var size = $(this).attr('size') || '';
        var label = color + (size ? ' · ' + size + ' ×' + val : ' ×' + val);
        if (label.trim()) {
            $summary.append($('<span class="a-row__summary-chip"></span>').text(label));
        }
    });
    if ($summary.children().length) {
        $summary.addClass('has-chips');
    }
}

function formatCategoryMeta($cat) {
    var colours = {};
    $cat.find('.mrk-qty-item').each(function() {
        var qty = parseInt($(this).val(), 10) || 0;
        if (qty > 0) {
            var colour = $(this).attr('color') || $(this).attr('colour') || '';
            if (colour) colours[colour] = (colours[colour] || 0) + qty;
        }
    });
    var sorted = Object.keys(colours)
        .map(function(c) { return { colour: c, qty: colours[c] }; })
        .sort(function(a, b) { return b.qty - a.qty || a.colour.localeCompare(b.colour); });
    if (!sorted.length) return '';
    var MAX = 3;
    var visible = sorted.slice(0, MAX);
    var extra = sorted.length - MAX;
    var text = visible.map(function(s) { return s.colour + ' \u00d7' + s.qty; }).join(' \u00b7 ');
    if (extra > 0) text += ' + ' + extra + ' more';
    return text;
}

function updateBundlePriceBreakdown() {
    var $items = $('.js-breakdown-items');
    var $content = $items.length ? $items.closest('.pb__panel-content') : $();
    var $totals = $content.find('.breakdown-totals');
    var $compareEl = $totals.find('.js-breakdown-compare-total');
    var $bundlePriceEl = $totals.find('.js-breakdown-bundle-price');
    var $savingsBar = $content.find('.js-breakdown-savings-bar');
    var $savingsEl = $savingsBar.find('.js-breakdown-savings');
    var $emptyMsg = $content.find('.js-breakdown-empty');
    var $toggleLabel = $('.breakdown-toggle__label');
    if (!$items.length) return;

    var rows = [];
    var compareTotalCents = 0;
    var priceTotalCents = 0;
    var bundleCents = null;

    var breakdownData = null;
    try {
        var dataEl = document.getElementById('bundle-breakdown-data-json');
        if (dataEl && dataEl.textContent) {
            breakdownData = JSON.parse(dataEl.textContent);
        }
    } catch (e) {}

    if (breakdownData && breakdownData.categories && breakdownData.categories.length > 0) {
        bundleCents = (breakdownData.bundle_price_cents != null && breakdownData.bundle_price_cents > 0)
            ? breakdownData.bundle_price_cents
            : null;
        breakdownData.categories.forEach(function(cat) {
            var products = cat.products || [];
            var limit = parseInt(cat.limit, 10) || 0;
            if (limit <= 0 || !products.length) return;
            // Pick most expensive product in category (highest compare_cents, fallback price_cents)
            var mostExpensive = products.reduce(function(best, p) {
                var pCompare = parseInt(p.compare_cents, 10) || 0;
                var pPrice = parseInt(p.price_cents, 10) || 0;
                var pVal = pCompare > 0 ? pCompare : pPrice;
                var bestCompare = parseInt(best.compare_cents, 10) || 0;
                var bestPrice = parseInt(best.price_cents, 10) || 0;
                var bestVal = bestCompare > 0 ? bestCompare : bestPrice;
                return pVal > bestVal ? p : best;
            }, products[0]);
            var c = parseInt(mostExpensive.compare_cents, 10) || 0;
            var pr = parseInt(mostExpensive.price_cents, 10) || 0;
            if (c <= 0 && pr <= 0) return;
            var rowCompareCents = c * limit;
            var rowPriceCents = pr * limit;
            rows.push({
                title: mostExpensive.title || 'Item',
                qty: limit,
                compareCents: rowCompareCents,
                priceCents: rowPriceCents
            });
            compareTotalCents += rowCompareCents;
            priceTotalCents += rowPriceCents;
        });
    } else {
        var staticProducts = null;
        try {
            var jsonEl = document.getElementById('bundle-breakdown-products-json');
            if (jsonEl && jsonEl.textContent) {
                staticProducts = JSON.parse(jsonEl.textContent);
            }
        } catch (e2) {}
        if (staticProducts && staticProducts.length > 0) {
            staticProducts.forEach(function(p) {
                var compareCents = parseInt(p.compare_cents, 10) || 0;
                var priceCents = parseInt(p.price_cents, 10) || 0;
                rows.push({ title: p.title || 'Item', qty: 1, compareCents: compareCents, priceCents: priceCents });
                compareTotalCents += compareCents;
                priceTotalCents += priceCents;
            });
        } else {
            $('.bundle-selector .bundle__details--mix-and-match').each(function() {
                var title = $(this).attr('data-product-title') || 'Item';
                var rowQty = 0;
                var rowCompareCents = 0;
                var rowPriceCents = 0;
                $(this).find('.mrk-qty-item').each(function() {
                    var q = parseInt($(this).val(), 10) || 0;
                    if (q <= 0) return;
                    var p = parseInt($(this).attr('data-price') || $(this).attr('price') || 0, 10);
                    var c = parseInt($(this).attr('data-compare') || $(this).attr('data-price') || $(this).attr('price') || 0, 10);
                    rowQty += q;
                    rowCompareCents += q * c;
                    rowPriceCents += q * p;
                });
                if (rowQty > 0) {
                    rows.push({ title: title, qty: rowQty, compareCents: rowCompareCents, priceCents: rowPriceCents });
                    compareTotalCents += rowCompareCents;
                    priceTotalCents += rowPriceCents;
                }
            });
        }
    }

    $items.empty();
    if (rows.length > 0) {
        rows.forEach(function(r) {
            var eachCents = r.qty > 1 ? Math.round(r.compareCents / r.qty) : r.compareCents;
            $items.append(
                '<div class="pb__item">' +
                '<span class="pb__item-name">' + r.title + '</span>' +
                '<div class="pb__item-cols">' +
                '<span class="pb__item-qty">\u00d7' + r.qty + '</span>' +
                '<span class="pb__item-each">' + formatMoney(eachCents) + '</span>' +
                '<span class="pb__item-total">' + formatMoney(r.compareCents) + '</span>' +
                '</div></div>'
            );
        });
        if (bundleCents == null) {
            try {
                var priceEl = document.getElementById('bundle-breakdown-price-json');
                if (priceEl && priceEl.textContent) {
                    var priceData = JSON.parse(priceEl.textContent);
                    if (priceData && typeof priceData.bundle_price_cents === 'number' && priceData.bundle_price_cents > 0) {
                        bundleCents = priceData.bundle_price_cents;
                    }
                }
            } catch (e) {}
        }
        if (bundleCents == null && typeof window.bundlePrice === 'number' && window.bundlePrice > 0) {
            bundleCents = window.bundlePrice;
        }
        if (bundleCents == null) {
            bundleCents = priceTotalCents;
        }
        // Table-derived totals: one source of truth (Individual total = sum of row totals)
        var compareDisplayCents = compareTotalCents;
        if ($compareEl.length) $compareEl.text(formatMoney(compareDisplayCents));
        if ($bundlePriceEl.length) $bundlePriceEl.text(formatMoney(bundleCents));
        var savingsCents = Math.max(0, compareDisplayCents - bundleCents);
        var savePct = (compareDisplayCents > 0 && savingsCents > 0 ? Math.round(savingsCents / compareDisplayCents * 100) : 0);
        if ($savingsEl.length) $savingsEl.text(formatMoney(savingsCents));
        $totals.show();
        if ($savingsBar.length) { savingsCents > 0 ? $savingsBar.show() : $savingsBar.hide(); }
        if ($emptyMsg.length) $emptyMsg.hide();
        // Sync savings anchor with breakdown so one number shows everywhere (Option A)
    } else {
        $totals.hide();
        if ($savingsBar.length) $savingsBar.hide();
        if ($emptyMsg.length) $emptyMsg.show();
    }

    if ($toggleLabel.length) {
        var totalItems = rows.length;
        var totalQty = 0;
        rows.forEach(function(r) { totalQty += r.qty || 0; });
        if (totalQty > 0) totalItems = totalQty;
        else if (breakdownData && breakdownData.total_items != null && breakdownData.total_items > 0) {
            totalItems = breakdownData.total_items;
        }
        $toggleLabel.text(totalItems > 0 ? 'Price breakdown \u2014 ' + totalItems + ' items' : 'Price breakdown');
    }
}

function upDateTotals(){
    var bundleTotal = 0;
    var totalLimit = typeof window.totalLimit === 'number' ? window.totalLimit : 0;

    // New bundle selector UI (.bundle-selector)
    if ($('.bundle-selector').length) {
        $('.bundle-selector .category').each(function() {
            var $cat = $(this);
            var limit = parseInt($cat.attr('data-category-limit') || 0, 10);
            var catTotal = 0;
            $cat.find('.mrk-qty-item').each(function() {
                catTotal += parseInt($(this).val(), 10) || 0;
            });
            bundleTotal += catTotal;
            var $countEl = $cat.find('.category__progress-count');
            var $fill = $cat.find('.category__bar-fill');
            if ($countEl.length) {
                $countEl.html(catTotal + ' <span>/ ' + limit + '</span>');
            }
            if ($fill.length) {
                $fill.css('width', limit ? (Math.min(catTotal, limit) / limit * 100) + '%' : '0%');
            }
            $cat.toggleClass('category--complete', catTotal === limit && limit > 0);
            if (catTotal === limit && limit > 0 && typeof jrsPDPTrack === 'function' && window.jrsProductId) {
              try {
                var stepNum = parseInt($cat.attr('data-category-index') || '1', 10);
                var stepCompleteKey = 'step_' + stepNum;
                if (!window.jrsConfiguratorStepCompleteFired) window.jrsConfiguratorStepCompleteFired = {};
                if (!window.jrsConfiguratorStepCompleteFired[stepCompleteKey]) {
                  window.jrsConfiguratorStepCompleteFired[stepCompleteKey] = true;
                  var catName = $cat.find('.category__name').text() || ('type_' + stepNum);
                  jrsPDPTrack('pdp_configurator_step_complete', {
                    product_id: window.jrsProductId,
                    step_number: stepNum,
                    step_label: 'type_' + stepNum,
                    selected_product_name: catName,
                    quantity: catTotal,
                    device_type: typeof jrsDeviceType === 'function' ? jrsDeviceType() : (window.innerWidth <= 768 ? 'mobile' : 'desktop')
                  });
                }
              } catch (err) { console.warn('GA4 step complete track error', err); }
            }

            /* Category body progress bar */
            var $bodyProgress = $cat.find('.category__body-progress');
            if ($bodyProgress.length) {
                var pct = limit > 0 ? Math.round((catTotal / limit) * 100) : 0;
                var $progFill = $bodyProgress.find('.category__body-progress__fill');
                $progFill.css('width', pct + '%');
                var isComplete = catTotal >= limit;
                $progFill.toggleClass('category__body-progress__fill--green', isComplete);
                var $progText = $bodyProgress.find('.category__body-progress__text');
                if (catTotal === 0) {
                    $progText.html('Select <em style="color:#E8621A">' + limit + '</em> items');
                } else if (isComplete) {
                    $progText.html('<em style="color:#2E7D32">' + catTotal + '</em> of ' + limit + ' \u2014 complete');
                } else {
                    $progText.html('<em style="color:#E8621A">' + catTotal + '</em> of ' + limit + ' selected');
                }
            }

            // Category-header summary chips (e.g. "Black ×3 · Fuchsia ×2 + 1 more").
            // Was previously gated on `catTotal >= limit && !isExpanded`, which meant the
            // meta only ever appeared on a completed-and-collapsed category. Now shown
            // any time the user has made at least one selection — gives a live summary
            // that updates as they edit, regardless of whether the category is expanded
            // or whether the cap has been reached.
            var $meta = $cat.find('.category__meta');
            if ($meta.length) {
                var metaText = catTotal > 0 ? formatCategoryMeta($cat) : '';
                if (metaText) {
                    $meta.text(metaText).css('display', '');
                } else {
                    $meta.empty().css('display', 'none');
                }
            }
            var $status = $cat.find('.category__status');
            if ($status.length) {
                if (catTotal === limit && limit > 0) {
                    $status.text('COMPLETE').removeClass('category__status--select category__status--progress').addClass('category__status--complete');
                } else if (catTotal > 0) {
                    $status.text((limit - catTotal) + ' MORE').removeClass('category__status--complete category__status--select').addClass('category__status--progress');
                } else {
                    $status.text('SELECT ' + limit).removeClass('category__status--complete category__status--progress').addClass('category__status--select');
                }
            }
            var hasOpenRow = $cat.find('.bundle__details--open').length > 0;
            $cat.find('.category__body-hint').toggle(catTotal === 0 && !hasOpenRow);
            $cat.find('.bundle__details--mix-and-match').each(function() {
                var rowTotal = 0;
                $(this).find('.mrk-qty-item').each(function() {
                    rowTotal += parseInt($(this).val(), 10) || 0;
                });
                $(this).toggleClass('has-selection', rowTotal > 0);
                var $badge = $(this).find('.a-row__qty');
                if (rowTotal > 0) {
                    $badge.text(rowTotal).removeClass('qty-neutral').addClass('qty-active');
                } else {
                    $badge.text('0').removeClass('qty-active').addClass('qty-neutral');
                }
            });
            if ($cat.find('.category__progress-label').length) {
                $cat.find('.category__progress-label').text(catTotal === limit && limit > 0 ? 'Complete' : ('Select ' + limit));
            }
            $cat.find('.mrk-selected-qty').text(limit - catTotal);
            if (catTotal === limit && limit > 0) {
                $cat.find('.mrk-selected-qty-text').hide();
                $cat.find('.bundle-complete-banner').show();
                $cat.find('.bundle-complete-count').text(limit);
                $cat.find('.bundle-complete-total').text(limit);
            } else {
                $cat.find('.remaining-banner--top').show();
                $cat.find('.remaining-banner--bottom').toggle($cat.find('.bundle__details--open').length > 0);
                $cat.find('.bundle-complete-banner').hide();
            }
            $cat.find('.bundle__colour-options').toggleClass('mrk-options-disabled', catTotal >= limit);

            // Auto-collapse this category once the user fills its cap, and (for
            // multi-category bundles) auto-open the next one. Single-category
            // bundles now collapse too — 2026-07-02, reversing the earlier "only
            // collapse when >1 dropdowns" rule; the auto-open-next below is a
            // no-op when there is no next category, so single-category just
            // collapses cleanly to signal "done".
            //
            // Guards (must all hold):
            //   • catTotal just transitioned from < limit to == limit
            //     (uses data-jrs-prev-cat-total so cart-restore at-cap on initial render
            //      doesn't trigger a spurious collapse before the user has even looked)
            //   • this category hasn't been auto-collapsed before in this page session
            //     (one-shot via data-jrs-auto-collapsed; lets the user re-expand and
            //      redistribute quantities without the card snapping shut on each refill)
            //   • limit > 0 sanity guard
            var _prevCatTotalRaw = $cat.attr('data-jrs-prev-cat-total');
            var _prevCatTotal = _prevCatTotalRaw == null ? NaN : parseInt(_prevCatTotalRaw, 10);
            var _alreadyAutoCollapsed = $cat.attr('data-jrs-auto-collapsed') === '1';
            var _transitionedToCap = isFinite(_prevCatTotal) && _prevCatTotal < limit && catTotal === limit;
            if (_transitionedToCap && !_alreadyAutoCollapsed && limit > 0) {
                $cat.attr('data-jrs-auto-collapsed', '1');
                $cat.find('.bundle__details').removeClass('bundle__details--open');
                $cat.find('.mixmatch-open.active').removeClass('active');
                $cat.find('.bundle__details-inner').slideUp('fast');
                $cat.removeClass('category--expanded category--active');
                $cat.find('.category__header').attr('aria-expanded', 'false');
                $cat.find('.category__body').slideUp('fast', function () {
                    // Reuse the existing accordion handler at the top of bindEvents()
                    // (line ~481) — it already closes other categories, opens the
                    // target, scrolls into view, and emits GA4 tracking.
                    var $next = $cat.nextAll('.category').first();
                    if ($next.length) $next.find('.category__header').first().click();
                });
            }
            // Always update prev-total LAST so the next upDateTotals() call sees the
            // correct previous value for transition detection.
            $cat.attr('data-jrs-prev-cat-total', String(catTotal));
        });
        /* When bundle fully complete, ensure "Select next category" is never shown */
        if (bundleTotal === totalLimit && totalLimit > 0) {
            $('.bundle-selector .category__next-hint').hide();
            if (typeof jrsPDPTrack === 'function' && window.jrsProductId && !window.jrsConfiguratorComplete) {
              try {
                window.jrsConfiguratorComplete = true;
                var totalValue = 0;
                $('.bundle-selector .mrk-qty-item').each(function() {
                  var q = parseInt($(this).val(), 10) || 0;
                  var p = parseInt($(this).attr('data-price') || 0, 10);
                  if (q > 0 && p) totalValue += q * p;
                });
                jrsPDPTrack('pdp_configurator_all_complete', {
                  product_id: window.jrsProductId,
                  total_items: bundleTotal,
                  team_size: window.jrsTeamSize != null ? String(window.jrsTeamSize) : '',
                  total_value: totalValue,
                  device_type: typeof jrsDeviceType === 'function' ? jrsDeviceType() : (window.innerWidth <= 768 ? 'mobile' : 'desktop')
                });
              } catch (err) { console.warn('GA4 all complete track error', err); }
            }
        }
        var $header = $('.bundle__wrapper.bundle-build-options .selector-header');
        if ($header.length) {
            $('.bundle__wrapper.bundle-build-options .selector-header__current, .bundle__wrapper.bundle-build-options .selected_products').text(bundleTotal);
            $header.find('[data-selector-current]').text(bundleTotal);
            var pct = totalLimit ? (Math.min(bundleTotal, totalLimit) / totalLimit * 100) : 0;
            $header.find('.selector-header__fill').css('width', pct + '%');
            $header.toggleClass('selector-header--complete', bundleTotal === totalLimit && totalLimit > 0);
        }
        var bundleTotalCents = 0, bundleCompareCents = 0;
        $('.bundle-selector .mrk-qty-item').each(function() {
            var q = parseInt($(this).val(), 10) || 0;
            if (q <= 0) return;
            var p = parseInt($(this).attr('data-price') || $(this).attr('price') || 0, 10);
            var c = parseInt($(this).attr('data-compare') || $(this).attr('data-price') || $(this).attr('price') || 0, 10);
            bundleTotalCents += q * p;
            bundleCompareCents += q * c;
        });
        var $deliveryText = $('.delivery-strip__free-delivery-text-delivery');
        if ($deliveryText.length) {
            $deliveryText.text(bundleTotalCents >= 12500 ? 'delivery' : 'delivery over £125 ex VAT');
        }
        var $cta = $('.bundle-selector .completion-cta');
        if (bundleTotal === totalLimit && totalLimit > 0) {
            if ($cta.length) $cta.hide();
            var totalCents = (typeof window.bundlePrice === 'number' && window.bundlePrice > 0)
                ? window.bundlePrice
                : bundleTotalCents;
            var compareCents = (typeof window.bundleComparePrice === 'number' && window.bundleComparePrice > 0)
                ? window.bundleComparePrice
                : bundleCompareCents;
            var $statsBar = $('.bundle-selector .stats-bar');
            if ($statsBar.length) {
                $statsBar.find('[data-stats-items]').text(bundleTotal);
                $statsBar.find('[data-stats-total]').text(formatMoney(totalCents));
                var savingsCents = Math.max(0, compareCents - totalCents);
                var savePct = (compareCents > 0 && compareCents > totalCents) ? Math.round(savingsCents / compareCents * 100) : 0;
                $statsBar.find('[data-stats-savings]').text(savingsCents > 0 ? '−' + formatMoney(savingsCents) : '£0');
                $statsBar.find('[data-stats-savings-label]').text('You save (' + savePct + '%)');
                $statsBar.show();
            }
            var $primaryCta = $('.bundle__wrapper.bundle-build-options .bundle-cta-primary');
            if ($primaryCta.length) {
                var ctaBase = $primaryCta.hasClass('mrk-direct-bundle-add') ? 'Add To Cart' : 'Add Logo & Customise';
                var priceText = (totalCents > 0) ? (formatMoney(totalCents) + ' +VAT') : '';
                var label = priceText ? (ctaBase + ' — ' + priceText) : ctaBase;
                $primaryCta.find('.cta-primary__label').text(label);
                $primaryCta.prop('disabled', false).removeClass('cta-primary--disabled').addClass('cta-primary--active');
            }
        } else {
            if ($cta.length) {
                $cta.find('.completion-cta__message').text('Choose your items to continue');
                $cta.find('.completion-cta__remaining').text((totalLimit - bundleTotal) + ' items remaining');
                $cta.show();
            }
            var $statsBar = $('.bundle-selector .stats-bar');
            if ($statsBar.length) $statsBar.hide();
            var $primaryCta = $('.bundle__wrapper.bundle-build-options .bundle-cta-primary');
            if ($primaryCta.length) {
                var ctaBase = $primaryCta.hasClass('mrk-direct-bundle-add') ? 'Add To Cart' : 'Add Logo & Customise';
                var remaining = totalLimit - bundleTotal;
                $primaryCta.find('.cta-primary__label').text(ctaBase + ' — ' + remaining + ' items remaining');
                $primaryCta.prop('disabled', true).removeClass('cta-primary--active').addClass('cta-primary--disabled');
            }
        }
        $('.bundle-selector .bundle__details--mix-and-match').each(function() {
            var productTotal = 0;
            $(this).find('.mrk-qty-item').each(function() {
                productTotal += parseInt($(this).val(), 10) || 0;
            });
            $(this).find('.amount-selected').text(productTotal);
        });
        $('.bundle-selector .bundle__details--mix-and-match').each(function() {
            updateOptionARow($(this));
        });
        $('.bundle-selector .colour-block, .bundle-selector .bundle__colour-option').each(function() {
            var $block = $(this);
            var $added = $block.find('.colour-block__added');
            if ($added.length) {
                var total = 0;
                $block.find('.mrk-qty-item').each(function() { total += parseInt($(this).val(), 10) || 0; });
                $added.text(total > 0 ? total + ' added' : '');
            }
            var $sizes = $block.find('.colour-block__sizes');
            var $flatGrid = $sizes.find('.flat-grid');
            if ($flatGrid.length) {
                $block.find('.sc').each(function() {
                    var $card = $(this);
                    var $input = $card.find('.mrk-qty-item');
                    var qty = parseInt($input.val(), 10) || 0;
                    $card.toggleClass('sc--active', qty > 0);
                    $card.find('.sc__val').toggleClass('sc__val--active', qty > 0);
                });
            } else if ($sizes.length) {
                var rowsWithQty = [];
                $sizes.find('.slim-row').each(function() {
                    var qty = parseInt($(this).find('.mrk-qty-item').val(), 10) || 0;
                    rowsWithQty.push({ el: this, qty: qty });
                });
                rowsWithQty.sort(function(a, b) { return b.qty - a.qty; });
                rowsWithQty.forEach(function(item) {
                    $sizes.append(item.el);
                });
                $block.find('.slim-row').each(function() {
                    var $row = $(this);
                    var $input = $row.find('.mrk-qty-item');
                    var qty = parseInt($input.val(), 10) || 0;
                    $row.toggleClass('slim-row--active', qty > 0);
                    $row.find('.h-stepper').toggleClass('h-stepper--active', qty > 0);
                    $row.find('.h-stepper__val').toggleClass('h-stepper__val--active', qty > 0);
                });
            }
        });
        $('.bundle-selector .bundle__details-inner').each(function() {
            var $inner = $(this);
            var $saveBanner = $inner.find('.bundle__save-banner');
            if (!$saveBanner.length) return;
            var compareCents = 0;
            var priceCents = 0;
            $inner.find('.bundle__colour-options .colour-block, .bundle__colour-options .bundle__colour-option').each(function() {
                var compare = parseInt($(this).attr('data-compare-cents') || 0, 10);
                var price = parseInt($(this).attr('data-price-cents') || 0, 10);
                if (compare > price && compare > 0) {
                    compareCents = compare;
                    priceCents = price;
                    return false;
                }
            });
            if (compareCents > priceCents && compareCents > 0) {
                var savePct = Math.round((compareCents - priceCents) / compareCents * 100);
                $saveBanner.find('.save-banner__pill').text('Save ' + savePct + '%');
                $saveBanner.find('.save-banner__text').text('From ' + formatMoney(priceCents) + ' per item (was ' + formatMoney(compareCents) + ')');
                $saveBanner.show();
            } else {
                $saveBanner.hide();
            }
        });
        var $reviewWrap = $('.bundle-selector [data-review-wrap]');
        var $reviewItems = $reviewWrap.find('.review__items');
        if ($reviewWrap.length && $reviewItems.length) {
            if (bundleTotal === totalLimit && totalLimit > 0) {
                var categoriesByProduct = {};
                $('.bundle-selector .mrk-qty-item').each(function() {
                    var q = parseInt($(this).val(), 10) || 0;
                    if (q <= 0) return;
                    var color = $(this).attr('color') || $(this).attr('colour') || '';
                    var size = $(this).attr('size') || '';
                    var productName = ($(this).attr('productname') || '').trim();
                    var sku = $(this).attr('sku') || '';
                    if (!productName) return;
                    if (!categoriesByProduct[productName]) {
                        categoriesByProduct[productName] = { name: productName, shortName: productName.split(/\s+/).slice(0, 2).join(' ') || productName, count: 0, items: [] };
                    }
                    var cat = categoriesByProduct[productName];
                    var lineKey = color + '|' + size;
                    var existing = cat.items.filter(function(it) { return (it.color + '|' + it.size) === lineKey; })[0];
                    if (existing) {
                        existing.qty += q;
                    } else {
                        var dotStyle = '#666';
                        try {
                            var $chip = $('.bundle-selector .colour-chip[data-value="' + (color + '').replace(/"/g, '\\"').replace(/'/g, "\\'") + '"]').first();
                            if ($chip.length && $chip.find('.colour-chip__dot').length) {
                                var $dot = $chip.find('.colour-chip__dot');
                                var styleAttr = $dot.attr('style');
                                if (styleAttr && styleAttr.indexOf('background') !== -1) {
                                    dotStyle = styleAttr;
                                } else {
                                    var bg = $dot.css('background-color');
                                    if (bg) dotStyle = 'background-color:' + bg;
                                }
                            }
                        } catch (e) {}
                        cat.items.push({ color: color, size: size, qty: q, dotStyle: dotStyle, lineLabel: (color ? color + ' ' : '') + productName + ' — ' + size });
                    }
                    cat.count += q;
                });
                var categories = Object.keys(categoriesByProduct).map(function(k) { return categoriesByProduct[k]; });
                var summaryParts = categories.map(function(c) { return c.count + ' ' + c.shortName; });
                var summaryStr = summaryParts.join(' \u00B7 ');
                $reviewWrap.find('.review-section__total').text(totalLimit);
                $reviewWrap.find('.review__header-summary').text(summaryStr);
                $reviewWrap.find('.review__header-count').text(totalLimit);
                $reviewWrap.show().addClass('review--collapsed').removeClass('review--open');
                $reviewItems.empty();
                categories.forEach(function(cat) {
                    var labelEl = $('<div class="review__group-label">').text(cat.name + ' — ' + cat.count + ' items');
                    $reviewItems.append(labelEl);
                    cat.items.forEach(function(it) {
                        var dotStyleStr = (it.dotStyle.indexOf('background') !== -1) ? it.dotStyle : 'background:' + it.dotStyle;
                        var $left = $('<div class="review__item-left">');
                        $left.append($('<div class="review__item-dot">').attr('style', dotStyleStr));
                        $left.append($('<span class="review__item-name">').text(it.lineLabel));
                        var $row = $('<div class="review__item">');
                        $row.append($left).append($('<span class="review__item-qty">').text('\u00D7' + it.qty));
                        $reviewItems.append($row);
                    });
                });
            } else {
                $reviewWrap.hide();
                $reviewItems.empty();
            }
        }

        if ($('#total_qty_chosen').length) {
            $('#total_qty_chosen').val(bundleTotal);
        }

        var $bundleWrapper = $('.bundle__wrapper.bundle-build-options');
        var isFullyComplete = bundleTotal === totalLimit && totalLimit > 0;
        $bundleWrapper.toggleClass('bundle-build-options--complete', isFullyComplete);

        var prevBundleTotalRaw = $bundleWrapper.attr('data-jrs-prev-bundle-total');
        var prevBundleTotal = prevBundleTotalRaw == null || prevBundleTotalRaw === '' ? NaN : parseInt(prevBundleTotalRaw, 10);
        var transitionedToComplete = isFullyComplete && isFinite(prevBundleTotal) && prevBundleTotal < totalLimit;

        if (transitionedToComplete && typeof scrollBundleElementIntoView === 'function') {
            var wrapperEl = $bundleWrapper[0];
            if (wrapperEl) {
                setTimeout(function() {
                    // Bring the WHOLE completed bundle wrapper into view from its
                    // TOP (not the bottom .cta-area — scrolling to that pushed the
                    // wrapper's top off the top of the screen). 'fit' fully shows
                    // it when it fits, else top-aligns. includeSelectorHeader:false
                    // because the wrapper's own sticky .selector-header is its
                    // first child — counting its height in the offset would shove
                    // the wrapper's top back under the sticky header, which is what
                    // hid it. Align to the SITE header only.
                    //
                    // When the wrapper is TALLER than the space available, 'fit'
                    // top-aligns it and the .cta-area at its bottom lands off
                    // screen — the shopper finishes selecting and cannot see the
                    // add-to-cart button. In that case scroll the CTA into view
                    // instead: it is the thing they need next, and the wrapper's
                    // top is unreachable either way.
                    var ctaEl = wrapperEl.querySelector('.cta-area');
                    var availTop = getBundleScrollOffset(false);
                    var bottomGap = window.innerWidth <= 768 ? 24 : 16;
                    var avail = (window.innerHeight || document.documentElement.clientHeight) - availTop - bottomGap;
                    var target = (ctaEl && wrapperEl.getBoundingClientRect().height > avail) ? ctaEl : wrapperEl;

                    scrollBundleElementIntoView(target, {
                        behavior: 'smooth',
                        block: 'fit',
                        includeSelectorHeader: false
                    });
                }, 320);
            }
        }

        $bundleWrapper.attr('data-jrs-prev-bundle-total', String(bundleTotal));

        window.bundleTotal = bundleTotal;
        updateNextPrevButton();
        updateBundlePriceBreakdown();
        return;
    }

    // Legacy tab UI
    var limit = Number($('.bundle__build-item--active').attr('limit'));
    var BundleItemTotal = 0;
    $('.mrk-bundle-active .mrk-qty-item').each(function(){
        var value = Number($(this).val());
        if(value>0){
            BundleItemTotal = BundleItemTotal + value;
        }
    });
    $('.mrk-bundle-active .mrk-selected-qty').text(limit - BundleItemTotal);
    $('.bundle__build-item--active .current_quantity_130').text(BundleItemTotal);
    if(BundleItemTotal == limit){
        $('.mrk-bundle-active .mrk-selected-qty-text').hide();
        $('.mrk-bundle-active .bundle__colour-options').addClass('mrk-options-disabled');
        $('.bundle__build-item--active').addClass('bundle__build-item--completed');

        // Bundle hit its limit — keep the product card and category expanded so
        // the user can decrement and redistribute. The state cleanup below still
        // runs (it just clears the "active for input" markers, no visual collapse).
        setTimeout(function(){
          $('.bundle__build-item--active.bundle__build-item--completed').closest('.bundle_inside_wrap').find('.mrk-bundle-products-items').removeClass('mrk-bundle-active');
          $('.bundle__build-item--active.bundle__build-item--completed').closest('.bundle_inside_wrap').removeClass('mx_active');
          $('.bundle__build-item--active.bundle__build-item--completed').removeClass('bundle__build-item--active');
        }, 0);
    }else if(BundleItemTotal < limit){
        $('.mrk-bundle-active .mrk-selected-qty-text').show();
        $('.mrk-bundle-active .bundle__colour-options').removeClass('mrk-options-disabled');
        $('.bundle__build-item--active').removeClass('bundle__build-item--completed');
    }
    $('.mrk-bundle-active .bundle__details--mix-and-match').each(function(){
        var productTotal = 0;
        $(this).find('.mrk-qty-item').each(function(){
            var value = Number($(this).val());
            if(value>0){
                productTotal = productTotal + value;
            }
        });
        $(this).find('.amount-selected').text(productTotal);
    });
    $('.bundle__details--mix-and-match .mrk-qty-item').each(function(){
        var value = Number($(this).val());
        if(value>0){
            bundleTotal = bundleTotal + value;
        }
    });
    $('.bundle__build .selected_products').text(bundleTotal);
    window.bundleTotal = bundleTotal;
    updateNextPrevButton();
    if (typeof window.updateStickyBarBundle === 'function') {
        window.updateStickyBarBundle();
    }
}
function updateNextPrevButton(){
    // New bundle selector: use category accordion
    if ($('.bundle-selector').length) {
        var $current = $('.bundle-selector .category--expanded');
        var $prev = $current.prev('.category');
        var $next = $current.next('.category');
        if ($prev.length) {
            $('.previous-bundle-product').show();
        } else {
            $('.previous-bundle-product').hide();
        }
        if (window.bundleTotal === window.totalLimit) {
            $('.next-bundle-product').hide();
            $('.mrkfinal-add-logo,.mrk-direct-bundle-add').show();
        } else if ($next.length) {
            $('.next-bundle-product').show();
            $('.mrkfinal-add-logo,.mrk-direct-bundle-add').show();
        } else {
            $('.next-bundle-product').hide();
            $('.mrkfinal-add-logo,.mrk-direct-bundle-add').show();
        }
        return;
    }
    // Legacy tab UI
    var $current = $('.bundle__build-item.bundle__build-item--active');
    var $prev = $current.prev('.bundle__build-item');
    var $next = $current.next('.bundle__build-item');
    if ($prev.length) {
        $('.previous-bundle-product').show();
    } else {
        $('.previous-bundle-product').hide();
    }
    if ($next.length) {
        $('.next-bundle-product').show();
    } else {
        $('.next-bundle-product').hide();
    }
    if (window.bundleTotal == window.totalLimit) {
        $('.next-bundle-product').hide();
        $('.mrkfinal-add-logo,.mrk-direct-bundle-add').show();
    } else if ($next.length) {
        $('.next-bundle-product').show();
        $('.mrkfinal-add-logo,.mrk-direct-bundle-add').show();
    } else {
        $('.mrkfinal-add-logo,.mrk-direct-bundle-add').show();
    }
}
// new js code  
function getLogoDetails(index) {
  var logoType = $('[name="logo-type"]:checked').val();
  var logo = {};

  if (logoType == 'Upload Your Logo') {
      logo = {
          [`Logo ${index}`]: $('[name="properties[Uploaded Logo]"]').val(),
          [`Note ${index}`]: $('#customerNotesFilesUploadedLogo').val()
      };
  } else if (logoType == 'Existing Logo') {
      logo = {
          [`Logo ${index}`]: $('[name="properties[Existing Logo]"]').val(),
          [`Note ${index}`]: $('#customerNotesFilesExisting').val()
      };
  } else if (logoType == 'Text Logo') {
      logo = {
          [`Logo Text ${index}`]: $('[name="properties[Text Line]"]').val(),
          [`Logo Text 2 ${index}`]: $('[name="properties[Text Line 2]"]').val(),
          [`Logo Text 3 ${index}`]: $('[name="properties[Text Line 3]"]').val(),
          [`Logo Text 4 ${index}`]: $('[name="properties[Text Line 4]"]').val(),
          [`Logo Color ${index}`]: $('#logoColor').val(),
          [`Logo Font ${index}`]: $('#font-family').val(),
          [`Note ${index}`]: $('#notesLogoText').val()
      };
  }
  return logo;
}

function addHiddenField(index, properties) {
  
  // Ensure container exists
  if ($('.mrk-hidden-fields').length === 0) {
    $('body').append('<div class="mrk-hidden-fields"></div>');
  }
  
  var hiddenField = $('<div class="mrk-hidden-field-item"></div>').attr('data-index', index);
  
  try {
    var jsonString = JSON.stringify(properties);
    $(hiddenField).html(jsonString);
    $('.mrk-hidden-fields').append(hiddenField);
    
    
    // Backup to sessionStorage for recovery
    try {
      var existing = JSON.parse(sessionStorage.getItem('bundle_positions') || '[]');
      existing.push({
        index: index,
        properties: properties,
        timestamp: Date.now()
      });
      sessionStorage.setItem('bundle_positions', JSON.stringify(existing));
    } catch(e) {
    }
    
  } catch(e) {
  }
}
function updateMeta() {
  
  var bundleItems = $('.mrk-bundle-products-items');
  const isEmbroidery = $('[name="application-type"]:checked').val() == 'Embroidery' ? true:false;
  var ParentVariantId = window.bundleId, positionsData = [];
  
  
  bundleItems.each(function(){
    var bundleIndex = $(this).attr('bundleitem');
    var bundleItemName = $(this).attr('bundleitemName');
    const positions = $(`.mrk-position-item .mrk-logo-inputs[forbundle="bundleItem-${bundleIndex}"]:checked`);
    var sizes = $(this).find('.mrk-qty-item');
    
    
    $(sizes).each(function(){
        if(Number($(this).val())>0){
            var property = $(this).attr('productname');
            var qty = Number($(this).val());
            if(qty>0){
            const positionData = getAllPositionsProperties(isEmbroidery,positions,qty,ParentVariantId,property);
            positionsData = positionsData.concat(positionData)
            }
        }
    })
  });
  
  
  var index = $('.mrk-hidden-fields .mrk-hidden-field-item').length + 1;
  
  var logoDetails = getLogoDetails(index),
      applicationMethod = $('[name="application-type"]:checked').val(),
      logoVariant = $('[name="logo-type"]:checked').attr('variant'),
      position = $('.mrk-position-item input:checked').val(),
      logoType = $('[name="logo-type"]:checked').val();
  
    // applicationMethod: applicationMethod,
    // logoVariant: logoVariant,
    // logoType: logoType,
    // position: position,
    // logoDetails: logoDetails
  // });
  
  var genericProperties = {
      [`Application Method ${index}`]: applicationMethod,
      [`Positions ${index}`]:positionsData,
      [`Logo Type ${index}`]: logoType,
      [`_logoVariant${index}`]: logoVariant,
      [`_time`]: universalTimeValue
  };
  
  var properties = Object.assign({}, genericProperties, logoDetails);
    // positionsCount: positionsData.length,
    // hasLogoDetails: Object.keys(logoDetails).length > 0,
    // totalProperties: Object.keys(properties).length
  // });
  
  addHiddenField(index, properties);
  // Disable current checked positions
  $('.mrk-position-item input:checked').each(function() {
    $(this).prop('disabled', true).parents('.mrk-position-item').addClass('mrk-checked-position');
  });
  
}
function handleLogo(){
  $('.mrk-add-another-logo').on('click', function() {
    updateMeta();
    initExistingLogos();
    $('.mrk-close-btn').click();
    // Reset position selections
    $('.mrk-position-item input').prop('checked', false);

    // Reset logo type and details
    $('[name="logo-type"]').prop('checked', false);
    $('[name="properties[Uploaded Logo]"]').val('');
    $('#customerNotesFilesUploadedLogo').val('');
    $('[name="properties[Existing Logo]"]').val('');
    $('#customerNotesFilesExisting').val('');
    $('[name="properties[Text Line]"]').val('');
    $('#logoColor').val('');
    $('#font-family').val('');
    $('#notesLogoText').val('');

    // $('#previewDiv').text('JRS');
    $('#logoText').val('JRS');
    $('#previewDivLine1').html('JRS');
    $('#previewDivLine2').html('');
    $('#previewDivLine3').html('');
    $('#previewDivLine4').html('');
    window.mrknavigateTo(0);
  });
}
function initPopup(){
    $('.mrk-product-csutomizer input').change(function (e) { 
      e.preventDefault();
      calculatePrice()
    });
    $('[name="application-type"]').change(function (e) {
      e.preventDefault();
      var val = $('[name="application-type"]:checked').val() || $(this).val() || 'unknown';
      trackUserInteraction('application_type_changed', { method: val });
      UpdatePositionPrices();
    });
    // $('.mrk-final-add-to-cart').click(function (e) { 
    //   e.preventDefault();
    //   // updateMeta();
    //   const positionsCount = $('.mrk-checked-position').length + $('.mrk-position-item input:checked').length;
    //   if(positionsCount == 0){
    //     alert('Select Positions!');
    //     window.mrknavigateTo(1);
    //     return;
    //   }
    //   const logoType = $('[name="logo-type"]:checked');
    //   if(logoType.length == 0){
    //     alert('Select Logo Type!');
    //     window.mrknavigateTo(2);
    //     return;
    //   }
    //   addBulkItems()
    // });
    // //AK custom code
    // $('.mrk-final-add-to-cart').click(function (e) { 
    //   e.preventDefault();
    //   // updateMeta();
    //   updateMetabundlenew();
    //   // const positionsCount = $('.mrk-checked-position').length + $('.mrk-position-item input:checked').length;
    //   // if(positionsCount == 0){
    //   //   alert('Select Positions!');
    //   //   window.mrknavigateTo(1);
    //   //   return;
    //   // }
    //   // const logoType = $('[name="logo-type"]:checked');
    //   // if(logoType.length == 0){
    //   //   alert('Select Logo Type!');
    //   //   window.mrknavigateTo(2);
    //   //   return;
    //   // }
    //   addBulkItems()
    // });
    // //AK custom code

    var _bundlePopupScrollTop = 0;
    function _bundleLockBodyScroll() {
      if (typeof window.matchMedia !== 'undefined' && !window.matchMedia('(max-width: 768px)').matches) return;
      _bundlePopupScrollTop = window.pageYOffset || document.documentElement.scrollTop;
      document.body.style.position = 'fixed';
      document.body.style.top = '-' + _bundlePopupScrollTop + 'px';
      document.body.style.width = '100%';
    }
    function _bundleUnlockBodyScroll() {
      if (typeof window.matchMedia !== 'undefined' && !window.matchMedia('(max-width: 768px)').matches) return;
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
      window.scrollTo(0, _bundlePopupScrollTop);
    }

    $('.popup__close.customizer-popup').click(function (e) { 
        e.preventDefault();
        if (typeof window._mrkCustomizerPopupUnlockBody === 'function') window._mrkCustomizerPopupUnlockBody();
        else _bundleUnlockBodyScroll();
        // Track popup close
        trackUserInteraction('popup_closed', {
          source: 'close_button',
          timestamp: new Date().toISOString(),
          timeInPopup: window.bundleUserJourney ? Date.now() - new Date(window.bundleUserJourney.startTime).getTime() : 0
        });
        
        var $overlay = $('section[data-template-type="bundle-new"] .mrk-customizer-popup-form .popup-overlay');
        if (!$overlay.length) $overlay = $('.mrk-customizer-popup-form .popup-overlay').not('.mrk-customizer-cart .mrk-customizer-popup-form .popup-overlay');
        if ($overlay.length) {
          $overlay.removeClass('show').css({ display: '', visibility: '', zIndex: '' });
        }
    });
    if (typeof multiStepForm === 'function') {
      multiStepForm($(".mrk-multistep"),{defaultStep: 0});
    }
    // Event delegation so click works even if CTA is re-rendered or binding runs before button exists
    $(document).on('click', '.mrkfinal-add-logo', function (e) {
        e.preventDefault();
        if ($(this).prop('disabled')) return;

        if (typeof jrsPDPTrack === 'function' && window.jrsProductId) {
          try {
            window.jrsCustomizerOpenTime = Date.now();
            var $expanded = $('.bundle-selector .category.category--expanded');
            var stepNum = $expanded.length ? (parseInt($expanded.attr('data-category-index'), 10) || 1) : 1;
            jrsPDPTrack('pdp_customizer_popup_open', {
              product_id: window.jrsProductId,
              step_number: stepNum,
              open_trigger: (($(this).find('.cta-primary__label').text() || '').trim()) || 'Add Logo & Customise',
              device_type: typeof jrsDeviceType === 'function' ? jrsDeviceType() : (window.innerWidth <= 768 ? 'mobile' : 'desktop')
            });
          } catch (err) { console.warn('GA4 customizer open track error', err); }
        }
        if (typeof trackUserInteraction === 'function') {
          trackUserInteraction('popup_opened', {
            timestamp: new Date().toISOString(),
            trigger: 'add_logo_button',
            checkedPositions: $(`.mrk-logo-inputs:checked`).length,
            bundleItems: $('.mrk-bundle-products-items').length
          });
        }

        var $overlay = $('section[data-template-type="bundle-new"] .mrk-customizer-popup-form .popup-overlay');
        if (!$overlay.length) $overlay = $('.mrk-customizer-popup-form .popup-overlay').not('.mrk-customizer-cart .mrk-customizer-popup-form .popup-overlay');
        if ($overlay.length) {
          $overlay.addClass('show').css({ display: 'flex', visibility: 'visible', zIndex: 100001111 });
          $overlay.closest('.mrk-customizer-popup-form').show();
          if (typeof window._mrkCustomizerPopupLockBody === 'function') window._mrkCustomizerPopupLockBody();
          else _bundleLockBodyScroll();
        }
    });
    $('.mrk-direct-bundle-add').click(function (e) {
        e.preventDefault();
        var btn = this;
        // In-flight lock: a second click while loading must not become a second order.
        if (btn.disabled || (btn.classList && btn.classList.contains('is-loading'))) return;
        trackUserInteraction('direct_bundle_add_clicked', {});
        // Same-frame feedback before the network call — mirrors the V3 popup CTA
        // pattern (is-loading + disabled + aria-busy, jrs-v2-customizer-popup.js).
        btn.classList.add('is-loading');
        btn.disabled = true;
        btn.setAttribute('aria-busy', 'true');
        // Inline !important keeps the button vivid while :disabled — several
        // theme rules gray disabled CTAs with !important and would otherwise
        // put a white spinner on a gray-300 background.
        try {
          btn.style.setProperty('background', '#E8621A', 'important');
          btn.style.setProperty('border-color', '#E8621A', 'important');
          btn.style.setProperty('color', 'transparent', 'important');
        } catch (styleErr) {}
        var settled = false;
        var restore = function () {
          if (settled) return;
          settled = true;
          window.__jrsDirectAddRestore = null;
          // Success ends in a redirect (flag set just before location.pathname
          // = '/cart'); keep the button locked while the page unloads.
          if (window.__jrsDirectAddRedirecting) return;
          btn.classList.remove('is-loading');
          btn.disabled = false;
          btn.removeAttribute('aria-busy');
          try {
            btn.style.removeProperty('background');
            btn.style.removeProperty('border-color');
            btn.style.removeProperty('color');
          } catch (styleErr) {}
        };
        // addBulkItems() is async but resolves BEFORE its cart-add network call
        // settles (the add runs in non-awaited jQuery callbacks), so its promise
        // must NOT drive the restore — that stripped the loading state ~300ms in.
        // The real settle points call window.__jrsDirectAddRestore: the add
        // request's complete handler on non-success, and the redirect flag on
        // success (which keeps the button locked through unload).
        window.__jrsDirectAddRestore = restore;
        try {
          addBulkItems();
        } catch (err) {
          restore();
          throw err;
        }
        // Failsafe: a hung request must not leave the button spinning forever.
        setTimeout(restore, 30000);
    });
  
    // On change of text input
    // $('#logoText').on('input', function() {
    //   // $('#previewDiv').html($(this).val());
    //   $('#previewDivLine1').html($(this).val());
    //   if($(this).val() != ''){
    //     $('.mrk-steps-footer').removeClass('mrk-disable-btn');
    //   }else{
    //     $('.mrk-steps-footer').addClass('mrk-disable-btn');
    //   }
      
    // });
    // $('#logoText2').on('input', function() {
    //    $('#previewDivLine2').html($(this).val());
    // });
    // $('#logoText3').on('input', function() {
    //   $('#previewDivLine3').html($(this).val());
    // });
    // $('#logoText4').on('input', function() {
    //   $('#previewDivLine4').html($(this).val());
    // });
    
    // // On change of font dropdown
    // $('#font-family').change(function() {
    //   const fontFamily = $(this).val();
    //   $('#previewDiv').css('font-style', fontFamily);
    // });
    
    // // On change of color dropdown
    // $('#logoColor').change(function() {
    //   const color = $(this).val();
    //   const bg = $('#logoColor option:selected').attr('bg') || 'black';
    //   $('#previewDiv').css('color', color).css('background', bg);
    // });
    $('.mrk-close-btn').click(function() {
      trackUserInteraction('customizer_close_clicked', {});
      $('.input-file-logo').val('');
      $('[data-mrk-thumbnail]').attr('src','');
      $('.preview-template').hide();
      $('.hiddenFileInput').val('').change();

      //Ak custom code      
      $(this).parents('.preview-template').find('.mrk-success-message').css('display','none');
      $('.mrk-steps-footer .mrk-steps-footer-next-buttons-container .next-bundle-inner').addClass('disabled');
      //Ak custom code
    });
    // uploader
    // When a file is chosen using the file input, upload it
    // $('.hiddenFileInput').change(function() {
    //   var container = $(this).parents('.tab');
    //   var file = this.files[0];
    //   if (file) {
    //       preparePreview(file,container);
    //       uploadFile(file,container);
    //   }
    // });
    UpdatePositionPrices();
    
  
      // Handle input change 
    function handleInputChange(input) {
        const container = $(input).parents('.mrk-step-existing-logo'); // Find the parent tab container
        const file = $(input).val(); // Get the value (URL)

        // Display the file name and show the preview
        $(container).find('.input-file-logo').val(file);
        $(container).find('.mrk-filename span[data-mrk-name]').text(file.replace('https://jrsindustrial-files.com/uploads/', ''));
        $(container).find('.preview-template').show();
        $(container).find('.mrk-image img').attr('src', file);
        $(container).find('.mrk-progress').hide(); // Hide the progress bar on success
        $('.mrk-steps-footer').removeClass('loading');
        $('.mrk-steps-footer').removeClass('mrk-disable-btn');

        //Ak custom code
        $('.mrk-steps-footer .mrk-steps-footer-next-buttons-container .next-bundle-inner').removeClass('disabled');
        $(container).find('button.next-inner').removeClass('disabled');
    }
  // Attach change event listener to dynamically created inputs
  // CRITICAL FIX (Bug 2): Use $(this) instead of $('.mrk-existing-logo-item:checked').
  // The old selector selected ALL checked radios across ALL categories, causing
  // handleInputChange to overwrite ALL categories' hidden inputs with the first radio's URL.
  // Using $(this) ensures only the clicked category's container is updated.
  $(document).on('change', '.mrk-existing-logo-item', function () {
    var $existingLogoRadio = $(this);
    var $bundleSteps = $existingLogoRadio.closest('.bundle_product_steps');
    var positionName = $bundleSteps.length ? ($bundleSteps.find('.mrk-logo-inputs:checked').attr('data-position-name') || 'Unknown') : 'Unknown';
    var bundleItem = $bundleSteps.length ? ($bundleSteps.attr('data-pro') || 'Unknown') : 'Unknown';
    var appMethod = $bundleSteps.length ? ($bundleSteps.find('.application-method-container input[type="radio"]:checked').val() || 'Embroidery') : '';
    trackUserInteraction('existing_logo_selected', { category: bundleItem, position: positionName, logoType: 'Existing Logo', applicationMethod: appMethod });
    handleInputChange($existingLogoRadio);

    // CRITICAL FIX (Bug 3): Generate and persist Logo ID when existing logo is selected.
    if ($bundleSteps.length > 0) {
      var $positionCheckbox = $bundleSteps.find('.mrk-logo-inputs:checked');
      positionName = $positionCheckbox.attr('data-position-name') || positionName;
      bundleItem = $bundleSteps.attr('data-pro') || bundleItem;
      appMethod = ($bundleSteps.find('.application-method-container input[type="radio"]:checked').val() || 'Embroidery');
      var selectedLogoUrl = $existingLogoRadio.val() || '';
      var existingLogoId = $positionCheckbox.attr('data-logo-id') || null;

      if ($positionCheckbox.length > 0 && !existingLogoId) {
        var logoId = String(Math.floor(Math.random() * (999998 + 1)));
        $positionCheckbox.attr('data-logo-id', logoId);

        // Store in sessionStorage
        try {
          var sessionKey = 'logoId_' + bundleItem + '_' + positionName + '_' + appMethod + '_Existing Logo';
          sessionStorage.setItem(sessionKey, logoId.toString());
        } catch(e) { /* sessionStorage might not be available */ }

        // Store in shared cache
        if (window.bundleLogoIdCache) {
          var cacheKey = createLogoIdCacheKey(bundleItem, positionName, appMethod, 'Existing Logo');
          window.bundleLogoIdCache[cacheKey] = logoId;
        }
        existingLogoId = logoId;
      }

      // 5a. Logo selection event tracking
      if (window.bundleDebugLog) {
        try {
          var hiddenFieldUrl = $bundleSteps.find('[name="properties[Existing Logo]"]').val() || 'not_found';
          window.bundleDebugLog.steps.push({
            step: 'logo_selected',
            status: 'success',
            details: {
              categoryName: bundleItem,
              positionName: positionName,
              logoType: 'Existing Logo',
              logoId: existingLogoId,
              logoIdSource: existingLogoId ? 'selection_time_generated' : 'pre_existing',
              logoUrl: selectedLogoUrl,
              logoUrlSource: 'radio_button_value',
              applicationMethod: appMethod,
              domState: {
                hiddenFieldLogoUrl: hiddenFieldUrl,
                radioValue: selectedLogoUrl,
                checkboxLogoId: $positionCheckbox.attr('data-logo-id') || 'not_set'
              }
            },
            time: new Date().toISOString()
          });
        } catch(e) { /* debug tracking should not break functionality */ }
      }
    }
  });
  initExistingLogos();
  handleLogo()
}
function initExistingLogos(){
  // Parse the stored logos from localStorage
  const logos = JSON.parse(localStorage.getItem('logos')) || [];
  
  // Generate the HTML and append it to a container
  // const $container = $('.mrkexisting-logo-select'); // Replace with your actual container selector
  // if(logos.length){
  //   $('.mrk-existing-logo-wrapper').show();
  //   $($container).html('');
  //   $('.mrk-existing-logo-selector').show()
  // }
  // logos.forEach((logo, index) => {
  //   const logoItem = `
  //     <div class="logo-item">
  //       <input type="radio" name="mrk-existing-logo" value="${logo}" class="mrk-existing-logo-item" id="mrk-existing-logo-${index}" />
  //       <label for="mrk-existing-logo-${index}">
  //         <img src="${logo}" class="mrk-exiting-logo-image" />
  //       </label>
  //     </div>
  //   `;
  //   $container.append(logoItem);
  // });

  // $containers.each(function () {
  //   const $container = $(this);
  //   const loopValue = $container.data('pro-loop'); // Will be `undefined` if not present
  //   const positionloopValue = $container.data('position-loop');

  //   $container.html(''); // Clear existing content
  //   logos.forEach((logo, index) => {
  //     const idSuffix = loopValue !== undefined ? `${index}-${loopValue}` : `${index}`;

  //     const logoItem = `
  //       <div class="logo-item">
  //         <input type="radio" name="mrk-existing-logo" value="${logo}" class="mrk-existing-logo-item" id="mrk-existing-logo-${idSuffix}" />
  //         <label for="mrk-existing-logo-${idSuffix}">
  //           <img src="${logo}" class="mrk-exiting-logo-image" />
  //         </label>
  //       </div>
  //     `;

  //     $container.append(logoItem);
  //   });
  // });

  const $containers = $('.mrkexisting-logo-select'); // Multiple containers

  if (logos.length) {
    $('.mrk-existing-logo-wrapper').show();
    $('.mrk-existing-logo-selector').show();
  }

  $containers.each(function () {
    const $container = $(this);
    const loopValue = $container.data('pro-loop'); // e.g. 2
    const positionloopValue = $container.data('position-loop'); // e.g. right-arm

    $container.html(''); // Clear existing content

    logos.forEach((logo, index) => {
      let idSuffix = `${index}`;
      let idSuffix_name = ``;

      if (loopValue !== undefined) {
        idSuffix += `-${loopValue}`;
        idSuffix_name += `-${loopValue}`;
      }

      if (positionloopValue !== undefined) {
        idSuffix += `-${positionloopValue}`;
        idSuffix_name += `-${positionloopValue}`;
      }

      const logoItem = `
        <div class="logo-item">
          <input type="radio" name="mrk-existing-logo-${idSuffix_name}" value="${logo}" class="mrk-existing-logo-item" id="mrk-existing-logo-${idSuffix}" />
          <label for="mrk-existing-logo-${idSuffix}">
            <img src="${logo}" class="mrk-exiting-logo-image" />
          </label>
        </div>
      `;

      $container.append(logoItem);
    });
  });




}
$('.next-bundle-product').click(function() {
    trackUserInteraction('next_product_clicked', {});
    if ($('.bundle-selector').length) {
        var $next = $('.bundle-selector .category--expanded').next('.category');
        if ($next.length) {
            $next.find('.category__header').first().click();
        }
        return;
    }
    var $current = $('.bundle__build-item.bundle__build-item--active');
    var $next = $current.next('.bundle__build-item');
    if ($next.length) {
        $next.click();
    }
});

$('.previous-bundle-product').click(function() {
    trackUserInteraction('previous_product_clicked', {});
    if ($('.bundle-selector').length) {
        var $prev = $('.bundle-selector .category--expanded').prev('.category');
        if ($prev.length) {
            $prev.find('.category__header').first().click();
        }
        return;
    }
    var $current = $('.bundle__build-item.bundle__build-item--active');
    var $prev = $current.prev('.bundle__build-item');
    if ($prev.length) {
        $prev.click();
    }
});
initPopup()





//Ak custom code New Bundle Customizer
function initPopupnew(){
    //AK custom code
    $('.mrk-final-add-to-cart').click(function (e) { 
      
      e.preventDefault();
      
      // CRITICAL FIX (Order #52475): Prevent double-click on Finish button
      var $finishButton = $(this);
      if ($finishButton.data('isProcessing')) {
        mrkDebug.log('[Bundle] Finish button already processing, ignoring click');
        if (window.bundleDebugLog && typeof addDebugStep === 'function') {
          addDebugStep('finish_button_double_click_prevented', 'warning', {
            note: 'Double-click prevented - button already processing'
          });
        }
        return;
      }
      
      // Mark as processing
      $finishButton.data('isProcessing', true);
      $finishButton.prop('disabled', true);
      var originalText = $finishButton.text() || $finishButton.html();
      $finishButton.data('originalText', originalText); // Store for later restoration
      $finishButton.text('Adding to cart...').html('Adding to cart...');

      var finishButtonTime = new Date().toISOString();
      var previouslyClicked = !!(window.bundleFinishPreviouslySucceeded);
      if (window.bundleDebugLog && typeof addDebugStep === 'function') {
        // Order #52267: bundleAlreadyInCart = cart drawer update mode (window.updates) OR bundle was just added (same variant)
        var bundleJustAddedSameVariant = !!(window.bundleLastAddedVariantId && window.bundleId && String(window.bundleLastAddedVariantId) === String(window.bundleId));
        var bundleRecentlyAdded = !!(window.bundleLastAddedAt && (Date.now() - window.bundleLastAddedAt) < 30 * 60 * 1000); // within 30 min
        addDebugStep('finish_button_state', 'success', {
          enabled: true,
          previouslyClicked: previouslyClicked,
          bundleAlreadyInCart: !!window.updates,
          bundleJustAddedSameVariant: bundleJustAddedSameVariant,
          bundleRecentlyAdded: bundleRecentlyAdded,
          allowSecondClick: true,
          note: previouslyClicked ? 'User may be re-configuring after first add; full add will run with new data' : 'First add'
        });
      }
      // CRITICAL FIX: Track finish_button_clicked event (was missing)
      trackUserInteraction('finish_button_clicked', {
        timestamp: finishButtonTime,
        checkedPositions: $(`.mrk-logo-inputs:checked`).length,
        hiddenFieldsBefore: $('.mrk-hidden-field-item').length,
        timeOnPage: window.bundleUserJourney ? (Date.now() - new Date(window.bundleUserJourney.startTime).getTime()) : 0
      });
      
      // Set flag to indicate Finish was clicked (prevents addBulkItems from clearing fresh hidden fields)
      window.bundleFinishButtonClicked = true;
      window.bundleFinishButtonTimestamp = finishButtonTime;
      
      // Check state before creating hidden fields
      
      // updateMeta();
      // debugLog is available globally via window.bundleDebugLog (created in addBulkItems)
      // If it doesn't exist yet, create it (in case Finish is clicked before addBulkItems)
      if (!window.bundleDebugLog) {
        window.bundleDebugLog = {
          timestamp: new Date().toISOString(),
          steps: [],
          warnings: [],
          errors: [],
          data: {}
        };
      }
      updateMetabundlenew(window.bundleDebugLog);
      
      
      // Verify hidden fields were created
      if ($('.mrk-hidden-field-item').length === 0) {
        //   return {
        //     position: $(this).val(),
        //     bundleItem: $(this).attr('forbundle'),
        //     checked: $(this).is(':checked')
        //   };
        // }).get());
      }
      
      // const positionsCount = $('.mrk-checked-position').length + $('.mrk-position-item input:checked').length;
      // if(positionsCount == 0){
      //   alert('Select Positions!');
      //   window.mrknavigateTo(1);
      //   return;
      // }
      // const logoType = $('[name="logo-type"]:checked');
      // if(logoType.length == 0){
      //   alert('Select Logo Type!');
      //   window.mrknavigateTo(2);
      //   return;
      // }
      
      
      // Initialize debug log for this add-to-cart attempt
      // This will be used by addBulkItems if it's called
      if (!window.bundleDebugLog) {
        window.bundleDebugLog = {
          timestamp: new Date().toISOString(),
          steps: [],
          warnings: [],
          errors: [],
          data: {}
        };
      }
      
      addBulkItems()
    });

    $('[name="properties[Text Line]"]').on('input', function() {
      // $('#previewDiv').html($(this).val());
      var textValue = $(this).val();
      $(this).parents('.mrk-step-text-logo').find('#previewDivLine1').html(textValue);
      // $('#previewDivLine1').html($(this).val());
      if(textValue != ''){
        $('.mrk-steps-footer').removeClass('mrk-disable-btn');
      }else{
        $('.mrk-steps-footer').addClass('mrk-disable-btn');
      }
      
      // Track text logo input
      var positionName = $(this).closest('.bundle_product_steps').find('.mrk-logo-inputs:checked').attr('data-position-name') || 'Unknown';
      var bundleItem = $(this).closest('.bundle_product_steps').attr('data-pro') || 'Unknown';
      trackUserInteraction('text_logo_entered', {
        line: 1,
        text: textValue,
        position: positionName,
        bundleItem: bundleItem,
        hasText: textValue.length > 0
      });
    });
    $('[name="properties[Text Line 2]"]').on('input', function() {
      var textValue = $(this).val();
      $(this).parents('.mrk-step-text-logo').find('#previewDivLine2').html(textValue);
      //  $('#previewDivLine2').html($(this).val());
      
      // Track text logo input
      var positionName = $(this).closest('.bundle_product_steps').find('.mrk-logo-inputs:checked').attr('data-position-name') || 'Unknown';
      var bundleItem = $(this).closest('.bundle_product_steps').attr('data-pro') || 'Unknown';
      trackUserInteraction('text_logo_entered', {
        line: 2,
        text: textValue,
        position: positionName,
        bundleItem: bundleItem,
        hasText: textValue.length > 0
      });
    });
    $('[name="properties[Text Line 3]"]').on('input', function() {
      var textValue = $(this).val();
      $(this).parents('.mrk-step-text-logo').find('#previewDivLine3').html(textValue);
      // $('#previewDivLine3').html($(this).val());
      
      // Track text logo input
      var positionName = $(this).closest('.bundle_product_steps').find('.mrk-logo-inputs:checked').attr('data-position-name') || 'Unknown';
      var bundleItem = $(this).closest('.bundle_product_steps').attr('data-pro') || 'Unknown';
      trackUserInteraction('text_logo_entered', {
        line: 3,
        text: textValue,
        position: positionName,
        bundleItem: bundleItem,
        hasText: textValue.length > 0
      });
    });
    $('[name="properties[Text Line 4]"]').on('input', function() {
      var textValue = $(this).val();
      $(this).parents('.mrk-step-text-logo').find('#previewDivLine4').html(textValue);
      // $('#previewDivLine4').html($(this).val());
      
      // Track text logo input
      var positionName = $(this).closest('.bundle_product_steps').find('.mrk-logo-inputs:checked').attr('data-position-name') || 'Unknown';
      var bundleItem = $(this).closest('.bundle_product_steps').attr('data-pro') || 'Unknown';
      trackUserInteraction('text_logo_entered', {
        line: 4,
        text: textValue,
        position: positionName,
        bundleItem: bundleItem,
        hasText: textValue.length > 0
      });
    });
    
    // On change of font dropdown
    $('.font-family-same').change(function() {
      const fontFamily = $(this).val();
      $(this).parents('.mrk-step-text-logo').find('#previewDiv').css('font-style', fontFamily);
      // $('#previewDiv').css('font-style', fontFamily);
    });
    
    // On change of color dropdown
    $('.logo-color-same').change(function() {
      const color = $(this).val();
      // const bg = $('#logoColor option:selected').attr('bg') || 'black';
      const bg = $(this).parents('.mrk-step-text-logo').find('#logoColor option:selected').attr('bg') || 'black';
      // $('#previewDiv').css('color', color).css('background', bg);
      $(this).parents('.mrk-step-text-logo').find('#previewDiv').css('color', color).css('background', bg);
    });

    //AK custom code

  $(document).on('click','.mrk-product-csutomizer .mrk-product-steps .bundle_products .bundle_pro',function(){
    var pro_handle = $(this).find('.bundle_pro_inner').attr('data-bundle-pro');

    $(this).parents('.tab').removeClass('current');
    $('.mrk-product-csutomizer .mrk-product-steps .bundle_pro_steps_main').removeClass('hidden');
    $('.mrk-product-csutomizer .mrk-product-steps .bundle_pro_steps_main .bundle_product_steps').addClass('hidden');
    $('.mrk-product-csutomizer .mrk-product-steps .bundle_pro_steps_main .bundle_product_steps[data-pro="'+pro_handle+'"]').removeClass('hidden');

    // Mix&match headwear: show only the position matching the selected headwear product (beanie vs cap)
    (function applyMixMatchHeadwearFilter() {
      var $steps = $('.mrk-product-csutomizer .mrk-product-steps .bundle_pro_steps_main .bundle_product_steps:not(.hidden)');
      if ($steps.length === 0 || $steps.attr('data-mix-match-headwear') !== 'true') return;

      var $headwearRow = $('.mrk-bundle-products-items[bundleitemName="Headwear"]');
      if ($headwearRow.length === 0) return;

      var selectedType = '';
      $headwearRow.find('.bundle__details').each(function() {
        var $details = $(this);
        var hasQty = $details.find('input.mrk-qty-item').filter(function() { return Number($(this).val()) > 0; }).length > 0;
        if (hasQty) {
          var handle = ($details.attr('data-product-handle') || '').toLowerCase();
          var title = ($details.attr('data-product-title') || '').toLowerCase();
          if (!handle && !title) {
            var labelEl = $details.find('.mixmatch-open span span:first-child').add($details.find('.a-row__name')).first();
            if (labelEl.length) title = (labelEl.text() || '').toLowerCase().trim();
          }
          if (handle.indexOf('beanie') !== -1 || title.indexOf('beanie') !== -1) selectedType = 'beanie';
          else if (handle.indexOf('cap') !== -1 || title.indexOf('cap') !== -1) selectedType = 'cap';
        }
      });

      if (!selectedType) return;

      // Reset visibility so we apply cleanly (e.g. when switching back to Headwear from another category)
      $steps.find('.mrk-position-item[data-position-headwear-type]').removeClass('mrk-headwear-position-hidden').css('display', '');
      $steps.find('.selected-position').removeClass('mrk-headwear-position-hidden').css('display', '');

      $steps.find('.mrk-position-item[data-position-headwear-type]').each(function() {
        var $item = $(this);
        var type = $item.attr('data-position-headwear-type');
        var $cb = $item.find('input.mrk-logo-inputs');
        if (type === selectedType) {
          $item.removeClass('mrk-headwear-position-hidden').css('display', '');
          if (!$cb.prop('checked')) $cb.prop('checked', true);
          $item.addClass('logo-position-checked');
          $item.find('.application-method-container').css('display', 'flex');
        } else {
          $item.addClass('mrk-headwear-position-hidden').css('display', 'none');
          $cb.prop('checked', false);
          $item.removeClass('logo-position-checked');
        }
      });

      $steps.find('.selected-position').each(function() {
        var $pos = $(this);
        var posName = $pos.attr('data-position-name');
        var match = (selectedType === 'beanie' && posName === 'beanie-front') || (selectedType === 'cap' && posName === 'cap-front');
        if (match) {
          $pos.removeClass('mrk-headwear-position-hidden').css('display', '');
          $pos.addClass('active');
        } else {
          $pos.addClass('mrk-headwear-position-hidden').css('display', 'none');
          $pos.removeClass('active');
        }
      });

      enableNextButton();
    })();

    $('.mrk-product-csutomizer .mrk-steps-footer .bundle-main-step-btn').addClass('hidden');
    $('.mrk-product-csutomizer .mrk-steps-footer .bundle-pro-inner-btn').removeClass('hidden');

    
    if (typeof multiStepFormbundleinner === 'function') {
      multiStepFormbundleinner($(".bundle_product_steps:visible"),{defaultStep: 0});
    }
    enableNextButton();
  });

  // $('.bundle_product_steps .mrk-logo-inputs').each(function(){
  //   $(this).on('input',function(){

  //   });
  // });
  let allLogoPositionItems = document.querySelectorAll(".bundle_product_steps .mrk-logo-inputs");
  
  allLogoPositionItems.forEach((el) => {
    el.addEventListener("input", () => {
      let positionName = el.getAttribute("data-position-name");
      let bundleItem = el.getAttribute("forbundle");
      let printVariant = el.getAttribute("data-printvariant");
      let embroideryVariant = el.getAttribute("data-embroideryvariant");
      let printPrice = el.getAttribute("data-printprice");
      let embroideryPrice = el.getAttribute("data-embroideryprice");
      
      
      trackUserInteraction('position_' + (el.checked ? 'selected' : 'deselected'), {
        position: positionName,
        bundleItem: bundleItem,
        printVariant: printVariant,
        printPrice: printPrice,
        embroideryVariant: embroideryVariant,
        embroideryPrice: embroideryPrice,
        totalCheckedPositions: document.querySelectorAll('.mrk-logo-inputs:checked').length
      });
      
      if (!el.checked) {
        document.querySelector(`.bundle_product_steps:not(.hidden) .selected-position[data-position-name="${positionName}"]`).classList.remove("active")
      }
      else if (el.checked) {
        document.querySelector(`.bundle_product_steps:not(.hidden) .selected-position[data-position-name="${positionName}"]`).classList.add("active")
        // Mix&match headwear: only one position allowed; uncheck others in this step
        var bundleSteps = el.closest('.bundle_product_steps');
        if (bundleSteps && bundleSteps.getAttribute('data-mix-match-headwear') === 'true') {
          bundleSteps.querySelectorAll('.mrk-logo-inputs').forEach(function(other) {
            if (other !== el) { other.checked = false; }
          });
          bundleSteps.querySelectorAll('.mrk-position-item').forEach(function(item) {
            item.classList.toggle('logo-position-checked', item.contains(el));
          });
          bundleSteps.querySelectorAll('.selected-position').forEach(function(sp) {
            sp.classList.toggle('active', sp.getAttribute('data-position-name') === positionName);
          });
        }
      }
      el.parentElement.classList.toggle("logo-position-checked");
      enableNextButton()
      // updateLastSelectedElement()
    })
  })

  //call remove and add events
  routineSetup();

  function enableNextButton() {
    let positionChecked = false;
    document.querySelectorAll(".bundle_product_steps .bundle_pro_step_1.current .mrk-logo-inputs").forEach((checkboxEl) => {
      if (checkboxEl.checked) {
        positionChecked = true;
      }
    })
    if (positionChecked) {
      document.querySelector(".mrk-steps-footer .bundle-pro-inner-btn").querySelector("button.next-bundle-btn").classList.remove("disabled");
    }
    else if (!positionChecked) {
      document.querySelector(".mrk-steps-footer .bundle-pro-inner-btn").querySelector("button.next-bundle-btn").classList.add("disabled");
    }
  }


  
  //customization style
  let lastSelected = document.querySelectorAll('.selected-position.active');
  let lastElement = lastSelected[lastSelected.length - 1];

  function updateLastSelectedElement() {
    lastSelected = document.querySelectorAll('.selected-position.active');
    lastElement = lastSelected[lastSelected.length - 1];
  }

  let assignmentStyleInputs = document.querySelectorAll('input[name="same-logo"]');
  
  assignmentStyleInputs.forEach((input) => {
      input.addEventListener("input", () => {
          document.querySelectorAll('.bundle_product_steps:not(.hidden) .logo-assignment-label').forEach(label => {
              label.classList.remove('selected');
          });
          input.closest('label').classList.add('selected');
          if (input.value == "yes"){
              document.querySelector(".bundle_product_steps:not(.hidden) .assignment-style-1").classList.remove("hidden")
              document.querySelector(".bundle_product_steps:not(.hidden) .assignment-style-2").classList.add("hidden")

              //Ak custom code
              document.querySelector(".mrk-steps-footer-next-buttons-container button.next-bundle-inner").classList.add("hidden");
              document.querySelector(".mrk-steps-footer-next-buttons-container button.next-bundle-inner").classList.add("disabled");
              //End Ak custom code
          }
          else if (input.value == "no"){
              document.querySelector(".bundle_product_steps:not(.hidden) .assignment-style-1").classList.add("hidden")
              document.querySelector(".bundle_product_steps:not(.hidden) .assignment-style-2").classList.remove("hidden")

              
              //Ak custom code
              let remainingNumber;
              let allActivePositions = document.querySelectorAll(".bundle_product_steps:not(.hidden) .selected-position.active").length;
              let allActiveDonePositions = document.querySelectorAll(".bundle_product_steps:not(.hidden) .selected-position.active.done").length;
              remainingNumber = Number(allActivePositions - allActiveDonePositions);
              // remainingNumber = checkRemainingActivePositions();
              if (remainingNumber < 2) {
                // document.querySelector("button.next-inner.mrk-final-add-to-cart").setAttribute("style", "display: block !important;");
              }
              else if (remainingNumber > 1) {
                // document.querySelector("button.next-inner.mrk-final-add-to-cart").setAttribute("style", "display: none;");
                document.querySelector(".mrk-steps-footer-next-buttons-container button.next-bundle-inner").classList.add("hidden");
                document.querySelector(".mrk-steps-footer-next-buttons-container button.next-bundle-inner").classList.add("disabled");
              }

              if(remainingNumber < 1){
                document.querySelector(".mrk-steps-footer-next-buttons-container button.next-bundle-inner").classList.remove("hidden");
                document.querySelector(".mrk-steps-footer-next-buttons-container button.next-bundle-inner").classList.remove("disabled");
                // button.next-inner
                // document.querySelector("button.next-inner.mrk-final-add-to-cart").setAttribute("style", "display: block;")
                // document.querySelector("button.next-inner.mrk-final-add-to-cart").classList.remove("disabled");
              }
              //Ak custom code
          }

      });
  });

    //application method
    let applicationMethodInputs = document.querySelectorAll(".application-method-container-input");
    applicationMethodInputs.forEach((el) => {
        el.addEventListener("input", () => {
            let positionName = el.getAttribute("data-position-name");
            let inputValue = el.getAttribute("value");
            let bundle_container = el.closest('.bundle_product_steps');
            let bundleItem = bundle_container ? bundle_container.getAttribute('data-pro') || 'Unknown' : 'Unknown';
            let selectPositionMethodLabel = bundle_container.querySelector(`.selected-position[data-position-name="${positionName}"]`).querySelector(`label[data-value="${inputValue}"]`);
            
            // Track application method change
            trackUserInteraction('application_method_changed', {
              position: positionName,
              bundleItem: bundleItem,
              method: inputValue,
              previousMethod: el.getAttribute('data-previous-value') || 'Unknown'
            });
            el.setAttribute('data-previous-value', inputValue);
            selectPositionMethodLabel.classList.add("active");
            if (selectPositionMethodLabel.nextElementSibling) {
                selectPositionMethodLabel.nextElementSibling.classList.remove("active");
            }
            else if (selectPositionMethodLabel.previousElementSibling) {
                selectPositionMethodLabel.previousElementSibling.classList.remove("active");
            }            
        })
    });

    $('.hiddenFileInput').change(function() {
      // var container = $(this).parents('.tab');
      var container = $(this).closest('.tab, .dd-tab');
      var file = this.files[0];
      if (file) {
          preparePreview(file,container);
          uploadFile(file,container);
      }
    });

    //change selection button for positions
    let allChangeSelectionBtns = document.querySelectorAll(".change-selection-btn");
    allChangeSelectionBtns.forEach((btn) => {
      btn.addEventListener("click", () => {
        btn.closest(".selected-position.active").classList.remove("done");
        btn.closest(".selected-position.active").querySelectorAll("input").forEach((inputEl) => {
          inputEl.checked = false;
        })

        //Ak custom code
        let remainingNumber;
        remainingNumber = checkRemainingActivePositions();
        // if(remainingNumber > 0){
        //   // button.next-inner
        //   document.querySelector("button.next-inner.mrk-final-add-to-cart").setAttribute("style", "display: none;")
        //   document.querySelector("button.next-inner.mrk-final-add-to-cart").classList.add("disabled");
        // }
        //Ak custom code

      })
    })

    //Next button which jump on first
    const nextBtn = document.querySelector('.mrk-steps-footer-next-buttons-container button.next-bundle-inner');
    if(nextBtn){
      nextBtn.addEventListener('click',function(){
        const current_pro = document.querySelector('.bundle_pro_steps_main .bundle_product_steps:not(.hidden)');
        if(current_pro){
          const handle = current_pro.getAttribute('data-pro');
          const step1_pro = document.querySelector('.mrk-product-steps .bundle_products .bundle_pro[data-pro="'+handle+'"]');
          if(step1_pro){
             preparesummary(current_pro);

             step1_pro.classList.add('done');
             nextBtn.classList.add('hidden');
             nextBtn.classList.add('disabled');
             window.mrknavigateTo(0);
             $('.mrk-step-custom-logo-tabs').addClass('hidden');
             $('.mrk-product-csutomizer .mrk-product-steps .bundle_pro_steps_main .bundle_product_steps').addClass('hidden');
             $('.mrk-steps-footer-back-buttons-container .back-to-first').addClass('hidden');
             $('.mrk-steps-footer-back-buttons-container .back-to-second').addClass('hidden');
             $('.mrk-steps-footer-back-buttons-container .back-to-first-inner').addClass('hidden');
          }
        }
      });
    }
    //Next button which jump on first

    popupContentScript()
}

function routineSetup() {
  // document.querySelectorAll('input[name="mrk-existing-logo"]').forEach((el) => {
  //   el.addEventListener("input", () => {
  //     document.querySelector(".mrk-steps-footer").querySelector(".mrk-next-btn").firstElementChild.classList.remove("disabled");
  //   })
  // })

  document.querySelectorAll('input[name="properties[Text Line]"]').forEach((el) => {
    el.addEventListener("input", () => {
      const this_is = el;
      update_text_next_btn(this_is);
      // document.querySelector(".mrk-steps-footer").querySelector(".mrk-next-btn").firstElementChild.classList.remove("disabled");
    })
  })

  document.querySelectorAll('input[name="properties[Text Line 2]"]').forEach((el) => {
    el.addEventListener("input", () => {
      const this_is = el;
      update_text_next_btn(this_is);
      // document.querySelector(".mrk-steps-footer").querySelector(".mrk-next-btn").firstElementChild.classList.remove("disabled");
    })
  })

  document.querySelectorAll('input[name="properties[Text Line 3]"]').forEach((el) => {
    el.addEventListener("input", () => {
      const this_is = el;
      update_text_next_btn(this_is);
      // document.querySelector(".mrk-steps-footer").querySelector(".mrk-next-btn").firstElementChild.classList.remove("disabled");
    })
  })

  document.querySelectorAll('input[name="properties[Text Line 4]"]').forEach((el) => {
    el.addEventListener("input", () => {
      const this_is = el;
      update_text_next_btn(this_is);
      // document.querySelector(".mrk-steps-footer").querySelector(".mrk-next-btn").firstElementChild.classList.remove("disabled");
    })
  })

  // let allLogoSelectionIcons = document.querySelectorAll(".selected-position-logo-style-icon-position");
  // allLogoSelectionIcons.forEach((el) => {
  //   el.addEventListener("click", () => {
  //     let logoTypeValue = el.firstElementChild.value;
  //     let positionName = el.parentElement.parentElement.getAttribute("data-position-name");
  //     document.querySelector(`.logo-position-checked[data-logo-position="${positionName}"]`).setAttribute("data-logo-type", logoTypeValue)
  //   })
  // })
}

function update_text_next_btn(el){
  if(el.closest('.mrk-step-text-logo').classList.contains('mrk-step-text-logo-original')){
      const text_1 = el.closest('.bundle_product_steps').querySelector('.mrk-step-text-logo-original #logoText');
      const text_2 = el.closest('.bundle_product_steps').querySelector('.mrk-step-text-logo-original #logoText2');
      const text_3 = el.closest('.bundle_product_steps').querySelector('.mrk-step-text-logo-original #logoText3');
      const text_4 = el.closest('.bundle_product_steps').querySelector('.mrk-step-text-logo-original #logoText4');

      const nextBtn = document.querySelector('.mrk-steps-footer .mrk-steps-footer-next-buttons-container .next-bundle-inner');

      if ((text_1 && text_1.value.trim() !== '') || (text_2 && text_2.value.trim() !== '') || (text_3 && text_3.value.trim() !== '') || (text_4 && text_4.value.trim() !== '')) {
        nextBtn.classList.remove('disabled');
      } else {
        nextBtn.classList.add('disabled');
      }
  }else if(el.closest('.mrk-step-text-logo').classList.contains('mrk-step-text-logo-position')){
      const text_1 = el.closest('.mrk-step-text-logo').querySelector('input[name="properties[Text Line]');
      const text_2 = el.closest('.mrk-step-text-logo').querySelector('input[name="properties[Text Line 2]');
      const text_3 = el.closest('.mrk-step-text-logo').querySelector('input[name="properties[Text Line 3]');
      const text_4 = el.closest('.mrk-step-text-logo').querySelector('input[name="properties[Text Line 4]');

      const nextBtn = el.closest('.mrk-step-text-logo').querySelector('button.next-inner');

      if ((text_1 && text_1.value.trim() !== '') || (text_2 && text_2.value.trim() !== '') || (text_3 && text_3.value.trim() !== '') || (text_4 && text_4.value.trim() !== '')) {
        nextBtn.classList.remove('disabled');
      } else {        
        nextBtn.classList.add('disabled');
      }
  }

}

function checkRemainingActivePositions() {
  let allActivePositions = document.querySelectorAll(".bundle_product_steps:not(.hidden) .selected-position.active").length;
  let allActiveDonePositions = document.querySelectorAll(".bundle_product_steps:not(.hidden) .selected-position.active.done").length;
  let remainingPositions = Number(allActivePositions - allActiveDonePositions);
  if (remainingPositions < 1) {
    // document.querySelector("button.next-inner.mrk-final-add-to-cart").setAttribute("style", "display: block !important;");
    document.querySelector(".mrk-steps-footer-next-buttons-container button.next-bundle-inner").classList.remove("hidden");
    document.querySelector(".mrk-steps-footer-next-buttons-container button.next-bundle-inner").classList.remove("disabled");
  }
  else if (remainingPositions > 0) {
    // document.querySelector("button.next-inner.mrk-final-add-to-cart").setAttribute("style", "display: none;");
    document.querySelector(".mrk-steps-footer-next-buttons-container button.next-bundle-inner").classList.add("hidden");
    document.querySelector(".mrk-steps-footer-next-buttons-container button.next-bundle-inner").classList.add("disabled");
    
  }
  return remainingPositions;
} 



function popupContentScript(){
  let backToFirst = document.querySelector(".back-to-first");
  let backToSecond = document.querySelector(".back-to-second");
  let backToFirstInner = document.querySelector(".back-to-first-inner");
  
  let originalExistingLogoButtons = document.querySelectorAll(".mrk-existing-logo-selector-original");
  let originalTextLogoButtons = document.querySelectorAll(".mrk-text-logo-selector-original");
  let originalUploadLogoButtons = document.querySelectorAll(".mrk-upload-your-logo-selector-original");

  let allExistingLogoSelectorEls = document.querySelectorAll(".mrk-existing-logo-selector-position");
  let allTextSelectorEls = document.querySelectorAll(".mrk-text-logo-selector-position");
  let allUploadLogoSelectorEls = document.querySelectorAll(".mrk-upload-your-logo-selector-position");

  let continueToNextPositionBtns = document.querySelectorAll(".bundle_pro_steps_main button.next-inner");

  backToFirst.addEventListener("click", () => {
    // window.mrknavigateTo(0);
    window.mrknavigateToInner(0);
    // multiStepContainer.setAttribute("data-step-number", 1)
    // document.querySelector(".mrk-steps-footer").querySelector(".mrk-next-btn").lastElementChild.classList.remove("hidden");
    document.querySelector(".bundle-pro-inner-btn").classList.remove("hidden");
    // document.querySelector(".mrk-steps-footer-back-buttons-container").classList.add("hidden");
    $('.mrk-steps-footer-back-buttons-container').hide();
    $('.mrk-steps-footer-back-buttons-container .back-to-first').addClass('hidden');
    

    document.querySelector(".mrk-steps-footer-next-buttons-container button.next-bundle-inner").classList.add("hidden");
    document.querySelector(".mrk-steps-footer-next-buttons-container button.next-bundle-inner").classList.add("disabled");

    //Ak custom code
    // const no_cart_btn = document.querySelector('.mrk-steps-footer .add_to_cart_direct');
    // if(no_cart_btn){
    //   no_cart_btn.style.display = 'block';
    // }
    //End Ak custom code
  })

  backToSecond.addEventListener("click", () => {
    $('.mrk-step-upload-logo.current').find('.preview-template .mrk-close-btn').trigger('click');
    // window.mrknavigateTo(1);
    window.mrknavigateToInner(1);
    // multiStepContainer.setAttribute("data-step-number", 2)
    let originalSelectorBtns = document.querySelectorAll(".mrk-product-steps .bundle_product_steps:not(.hidden) .original-selector-btn"); 
    originalSelectorBtns.forEach((btn) => {
      btn.querySelector("input").checked = false;
    })

    document.querySelectorAll('.mrk-product-steps .bundle_product_steps:not(.hidden) input.mrk-existing-logo-item').forEach((inputEl) => {
      inputEl.checked = false;
    })
    //Ak custom code
    $('.mrk-steps-footer .mrk-steps-footer-next-buttons-container .next-bundle-inner').addClass('disabled');

    $('.mrk-steps-footer-back-buttons-container .back-to-second').addClass('hidden');
    $('.mrk-steps-footer-next-buttons-container .next-bundle-inner').addClass('hidden');

    document.querySelector(".mrk-steps-footer-next-buttons-container button.next-bundle-inner").classList.add("hidden");
    document.querySelector(".mrk-steps-footer-next-buttons-container button.next-bundle-inner").classList.add("disabled");
    
  })

  backToFirstInner.addEventListener("click", () => {
    // window.mrknavigateTo(1);
    const upload_logo = document.querySelector('.mrk-product-steps .bundle_product_steps:not(.hidden) .mrk-step-upload-logo-position:not(.hidden)');
    if(upload_logo){
        upload_logo.querySelector('.preview-template .mrk-close-btn').click();
    }
    
    const next_btn = document.querySelector('.mrk-product-steps .bundle_product_steps:not(.hidden) .mrk-step-custom-logo-tabs:not(.hidden) button.next-inner');
    if(next_btn){
      next_btn.classList.add('disabled');
    }
    window.mrknavigateToInner(1);
    // showAllNonRelatedElements()
    // multiStepContainer.setAttribute("data-step-number", 2)
    let positionSelectorBtns = document.querySelectorAll(".bundle_product_steps:not(.hidden) .position-selector-btn");
    positionSelectorBtns.forEach((btn) => {
      btn.querySelector("input").checked = false;
    })
    document.querySelectorAll('.bundle_product_steps:not(.hidden) input.mrk-existing-logo-item').forEach((inputEl) => {
      inputEl.checked = false;
    })

    // multiStepContainer.removeAttribute("data-selector-value")
    $('.mrk-steps-footer-back-buttons-container .back-to-first-inner').addClass('hidden');
    $('.mrk-steps-footer-next-buttons-container .next-bundle-inner').addClass('hidden');
    document.querySelectorAll(".mrk-product-steps .bundle_product_steps:not(.hidden) .mrk-step-custom-logo-tabs").forEach((el) => {
      el.classList.add("hidden");
    });
  });

  continueToNextPositionBtns.forEach((conitnueBtn) => {
    conitnueBtn.addEventListener("click", () => {
      // window.mrknavigateTo(1);
      conitnueBtn.closest('.dd-tab').classList.add('hidden');
      $('.mrk-steps-footer-back-buttons-container .back-to-first-inner').addClass('hidden');
      window.mrknavigateToInner(1);

      // showAllNonRelatedElements()
      // multiStepContainer.setAttribute("data-step-number", 2)
      // multiStepContainer.removeAttribute("data-selector-value")
      // multiStepContainer.removeAttribute("data-step-final")
      if (conitnueBtn.getAttribute("data-position-number")){
        document.querySelectorAll(".bundle_product_steps:not(.hidden) .selected-position")[Number(conitnueBtn.getAttribute("data-position-number")) - 1].classList.add("done"); 
      }    

      //Ak custom code
      let remainingNumber;
      remainingNumber = checkRemainingActivePositions();
      // if(remainingNumber < 1){
      //   // button.next-inner
      //   // document.querySelector("button.next-inner.mrk-final-add-to-cart").setAttribute("style", "display: block;")
      //   // document.querySelector("button.next-inner.mrk-final-add-to-cart").classList.remove("disabled");
      // }
      // if (remainingNumber < 1) {
      //   // document.querySelector("button.next-inner.mrk-final-add-to-cart").setAttribute("style", "display: block !important;");
      //   document.querySelector(".mrk-steps-footer-next-buttons-container button.next-bundle-inner").classList.remove("hidden");
      //   document.querySelector(".mrk-steps-footer-next-buttons-container button.next-bundle-inner").classList.remove("disabled");
      // }
      // else if (remainingNumber > 1) {
      //   // document.querySelector("button.next-inner.mrk-final-add-to-cart").setAttribute("style", "display: none;");
      //   document.querySelector(".mrk-steps-footer-next-buttons-container button.next-bundle-inner").classList.add("hidden");
      //   document.querySelector(".mrk-steps-footer-next-buttons-container button.next-bundle-inner").classList.add("disabled");
        
      // }
      //Ak custom code

    })
  })

  allExistingLogoSelectorEls.forEach((el) => {
    el.querySelector('label').addEventListener("click", () => {
    // el.addEventListener("click", () => {
      let stepClassName = el.firstElementChild.getAttribute("data-target");
       el.closest('.bundle_product_steps').querySelector(`.${stepClassName}`).classList.remove("hidden");
       hideAllNonRelatedElements(el);
    })
  });

  allTextSelectorEls.forEach((el) => {
    el.querySelector('label').addEventListener("click", () => {
    // el.addEventListener("click", () => {
      let stepClassName = el.firstElementChild.getAttribute("data-target");
      el.closest('.bundle_product_steps').querySelector(`.${stepClassName}`).classList.remove("hidden");

      const text_1 = el.closest('.bundle_product_steps').querySelector(`.${stepClassName}`).querySelector('input[name="properties[Text Line]');
      const text_2 = el.closest('.bundle_product_steps').querySelector(`.${stepClassName}`).querySelector('input[name="properties[Text Line 2]');
      const text_3 = el.closest('.bundle_product_steps').querySelector(`.${stepClassName}`).querySelector('input[name="properties[Text Line 3]');
      const text_4 = el.closest('.bundle_product_steps').querySelector(`.${stepClassName}`).querySelector('input[name="properties[Text Line 4]');

      const nextBtn = el.closest('.bundle_product_steps').querySelector(`.${stepClassName}`).querySelector('button.next-inner');

      if ((text_1 && text_1.value.trim() !== '') || (text_2 && text_2.value.trim() !== '') || (text_3 && text_3.value.trim() !== '') || (text_4 && text_4.value.trim() !== '')) {
        nextBtn.classList.remove('disabled');
      } else {
        nextBtn.classList.add('disabled');
      }
      hideAllNonRelatedElements(el);
    })
  });

  allUploadLogoSelectorEls.forEach((el) => {
    el.querySelector('label').addEventListener("click", () => {
    // el.addEventListener("click", () => {
      let stepClassName = el.firstElementChild.getAttribute("data-target");
      el.closest('.bundle_product_steps').querySelector(`.${stepClassName}`).classList.remove("hidden");
      hideAllNonRelatedElements(el);
    })
  })

  originalExistingLogoButtons.forEach(function(originalExistingLogoButton){  
    originalExistingLogoButton.querySelector('label').addEventListener("click", () => {  
    // originalExistingLogoButton.addEventListener("click", (event) => {
      originalExistingLogoButton.closest('.bundle_inner_step').classList.remove("current");
      originalExistingLogoButton.closest('.bundle_product_steps').querySelector('.mrk-step-existing-logo-original').classList.add("current");
      setTheFooterButtons()
    })
  });
  originalTextLogoButtons.forEach(function(originalTextLogoButton){
    originalTextLogoButton.querySelector('label').addEventListener("click", () => { 
    // originalTextLogoButton.addEventListener("click", (event) => {
      originalTextLogoButton.closest('.bundle_inner_step').classList.remove("current");
      originalTextLogoButton.closest('.bundle_product_steps').querySelector('.mrk-step-text-logo-original').classList.add("current");  
      const text_1 = originalTextLogoButton.closest('.bundle_product_steps').querySelector('.mrk-step-text-logo-original #logoText');
      const text_2 = originalTextLogoButton.closest('.bundle_product_steps').querySelector('.mrk-step-text-logo-original #logoText2');
      const text_3 = originalTextLogoButton.closest('.bundle_product_steps').querySelector('.mrk-step-text-logo-original #logoText3');
      const text_4 = originalTextLogoButton.closest('.bundle_product_steps').querySelector('.mrk-step-text-logo-original #logoText4');

      const nextBtn = document.querySelector('.mrk-steps-footer .mrk-steps-footer-next-buttons-container .next-bundle-inner');

      if ((text_1 && text_1.value.trim() !== '') || (text_2 && text_2.value.trim() !== '') || (text_3 && text_3.value.trim() !== '') || (text_4 && text_4.value.trim() !== '')) {
        nextBtn.classList.remove('disabled');
      } else {
        nextBtn.classList.add('disabled');
      }
      // $('.mrk-steps-footer .mrk-steps-footer-next-buttons-container .next-bundle-inner').removeClass('disabled');
      setTheFooterButtons()
    });
  });

  originalUploadLogoButtons.forEach(function(originalUploadLogoButton){
    originalUploadLogoButton.querySelector('label').addEventListener("click", () => { 
    // originalUploadLogoButton.addEventListener("click", (event) => {
      originalUploadLogoButton.closest('.bundle_inner_step').classList.remove("current");
      originalUploadLogoButton.closest('.bundle_product_steps').querySelector('.mrk-step-upload-logo-original').classList.add("current");
      setTheFooterButtons()
    });
  });


  function setTheFooterButtons() {
    $('.mrk-steps-footer-back-buttons-container .back-to-first').addClass('hidden');
    $('.mrk-steps-footer-back-buttons-container .back-to-second').removeClass('hidden');
    $('.mrk-steps-footer-next-buttons-container .next-bundle-inner').removeClass('hidden');
  }

  function hideAllNonRelatedElements(el) {
    el.closest('.bundle_inner_step').classList.remove("current");
    $('.mrk-steps-footer-back-buttons-container .back-to-first').addClass('hidden');
    $('.mrk-steps-footer-back-buttons-container .back-to-first-inner').removeClass('hidden');
    // let activeStep = document.querySelector(".tab.mrk-step-2.mrk-print-active");
    // activeStep.classList.remove("current");
    // let stepsFooter = document.querySelector(".mrk-steps-footer");
    // stepsFooter.classList.add("hidden");
  }
}


function preparesummary(current_pro){
  current_pro.classList.add('hiiii');
  const logo_position = current_pro.querySelector('.bundle_pro_logo_position');
  const logo_style = current_pro.querySelector('.bundle_pro_logo_style');
  const logo_style_val = logo_style.querySelector('.logo-assignment-labels-container .logo-assignment-label.selected input[type="radio"]').value;
  
  const producthandle = current_pro.getAttribute('data-pro');

  if(logo_position){
    let selected_positions = logo_position.querySelectorAll('.logo-position-checked');
    // Mix&match headwear: use same source as filter — builder selection (beanie vs cap), then pick that position
    const isMixMatchHeadwear = current_pro.getAttribute('data-mix-match-headwear') === 'true';
    if (isMixMatchHeadwear) {
      var selectedType = '';
      var headwearRow = document.querySelector('.mrk-bundle-products-items[bundleitemName="Headwear"]');
      if (headwearRow) {
        headwearRow.querySelectorAll('.bundle__details').forEach(function(details) {
          var qtyInputs = details.querySelectorAll('input.mrk-qty-item');
          for (var i = 0; i < qtyInputs.length; i++) {
            if (Number(qtyInputs[i].value) > 0) {
              var handle = (details.getAttribute('data-product-handle') || '').toLowerCase();
              var title = (details.getAttribute('data-product-title') || '').toLowerCase();
              if (!handle && !title) {
                var labelSpan = details.querySelector('.mixmatch-open span span:first-child') || details.querySelector('.a-row__name');
                if (labelSpan) title = (labelSpan.textContent || '').toLowerCase().trim();
              }
              if (handle.indexOf('beanie') !== -1 || title.indexOf('beanie') !== -1) selectedType = 'beanie';
              else if (handle.indexOf('cap') !== -1 || title.indexOf('cap') !== -1) selectedType = 'cap';
              break;
            }
          }
        });
      }
      if (selectedType) {
        var matchItem = logo_position.querySelector('.mrk-position-item[data-position-headwear-type="' + selectedType + '"]');
        if (matchItem) selected_positions = [matchItem];
      }
    }

    let summary_html = '';

    selected_positions.forEach(function(position){
      // let title = position.querySelector('.radio-value').textContent;
      let title = position.querySelector('input[type="checkbox"]').value;
      let position_name = position.querySelector('input[type="checkbox"]').getAttribute('data-position-name');
      
      var applicationMethodEl = position.querySelector('.application-method-container input[type="radio"]:checked');
      let application_method = applicationMethodEl ? applicationMethodEl.value : 'Embroidery';
      var positionImgEl = position.querySelector('.mrk-radio-image img.product-img');
      let position_img = positionImgEl ? positionImgEl.getAttribute('src') : '';


      let logo_type;
      let logo_url;
      let text_line_1;
      let text_line_2;
      let text_line_3;
      let text_line_4;
      let text_color;
      let text_font;

      if(logo_style_val == 'yes'){
        logo_type = logo_style.querySelector('.assignment-style-1 input[type="radio"]:checked').value;
        logo_type = logo_type.toLowerCase();


        if(logo_type.includes('existing')){
          logo_url = current_pro.querySelector('.mrk-step-existing-logo-original .mrkexisting-logo-select .logo-item input[type="radio"]:checked').value;
        }else if(logo_type.includes('text')){
          logo_url = logo_style.querySelector('.assignment-style-1 input[type="radio"]:checked').nextElementSibling.querySelector('img').getAttribute('src');

          const text_1 = current_pro.querySelector('.mrk-step-text-logo-original [name="properties[Text Line]"]');
          if(text_1){
            text_line_1 = text_1.value;
          }
          const text_2 = current_pro.querySelector('.mrk-step-text-logo-original [name="properties[Text Line 2]"]');
          if(text_2){
            text_line_2 = text_2.value;
          }
          const text_3 = current_pro.querySelector('.mrk-step-text-logo-original [name="properties[Text Line 3]"]');
          if(text_3){
            text_line_3 = text_3.value;
          }
          const text_4 = current_pro.querySelector('.mrk-step-text-logo-original [name="properties[Text Line 4]"]');
          if(text_4){
            text_line_4 = text_4.value;
          }

          const logo_font = current_pro.querySelector('.mrk-step-text-logo-original #font-family');
          if(logo_font){
            text_font = logo_font.value;
          }

          const logo_color = current_pro.querySelector('.mrk-step-text-logo-original #logoColor');
          if(logo_color){
            text_color = logo_color.value;
          }


        }else if(logo_type.includes('upload')){
          logo_url = current_pro.querySelector('.mrk-step-upload-logo-original .preview-template .mrk-image img').getAttribute('src');
        }
      }else{
        logo_type = logo_style.querySelector('.assignment-style-2 .selected-position.active[data-position-name="'+position_name+'"] input[type="radio"]:checked').value;
        logo_type = logo_type.toLowerCase();
        const data_target = logo_style.querySelector('.assignment-style-2 .selected-position.active[data-position-name="'+position_name+'"] input[type="radio"]:checked').getAttribute('data-target');

        if(logo_type.includes('existing')){
          logo_url = current_pro.querySelector(`.${data_target} .mrkexisting-logo-select .logo-item input[type="radio"]:checked`).value;
        }else if(logo_type.includes('text')){
          logo_url = logo_style.querySelector('.assignment-style-2 .selected-position.active[data-position-name="'+position_name+'"] input[type="radio"]:checked').nextElementSibling.querySelector('img').getAttribute('src');


          const text_1 = current_pro.querySelector(`.${data_target} [name="properties[Text Line]"]`);
          if(text_1){
            text_line_1 = text_1.value;
          }
          const text_2 = current_pro.querySelector(`.${data_target} [name="properties[Text Line 2]"]`);
          if(text_2){
            text_line_2 = text_2.value;
          }
          const text_3 = current_pro.querySelector(`.${data_target} [name="properties[Text Line 3]"]`);
          if(text_3){
            text_line_3 = text_3.value;
          }
          const text_4 = current_pro.querySelector(`.${data_target} [name="properties[Text Line 4]"]`);
          if(text_4){
            text_line_4 = text_4.value;
          }

          const logo_font = current_pro.querySelector(`.${data_target} .font-family-position`);
          if(logo_font){
            text_font = logo_font.value;
          }

          const logo_color = current_pro.querySelector(`.${data_target} .logoColor-position`);
          if(logo_color){
            text_color = logo_color.value;
          }
        }else if(logo_type.includes('upload')){
          logo_url = current_pro.querySelector(`.${data_target} .preview-template .mrk-image img`).getAttribute('src');
        }
      }



      text_line_1 = text_line_1 ? `<p>Logo Text Line 1: <b>${text_line_1}</b></p>` : '';
      text_line_2 = text_line_2 ? `<p>Logo Text Line 2: <b>${text_line_2}</b></p>` : '';
      text_line_3 = text_line_3 ? `<p>Logo Text Line 3: <b>${text_line_3}</b></p>` : '';
      text_line_4 = text_line_4 ? `<p>Logo Text Line 4: <b>${text_line_4}</b></p>` : '';
      text_font   = text_font ? `<p>Logo Font: <b>${text_font}</b></p>` : '';
      text_color  = text_color ? `<p>Logo Color: <b>${text_color}</b></p>` : '';



       summary_html += `<div class="summary-position" data-position-name="${title}" data-logo-type="${logo_type}">
                          <div class="summary-position-left">
                            <div class="summary-img-title">
                              <div class="summary-img">
                                <img src="${position_img}"/>
                              </div>
                              <div class="summary-position-title">
                                 <div class="title-value">${title}</div>
                              </div>
                            </div>
                            <div class="summary-application-method">
                               <div class="method-value">${application_method}</div>
                            </div>
                          </div>

                          <div class="summary-position-right">
                            <div class="logo-img">
                               <img src="${logo_url}"/>
                            </div>
                            <div class="logo-description">
                              ${text_line_1}
                              ${text_line_2}
                              ${text_line_3}
                              ${text_line_4}
                              ${text_color}
                              ${text_font}
                            </div>
                          </div>

                        </div>`;

    });


    setTimeout(function() {
      const pro_summary_div = document.querySelector('.mrk-product-steps .summary-step .summary-pro[data-pro="'+producthandle+'"]');
      if(pro_summary_div){
        pro_summary_div.querySelector('.bundle-summary-data').innerHTML = summary_html;
      }
    }, 1000);
    
    
  }
} 


function getLogoDetailsbundleout(index,logo_style, logo_type, main_div,position_name,target_position) {
  var logo = {};
  var resolvedUrl = null;
  var urlSource = '';

  if(logo_style == 'yes'){
      if (logo_type == 'Upload Your Logo') {
          resolvedUrl = $(main_div).find('.mrk-step-upload-logo-original [name="properties[Uploaded Logo]"]').val();
          urlSource = 'shared_upload_hidden_input';
          logo = { [`Logo ${index}`]: resolvedUrl,
                   [`Note ${index}`]: $(main_div).find('.mrk-step-upload-logo-original #customerNotesFilesUploadedLogo').val()
                };
      } else if (logo_type == 'Existing Logo') {
          resolvedUrl = $(main_div).find('.mrk-step-existing-logo-original [name="properties[Existing Logo]"]').val();
          urlSource = 'shared_existing_hidden_input';
          logo = { [`Logo ${index}`]: resolvedUrl,
                   [`Note ${index}`]: $(main_div).find('.mrk-step-existing-logo-original #customerNotesFilesExisting').val()
                };
      } else if (logo_type == 'Text Logo') {
        urlSource = 'text_logo';
        logo = {
              [`Logo Text ${index}`]: $(main_div).find('.mrk-step-text-logo-original [name="properties[Text Line]"]').val(),
              [`Logo Text 2 ${index}`]: $(main_div).find('.mrk-step-text-logo-original [name="properties[Text Line 2]"]').val(),
              [`Logo Text 3 ${index}`]: $(main_div).find('.mrk-step-text-logo-original [name="properties[Text Line 3]"]').val(),
              [`Logo Text 4 ${index}`]: $(main_div).find('.mrk-step-text-logo-original [name="properties[Text Line 4]"]').val(),
              [`Logo Color ${index}`]: $(main_div).find('.mrk-step-text-logo-original #logoColor').val(),
              [`Logo Font ${index}`]: $(main_div).find('.mrk-step-text-logo-original #font-family').val(),
              [`Note ${index}`]: $(main_div).find('.mrk-step-text-logo-original #notesLogoText').val()
          };
      }
  }else{
      if (logo_type == 'Upload Your Logo') {
          resolvedUrl = $(main_div).find(`.${target_position} [name="properties[Uploaded Logo]"]`).val();
          urlSource = 'position_upload_hidden_input';
          logo = { [`Logo ${index}`]: resolvedUrl,
                   [`Note ${index}`]: $(main_div).find(`.${target_position} #customerNotesFilesUploadedLogo`).val()
                };
      } else if (logo_type == 'Existing Logo') {
          resolvedUrl = $(main_div).find(`.${target_position} [name="properties[Existing Logo]"]`).val();
          urlSource = 'position_existing_hidden_input';
          logo = { [`Logo ${index}`]: resolvedUrl,
                 [`Note ${index}`]: $(main_div).find(`.${target_position} #customerNotesFilesExisting`).val()
                };
      } else if (logo_type == 'Text Logo') {
        urlSource = 'text_logo';
        logo = {
              [`Logo Text ${index}`]: $(main_div).find(`.${target_position} [name="properties[Text Line]"]`).val(),
              [`Logo Text 2 ${index}`]: $(main_div).find(`.${target_position} [name="properties[Text Line 2]"]`).val(),
              [`Logo Text 3 ${index}`]: $(main_div).find(`.${target_position} [name="properties[Text Line 3]"]`).val(),
              [`Logo Text 4 ${index}`]: $(main_div).find(`.${target_position} [name="properties[Text Line 4]"]`).val(),
              [`Logo Color ${index}`]: $(main_div).find(`.${target_position} .logoColor-position`).val(),
              [`Logo Font ${index}`]: $(main_div).find(`.${target_position} .font-family-position`).val(),
              [`Note ${index}`]: $(main_div).find(`.${target_position} .notesLogoText-position`).val()
          };
      }
  }

  // 5b. Logo URL resolution tracking
  if (window.bundleDebugLog && (logo_type === 'Existing Logo' || logo_type === 'Upload Your Logo')) {
    try {
      window.bundleDebugLog.steps.push({
        step: 'logo_url_resolved',
        status: resolvedUrl ? 'success' : 'error',
        details: {
          positionIndex: index,
          positionName: position_name,
          logoType: logo_type,
          logoStyle: logo_style,
          resolvedUrl: resolvedUrl || 'MISSING',
          urlSource: urlSource,
          targetPosition: target_position || 'N/A',
          mainDivPro: $(main_div).attr('data-pro') || 'unknown'
        },
        time: new Date().toISOString()
      });
    } catch(e) { /* debug should not break functionality */ }
  }

  return logo;
}

function updateMetabundlenew(debugLog){
  // Use global debugLog if not provided (for Finish button calls)
  if (!debugLog && window.bundleDebugLog) {
    debugLog = window.bundleDebugLog;
  }
  
  var timestamp = new Date().toISOString();
  
  if (debugLog && debugLog.steps) {
    debugLog.steps.push({
      step: 'updateMetabundlenew_called',
      status: 'started',
      details: {},
      time: timestamp
    });
  }
  
  var bundleItems = $('.mrk-bundle-products-items');
  let isEmbroidery = $('[name="application-type"]:checked').val() == 'Embroidery' ? true:false;
  var ParentVariantId = window.bundleId, positionsData = [];
  
  
  if (debugLog && debugLog.data) {
    if (!debugLog.data.updateMetabundlenew) {
      debugLog.data.updateMetabundlenew = {};
    }
    debugLog.data.updateMetabundlenew.applicationMethod = isEmbroidery ? 'Embroidery' : 'Print';
    debugLog.data.updateMetabundlenew.parentVariantId = ParentVariantId;
    debugLog.data.updateMetabundlenew.bundleItemsCount = bundleItems.length;
    debugLog.data.updateMetabundlenew.checkedPositions = $(`.mrk-logo-inputs:checked`).length;
  }
  
  // let genericProperties;
  bundleItems.each(function(){
    var bundleIndex = $(this).attr('bundleitem');
    var bundleItemName = $(this).attr('bundleitemName');
    const positions = $(`.mrk-position-item .mrk-logo-inputs[forbundle="bundleItem-${bundleIndex}"]:checked`);
    var sizes = $(this).find('.mrk-qty-item');
    
    
    // ====================================================================
    // CRITICAL FIX: Item Multiplication Bug (Bundle Bug Report #3)
    // ====================================================================
    // PROBLEM: getAllPositionsProperties was being called ONCE PER PRODUCT/SIZE
    // with qty > 0. This caused positions to be duplicated:
    // - If 3 products have qty > 0, positions are added 3 times
    // - Result: 2 positions * 3 products = 6 items (should be 2)
    //
    // SOLUTION: Call getAllPositionsProperties ONCE per bundle category.
    // Positions are shared across all products in the same bundle category.
    // The qty parameter should be the total quantity for the category, or 1 per position.
    // ====================================================================
    
    // Calculate total quantity for this bundle category (sum of all products with qty > 0)
    var totalCategoryQty = 0;
    var productsWithQty = [];
    $(sizes).each(function(){
        if(Number($(this).val()) > 0){
            var property = $(this).attr('productname');
            var qty = Number($(this).val());
            totalCategoryQty += qty;
            productsWithQty.push({property: property, qty: qty});
        }
    });
    
    // Only process positions if there are products with quantity > 0
    if (totalCategoryQty > 0 && positions.length > 0) {
      // CRITICAL FIX: Call getAllPositionsProperties ONCE per bundle category
      // Use the first product's name as the property (for backward compatibility)
      // Positions are shared across all products in the same category
      var firstProduct = productsWithQty.length > 0 ? productsWithQty[0].property : bundleItemName;
      
      // Call once per bundle category (not once per product)
      // CRITICAL FIX: Use totalCategoryQty instead of 1 (Order #51763 fix)
      // This ensures position variants have the correct quantity matching the category total
      const positionData = getAllPositionsProperties(isEmbroidery, positions, totalCategoryQty, ParentVariantId, firstProduct);
      
      if (debugLog && debugLog.steps) {
        debugLog.steps.push({
          step: 'getAllPositionsProperties_called',
          status: 'success',
          details: {
            bundleItem: bundleItemName,
            bundleIndex: bundleIndex,
            positionsCount: positions.length,
            productsWithQty: productsWithQty.length,
            totalCategoryQty: totalCategoryQty,
            positionDataCollected: positionData.length,
            note: 'Called once per bundle category (not per product) to prevent multiplication'
          },
          time: new Date().toISOString()
        });
      }
      
      positionsData = positionsData.concat(positionData);
    }

  // Ak custom code
  // positions.each(function(index){
  //   // if(Number($(this).data('printprice')) == 0 && Number($(this).data('embroideryprice')) == 0){
  //   //   return
  //   // }
  //   //  const isEmbroidery = $('[name="application-type"]:checked').val() == 'Embroidery' ? true:false;
  //   // this.nextElementSibling.nextElementSibling.classList.add('hhhjj')
  //   // let isEmbroidery;
  //   index = index + 1;
  //   const targetDiv = this.parentElement.querySelector('.application-method-container');
  //   if (targetDiv) {
  //     const application_method_val = targetDiv.querySelector('input[type="radio"]:checked').value;
  //     isEmbroidery = application_method_val == 'Embroidery' ? true:false;
  //   }

  //   let application_method;
  //   if(isEmbroidery){
  //     id = Number($(this).data('embroideryvariant'));
  //     application_method = 'Embroidery';
  //   }else{
  //     id = Number($(this).data('printvariant'));
  //     application_method = 'Print';
  //   }
  //   var name = $(this).val();

  //   var main_div = $(this).parents('.bundle_product_steps');
  //   var position_name = $(this).attr('data-position-name');
  //   var logo_style = $(main_div).find('.bundle_pro_logo_style .logo-assignment-labels-container .logo-assignment-label.selected input[type="radio"]').val();
  //   let logo_type;
  //   let logoVariant;
  //   let target_position;

  //   if(logo_style == 'yes'){
  //     logo_type = $(main_div).find('.bundle_pro_logo_style .assignment-style-1 input[type="radio"]:checked').val();
  //     logoVariant = $(main_div).find('.bundle_pro_logo_style .assignment-style-1 input[type="radio"]:checked').attr('variant');
  //     target_position = '';
  //   }else{
  //     logo_type = $(main_div).find('.bundle_pro_logo_style .assignment-style-2 .selected-position.active[data-position-name="'+position_name+'"] input[type="radio"]:checked').val();
  //     logoVariant = $(main_div).find('.bundle_pro_logo_style .assignment-style-2 .selected-position.active[data-position-name="'+position_name+'"] input[type="radio"]:checked').attr('variant');
  //     target_position = $(main_div).find('.bundle_pro_logo_style .assignment-style-2 .selected-position.active[data-position-name="'+position_name+'"] input[type="radio"]:checked').attr('data-target');      
  //   }

  //   let logoDetails = getLogoDetailsbundleout(index,logo_style, logo_type, main_div,position_name,target_position);

  //   genericProperties = {
  //     [`Application Method ${index}`]: application_method,      
  //     [`Logo Type ${index}`]: logo_type,
  //     [`_logoVariant${index}`]: logoVariant,
  //     [`_time`]: universalTimeValue
  //   };

  //   var properties = Object.assign({}, genericProperties, logoDetails);
  //   addHiddenField(index, properties);

  //   //Ak custom code
    
  // })
  //end Ak custom code

  });
  
  if (debugLog && debugLog.data && debugLog.data.updateMetabundlenew) {
    debugLog.data.updateMetabundlenew.positionsDataCount = positionsData.length;
  }
  
  if (positionsData.length === 0) {
    
    if (debugLog && debugLog.errors) {
      debugLog.errors.push({
        message: 'No positions data collected in updateMetabundlenew',
        details: {
          bundleItemsCount: bundleItems.length,
          checkedPositions: $(`.mrk-logo-inputs:checked`).length,
          applicationMethod: isEmbroidery ? 'Embroidery' : 'Print'
        },
        time: new Date().toISOString()
      });
    }
    
    return; // Don't create empty hidden field
  }
  
  var index = $('.mrk-hidden-fields .mrk-hidden-field-item').length + 1;
  
  // Collect logo details from checked positions (similar to buildMainVariant lines 930-988)
  // For bundles, logo details are collected per-position from the DOM
  // CRITICAL FIX (Bug 2): Iterate by category order instead of global DOM order.
  // The old global selector $(`.mrk-logo-inputs:checked`) returned positions in DOM order
  // which could differ from category order (Cat0→Cat1→Cat2), causing numbered properties
  // (_logoproduct, _logoposition, Application Method, etc.) to be scrambled in the hidden field.
  var allPositionsForDetails = [];
  bundleItems.each(function() {
      var bIdx = $(this).attr('bundleitem');
      var categoryPositions = $(`.mrk-position-item .mrk-logo-inputs[forbundle="bundleItem-${bIdx}"]:checked`);
      categoryPositions.each(function() {
          allPositionsForDetails.push(this);
      });
  });
  const positions = $(allPositionsForDetails);  // Now in category order
  var allLogoDetails = {};
  var applicationMethod = null;
  var logoType = null;
  var logoVariant = null;
  
  
  if (positions.length > 0) {
    // Collect logo details from each checked position (same logic as buildMainVariant)
    positions.each(function(posIndex){
      var actualIndex = posIndex + 1;
      const targetDiv = this.parentElement.querySelector('.application-method-container');
      var isEmbroidery = false;
      if (targetDiv) {
        const application_method_val = targetDiv.querySelector('input[type="radio"]:checked');
        if (application_method_val) {
          isEmbroidery = application_method_val.value == 'Embroidery' ? true : false;
        }
      }

      var application_method;
      if(isEmbroidery){
        application_method = 'Embroidery';
      }else{
        application_method = 'Print';
      }
      var name = $(this).val();

      var main_div = $(this).parents('.bundle_product_steps');
      var position_name = $(this).attr('data-position-name');
      var logo_style = main_div.find('.bundle_pro_logo_style .logo-assignment-labels-container .logo-assignment-label.selected input[type="radio"]').val();
      let logo_type;
      let logoVariant_pos;
      let target_position;

      if(logo_style == 'yes'){
        logo_type = main_div.find('.bundle_pro_logo_style .assignment-style-1 input[type="radio"]:checked').val();
        logoVariant_pos = main_div.find('.bundle_pro_logo_style .assignment-style-1 input[type="radio"]:checked').attr('variant');
        target_position = '';
      }else{
        logo_type = main_div.find('.bundle_pro_logo_style .assignment-style-2 .selected-position.active[data-position-name="'+position_name+'"] input[type="radio"]:checked').val();
        logoVariant_pos = main_div.find('.bundle_pro_logo_style .assignment-style-2 .selected-position.active[data-position-name="'+position_name+'"] input[type="radio"]:checked').attr('variant');
        target_position = main_div.find('.bundle_pro_logo_style .assignment-style-2 .selected-position.active[data-position-name="'+position_name+'"] input[type="radio"]:checked').attr('data-target');      
      }

      const product_name = main_div.attr('data-pro-name');

      // Use getLogoDetailsbundleout (with 'out' suffix) for bundle popup context
      let logoDetails = getLogoDetailsbundleout(actualIndex, logo_style, logo_type, main_div, position_name, target_position);
      
      // FIXED (BUG-4): Capture from first position with valid logo data, not just posIndex === 0
      // Category 0's DOM lookup can fail (hasStyle1: false), leaving config null
      // Use ANY position that has valid logo configuration
      if ((!applicationMethod || !logoType || !logoVariant) && 
          application_method && logo_type && logoVariant_pos) {
        applicationMethod = application_method;
        logoType = logo_type;
        logoVariant = logoVariant_pos;
        
        // Add debug logging to track which position provided the config
        if (debugLog && debugLog.steps) {
          debugLog.steps.push({
            step: 'top_level_logo_config_captured',
            status: 'success',
            details: {
              fromPositionIndex: posIndex,
              positionName: name,
              applicationMethod: applicationMethod,
              logoType: logoType,
              logoVariant: logoVariant,
              note: 'Captured from first position with valid logo data (BUG-4 fix)'
            },
            time: new Date().toISOString()
          });
        }
      }
      
      // Merge logo details with indexed keys
      Object.keys(logoDetails).forEach(function(key) {
        allLogoDetails[key] = logoDetails[key];
      });
      
      // Also store per-position properties
      allLogoDetails[`Application Method ${actualIndex}`] = application_method;
      allLogoDetails[`Logo Type ${actualIndex}`] = logo_type;
      allLogoDetails[`_logoVariant${actualIndex}`] = logoVariant_pos;
      allLogoDetails[`_logoproduct${actualIndex}`] = product_name;
      allLogoDetails[`_logoposition${actualIndex}`] = name;
    });
  }
  
    // applicationMethod: applicationMethod || 'MISSING',
    // logoVariant: logoVariant || 'MISSING',
    // logoType: logoType || 'MISSING',
    // logoDetailsKeys: Object.keys(allLogoDetails),
    // logoDetailsCount: Object.keys(allLogoDetails).length
  // });
  
  var genericProperties = {
      [`Application Method ${index}`]: applicationMethod,
      [`Positions ${index}`]:positionsData,
      [`Logo Type ${index}`]: logoType,
      [`_logoVariant${index}`]: logoVariant,
      [`_time`]: universalTimeValue
  };
  
  var properties = Object.assign({}, genericProperties, allLogoDetails);
  
    // positionsCount: positionsData.length,
    // hasLogoDetails: Object.keys(allLogoDetails).length > 0,
    // totalProperties: Object.keys(properties).length,
    // applicationMethod: applicationMethod || 'MISSING',
    // logoType: logoType || 'MISSING',
    // logoVariant: logoVariant || 'MISSING'
  // });
  
  if (!applicationMethod || !logoType || !logoVariant) {
    var positionDetails = positions.map(function() {
      var main_div = $(this).parents('.bundle_product_steps');
      var logo_style = main_div.find('.bundle_pro_logo_style .logo-assignment-labels-container .logo-assignment-label.selected input[type="radio"]').val();
      return {
        position: $(this).val(),
        logo_style: logo_style,
        hasStyle1: main_div.find('.bundle_pro_logo_style .assignment-style-1 input[type="radio"]:checked').length > 0,
        hasStyle2: main_div.find('.bundle_pro_logo_style .assignment-style-2 .selected-position.active input[type="radio"]:checked').length > 0
      };
    }).get();
    
    if (debugLog && debugLog.errors) {
      debugLog.errors.push({
        message: 'Missing logo configuration in updateMetabundlenew',
        details: {
          applicationMethod: applicationMethod || 'MISSING',
          logoType: logoType || 'MISSING',
          logoVariant: logoVariant || 'MISSING',
          checkedPositions: positions.length,
          positionDetails: positionDetails
        },
        time: new Date().toISOString()
      });
    }
  }
  
  addHiddenField(index, properties);
  
  // Disable current checked positions
  $('.mrk-position-item input:checked').each(function() {
    $(this).prop('disabled', true).parents('.mrk-position-item').addClass('mrk-checked-position');
  });
  
  var finalHiddenFieldsCount = $('.mrk-hidden-field-item').length;
  
  if (debugLog && debugLog.steps) {
    debugLog.steps.push({
      step: 'updateMetabundlenew_completed',
      status: finalHiddenFieldsCount > 0 ? 'success' : 'warning',
      details: {
        hiddenFieldsCreated: finalHiddenFieldsCount,
        positionsDataCount: positionsData.length,
        hasApplicationMethod: !!applicationMethod,
        hasLogoType: !!logoType,
        hasLogoVariant: !!logoVariant
      },
      time: new Date().toISOString()
    });
    
    if (debugLog.data && debugLog.data.updateMetabundlenew) {
      debugLog.data.updateMetabundlenew.finalHiddenFieldsCount = finalHiddenFieldsCount;
      debugLog.data.updateMetabundlenew.positionsDataCount = positionsData.length;
      debugLog.data.updateMetabundlenew.hasApplicationMethod = !!applicationMethod;
      debugLog.data.updateMetabundlenew.hasLogoType = !!logoType;
      debugLog.data.updateMetabundlenew.hasLogoVariant = !!logoVariant;
    }
  }
}

initPopupnew()
//Ak custom code New Bundle Customizer
//Ak custom code New Bundle Customizer